(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireda16"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireda16"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7wgKE", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $579884101b2e33e1$export$6503ec6e8aabbaf; }, function (v) { return $579884101b2e33e1$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $579884101b2e33e1$export$f7ad0328861e2f03; }, function (v) { return $579884101b2e33e1$export$f7ad0328861e2f03 = v; });
var $579884101b2e33e1$export$6503ec6e8aabbaf;
var $579884101b2e33e1$export$f7ad0328861e2f03;
"use strict";
var $579884101b2e33e1$var$mapping = new Map();
function $579884101b2e33e1$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$579884101b2e33e1$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $579884101b2e33e1$var$resolve(id) {
    var resolved = $579884101b2e33e1$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$579884101b2e33e1$export$6503ec6e8aabbaf = $579884101b2e33e1$var$register;
$579884101b2e33e1$export$f7ad0328861e2f03 = $579884101b2e33e1$var$resolve;

});

parcelRegister("kSeqf", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $f32409c1b79251cc$export$bdfd709ae4826697; }, function (v) { return $f32409c1b79251cc$export$bdfd709ae4826697 = v; });
var $f32409c1b79251cc$export$bdfd709ae4826697;
var $f32409c1b79251cc$export$c9e73fbda7da57b6;
var $f32409c1b79251cc$export$5a759dc7a1cfb72a;
"use strict";
var $f32409c1b79251cc$var$bundleURL = {};
function $f32409c1b79251cc$var$getBundleURLCached(id) {
    var value = $f32409c1b79251cc$var$bundleURL[id];
    if (!value) {
        value = $f32409c1b79251cc$var$getBundleURL();
        $f32409c1b79251cc$var$bundleURL[id] = value;
    }
    return value;
}
function $f32409c1b79251cc$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f32409c1b79251cc$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $f32409c1b79251cc$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $f32409c1b79251cc$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$f32409c1b79251cc$export$bdfd709ae4826697 = $f32409c1b79251cc$var$getBundleURLCached;
$f32409c1b79251cc$export$c9e73fbda7da57b6 = $f32409c1b79251cc$var$getBaseURL;
$f32409c1b79251cc$export$5a759dc7a1cfb72a = $f32409c1b79251cc$var$getOrigin;

});

parcelRegister("kRmIq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f2fa60bb79d42ae6$export$1b5e630bc3aea29f; });

var $eDADq = parcelRequire("eDADq");

var $h6YrN = parcelRequire("h6YrN");

var $ki5z8 = parcelRequire("ki5z8");

var $hFE5s = parcelRequire("hFE5s");
function $f2fa60bb79d42ae6$export$1b5e630bc3aea29f(arr) {
    return (0, $eDADq._array_without_holes)(arr) || (0, $h6YrN._iterable_to_array)(arr) || (0, $hFE5s._unsupported_iterable_to_array)(arr) || (0, $ki5z8._non_iterable_spread)();
}

});
parcelRegister("eDADq", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $aa81201c4814362b$export$7e0947b5ad3404e2; });

var $5QELw = parcelRequire("5QELw");
function $aa81201c4814362b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $5QELw._array_like_to_array)(arr);
}

});
parcelRegister("5QELw", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $44216e45ec0ec066$export$79e617b1955a2616; });
function $44216e45ec0ec066$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("h6YrN", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $c751e2c35ca33d70$export$1eb58a6e75231000; });
function $c751e2c35ca33d70$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("ki5z8", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $ec59ce54b437d8a4$export$e6f3c4780d19eb2b; });
function $ec59ce54b437d8a4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("hFE5s", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $cdd55c7450520114$export$a5be06335b3a083c; });

var $5QELw = parcelRequire("5QELw");
function $cdd55c7450520114$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5QELw._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5QELw._array_like_to_array)(o, minLen);
}

});


parcelRegister("5YOUh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $45aa0b62b4686e01$export$7c398597f8905a1; });
function $45aa0b62b4686e01$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $45aa0b62b4686e01$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $45aa0b62b4686e01$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $45aa0b62b4686e01$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("j4B9x", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $de2b35d45bf23e9b$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $de2b35d45bf23e9b$var$extendStatics = function extendStatics1(d, b) {
    $de2b35d45bf23e9b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $de2b35d45bf23e9b$var$extendStatics(d, b);
};
function $de2b35d45bf23e9b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $de2b35d45bf23e9b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $de2b35d45bf23e9b$export$18ce0697a983be9b = function __assign1() {
    $de2b35d45bf23e9b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de2b35d45bf23e9b$export$18ce0697a983be9b.apply(this, arguments);
};
function $de2b35d45bf23e9b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $de2b35d45bf23e9b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $de2b35d45bf23e9b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $de2b35d45bf23e9b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $de2b35d45bf23e9b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $de2b35d45bf23e9b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $de2b35d45bf23e9b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $de2b35d45bf23e9b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $de2b35d45bf23e9b$export$45d3717a4c69092e(o, m, p);
}
function $de2b35d45bf23e9b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $de2b35d45bf23e9b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $de2b35d45bf23e9b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($de2b35d45bf23e9b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $de2b35d45bf23e9b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $de2b35d45bf23e9b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $de2b35d45bf23e9b$export$10c90e4f7922046c(v) {
    return this instanceof $de2b35d45bf23e9b$export$10c90e4f7922046c ? (this.v = v, this) : new $de2b35d45bf23e9b$export$10c90e4f7922046c(v);
}
function $de2b35d45bf23e9b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $de2b35d45bf23e9b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $de2b35d45bf23e9b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $de2b35d45bf23e9b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $de2b35d45bf23e9b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $de2b35d45bf23e9b$export$19a8beecd37a4c45 === "function" ? $de2b35d45bf23e9b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $de2b35d45bf23e9b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $de2b35d45bf23e9b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $de2b35d45bf23e9b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $de2b35d45bf23e9b$export$45d3717a4c69092e(result, mod, k);
    }
    $de2b35d45bf23e9b$var$__setModuleDefault(result, mod);
    return result;
}
function $de2b35d45bf23e9b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $de2b35d45bf23e9b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $de2b35d45bf23e9b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $de2b35d45bf23e9b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

});

parcelRegister("i7mYY", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $d30ab54a4b4aa90f$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "getExn", function () { return $d30ab54a4b4aa90f$export$2d6fda808293d631; });
$parcel$export(module.exports, "shuffleInPlace", function () { return $d30ab54a4b4aa90f$export$c8bbd489f517fb10; });
$parcel$export(module.exports, "reverse", function () { return $d30ab54a4b4aa90f$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "makeBy", function () { return $d30ab54a4b4aa90f$export$849fbdcc2211fcde; });
$parcel$export(module.exports, "range", function () { return $d30ab54a4b4aa90f$export$d02631cccf789723; });
$parcel$export(module.exports, "zip", function () { return $d30ab54a4b4aa90f$export$8901015135f2fb22; });
$parcel$export(module.exports, "concat", function () { return $d30ab54a4b4aa90f$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatMany", function () { return $d30ab54a4b4aa90f$export$252d63de73a739bf; });
$parcel$export(module.exports, "slice", function () { return $d30ab54a4b4aa90f$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "sliceToEnd", function () { return $d30ab54a4b4aa90f$export$636515b12ce971; });
$parcel$export(module.exports, "blitUnsafe", function () { return $d30ab54a4b4aa90f$export$4893c6afb9c50600; });
$parcel$export(module.exports, "forEach", function () { return $d30ab54a4b4aa90f$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "map", function () { return $d30ab54a4b4aa90f$export$871de8747c9eaa88; });
$parcel$export(module.exports, "flatMap", function () { return $d30ab54a4b4aa90f$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "getBy", function () { return $d30ab54a4b4aa90f$export$d42617c71165e4fc; });
$parcel$export(module.exports, "getIndexBy", function () { return $d30ab54a4b4aa90f$export$165a6dc283bb948c; });
$parcel$export(module.exports, "keep", function () { return $d30ab54a4b4aa90f$export$fae3166c418e0471; });
$parcel$export(module.exports, "keepWithIndex", function () { return $d30ab54a4b4aa90f$export$3f46207acfee6bc5; });
$parcel$export(module.exports, "keepMap", function () { return $d30ab54a4b4aa90f$export$8b311cdc49e179cd; });
$parcel$export(module.exports, "forEachWithIndex", function () { return $d30ab54a4b4aa90f$export$2590cec716f5563e; });
$parcel$export(module.exports, "mapWithIndex", function () { return $d30ab54a4b4aa90f$export$8f07ddce13659f50; });
$parcel$export(module.exports, "reduce", function () { return $d30ab54a4b4aa90f$export$533b26079ad0b4b; });
$parcel$export(module.exports, "reduceReverseU", function () { return $d30ab54a4b4aa90f$export$ef531491e938ae6d; });
$parcel$export(module.exports, "reduceReverse2U", function () { return $d30ab54a4b4aa90f$export$c37d484a2f360d20; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $d30ab54a4b4aa90f$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "every", function () { return $d30ab54a4b4aa90f$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "some", function () { return $d30ab54a4b4aa90f$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "some2", function () { return $d30ab54a4b4aa90f$export$2b9a9c68d2ecbfcb; });
$parcel$export(module.exports, "joinWith", function () { return $d30ab54a4b4aa90f$export$ec1dc8fbeea3467e; });

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $5alaa = parcelRequire("5alaa");

var $loT9g = parcelRequire("loT9g");
function $d30ab54a4b4aa90f$export$3988ae62b71be9a3(arr, i) {
    if (i >= 0 && i < arr.length) return $loT9g.some(arr[i]);
}
function $d30ab54a4b4aa90f$export$2d6fda808293d631(arr, i) {
    if (!(i >= 0 && i < arr.length)) throw {
        RE_EXN_ID: "Assert_failure",
        _1: [
            "belt_Array.ml",
            35,
            2
        ],
        Error: new Error()
    };
    return arr[i];
}
function $d30ab54a4b4aa90f$export$adaa4cf7ef1b65be(arr, i, v) {
    if (i >= 0 && i < arr.length) {
        arr[i] = v;
        return true;
    } else return false;
}
function $d30ab54a4b4aa90f$export$2759592af1430f00(arr, i, v) {
    if (!(i >= 0 && i < arr.length)) throw {
        RE_EXN_ID: "Assert_failure",
        _1: [
            "belt_Array.ml",
            45,
            2
        ],
        Error: new Error()
    };
    arr[i] = v;
}
function $d30ab54a4b4aa90f$var$swapUnsafe(xs, i, j) {
    var tmp = xs[i];
    xs[i] = xs[j];
    xs[j] = tmp;
}
function $d30ab54a4b4aa90f$export$c8bbd489f517fb10(xs) {
    var len = xs.length;
    for(var i = 0; i < len; ++i)$d30ab54a4b4aa90f$var$swapUnsafe(xs, i, $5alaa.random_int(i, len));
}
function $d30ab54a4b4aa90f$export$448332262467e042(xs) {
    var result = xs.slice(0);
    $d30ab54a4b4aa90f$export$c8bbd489f517fb10(result);
    return result;
}
function $d30ab54a4b4aa90f$export$4ac24d4081114593(xs) {
    var len = xs.length;
    var ofs = 0;
    for(var i = 0, i_finish = len / 2 | 0; i < i_finish; ++i)$d30ab54a4b4aa90f$var$swapUnsafe(xs, ofs + i | 0, ((ofs + len | 0) - i | 0) - 1 | 0);
}
function $d30ab54a4b4aa90f$export$66c1ae025e96b4bc(xs) {
    var len = xs.length;
    var result = new Array(len);
    for(var i = 0; i < len; ++i)result[i] = xs[(len - 1 | 0) - i | 0];
    return result;
}
function $d30ab54a4b4aa90f$export$dd44f18ab656f3bb(l, f) {
    if (l <= 0) return [];
    var res = new Array(l);
    for(var i = 0; i < l; ++i)res[i] = f;
    return res;
}
function $d30ab54a4b4aa90f$export$790d8bf8abeeba86(l, f) {
    if (l <= 0) return [];
    var res = new Array(l);
    for(var i = 0; i < l; ++i)res[i] = f(i);
    return res;
}
function $d30ab54a4b4aa90f$export$849fbdcc2211fcde(l, f) {
    return $d30ab54a4b4aa90f$export$790d8bf8abeeba86(l, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$50f4f1c72194705e(l, f) {
    var u = $d30ab54a4b4aa90f$export$790d8bf8abeeba86(l, f);
    $d30ab54a4b4aa90f$export$c8bbd489f517fb10(u);
    return u;
}
function $d30ab54a4b4aa90f$export$e8d9b7996a060f6(l, f) {
    return $d30ab54a4b4aa90f$export$50f4f1c72194705e(l, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$d02631cccf789723(start, finish) {
    var cut = finish - start | 0;
    if (cut < 0) return [];
    var arr = new Array(cut + 1 | 0);
    for(var i = 0; i <= cut; ++i)arr[i] = start + i | 0;
    return arr;
}
function $d30ab54a4b4aa90f$export$d458fdc59efa85a1(start, finish, step) {
    var cut = finish - start | 0;
    if (cut < 0 || step <= 0) return [];
    var nb = (cut / step | 0) + 1 | 0;
    var arr = new Array(nb);
    var cur = start;
    for(var i = 0; i < nb; ++i){
        arr[i] = cur;
        cur = cur + step | 0;
    }
    return arr;
}
function $d30ab54a4b4aa90f$export$8901015135f2fb22(xs, ys) {
    var lenx = xs.length;
    var leny = ys.length;
    var len = lenx < leny ? lenx : leny;
    var s = new Array(len);
    for(var i = 0; i < len; ++i)s[i] = [
        xs[i],
        ys[i]
    ];
    return s;
}
function $d30ab54a4b4aa90f$export$35c5113aa227aa5(xs, ys, f) {
    var lenx = xs.length;
    var leny = ys.length;
    var len = lenx < leny ? lenx : leny;
    var s = new Array(len);
    for(var i = 0; i < len; ++i)s[i] = f(xs[i], ys[i]);
    return s;
}
function $d30ab54a4b4aa90f$export$d9e678742f9ba92(xs, ys, f) {
    return $d30ab54a4b4aa90f$export$35c5113aa227aa5(xs, ys, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$ee1b3e54f0441b22(a1, a2) {
    var l1 = a1.length;
    var l2 = a2.length;
    var a1a2 = new Array(l1 + l2 | 0);
    for(var i = 0; i < l1; ++i)a1a2[i] = a1[i];
    for(var i$1 = 0; i$1 < l2; ++i$1)a1a2[l1 + i$1 | 0] = a2[i$1];
    return a1a2;
}
function $d30ab54a4b4aa90f$export$252d63de73a739bf(arrs) {
    var lenArrs = arrs.length;
    var totalLen = 0;
    for(var i = 0; i < lenArrs; ++i)totalLen = totalLen + arrs[i].length | 0;
    var result = new Array(totalLen);
    totalLen = 0;
    for(var j = 0; j < lenArrs; ++j){
        var cur = arrs[j];
        for(var k = 0, k_finish = cur.length; k < k_finish; ++k){
            result[totalLen] = cur[k];
            totalLen = totalLen + 1 | 0;
        }
    }
    return result;
}
function $d30ab54a4b4aa90f$export$58adb3bec8346d0f(a, offset, len) {
    if (len <= 0) return [];
    var lena = a.length;
    var ofs = offset < 0 ? $81N94.int_max(lena + offset | 0, 0) : offset;
    var hasLen = lena - ofs | 0;
    var copyLength = hasLen < len ? hasLen : len;
    if (copyLength <= 0) return [];
    var result = new Array(copyLength);
    for(var i = 0; i < copyLength; ++i)result[i] = a[ofs + i | 0];
    return result;
}
function $d30ab54a4b4aa90f$export$636515b12ce971(a, offset) {
    var lena = a.length;
    var ofs = offset < 0 ? $81N94.int_max(lena + offset | 0, 0) : offset;
    var len = lena > ofs ? lena - ofs | 0 : 0;
    var result = new Array(len);
    for(var i = 0; i < len; ++i)result[i] = a[ofs + i | 0];
    return result;
}
function $d30ab54a4b4aa90f$export$9563e054e6f787fb(a, offset, len, v) {
    if (len <= 0) return;
    var lena = a.length;
    var ofs = offset < 0 ? $81N94.int_max(lena + offset | 0, 0) : offset;
    var hasLen = lena - ofs | 0;
    var fillLength = hasLen < len ? hasLen : len;
    if (fillLength <= 0) return;
    for(var i = ofs, i_finish = ofs + fillLength | 0; i < i_finish; ++i)a[i] = v;
}
function $d30ab54a4b4aa90f$export$4893c6afb9c50600(a1, srcofs1, a2, srcofs2, blitLength) {
    if (srcofs2 <= srcofs1) {
        for(var j = 0; j < blitLength; ++j)a2[j + srcofs2 | 0] = a1[j + srcofs1 | 0];
        return;
    }
    for(var j$1 = blitLength - 1 | 0; j$1 >= 0; --j$1)a2[j$1 + srcofs2 | 0] = a1[j$1 + srcofs1 | 0];
}
function $d30ab54a4b4aa90f$export$1b8713e12f56ba52(a1, ofs1, a2, ofs2, len) {
    var lena1 = a1.length;
    var lena2 = a2.length;
    var srcofs1 = ofs1 < 0 ? $81N94.int_max(lena1 + ofs1 | 0, 0) : ofs1;
    var srcofs2 = ofs2 < 0 ? $81N94.int_max(lena2 + ofs2 | 0, 0) : ofs2;
    var blitLength = $81N94.int_min(len, $81N94.int_min(lena1 - srcofs1 | 0, lena2 - srcofs2 | 0));
    if (srcofs2 <= srcofs1) {
        for(var j = 0; j < blitLength; ++j)a2[j + srcofs2 | 0] = a1[j + srcofs1 | 0];
        return;
    }
    for(var j$1 = blitLength - 1 | 0; j$1 >= 0; --j$1)a2[j$1 + srcofs2 | 0] = a1[j$1 + srcofs1 | 0];
}
function $d30ab54a4b4aa90f$export$e4198045b3bb8c9c(a, f) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)f(a[i]);
}
function $d30ab54a4b4aa90f$export$4b80e395e36b5a56(a, f) {
    $d30ab54a4b4aa90f$export$e4198045b3bb8c9c(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$cc22bf2a9ce99b1(a, f) {
    var l = a.length;
    var r = new Array(l);
    for(var i = 0; i < l; ++i)r[i] = f(a[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$871de8747c9eaa88(a, f) {
    return $d30ab54a4b4aa90f$export$cc22bf2a9ce99b1(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$88eb46a8b99993cf(a, f) {
    return $d30ab54a4b4aa90f$export$252d63de73a739bf($d30ab54a4b4aa90f$export$cc22bf2a9ce99b1(a, f));
}
function $d30ab54a4b4aa90f$export$5b8affa63fc6df16(a, f) {
    return $d30ab54a4b4aa90f$export$252d63de73a739bf($d30ab54a4b4aa90f$export$cc22bf2a9ce99b1(a, $iv6Yc.__1(f)));
}
function $d30ab54a4b4aa90f$export$bc39419d633f09a1(a, p) {
    var l = a.length;
    var i = 0;
    var r;
    while(r === undefined && i < l){
        var v = a[i];
        if (p(v)) r = $loT9g.some(v);
        i = i + 1 | 0;
    }
    return r;
}
function $d30ab54a4b4aa90f$export$d42617c71165e4fc(a, p) {
    return $d30ab54a4b4aa90f$export$bc39419d633f09a1(a, $iv6Yc.__1(p));
}
function $d30ab54a4b4aa90f$export$c3c636d892d6cca6(a, p) {
    var l = a.length;
    var i = 0;
    var r;
    while(r === undefined && i < l){
        var v = a[i];
        if (p(v)) r = i;
        i = i + 1 | 0;
    }
    return r;
}
function $d30ab54a4b4aa90f$export$165a6dc283bb948c(a, p) {
    return $d30ab54a4b4aa90f$export$c3c636d892d6cca6(a, $iv6Yc.__1(p));
}
function $d30ab54a4b4aa90f$export$2e45af2d40d3fd2b(a, f) {
    var l = a.length;
    var r = new Array(l);
    var j = 0;
    for(var i = 0; i < l; ++i){
        var v = a[i];
        if (f(v)) {
            r[j] = v;
            j = j + 1 | 0;
        }
    }
    r.length = j;
    return r;
}
function $d30ab54a4b4aa90f$export$fae3166c418e0471(a, f) {
    return $d30ab54a4b4aa90f$export$2e45af2d40d3fd2b(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$c322a8aa3e32d301(a, f) {
    var l = a.length;
    var r = new Array(l);
    var j = 0;
    for(var i = 0; i < l; ++i){
        var v = a[i];
        if (f(v, i)) {
            r[j] = v;
            j = j + 1 | 0;
        }
    }
    r.length = j;
    return r;
}
function $d30ab54a4b4aa90f$export$3f46207acfee6bc5(a, f) {
    return $d30ab54a4b4aa90f$export$c322a8aa3e32d301(a, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$fb6daf1607d5d777(a, f) {
    var l = a.length;
    var r = new Array(l);
    var j = 0;
    for(var i = 0; i < l; ++i){
        var v = a[i];
        var v$1 = f(v);
        if (v$1 !== undefined) {
            r[j] = $loT9g.valFromOption(v$1);
            j = j + 1 | 0;
        }
    }
    r.length = j;
    return r;
}
function $d30ab54a4b4aa90f$export$8b311cdc49e179cd(a, f) {
    return $d30ab54a4b4aa90f$export$fb6daf1607d5d777(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$fd682543f1c8c317(a, f) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)f(i, a[i]);
}
function $d30ab54a4b4aa90f$export$2590cec716f5563e(a, f) {
    $d30ab54a4b4aa90f$export$fd682543f1c8c317(a, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$4cb8e22ecd37a3cf(a, f) {
    var l = a.length;
    var r = new Array(l);
    for(var i = 0; i < l; ++i)r[i] = f(i, a[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$8f07ddce13659f50(a, f) {
    return $d30ab54a4b4aa90f$export$4cb8e22ecd37a3cf(a, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$ae643c57dec5ffec(a, x, f) {
    var r = x;
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)r = f(r, a[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$533b26079ad0b4b(a, x, f) {
    return $d30ab54a4b4aa90f$export$ae643c57dec5ffec(a, x, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$ef531491e938ae6d(a, x, f) {
    var r = x;
    for(var i = a.length - 1 | 0; i >= 0; --i)r = f(r, a[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$e11ac067bdfe867d(a, x, f) {
    return $d30ab54a4b4aa90f$export$ef531491e938ae6d(a, x, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$c37d484a2f360d20(a, b, x, f) {
    var r = x;
    var len = $81N94.int_min(a.length, b.length);
    for(var i = len - 1 | 0; i >= 0; --i)r = f(r, a[i], b[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$29d0b882e6ca8ad4(a, b, x, f) {
    return $d30ab54a4b4aa90f$export$c37d484a2f360d20(a, b, x, $iv6Yc.__3(f));
}
function $d30ab54a4b4aa90f$export$671b20c9914d5d4(a, x, f) {
    var r = x;
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)r = f(r, a[i], i);
    return r;
}
function $d30ab54a4b4aa90f$export$bbd3ef8720e22369(a, x, f) {
    return $d30ab54a4b4aa90f$export$671b20c9914d5d4(a, x, $iv6Yc.__3(f));
}
function $d30ab54a4b4aa90f$export$f294ebd954c6e224(arr, b) {
    var len = arr.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === len) return true;
        if (!b(arr[i])) return false;
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$7ecc1a3b11b57dab(arr, f) {
    return $d30ab54a4b4aa90f$export$f294ebd954c6e224(arr, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$6d4e2e7ededf6e6e(arr, b) {
    var len = arr.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === len) return false;
        if (b(arr[i])) return true;
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$ad14ef4001db2bcd(arr, f) {
    return $d30ab54a4b4aa90f$export$6d4e2e7ededf6e6e(arr, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$var$everyAux2(arr1, arr2, _i, b, len) {
    while(true){
        var i = _i;
        if (i === len) return true;
        if (!b(arr1[i], arr2[i])) return false;
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$32d47f85bf8fcd80(a, b, p) {
    return $d30ab54a4b4aa90f$var$everyAux2(a, b, 0, p, $81N94.int_min(a.length, b.length));
}
function $d30ab54a4b4aa90f$export$bb2198ede04be76f(a, b, p) {
    return $d30ab54a4b4aa90f$export$32d47f85bf8fcd80(a, b, $iv6Yc.__2(p));
}
function $d30ab54a4b4aa90f$export$febfdec44bdabfd5(a, b, p) {
    var _i = 0;
    var len = $81N94.int_min(a.length, b.length);
    while(true){
        var i = _i;
        if (i === len) return false;
        if (p(a[i], b[i])) return true;
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$2b9a9c68d2ecbfcb(a, b, p) {
    return $d30ab54a4b4aa90f$export$febfdec44bdabfd5(a, b, $iv6Yc.__2(p));
}
function $d30ab54a4b4aa90f$export$f28cee400b9bf71f(a, b, p) {
    var lena = a.length;
    var lenb = b.length;
    if (lena === lenb) return $d30ab54a4b4aa90f$var$everyAux2(a, b, 0, p, lena);
    else return false;
}
function $d30ab54a4b4aa90f$export$9663ddc1cf085b32(a, b, p) {
    return $d30ab54a4b4aa90f$export$f28cee400b9bf71f(a, b, $iv6Yc.__2(p));
}
function $d30ab54a4b4aa90f$export$c0aec0f0618831d3(a, b, p) {
    var lena = a.length;
    var lenb = b.length;
    if (lena > lenb) return 1;
    else if (lena < lenb) return -1;
    else {
        var _i = 0;
        while(true){
            var i = _i;
            if (i === lena) return 0;
            var c = p(a[i], b[i]);
            if (c !== 0) return c;
            _i = i + 1 | 0;
            continue;
        }
    }
}
function $d30ab54a4b4aa90f$export$6154dcdb7d23e37b(a, b, p) {
    return $d30ab54a4b4aa90f$export$c0aec0f0618831d3(a, b, $iv6Yc.__2(p));
}
function $d30ab54a4b4aa90f$export$5a6fbee869ed7abd(a, f) {
    var l = a.length;
    var i = 0;
    var j = 0;
    var a1 = new Array(l);
    var a2 = new Array(l);
    for(var ii = 0; ii < l; ++ii){
        var v = a[ii];
        if (f(v)) {
            a1[i] = v;
            i = i + 1 | 0;
        } else {
            a2[j] = v;
            j = j + 1 | 0;
        }
    }
    a1.length = i;
    a2.length = j;
    return [
        a1,
        a2
    ];
}
function $d30ab54a4b4aa90f$export$b29f828819edca8d(a, f) {
    return $d30ab54a4b4aa90f$export$5a6fbee869ed7abd(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$23c8d3f8757cab88(a) {
    var l = a.length;
    var a1 = new Array(l);
    var a2 = new Array(l);
    for(var i = 0; i < l; ++i){
        var match = a[i];
        a1[i] = match[0];
        a2[i] = match[1];
    }
    return [
        a1,
        a2
    ];
}
function $d30ab54a4b4aa90f$export$307cd3158c4754(a, sep, toString) {
    var l = a.length;
    if (l === 0) return "";
    var lastIndex = l - 1 | 0;
    var _i = 0;
    var _res = "";
    while(true){
        var res = _res;
        var i = _i;
        if (i === lastIndex) return res + toString(a[i]);
        _res = res + (toString(a[i]) + sep);
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$ec1dc8fbeea3467e(a, sep, toString) {
    return $d30ab54a4b4aa90f$export$307cd3158c4754(a, sep, $iv6Yc.__1(toString));
}
function $d30ab54a4b4aa90f$export$8e9de877e669511(n, f) {
    var v = new Array(n);
    for(var i = 0; i < n; ++i)v[i] = f(i);
    return v;
}
function $d30ab54a4b4aa90f$export$2cd8252107eb640b(n, f) {
    return $d30ab54a4b4aa90f$export$8e9de877e669511(n, $iv6Yc.__1(f));
}
 /* No side effect */ 
});
parcelRegister("81N94", function(module, exports) {

$parcel$export(module.exports, "int_compare", function () { return $5d8489fbba0fc2eb$export$354522a5acffad9c; });
$parcel$export(module.exports, "bool_compare", function () { return $5d8489fbba0fc2eb$export$c240aa38e4535f72; });
$parcel$export(module.exports, "float_compare", function () { return $5d8489fbba0fc2eb$export$856f195a8d3a917f; });
$parcel$export(module.exports, "string_compare", function () { return $5d8489fbba0fc2eb$export$d02a1e3d7b207b97; });
$parcel$export(module.exports, "int_min", function () { return $5d8489fbba0fc2eb$export$db1557085c62b9b9; });
$parcel$export(module.exports, "int_max", function () { return $5d8489fbba0fc2eb$export$355a5a6d39351009; });
$parcel$export(module.exports, "float_max", function () { return $5d8489fbba0fc2eb$export$42304c34585496aa; });
$parcel$export(module.exports, "i64_eq", function () { return $5d8489fbba0fc2eb$export$f55f62f23aa7e7c0; });
$parcel$export(module.exports, "i64_ge", function () { return $5d8489fbba0fc2eb$export$ac07213c4002d153; });
$parcel$export(module.exports, "i64_neq", function () { return $5d8489fbba0fc2eb$export$a47f15e99e00908d; });
$parcel$export(module.exports, "i64_lt", function () { return $5d8489fbba0fc2eb$export$175b4467bd3db13; });
$parcel$export(module.exports, "i64_gt", function () { return $5d8489fbba0fc2eb$export$1b8becaf35b9a53b; });
function $5d8489fbba0fc2eb$export$354522a5acffad9c(x, y) {
    if (x < y) return -1;
    else if (x === y) return 0;
    else return 1;
}
function $5d8489fbba0fc2eb$export$c240aa38e4535f72(x, y) {
    if (x) {
        if (y) return 0;
        else return 1;
    } else if (y) return -1;
    else return 0;
}
function $5d8489fbba0fc2eb$export$856f195a8d3a917f(x, y) {
    if (x === y) return 0;
    else if (x < y) return -1;
    else if (x > y || x === x) return 1;
    else if (y === y) return -1;
    else return 0;
}
function $5d8489fbba0fc2eb$export$d02a1e3d7b207b97(s1, s2) {
    if (s1 === s2) return 0;
    else if (s1 < s2) return -1;
    else return 1;
}
function $5d8489fbba0fc2eb$export$530c458936ea02e3(x, y) {
    if (x) return y;
    else return x;
}
function $5d8489fbba0fc2eb$export$db1557085c62b9b9(x, y) {
    if (x < y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$d8d137fb490364a5(x, y) {
    if (x < y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$dfaa2934841e6863(x, y) {
    if (x < y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$51b90cb522e2ba01(x, y) {
    if (x) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$355a5a6d39351009(x, y) {
    if (x > y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$42304c34585496aa(x, y) {
    if (x > y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$91b095ed6d71abba(x, y) {
    if (x > y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$f55f62f23aa7e7c0(x, y) {
    if (x[1] === y[1]) return x[0] === y[0];
    else return false;
}
function $5d8489fbba0fc2eb$export$ac07213c4002d153(param, param$1) {
    var other_hi = param$1[0];
    var hi = param[0];
    if (hi > other_hi) return true;
    else if (hi < other_hi) return false;
    else return param[1] >= param$1[1];
}
function $5d8489fbba0fc2eb$export$a47f15e99e00908d(x, y) {
    return !$5d8489fbba0fc2eb$export$f55f62f23aa7e7c0(x, y);
}
function $5d8489fbba0fc2eb$export$175b4467bd3db13(x, y) {
    return !$5d8489fbba0fc2eb$export$ac07213c4002d153(x, y);
}
function $5d8489fbba0fc2eb$export$1b8becaf35b9a53b(x, y) {
    if (x[0] > y[0]) return true;
    else if (x[0] < y[0]) return false;
    else return x[1] > y[1];
}
function $5d8489fbba0fc2eb$export$dca4e68e7d76d59b(x, y) {
    return !$5d8489fbba0fc2eb$export$1b8becaf35b9a53b(x, y);
}
function $5d8489fbba0fc2eb$export$500c8725a7d28fae(x, y) {
    if ($5d8489fbba0fc2eb$export$ac07213c4002d153(x, y)) return y;
    else return x;
}
function $5d8489fbba0fc2eb$export$2f5070955f9fbf0e(x, y) {
    if ($5d8489fbba0fc2eb$export$1b8becaf35b9a53b(x, y)) return x;
    else return y;
}
 /* No side effect */ 
});

parcelRegister("iv6Yc", function(module, exports) {

$parcel$export(module.exports, "app", function () { return $d7808759cc50027a$export$729c8b7179294ba; });
$parcel$export(module.exports, "_1", function () { return $d7808759cc50027a$export$6bb4ba3ef072a075; });
$parcel$export(module.exports, "__1", function () { return $d7808759cc50027a$export$cd395b1790869493; });
$parcel$export(module.exports, "_2", function () { return $d7808759cc50027a$export$ec609e2ed7190fc2; });
$parcel$export(module.exports, "__2", function () { return $d7808759cc50027a$export$9d7677205a3a0fa7; });
$parcel$export(module.exports, "_3", function () { return $d7808759cc50027a$export$24aa22226b6cf255; });
$parcel$export(module.exports, "__3", function () { return $d7808759cc50027a$export$67f030eafa9ce57; });
$parcel$export(module.exports, "_4", function () { return $d7808759cc50027a$export$86520c20d9656c74; });
$parcel$export(module.exports, "__4", function () { return $d7808759cc50027a$export$321742c2090790cd; });
$parcel$export(module.exports, "_5", function () { return $d7808759cc50027a$export$6991ae8ef79c0b2b; });
$parcel$export(module.exports, "__5", function () { return $d7808759cc50027a$export$6370d775c271b44a; });
$parcel$export(module.exports, "_6", function () { return $d7808759cc50027a$export$ab694918f6f09b83; });
$parcel$export(module.exports, "__6", function () { return $d7808759cc50027a$export$7b5cf4094c54cf84; });
$parcel$export(module.exports, "_7", function () { return $d7808759cc50027a$export$c74ac252bb0cfc27; });
$parcel$export(module.exports, "_8", function () { return $d7808759cc50027a$export$fb0020d138ee4a60; });

var $1PGgk = parcelRequire("1PGgk");
function $d7808759cc50027a$export$729c8b7179294ba(_f, _args) {
    while(true){
        var args = _args;
        var f = _f;
        var init_arity = f.length;
        var arity = init_arity === 0 ? 1 : init_arity;
        var len = args.length;
        var d = arity - len | 0;
        if (d === 0) return f.apply(null, args);
        if (d >= 0) return function(f, args) {
            return function(x) {
                return $d7808759cc50027a$export$729c8b7179294ba(f, args.concat([
                    x
                ]));
            };
        }(f, args);
        _args = $1PGgk.sub(args, arity, -d | 0);
        _f = f.apply(null, $1PGgk.sub(args, 0, arity));
        continue;
    }
}
function $d7808759cc50027a$export$6bb4ba3ef072a075(o, a0) {
    var arity = o.length;
    if (arity === 1) return o(a0);
    else switch(arity){
        case 1:
            return o(a0);
        case 2:
            return function(param) {
                return o(a0, param);
            };
        case 3:
            return function(param, param$1) {
                return o(a0, param, param$1);
            };
        case 4:
            return function(param, param$1, param$2) {
                return o(a0, param, param$1, param$2);
            };
        case 5:
            return function(param, param$1, param$2, param$3) {
                return o(a0, param, param$1, param$2, param$3);
            };
        case 6:
            return function(param, param$1, param$2, param$3, param$4) {
                return o(a0, param, param$1, param$2, param$3, param$4);
            };
        case 7:
            return function(param, param$1, param$2, param$3, param$4, param$5) {
                return o(a0, param, param$1, param$2, param$3, param$4, param$5);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0
            ]);
    }
}
function $d7808759cc50027a$export$cd395b1790869493(o) {
    var arity = o.length;
    if (arity === 1) return o;
    else return function(a0) {
        return $d7808759cc50027a$export$6bb4ba3ef072a075(o, a0);
    };
}
function $d7808759cc50027a$export$ec609e2ed7190fc2(o, a0, a1) {
    var arity = o.length;
    if (arity === 2) return o(a0, a1);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1
            ]);
        case 2:
            return o(a0, a1);
        case 3:
            return function(param) {
                return o(a0, a1, param);
            };
        case 4:
            return function(param, param$1) {
                return o(a0, a1, param, param$1);
            };
        case 5:
            return function(param, param$1, param$2) {
                return o(a0, a1, param, param$1, param$2);
            };
        case 6:
            return function(param, param$1, param$2, param$3) {
                return o(a0, a1, param, param$1, param$2, param$3);
            };
        case 7:
            return function(param, param$1, param$2, param$3, param$4) {
                return o(a0, a1, param, param$1, param$2, param$3, param$4);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1
            ]);
    }
}
function $d7808759cc50027a$export$9d7677205a3a0fa7(o) {
    var arity = o.length;
    if (arity === 2) return o;
    else return function(a0, a1) {
        return $d7808759cc50027a$export$ec609e2ed7190fc2(o, a0, a1);
    };
}
function $d7808759cc50027a$export$24aa22226b6cf255(o, a0, a1, a2) {
    var arity = o.length;
    if (arity === 3) return o(a0, a1, a2);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2
            ]);
        case 3:
            return o(a0, a1, a2);
        case 4:
            return function(param) {
                return o(a0, a1, a2, param);
            };
        case 5:
            return function(param, param$1) {
                return o(a0, a1, a2, param, param$1);
            };
        case 6:
            return function(param, param$1, param$2) {
                return o(a0, a1, a2, param, param$1, param$2);
            };
        case 7:
            return function(param, param$1, param$2, param$3) {
                return o(a0, a1, a2, param, param$1, param$2, param$3);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2
            ]);
    }
}
function $d7808759cc50027a$export$67f030eafa9ce57(o) {
    var arity = o.length;
    if (arity === 3) return o;
    else return function(a0, a1, a2) {
        return $d7808759cc50027a$export$24aa22226b6cf255(o, a0, a1, a2);
    };
}
function $d7808759cc50027a$export$86520c20d9656c74(o, a0, a1, a2, a3) {
    var arity = o.length;
    if (arity === 4) return o(a0, a1, a2, a3);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3
            ]);
        case 4:
            return o(a0, a1, a2, a3);
        case 5:
            return function(param) {
                return o(a0, a1, a2, a3, param);
            };
        case 6:
            return function(param, param$1) {
                return o(a0, a1, a2, a3, param, param$1);
            };
        case 7:
            return function(param, param$1, param$2) {
                return o(a0, a1, a2, a3, param, param$1, param$2);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3
            ]);
    }
}
function $d7808759cc50027a$export$321742c2090790cd(o) {
    var arity = o.length;
    if (arity === 4) return o;
    else return function(a0, a1, a2, a3) {
        return $d7808759cc50027a$export$86520c20d9656c74(o, a0, a1, a2, a3);
    };
}
function $d7808759cc50027a$export$6991ae8ef79c0b2b(o, a0, a1, a2, a3, a4) {
    var arity = o.length;
    if (arity === 5) return o(a0, a1, a2, a3, a4);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3,
                a4
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3,
                a4
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3,
                a4
            ]);
        case 4:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3), [
                a4
            ]);
        case 5:
            return o(a0, a1, a2, a3, a4);
        case 6:
            return function(param) {
                return o(a0, a1, a2, a3, a4, param);
            };
        case 7:
            return function(param, param$1) {
                return o(a0, a1, a2, a3, a4, param, param$1);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3,
                a4
            ]);
    }
}
function $d7808759cc50027a$export$6370d775c271b44a(o) {
    var arity = o.length;
    if (arity === 5) return o;
    else return function(a0, a1, a2, a3, a4) {
        return $d7808759cc50027a$export$6991ae8ef79c0b2b(o, a0, a1, a2, a3, a4);
    };
}
function $d7808759cc50027a$export$ab694918f6f09b83(o, a0, a1, a2, a3, a4, a5) {
    var arity = o.length;
    if (arity === 6) return o(a0, a1, a2, a3, a4, a5);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3,
                a4,
                a5
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3,
                a4,
                a5
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3,
                a4,
                a5
            ]);
        case 4:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3), [
                a4,
                a5
            ]);
        case 5:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4), [
                a5
            ]);
        case 6:
            return o(a0, a1, a2, a3, a4, a5);
        case 7:
            return function(param) {
                return o(a0, a1, a2, a3, a4, a5, param);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3,
                a4,
                a5
            ]);
    }
}
function $d7808759cc50027a$export$7b5cf4094c54cf84(o) {
    var arity = o.length;
    if (arity === 6) return o;
    else return function(a0, a1, a2, a3, a4, a5) {
        return $d7808759cc50027a$export$ab694918f6f09b83(o, a0, a1, a2, a3, a4, a5);
    };
}
function $d7808759cc50027a$export$c74ac252bb0cfc27(o, a0, a1, a2, a3, a4, a5, a6) {
    var arity = o.length;
    if (arity === 7) return o(a0, a1, a2, a3, a4, a5, a6);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3,
                a4,
                a5,
                a6
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3,
                a4,
                a5,
                a6
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3,
                a4,
                a5,
                a6
            ]);
        case 4:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3), [
                a4,
                a5,
                a6
            ]);
        case 5:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4), [
                a5,
                a6
            ]);
        case 6:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4, a5), [
                a6
            ]);
        case 7:
            return o(a0, a1, a2, a3, a4, a5, a6);
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3,
                a4,
                a5,
                a6
            ]);
    }
}
function $d7808759cc50027a$export$23d6e11d6b3715bb(o) {
    var arity = o.length;
    if (arity === 7) return o;
    else return function(a0, a1, a2, a3, a4, a5, a6) {
        return $d7808759cc50027a$export$c74ac252bb0cfc27(o, a0, a1, a2, a3, a4, a5, a6);
    };
}
function $d7808759cc50027a$export$fb0020d138ee4a60(o, a0, a1, a2, a3, a4, a5, a6, a7) {
    var arity = o.length;
    if (arity === 8) return o(a0, a1, a2, a3, a4, a5, a6, a7);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3,
                a4,
                a5,
                a6,
                a7
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3,
                a4,
                a5,
                a6,
                a7
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3,
                a4,
                a5,
                a6,
                a7
            ]);
        case 4:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3), [
                a4,
                a5,
                a6,
                a7
            ]);
        case 5:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4), [
                a5,
                a6,
                a7
            ]);
        case 6:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4, a5), [
                a6,
                a7
            ]);
        case 7:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4, a5, a6), [
                a7
            ]);
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3,
                a4,
                a5,
                a6,
                a7
            ]);
    }
}
function $d7808759cc50027a$export$23302abb4f52e562(o) {
    var arity = o.length;
    if (arity === 8) return o;
    else return function(a0, a1, a2, a3, a4, a5, a6, a7) {
        return $d7808759cc50027a$export$fb0020d138ee4a60(o, a0, a1, a2, a3, a4, a5, a6, a7);
    };
}
 /* No side effect */ 
});
parcelRegister("1PGgk", function(module, exports) {

$parcel$export(module.exports, "sub", function () { return $155b5649ad275916$export$f93b5905241a7cca; });
$parcel$export(module.exports, "concat", function () { return $155b5649ad275916$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "set", function () { return $155b5649ad275916$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "get", function () { return $155b5649ad275916$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "make", function () { return $155b5649ad275916$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "make_float", function () { return $155b5649ad275916$export$d79c6918e0a9d9af; });
$parcel$export(module.exports, "blit", function () { return $155b5649ad275916$export$1b8713e12f56ba52; });
function $155b5649ad275916$export$f93b5905241a7cca(x, offset, len) {
    var result = new Array(len);
    var j = 0;
    var i = offset;
    while(j < len){
        result[j] = x[i];
        j = j + 1 | 0;
        i = i + 1 | 0;
    }
    return result;
}
function $155b5649ad275916$var$len(_acc, _l) {
    while(true){
        var l = _l;
        var acc = _acc;
        if (!l) return acc;
        _l = l.tl;
        _acc = l.hd.length + acc | 0;
        continue;
    }
}
function $155b5649ad275916$var$fill(arr, _i, _l) {
    while(true){
        var l = _l;
        var i = _i;
        if (!l) return;
        var x = l.hd;
        var l$1 = x.length;
        var k = i;
        var j = 0;
        while(j < l$1){
            arr[k] = x[j];
            k = k + 1 | 0;
            j = j + 1 | 0;
        }
        _l = l.tl;
        _i = k;
        continue;
    }
}
function $155b5649ad275916$export$ee1b3e54f0441b22(l) {
    var v = $155b5649ad275916$var$len(0, l);
    var result = new Array(v);
    $155b5649ad275916$var$fill(result, 0, l);
    return result;
}
function $155b5649ad275916$export$adaa4cf7ef1b65be(xs, index, newval) {
    if (index < 0 || index >= xs.length) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "index out of bounds",
        Error: new Error()
    };
    xs[index] = newval;
}
function $155b5649ad275916$export$3988ae62b71be9a3(xs, index) {
    if (index < 0 || index >= xs.length) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "index out of bounds",
        Error: new Error()
    };
    return xs[index];
}
function $155b5649ad275916$export$dd44f18ab656f3bb(len, init) {
    var b = new Array(len);
    for(var i = 0; i < len; ++i)b[i] = init;
    return b;
}
function $155b5649ad275916$export$d79c6918e0a9d9af(len) {
    var b = new Array(len);
    for(var i = 0; i < len; ++i)b[i] = 0;
    return b;
}
function $155b5649ad275916$export$1b8713e12f56ba52(a1, i1, a2, i2, len) {
    if (i2 <= i1) {
        for(var j = 0; j < len; ++j)a2[j + i2 | 0] = a1[j + i1 | 0];
        return;
    }
    for(var j$1 = len - 1 | 0; j$1 >= 0; --j$1)a2[j$1 + i2 | 0] = a1[j$1 + i1 | 0];
}
function $155b5649ad275916$export$f4427c3005d2d1a9(prim) {
    return prim.slice(0);
}
 /* No side effect */ 
});


parcelRegister("5alaa", function(module, exports) {

$parcel$export(module.exports, "floor_int", function () { return $3c2e4d6ea9997d35$export$9c44a373dcac123d; });
$parcel$export(module.exports, "random_int", function () { return $3c2e4d6ea9997d35$export$ffc8773aa9b24c08; });
$parcel$export(module.exports, "ceil", function () { return $3c2e4d6ea9997d35$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "floor", function () { return $3c2e4d6ea9997d35$export$a3fe094919f356fd; });

var $dQgXi = parcelRequire("dQgXi");
function $3c2e4d6ea9997d35$export$8c9e53b937a7ea1a(prim) {
    return Math.ceil(prim);
}
function $3c2e4d6ea9997d35$export$5a67a7133f8be3ef(f) {
    if (f > $dQgXi.max) return $dQgXi.max;
    else if (f < $dQgXi.min) return $dQgXi.min;
    else return Math.ceil(f);
}
function $3c2e4d6ea9997d35$export$ff8f5b2ad008fc0e(prim) {
    return Math.floor(prim);
}
function $3c2e4d6ea9997d35$export$9c44a373dcac123d(f) {
    if (f > $dQgXi.max) return $dQgXi.max;
    else if (f < $dQgXi.min) return $dQgXi.min;
    else return Math.floor(f);
}
function $3c2e4d6ea9997d35$export$ffc8773aa9b24c08(min, max) {
    return $3c2e4d6ea9997d35$export$9c44a373dcac123d(Math.random() * (max - min | 0)) + min | 0;
}
var $3c2e4d6ea9997d35$export$803ce6b71a0a94b2 = $3c2e4d6ea9997d35$export$5a67a7133f8be3ef;
var $3c2e4d6ea9997d35$export$a3fe094919f356fd = $3c2e4d6ea9997d35$export$9c44a373dcac123d;
 /* No side effect */ 
});
parcelRegister("dQgXi", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $a13d48b421e31b62$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $a13d48b421e31b62$export$96ec731ed4dcb222; });
function $a13d48b421e31b62$export$411ce8e5a71e3069(x, y) {
    return x === y;
}
var $a13d48b421e31b62$export$8960430cfd85939f = 2147483647;
var $a13d48b421e31b62$export$96ec731ed4dcb222 = -2147483648;
 /* No side effect */ 
});


parcelRegister("loT9g", function(module, exports) {

$parcel$export(module.exports, "some", function () { return $f9469e32778ad918$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "nullable_to_opt", function () { return $f9469e32778ad918$export$73807854efd48d62; });
$parcel$export(module.exports, "undefined_to_opt", function () { return $f9469e32778ad918$export$daa96954a277296c; });
$parcel$export(module.exports, "null_to_opt", function () { return $f9469e32778ad918$export$3370544e9afcd152; });
$parcel$export(module.exports, "valFromOption", function () { return $f9469e32778ad918$export$2d819ee58e195d2e; });
function $f9469e32778ad918$export$4a8d4869baca50f2(x) {
    return x.BS_PRIVATE_NESTED_SOME_NONE !== undefined;
}
function $f9469e32778ad918$export$ad14ef4001db2bcd(x) {
    if (x === undefined) return {
        BS_PRIVATE_NESTED_SOME_NONE: 0
    };
    else if (x !== null && x.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return {
        BS_PRIVATE_NESTED_SOME_NONE: x.BS_PRIVATE_NESTED_SOME_NONE + 1 | 0
    };
    else return x;
}
function $f9469e32778ad918$export$73807854efd48d62(x) {
    if (x == null) return;
    else return $f9469e32778ad918$export$ad14ef4001db2bcd(x);
}
function $f9469e32778ad918$export$daa96954a277296c(x) {
    if (x === undefined) return;
    else return $f9469e32778ad918$export$ad14ef4001db2bcd(x);
}
function $f9469e32778ad918$export$3370544e9afcd152(x) {
    if (x === null) return;
    else return $f9469e32778ad918$export$ad14ef4001db2bcd(x);
}
function $f9469e32778ad918$export$2d819ee58e195d2e(x) {
    if (!(x !== null && x.BS_PRIVATE_NESTED_SOME_NONE !== undefined)) return x;
    var depth = x.BS_PRIVATE_NESTED_SOME_NONE;
    if (depth === 0) return;
    else return {
        BS_PRIVATE_NESTED_SOME_NONE: depth - 1 | 0
    };
}
function $f9469e32778ad918$export$953ca920446a35(x) {
    if (x === undefined) return;
    else return $f9469e32778ad918$export$2d819ee58e195d2e(x);
}
function $f9469e32778ad918$export$4a9d7f619f776b55(x) {
    if (x !== undefined) return x.VAL;
    else return x;
}
 /* No side effect */ 
});


parcelRegister("2whNH", function(module, exports) {

$parcel$export(module.exports, "keep", function () { return $1d5c60bfdfc55398$export$fae3166c418e0471; });
$parcel$export(module.exports, "forEach", function () { return $1d5c60bfdfc55398$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "mapWithDefault", function () { return $1d5c60bfdfc55398$export$ae51aac33fd70d30; });
$parcel$export(module.exports, "map", function () { return $1d5c60bfdfc55398$export$871de8747c9eaa88; });
$parcel$export(module.exports, "flatMap", function () { return $1d5c60bfdfc55398$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "getWithDefault", function () { return $1d5c60bfdfc55398$export$73b8ef55a37133c7; });
$parcel$export(module.exports, "orElse", function () { return $1d5c60bfdfc55398$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "isSome", function () { return $1d5c60bfdfc55398$export$5d7e502287836e58; });
$parcel$export(module.exports, "isNone", function () { return $1d5c60bfdfc55398$export$e56af863d5645d5f; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");
function $1d5c60bfdfc55398$export$2e45af2d40d3fd2b(opt, p) {
    if (opt !== undefined && p($loT9g.valFromOption(opt))) return opt;
}
function $1d5c60bfdfc55398$export$fae3166c418e0471(opt, p) {
    return $1d5c60bfdfc55398$export$2e45af2d40d3fd2b(opt, $iv6Yc.__1(p));
}
function $1d5c60bfdfc55398$export$e4198045b3bb8c9c(opt, f) {
    if (opt !== undefined) return f($loT9g.valFromOption(opt));
}
function $1d5c60bfdfc55398$export$4b80e395e36b5a56(opt, f) {
    $1d5c60bfdfc55398$export$e4198045b3bb8c9c(opt, $iv6Yc.__1(f));
}
function $1d5c60bfdfc55398$export$2d6fda808293d631(x) {
    if (x !== undefined) return $loT9g.valFromOption(x);
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function $1d5c60bfdfc55398$export$28a83b3631ef8d34(opt, $$default, f) {
    if (opt !== undefined) return f($loT9g.valFromOption(opt));
    else return $$default;
}
function $1d5c60bfdfc55398$export$ae51aac33fd70d30(opt, $$default, f) {
    return $1d5c60bfdfc55398$export$28a83b3631ef8d34(opt, $$default, $iv6Yc.__1(f));
}
function $1d5c60bfdfc55398$export$cc22bf2a9ce99b1(opt, f) {
    if (opt !== undefined) return $loT9g.some(f($loT9g.valFromOption(opt)));
}
function $1d5c60bfdfc55398$export$871de8747c9eaa88(opt, f) {
    return $1d5c60bfdfc55398$export$cc22bf2a9ce99b1(opt, $iv6Yc.__1(f));
}
function $1d5c60bfdfc55398$export$88eb46a8b99993cf(opt, f) {
    if (opt !== undefined) return f($loT9g.valFromOption(opt));
}
function $1d5c60bfdfc55398$export$5b8affa63fc6df16(opt, f) {
    return $1d5c60bfdfc55398$export$88eb46a8b99993cf(opt, $iv6Yc.__1(f));
}
function $1d5c60bfdfc55398$export$73b8ef55a37133c7(opt, $$default) {
    if (opt !== undefined) return $loT9g.valFromOption(opt);
    else return $$default;
}
function $1d5c60bfdfc55398$export$41d1a04d78e7b141(opt, other) {
    if (opt !== undefined) return opt;
    else return other;
}
function $1d5c60bfdfc55398$export$5d7e502287836e58(param) {
    return param !== undefined;
}
function $1d5c60bfdfc55398$export$e56af863d5645d5f(x) {
    return x === undefined;
}
function $1d5c60bfdfc55398$export$f28cee400b9bf71f(a, b, f) {
    if (a !== undefined) {
        if (b !== undefined) return f($loT9g.valFromOption(a), $loT9g.valFromOption(b));
        else return false;
    } else return b === undefined;
}
function $1d5c60bfdfc55398$export$9663ddc1cf085b32(a, b, f) {
    return $1d5c60bfdfc55398$export$f28cee400b9bf71f(a, b, $iv6Yc.__2(f));
}
function $1d5c60bfdfc55398$export$c0aec0f0618831d3(a, b, f) {
    if (a !== undefined) {
        if (b !== undefined) return f($loT9g.valFromOption(a), $loT9g.valFromOption(b));
        else return 1;
    } else if (b !== undefined) return -1;
    else return 0;
}
function $1d5c60bfdfc55398$export$6154dcdb7d23e37b(a, b, f) {
    return $1d5c60bfdfc55398$export$c0aec0f0618831d3(a, b, $iv6Yc.__2(f));
}
 /* No side effect */ 
});

parcelRegister("2gwg0", function(module, exports) {

$parcel$export(module.exports, "isShopify", function () { return $1a6618ff3241895e$export$55e72648ecf74d00; });
$parcel$export(module.exports, "getShop", function () { return $1a6618ff3241895e$export$94a798e7920ff647; });
$parcel$export(module.exports, "getCountry", function () { return $1a6618ff3241895e$export$a27f7d52d5670305; });
$parcel$export(module.exports, "getLanguage", function () { return $1a6618ff3241895e$export$64783e31db14f0ba; });
$parcel$export(module.exports, "makeUrl", function () { return $1a6618ff3241895e$export$e98ca45c96b2aafe; });
$parcel$export(module.exports, "makeCoverUrl", function () { return $1a6618ff3241895e$export$5b34c872bd037cc3; });
$parcel$export(module.exports, "isShopifyImg", function () { return $1a6618ff3241895e$export$d61d1a5886754ed1; });
$parcel$export(module.exports, "getCheckoutLink", function () { return $1a6618ff3241895e$export$2a04187f21f7a890; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $bygWp = parcelRequire("bygWp");
function $1a6618ff3241895e$export$55e72648ecf74d00(param) {
    return $2whNH.isSome(window.Shopify);
}
function $1a6618ff3241895e$export$94a798e7920ff647(param) {
    return $2whNH.flatMap(window.Shopify, function(shopify) {
        return shopify.shop;
    });
}
function $1a6618ff3241895e$export$a27f7d52d5670305(param) {
    return $2whNH.flatMap(window.Shopify, function(shopify) {
        return shopify.country;
    });
}
function $1a6618ff3241895e$export$64783e31db14f0ba(param) {
    return $2whNH.flatMap(window.Shopify, function(shopify) {
        return shopify.locale;
    });
}
function $1a6618ff3241895e$export$a8eb35c07a9de52(__x) {
    return __x.replace(/(_\d+x(\d+|)).(\w{3,4}\?)/, ".$3");
}
function $1a6618ff3241895e$export$e98ca45c96b2aafe(url, w, h, dprOpt, unit) {
    var dpr = dprOpt !== undefined ? dprOpt : 1;
    var url$1 = $1a6618ff3241895e$export$a8eb35c07a9de52(url);
    var width = $2whNH.mapWithDefault(w, "", function(w) {
        return "&width=" + String(Math.imul(w, dpr));
    });
    var height = $2whNH.mapWithDefault(h, "", function(h) {
        return "&height=" + String(Math.imul(h, dpr));
    });
    return url$1 + width + height;
}
function $1a6618ff3241895e$export$5b34c872bd037cc3(url, w, h, naturalWidth, naturalHeight, dprOpt, unit) {
    var dpr = dprOpt !== undefined ? dprOpt : 1;
    var url$1 = $1a6618ff3241895e$export$a8eb35c07a9de52(url);
    var param;
    if (w !== undefined && h !== undefined) {
        if (naturalWidth !== undefined) {
            if (naturalHeight !== undefined) {
                var dw = w / naturalWidth;
                var dh = h / naturalHeight;
                param = dh < dw ? "&width=" + String(Math.imul(w, dpr)) + "" : "&height=" + String(Math.imul(h, dpr)) + "";
            } else param = "";
        } else param = naturalHeight !== undefined ? "" : h < w ? "&width=" + String(Math.imul(w, dpr)) + "" : "&height=" + String(Math.imul(h, dpr)) + "";
    } else param = "";
    return url$1 + param;
}
function $1a6618ff3241895e$export$d61d1a5886754ed1(src) {
    return src.includes("cdn.shopify.com");
}
function $1a6618ff3241895e$export$2a04187f21f7a890(cart, clientId, transitiveStore, checkoutLink) {
    var getVariantId = function getVariantId(variantId, url) {
        var isNumeric = variantId.length === $2whNH.getWithDefault($2whNH.getWithDefault($i7mYY.get($2whNH.getWithDefault($loT9g.null_to_opt(variantId.match(/([0-9]+)/)), []), 0), undefined), "").length;
        var variantIdFromLink = $i7mYY.get($2whNH.getWithDefault($loT9g.null_to_opt($2whNH.getWithDefault(url, "").match(/variant=([0-9]+)/)), []), 1);
        if (isNumeric) return variantId;
        if (variantIdFromLink === undefined) return variantId;
        var variantIdFromLink$1 = $loT9g.valFromOption(variantIdFromLink);
        if (variantIdFromLink$1 !== undefined) return variantIdFromLink$1;
        else return variantId;
    };
    var baseUrl = $2whNH.map($2whNH.flatMap(checkoutLink, $bygWp.maybeMakeUrl), function(prim) {
        return prim.origin;
    });
    return $2whNH.map($2whNH.flatMap(baseUrl, $bygWp.maybeMakeUrl), function(baseUrl) {
        var queryParams = [];
        var token = $2whNH.flatMap(transitiveStore, function(store) {
            return store.shopifyStorefrontAccessToken;
        });
        var queryParams$1 = token !== undefined ? $i7mYY.concat(queryParams, [
            "access_token=" + token + ""
        ]) : queryParams;
        var queryParams$2 = clientId !== undefined ? $i7mYY.concat(queryParams$1, [
            "ref=mkr|" + clientId[0] + "|" + clientId[1] + ""
        ]) : queryParams$1;
        var queryParams$3 = $i7mYY.joinWith(queryParams$2, "&", function(a) {
            return a;
        });
        var queryParams$4 = queryParams$3 === "" ? "" : "?" + queryParams$3;
        return baseUrl.origin + "/cart/" + $i7mYY.joinWith($2whNH.mapWithDefault(cart, [], function(cart) {
            return cart.items;
        }), ",", function(param) {
            return getVariantId(param.variantId, param.url) + ":" + String(param.quantity);
        }) + queryParams$4;
    });
}
 /* No side effect */ 
});
parcelRegister("bygWp", function(module, exports) {

$parcel$export(module.exports, "getEstimatedVideoMimeFromUrl", function () { return $869002d3db994acc$export$b7f4c428112a07ab; });
$parcel$export(module.exports, "addProtocolIfMissing", function () { return $869002d3db994acc$export$54a0c441cd72babc; });
$parcel$export(module.exports, "resolveRelativePath", function () { return $869002d3db994acc$export$d3e288fe2560b9f7; });
$parcel$export(module.exports, "maybeMakeUrl", function () { return $869002d3db994acc$export$f37acb312a335172; });
$parcel$export(module.exports, "getCanonical", function () { return $869002d3db994acc$export$2c10ae20b5734e88; });
$parcel$export(module.exports, "getCurrentHostname", function () { return $869002d3db994acc$export$c41f2426343a61c1; });
$parcel$export(module.exports, "getCurrentUrl", function () { return $869002d3db994acc$export$dc90482e4ef07afd; });
$parcel$export(module.exports, "getPathname", function () { return $869002d3db994acc$export$b829272b1dcc6798; });
$parcel$export(module.exports, "getParam", function () { return $869002d3db994acc$export$ecf541e09a511845; });
$parcel$export(module.exports, "changeParam", function () { return $869002d3db994acc$export$83a2651f56a4b1d8; });
$parcel$export(module.exports, "deleteParamWithRegex", function () { return $869002d3db994acc$export$aea854206f351518; });
$parcel$export(module.exports, "addHostnameMaybe", function () { return $869002d3db994acc$export$6abdb4c09c2e81a1; });
$parcel$export(module.exports, "maybeMakeRelativeUrl", function () { return $869002d3db994acc$export$c7b1edcbf49dfe63; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $oO3sB = parcelRequire("oO3sB");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $869002d3db994acc$export$b7f4c428112a07ab(src) {
    var parts = $i7mYY.get($i7mYY.keepMap($2whNH.getWithDefault($loT9g.null_to_opt($2whNH.getWithDefault($i7mYY.get(src.split("?"), 0), "").toLowerCase().match(/(.mp4|.m3u8|.mov)$/)), []), function(a) {
        return a;
    }), 0);
    if (parts === undefined) return;
    switch(parts){
        case ".m3u8":
            return "application/x-mpegURL";
        case ".mov":
            return "video/quicktime";
        case ".mp4":
            return "video/mp4";
        default:
            return;
    }
}
function $869002d3db994acc$export$fde0ca51e692f9(src) {
    return $2whNH.isSome($869002d3db994acc$export$b7f4c428112a07ab(src));
}
function $869002d3db994acc$export$54a0c441cd72babc(str) {
    var isMissingProtocol = !/^([^\/])+:\/\//.test(str) && !/^\/([^\/]+)/.test(str) && str.trim() !== "";
    if (isMissingProtocol) return str.replace(/^(?:(.*:)?\/\/)?(.*)/i, "https://$2");
    else return str;
}
function $869002d3db994acc$export$d3e288fe2560b9f7(relativePath) {
    var isRelativePath = relativePath.startsWith("/");
    if (isRelativePath) return window.location.origin + relativePath;
    else return relativePath;
}
function $869002d3db994acc$export$f37acb312a335172(url) {
    try {
        return $loT9g.some(new URL(url));
    } catch (e) {
        return;
    }
}
function $869002d3db994acc$export$2c10ae20b5734e88(param) {
    var link = $2whNH.flatMap($2whNH.map($loT9g.nullable_to_opt(document.querySelector("link[rel='canonical']")), function(el) {
        return $loT9g.nullable_to_opt(el.getAttribute("href"));
    }), function(href) {
        if (href === "") return;
        else return href;
    });
    var link$1;
    if (link !== undefined) link$1 = link;
    else {
        var $$location = window.location;
        link$1 = $$location.origin + $$location.pathname;
    }
    var link$2 = $2whNH.isSome($loT9g.null_to_opt(link$1.match(/^http/))) ? link$1 : "https://" + link$1;
    var url = $869002d3db994acc$export$f37acb312a335172(link$2);
    if (url === undefined) return "";
    var url$1 = $loT9g.valFromOption(url);
    $i7mYY.forEach($i7mYY.keep(Array.from(url$1.searchParams.keys()), function(param) {
        return $oO3sB.includes("QN", param);
    }), function(key) {
        url$1.searchParams.delete(key);
    });
    return url$1.toString();
}
function $869002d3db994acc$export$c41f2426343a61c1(param) {
    return window.location.hostname;
}
function $869002d3db994acc$export$dc90482e4ef07afd(param) {
    return window.location.href;
}
function $869002d3db994acc$export$e61aef4ae55da883(input) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url !== undefined) return $loT9g.valFromOption(url).hostname;
}
function $869002d3db994acc$export$b829272b1dcc6798(input) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url !== undefined) return $loT9g.valFromOption(url).pathname;
}
function $869002d3db994acc$export$ecf541e09a511845(input, key) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url !== undefined) return $loT9g.nullable_to_opt($loT9g.valFromOption(url).searchParams.get(key));
}
function $869002d3db994acc$export$83a2651f56a4b1d8(input, key, value) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url === undefined) return input;
    var url$1 = $loT9g.valFromOption(url);
    if (value !== undefined) url$1.searchParams.set(key, value);
    else url$1.searchParams.delete(key);
    return url$1.toString();
}
function $869002d3db994acc$export$aea854206f351518(input, keyRe) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url === undefined) return input;
    var url$1 = $loT9g.valFromOption(url);
    $i7mYY.forEach($i7mYY.keep(Array.from(url$1.searchParams.keys()), function(param) {
        return keyRe.test(param);
    }), function(key) {
        url$1.searchParams.delete(key);
    });
    return url$1.toString();
}
function $869002d3db994acc$export$6abdb4c09c2e81a1(url, hostname) {
    var match = $869002d3db994acc$export$e61aef4ae55da883(url);
    if (match !== undefined) return url;
    else return hostname + url;
}
function $869002d3db994acc$export$c7b1edcbf49dfe63(url) {
    var urlObj = $869002d3db994acc$export$f37acb312a335172(url);
    return $2whNH.mapWithDefault(urlObj, url, function(obj) {
        if (obj.hostname === window.location.hostname) return obj.pathname + obj.search + obj.hash;
        else return obj.href;
    });
}
 /* No side effect */ 
});
parcelRegister("oO3sB", function(module, exports) {

$parcel$export(module.exports, "includes", function () { return $04a911d9514e6a54$export$ee2e0f811dca1807; });
$parcel$export(module.exports, "match_", function () { return $04a911d9514e6a54$export$cdda381943c99125; });
$parcel$export(module.exports, "split", function () { return $04a911d9514e6a54$export$65980d18b75784e2; });
$parcel$export(module.exports, "splitByRe", function () { return $04a911d9514e6a54$export$d3429aad18808f65; });
$parcel$export(module.exports, "substr", function () { return $04a911d9514e6a54$export$2f35ab04d2335697; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");

var $e1M2F = parcelRequire("e1M2F");
function $04a911d9514e6a54$export$bbcf894add1d392c(arg1, obj) {
    return obj.charAt(arg1);
}
function $04a911d9514e6a54$export$c0c1d67d36c309b0(arg1, obj) {
    return obj.charCodeAt(arg1);
}
function $04a911d9514e6a54$export$42977f40461e1360(arg1, obj) {
    return obj.codePointAt(arg1);
}
function $04a911d9514e6a54$export$ee1b3e54f0441b22(arg1, obj) {
    return obj.concat(arg1);
}
function $04a911d9514e6a54$export$252d63de73a739bf(arg1, obj) {
    return $e1M2F.spliceObjApply(obj, "concat", [
        arg1
    ]);
}
function $04a911d9514e6a54$export$10fdab3683b55b22(arg1, obj) {
    return obj.endsWith(arg1);
}
function $04a911d9514e6a54$export$d6b198f3d68b24db(arg1, arg2, obj) {
    return obj.endsWith(arg1, arg2);
}
function $04a911d9514e6a54$export$ee2e0f811dca1807(arg1, obj) {
    return obj.includes(arg1);
}
function $04a911d9514e6a54$export$92bc748dfba5c3(arg1, arg2, obj) {
    return obj.includes(arg1, arg2);
}
function $04a911d9514e6a54$export$305f7d4e9d4624f2(arg1, obj) {
    return obj.indexOf(arg1);
}
function $04a911d9514e6a54$export$3840751aad9a3d1c(arg1, arg2, obj) {
    return obj.indexOf(arg1, arg2);
}
function $04a911d9514e6a54$export$557cfb7ed375eeb7(arg1, obj) {
    return obj.lastIndexOf(arg1);
}
function $04a911d9514e6a54$export$4a78c614e5d162c5(arg1, arg2, obj) {
    return obj.lastIndexOf(arg1, arg2);
}
function $04a911d9514e6a54$export$35652c12e6caefdf(arg1, obj) {
    return obj.localeCompare(arg1);
}
function $04a911d9514e6a54$export$cdda381943c99125(arg1, obj) {
    return $loT9g.null_to_opt(obj.match(arg1));
}
function $04a911d9514e6a54$export$cec6843133747b7a(arg1, obj) {
    return obj.normalize(arg1);
}
function $04a911d9514e6a54$export$76d90c956114f2c2(arg1, obj) {
    return obj.repeat(arg1);
}
function $04a911d9514e6a54$export$77ad94ebf1c2b9ed(arg1, arg2, obj) {
    return obj.replace(arg1, arg2);
}
function $04a911d9514e6a54$export$bb211dc63ac1cd60(arg1, arg2, obj) {
    return obj.replace(arg1, arg2);
}
function $04a911d9514e6a54$export$7869610114f2a6db(arg1, arg2, obj) {
    return obj.replace(arg1, $iv6Yc.__3(arg2));
}
function $04a911d9514e6a54$export$72af1fe9efa233b9(arg1, arg2, obj) {
    return obj.replace(arg1, $iv6Yc.__4(arg2));
}
function $04a911d9514e6a54$export$6cde2f74b467cfda(arg1, arg2, obj) {
    return obj.replace(arg1, $iv6Yc.__5(arg2));
}
function $04a911d9514e6a54$export$c24f5eff759a8aa8(arg1, arg2, obj) {
    return obj.replace(arg1, $iv6Yc.__6(arg2));
}
function $04a911d9514e6a54$export$d76128d007d19019(arg1, obj) {
    return obj.search(arg1);
}
function $04a911d9514e6a54$export$58adb3bec8346d0f(from, to_, obj) {
    return obj.slice(from, to_);
}
function $04a911d9514e6a54$export$636515b12ce971(from, obj) {
    return obj.slice(from);
}
function $04a911d9514e6a54$export$65980d18b75784e2(arg1, obj) {
    return obj.split(arg1);
}
function $04a911d9514e6a54$export$a8fe09dfdc2aaa22(arg1, limit, obj) {
    return obj.split(arg1, limit);
}
function $04a911d9514e6a54$export$d3429aad18808f65(arg1, obj) {
    return obj.split(arg1);
}
function $04a911d9514e6a54$export$c1daf8ec930c1b4e(arg1, limit, obj) {
    return obj.split(arg1, limit);
}
function $04a911d9514e6a54$export$68326237475e9a7d(arg1, obj) {
    return obj.startsWith(arg1);
}
function $04a911d9514e6a54$export$dfe4dcb5aa627eb2(arg1, arg2, obj) {
    return obj.startsWith(arg1, arg2);
}
function $04a911d9514e6a54$export$2f35ab04d2335697(from, obj) {
    return obj.substr(from);
}
function $04a911d9514e6a54$export$d7de59369970b89d(from, length, obj) {
    return obj.substr(from, length);
}
function $04a911d9514e6a54$export$662d3818631fba36(from, to_, obj) {
    return obj.substring(from, to_);
}
function $04a911d9514e6a54$export$7137b6142d2c0135(from, obj) {
    return obj.substring(from);
}
function $04a911d9514e6a54$export$2e2992790a6f69a8(arg1, obj) {
    return obj.anchor(arg1);
}
function $04a911d9514e6a54$export$9c30223ca0a664fb(arg1, obj) {
    return obj.link(arg1);
}
 /* No side effect */ 
});
parcelRegister("e1M2F", function(module, exports) {

$parcel$export(module.exports, "spliceObjApply", function () { return $a3666ccefeabf94f$export$38bd5c25b9c03fdc; });
var $a3666ccefeabf94f$export$b883dd1aeef19298 = function spliceApply(fn, args) {
    var i, argLen;
    argLen = args.length;
    var applied = [];
    for(i = 0; i < argLen - 1; ++i)applied.push(args[i]);
    var lastOne = args[argLen - 1];
    for(i = 0; i < lastOne.length; ++i)applied.push(lastOne[i]);
    return fn.apply(null, applied);
};
var $a3666ccefeabf94f$export$4fb8f84441cf41b = function spliceNewApply(ctor, args) {
    var i, argLen;
    argLen = args.length;
    var applied = [
        null
    ] // Function.prototype.bind.apply(fn, args) requires the first element in `args` to be `null`
    ;
    for(i = 0; i < argLen - 1; ++i)applied.push(args[i]);
    var lastOne = args[argLen - 1];
    for(i = 0; i < lastOne.length; ++i)applied.push(lastOne[i]);
    var C = Function.prototype.bind.apply(ctor, applied);
    return new C();
};
var $a3666ccefeabf94f$export$38bd5c25b9c03fdc = function spliceObjApply(obj, name, args) {
    var i, argLen;
    argLen = args.length;
    var applied = [];
    for(i = 0; i < argLen - 1; ++i)applied.push(args[i]);
    var lastOne = args[argLen - 1];
    for(i = 0; i < lastOne.length; ++i)applied.push(lastOne[i]);
    return obj[name].apply(obj, applied);
};
 /* No side effect */ 
});




parcelRegister("dJ00A", function(module, exports) {

$parcel$export(module.exports, "isAltFunnel", function () { return $9fdf7c0153f60f3f$export$9757da9f9bbb9c14; });
$parcel$export(module.exports, "setupAltFunnelElement", function () { return $9fdf7c0153f60f3f$export$562500b99c3c89c; });
$parcel$export(module.exports, "appendBottomBar", function () { return $9fdf7c0153f60f3f$export$c8603593494de511; });
$parcel$export(module.exports, "updateAltFunnelVariant", function () { return $9fdf7c0153f60f3f$export$4289ce05efcce874; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ceAXu = parcelRequire("ceAXu");

var $7GW0c = parcelRequire("7GW0c");

var $cdK26 = parcelRequire("cdK26");
function $9fdf7c0153f60f3f$export$606c153358defcb8(param) {
    try {
        return $loT9g.nullable_to_opt(new URL(window.location.href).searchParams.get("QNConfigId__alt"));
    } catch (exn) {
        return;
    }
}
function $9fdf7c0153f60f3f$export$9757da9f9bbb9c14(param) {
    return $2whNH.isSome($9fdf7c0153f60f3f$export$606c153358defcb8(undefined));
}
function $9fdf7c0153f60f3f$export$562500b99c3c89c(element) {
    var configId = $9fdf7c0153f60f3f$export$606c153358defcb8(undefined);
    if (configId !== undefined) {
        element.setAttribute("data-config", configId);
        element.setAttribute("data-namespace", "alt");
        element.setAttribute("data-auto-namespace", "false");
    }
    return element;
}
function $9fdf7c0153f60f3f$export$c8603593494de511(param) {
    var localhost = $2whNH.isSome($loT9g.nullable_to_opt(document.querySelector('script[src^="http://localhost:8787/optimize.js?id="]')));
    var production = $2whNH.isSome($loT9g.nullable_to_opt(document.querySelector('script[src^="https://embed.maker.co/optimize.js?id="]')));
    var host = localhost ? "http://localhost:6007" : production ? "https://showside.maker.co" : window.location.origin;
    var script = document.createElement("script");
    script.setAttribute("src", host + "/smartnav-v2.js");
    $2whNH.forEach($7GW0c.$$Document.body(document), function(param) {
        param.appendChild(script);
    });
}
function $9fdf7c0153f60f3f$export$4289ce05efcce874(variant) {
    return $9fdf7c0153f60f3f$var$_updateAltFunnelVariant.apply(this, arguments);
}
function $9fdf7c0153f60f3f$var$_updateAltFunnelVariant() {
    $9fdf7c0153f60f3f$var$_updateAltFunnelVariant = (0, $5YOUh._)(function(variant) {
        var variantValue, variantIsProductAltFunnel, variantIsCollectionAltFunnel, match, match$1, variant$1, match$2, match$3, variant$2, exit, variantId, value, value$1, value$2;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    variantValue = $2whNH.mapWithDefault(variant.value, variant.targetId, function(v) {
                        return v;
                    });
                    variantIsProductAltFunnel = $2whNH.getWithDefault(variantValue, "").includes("QNProductId__alt=...");
                    variantIsCollectionAltFunnel = $2whNH.getWithDefault(variantValue, "").includes("QNView__alt=category%3A...");
                    match = $2whNH.isSome($9fdf7c0153f60f3f$export$606c153358defcb8(undefined));
                    match$1 = variantIsProductAltFunnel || variantIsCollectionAltFunnel;
                    variant$1 = match && match$1 ? ($ceAXu.log2("already in alt funnel, skipping", {
                        variant: variant.targetId,
                        value: variantValue
                    }), undefined) : variant;
                    if (!variantIsProductAltFunnel) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $cdK26.waitForShopifyAnalytics(undefined, undefined)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    if (!variantIsCollectionAltFunnel) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $cdK26.waitForShopifyAnalytics(undefined, undefined)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    match$2 = $cdK26.getProductPageProductId(undefined);
                    match$3 = $cdK26.getCollectionPageCollectionId(undefined);
                    if (variant$1 === undefined) return [
                        2,
                        variant$1
                    ];
                    exit = 0;
                    if (variantIsProductAltFunnel) {
                        if (match$2 !== undefined) {
                            $ceAXu.log2("alt funnel matched", {
                                variant: variant$1.targetId,
                                value: variantValue,
                                productId: match$2,
                                variantId: $cdK26.getProductPageVariantId(undefined)
                            });
                            variantId = $cdK26.getProductPageVariantId(undefined);
                            value = variantId !== undefined ? $2whNH.map(variantValue, function(__x) {
                                return __x.replace("QNProductId__alt=...", "QNProductId__alt=...&QNVariantId__alt=" + variantId + "");
                            }) : variantValue;
                            value$1 = $2whNH.map(value, function(__x) {
                                return __x.replace("QNProductId__alt=...", "QNProductId__alt=" + match$2 + "");
                            });
                            return [
                                2,
                                {
                                    targetId: variant$1.targetId,
                                    target: variant$1.target,
                                    value: value$1,
                                    targetType: variant$1.targetType,
                                    splitRange: variant$1.splitRange,
                                    createdAt: variant$1.createdAt,
                                    updatedAt: variant$1.updatedAt,
                                    trackingId: variant$1.trackingId
                                }
                            ];
                        }
                        exit = 2;
                    } else exit = 2;
                    if (exit === 2) {
                        if (variantIsCollectionAltFunnel) {
                            if (match$3 !== undefined) {
                                $ceAXu.log2("alt funnel matched", {
                                    variant: variant$1.targetId,
                                    value: variantValue,
                                    collectionId: match$3
                                });
                                value$2 = $2whNH.map(variantValue, function(__x) {
                                    return __x.replace("QNView__alt=category%3A...", "QNView__alt=category%3A" + match$3 + "");
                                });
                                return [
                                    2,
                                    {
                                        targetId: variant$1.targetId,
                                        target: variant$1.target,
                                        value: value$2,
                                        targetType: variant$1.targetType,
                                        splitRange: variant$1.splitRange,
                                        createdAt: variant$1.createdAt,
                                        updatedAt: variant$1.updatedAt,
                                        trackingId: variant$1.trackingId
                                    }
                                ];
                            }
                            variant$2 = variant$1;
                        } else {
                            if (!variantIsProductAltFunnel) return [
                                2,
                                variant$1
                            ];
                            variant$2 = variant$1;
                        }
                    }
                    $ceAXu.log2("alt funnel matched but Shopify product or collection ID not found", {
                        variant: variant$2.targetId,
                        value: variantValue
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return $9fdf7c0153f60f3f$var$_updateAltFunnelVariant.apply(this, arguments);
}
 /* WebapiUtils-Showside Not a pure module */ 
});
parcelRegister("ceAXu", function(module, exports) {

$parcel$export(module.exports, "log", function () { return $8e83760a6de60d84$export$bef1f36f5486a6a3; });
$parcel$export(module.exports, "log2", function () { return $8e83760a6de60d84$export$b9fae0bba9d9094d; });
$parcel$export(module.exports, "Tap", function () { return $8e83760a6de60d84$export$4451a18ddc7083b7; });
$parcel$export(module.exports, "getResults", function () { return $8e83760a6de60d84$export$7e34e99eb2ee781b; });
$parcel$export(module.exports, "getWinners", function () { return $8e83760a6de60d84$export$e32b26a24de8363f; });
$parcel$export(module.exports, "logResults", function () { return $8e83760a6de60d84$export$c239fdd1aa3794db; });
$parcel$export(module.exports, "logFacts", function () { return $8e83760a6de60d84$export$23da166c95567064; });
$parcel$export(module.exports, "logWinner", function () { return $8e83760a6de60d84$export$f9219c011d6cc400; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $8e83760a6de60d84$export$69c04c4d1084c9c8(msg) {
    return "[nav optimize] " + msg;
}
function $8e83760a6de60d84$export$220b4a817d498a2f(param) {
    return $7bjme.equal($loT9g.nullable_to_opt(new URL(window.location.href).searchParams.get("maker_logs")), "true");
}
function $8e83760a6de60d84$export$bef1f36f5486a6a3(msg) {
    if ($8e83760a6de60d84$export$220b4a817d498a2f(undefined)) {
        console.log("[nav optimize] " + msg);
        return;
    }
}
function $8e83760a6de60d84$export$b9fae0bba9d9094d(msg, data) {
    if ($8e83760a6de60d84$export$220b4a817d498a2f(undefined)) {
        console.log("[nav optimize] " + msg, data);
        return;
    }
}
function $8e83760a6de60d84$var$tap(data, fn) {
    $iv6Yc._1(fn, data);
    return data;
}
function $8e83760a6de60d84$var$log2$1(data, msg) {
    $8e83760a6de60d84$export$b9fae0bba9d9094d(msg, data);
    return data;
}
var $8e83760a6de60d84$export$4451a18ddc7083b7 = {
    tap: $8e83760a6de60d84$var$tap,
    log2: $8e83760a6de60d84$var$log2$1
};
function $8e83760a6de60d84$export$7e34e99eb2ee781b(param) {
    return $2whNH.getWithDefault($2whNH.flatMap($2whNH.map(window.maker_optimize, function(prim) {
        return prim.results;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), {});
}
function $8e83760a6de60d84$export$e32b26a24de8363f(param) {
    return $2whNH.getWithDefault($2whNH.flatMap($2whNH.map(window.maker_optimize, function(prim) {
        return prim.winners;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), []);
}
function $8e83760a6de60d84$export$41b63253271a577a(param) {
    window.dispatchEvent(new Event("makerOptimizeUpdate"));
}
function $8e83760a6de60d84$export$c239fdd1aa3794db(experimentId, clearOpt, results) {
    var clear = clearOpt !== undefined ? clearOpt : false;
    var current = $8e83760a6de60d84$export$7e34e99eb2ee781b(undefined);
    var currentExperiment = $2whNH.getWithDefault($d3YYW.get(current, experimentId), []);
    var currentExperimentWinner = $i7mYY.concatMany($i7mYY.map(currentExperiment, function(results) {
        return $i7mYY.concat($2whNH.getWithDefault(results.conditions.all, []), $2whNH.getWithDefault(results.conditions.any, []));
    }));
    var newResults = $i7mYY.concatMany($i7mYY.map(results, function(results) {
        return $i7mYY.concat($2whNH.getWithDefault(results.conditions.all, []), $2whNH.getWithDefault(results.conditions.any, []));
    }));
    var currentExperimentWinner$1 = currentExperimentWinner.length !== 0 && currentExperimentWinner.length > newResults.length && $i7mYY.reduce(currentExperimentWinner, true, function(acc, result) {
        if (acc) return result.result;
        else return false;
    });
    if (!currentExperimentWinner$1) {
        var currentExperiment$1 = clear ? [] : currentExperiment;
        current[experimentId] = $i7mYY.concat(currentExperiment$1, results);
        $2whNH.forEach(window.maker_optimize, function(__x) {
            __x.results = current;
        });
    }
    $8e83760a6de60d84$export$41b63253271a577a(undefined);
}
function $8e83760a6de60d84$export$23da166c95567064(facts) {
    $2whNH.forEach(window.maker_optimize, function(__x) {
        __x.facts = facts;
    });
}
function $8e83760a6de60d84$export$f9219c011d6cc400(experimentId, reason, variantId) {
    var current = $8e83760a6de60d84$export$e32b26a24de8363f(undefined);
    var exists = $i7mYY.some(current, function(winner) {
        if ($7bjme.equal(winner.experimentId, experimentId) && winner.variantId === variantId) return $7bjme.equal(winner.reason, reason);
        else return false;
    });
    if (exists) return;
    var winners = $i7mYY.concat(current, [
        {
            experimentId: experimentId,
            variantId: variantId,
            reason: reason
        }
    ]);
    $2whNH.forEach(window.maker_optimize, function(__x) {
        __x.winners = winners;
    });
    $8e83760a6de60d84$export$41b63253271a577a(undefined);
}
 /* No side effect */ 
});
parcelRegister("d3YYW", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $982adbe8cdff673c$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "entries", function () { return $982adbe8cdff673c$export$3e9f948b41964866; });
$parcel$export(module.exports, "values", function () { return $982adbe8cdff673c$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "fromArray", function () { return $982adbe8cdff673c$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "map", function () { return $982adbe8cdff673c$export$871de8747c9eaa88; });

var $loT9g = parcelRequire("loT9g");
function $982adbe8cdff673c$export$3988ae62b71be9a3(dict, k) {
    if (k in dict) return $loT9g.some(dict[k]);
}
var $982adbe8cdff673c$export$d86d26fcf9b6eff8 = function unsafeDeleteKey(dict, key) {
    delete dict[key];
};
function $982adbe8cdff673c$export$3e9f948b41964866(dict) {
    var keys = Object.keys(dict);
    var l = keys.length;
    var values = new Array(l);
    for(var i = 0; i < l; ++i){
        var key = keys[i];
        values[i] = [
            key,
            dict[key]
        ];
    }
    return values;
}
function $982adbe8cdff673c$export$68c286be0e7e55b7(dict) {
    var keys = Object.keys(dict);
    var l = keys.length;
    var values$1 = new Array(l);
    for(var i = 0; i < l; ++i)values$1[i] = dict[keys[i]];
    return values$1;
}
function $982adbe8cdff673c$export$88e0dae599377b39(entries) {
    var dict = {};
    var _param = entries;
    while(true){
        var param = _param;
        if (!param) return dict;
        var match = param.hd;
        dict[match[0]] = match[1];
        _param = param.tl;
        continue;
    }
}
function $982adbe8cdff673c$export$571d59b505e6bb4e(entries) {
    var dict = {};
    var l = entries.length;
    for(var i = 0; i < l; ++i){
        var match = entries[i];
        dict[match[0]] = match[1];
    }
    return dict;
}
function $982adbe8cdff673c$export$871de8747c9eaa88(f, source) {
    var target = {};
    var keys = Object.keys(source);
    var l = keys.length;
    for(var i = 0; i < l; ++i){
        var key = keys[i];
        target[key] = f(source[key]);
    }
    return target;
}
 /* No side effect */ 
});

parcelRegister("7bjme", function(module, exports) {

$parcel$export(module.exports, "obj_dup", function () { return $53a893834dd90926$export$d8fa716a4e6e8723; });
$parcel$export(module.exports, "equal", function () { return $53a893834dd90926$export$411ce8e5a71e3069; });
$parcel$export(module.exports, "notequal", function () { return $53a893834dd90926$export$e3d9078e809a082f; });
$parcel$export(module.exports, "greaterequal", function () { return $53a893834dd90926$export$4fa9ef49e56dee0c; });
$parcel$export(module.exports, "greaterthan", function () { return $53a893834dd90926$export$2c5a6007921c641b; });
$parcel$export(module.exports, "lessthan", function () { return $53a893834dd90926$export$54a65104ebc207fc; });

var $gfRPo = parcelRequire("gfRPo");

var $81N94 = parcelRequire("81N94");
var $53a893834dd90926$var$for_in = function for_in(o, foo) {
    for(var x in o)foo(x);
};
var $53a893834dd90926$export$d8fa716a4e6e8723 = function obj_dup(x) {
    if (Array.isArray(x)) {
        var len = x.length;
        var v = new Array(len);
        for(var i = 0; i < len; ++i)v[i] = x[i];
        if (x.TAG !== undefined) v.TAG = x.TAG // TODO this can be removed eventually
        ;
        return v;
    }
    return Object.assign({}, x);
};
var $53a893834dd90926$export$41a7c804a30c74cd = function update_dummy(x, y) {
    var k;
    if (Array.isArray(y)) {
        for(k = 0; k < y.length; ++k)x[k] = y[k];
        if (y.TAG !== undefined) x.TAG = y.TAG;
    } else for(var k in y)x[k] = y[k];
};
function $53a893834dd90926$export$398604a469f7de9a(a, b) {
    if (a === b) return 0;
    var a_type = typeof a === "undefined" ? "undefined" : (0, $gfRPo._)(a);
    var b_type = typeof b === "undefined" ? "undefined" : (0, $gfRPo._)(b);
    switch(a_type){
        case "boolean":
            if (b_type === "boolean") return $81N94.bool_compare(a, b);
            break;
        case "function":
            if (b_type === "function") throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "compare: functional value",
                Error: new Error()
            };
            break;
        case "number":
            if (b_type === "number") return $81N94.float_compare(a, b);
            break;
        case "string":
            if (b_type === "string") return $81N94.string_compare(a, b);
            else return 1;
        case "undefined":
            return -1;
        default:
    }
    switch(b_type){
        case "string":
            return -1;
        case "undefined":
            return 1;
        default:
            if (a_type === "boolean") return 1;
            if (b_type === "boolean") return -1;
            if (a_type === "function") return 1;
            if (b_type === "function") return -1;
            if (a_type === "number") {
                if (b === null || b.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return 1;
                else return -1;
            }
            if (b_type === "number") {
                if (a === null || a.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return -1;
                else return 1;
            }
            if (a === null) {
                if (b.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return 1;
                else return -1;
            }
            if (b === null) {
                if (a.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return -1;
                else return 1;
            }
            if (a.BS_PRIVATE_NESTED_SOME_NONE !== undefined) {
                if (b.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return $53a893834dd90926$var$aux_obj_compare(a, b);
                else return -1;
            }
            var tag_a = a.TAG | 0;
            var tag_b = b.TAG | 0;
            if (tag_a === 248) return $81N94.int_compare(a[1], b[1]);
            if (tag_a === 251) throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "equal: abstract value",
                Error: new Error()
            };
            if (tag_a !== tag_b) {
                if (tag_a < tag_b) return -1;
                else return 1;
            }
            var len_a = a.length | 0;
            var len_b = b.length | 0;
            if (len_a === len_b) {
                if (Array.isArray(a)) {
                    var _i = 0;
                    while(true){
                        var i = _i;
                        if (i === len_a) return 0;
                        var res = $53a893834dd90926$export$398604a469f7de9a(a[i], b[i]);
                        if (res !== 0) return res;
                        _i = i + 1 | 0;
                        continue;
                    }
                } else if (a instanceof Date && b instanceof Date) return a - b;
                else return $53a893834dd90926$var$aux_obj_compare(a, b);
            } else if (len_a < len_b) {
                var _i$1 = 0;
                while(true){
                    var i$1 = _i$1;
                    if (i$1 === len_a) return -1;
                    var res$1 = $53a893834dd90926$export$398604a469f7de9a(a[i$1], b[i$1]);
                    if (res$1 !== 0) return res$1;
                    _i$1 = i$1 + 1 | 0;
                    continue;
                }
            } else {
                var _i$2 = 0;
                while(true){
                    var i$2 = _i$2;
                    if (i$2 === len_b) return 1;
                    var res$2 = $53a893834dd90926$export$398604a469f7de9a(a[i$2], b[i$2]);
                    if (res$2 !== 0) return res$2;
                    _i$2 = i$2 + 1 | 0;
                    continue;
                }
            }
    }
}
function $53a893834dd90926$var$aux_obj_compare(a, b) {
    var min_key_lhs = {
        contents: undefined
    };
    var min_key_rhs = {
        contents: undefined
    };
    var do_key = function do_key(param, key) {
        var min_key = param[2];
        var _$b = param[1];
        if (!(!Object.prototype.hasOwnProperty.call(_$b, key) || $53a893834dd90926$export$398604a469f7de9a(param[0][key], _$b[key]) > 0)) return;
        var mk = min_key.contents;
        if (mk !== undefined && key >= mk) return;
        else {
            min_key.contents = key;
            return;
        }
    };
    var partial_arg = [
        a,
        b,
        min_key_rhs
    ];
    var do_key_a = function do_key_a(param) {
        return do_key(partial_arg, param);
    };
    var partial_arg$1 = [
        b,
        a,
        min_key_lhs
    ];
    var do_key_b = function do_key_b(param) {
        return do_key(partial_arg$1, param);
    };
    $53a893834dd90926$var$for_in(a, do_key_a);
    $53a893834dd90926$var$for_in(b, do_key_b);
    var match = min_key_lhs.contents;
    var match$1 = min_key_rhs.contents;
    if (match !== undefined) {
        if (match$1 !== undefined) return $81N94.string_compare(match, match$1);
        else return -1;
    } else if (match$1 !== undefined) return 1;
    else return 0;
}
function $53a893834dd90926$export$411ce8e5a71e3069(a, b) {
    if (a === b) return true;
    var a_type = typeof a === "undefined" ? "undefined" : (0, $gfRPo._)(a);
    if (a_type === "string" || a_type === "number" || a_type === "boolean" || a_type === "undefined" || a === null) return false;
    var b_type = typeof b === "undefined" ? "undefined" : (0, $gfRPo._)(b);
    if (a_type === "function" || b_type === "function") throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "equal: functional value",
        Error: new Error()
    };
    if (b_type === "number" || b_type === "undefined" || b === null) return false;
    var tag_a = a.TAG | 0;
    var tag_b = b.TAG | 0;
    if (tag_a === 248) return a[1] === b[1];
    if (tag_a === 251) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "equal: abstract value",
        Error: new Error()
    };
    if (tag_a !== tag_b) return false;
    var len_a = a.length | 0;
    var len_b = b.length | 0;
    if (len_a === len_b) {
        if (Array.isArray(a)) {
            var _i = 0;
            while(true){
                var i = _i;
                if (i === len_a) return true;
                if (!$53a893834dd90926$export$411ce8e5a71e3069(a[i], b[i])) return false;
                _i = i + 1 | 0;
                continue;
            }
        } else if (a instanceof Date && b instanceof Date) return !(a > b || a < b);
        else {
            var result = {
                contents: true
            };
            var do_key_a = function do_key_a(key) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    result.contents = false;
                    return;
                }
            };
            var do_key_b = function do_key_b(key) {
                if (!Object.prototype.hasOwnProperty.call(a, key) || !$53a893834dd90926$export$411ce8e5a71e3069(b[key], a[key])) {
                    result.contents = false;
                    return;
                }
            };
            $53a893834dd90926$var$for_in(a, do_key_a);
            if (result.contents) $53a893834dd90926$var$for_in(b, do_key_b);
            return result.contents;
        }
    } else return false;
}
function $53a893834dd90926$export$59e6990050957897(x, y) {
    if (y !== null) return $53a893834dd90926$export$411ce8e5a71e3069(x, y);
    else return x === y;
}
function $53a893834dd90926$export$f1ff0552b435f9a8(x, y) {
    if (y !== undefined) return $53a893834dd90926$export$411ce8e5a71e3069(x, y);
    else return x === y;
}
function $53a893834dd90926$export$82648b0ea8b9e17f(x, y) {
    if (y == null) return x === y;
    else return $53a893834dd90926$export$411ce8e5a71e3069(x, y);
}
function $53a893834dd90926$export$e3d9078e809a082f(a, b) {
    if (typeof a === "number" && typeof b === "number") return a !== b;
    else return !$53a893834dd90926$export$411ce8e5a71e3069(a, b);
}
function $53a893834dd90926$export$4fa9ef49e56dee0c(a, b) {
    if (typeof a === "number" && typeof b === "number") return a >= b;
    else return $53a893834dd90926$export$398604a469f7de9a(a, b) >= 0;
}
function $53a893834dd90926$export$2c5a6007921c641b(a, b) {
    if (typeof a === "number" && typeof b === "number") return a > b;
    else return $53a893834dd90926$export$398604a469f7de9a(a, b) > 0;
}
function $53a893834dd90926$export$8825358824a4a274(a, b) {
    if (typeof a === "number" && typeof b === "number") return a <= b;
    else return $53a893834dd90926$export$398604a469f7de9a(a, b) <= 0;
}
function $53a893834dd90926$export$54a65104ebc207fc(a, b) {
    if (typeof a === "number" && typeof b === "number") return a < b;
    else return $53a893834dd90926$export$398604a469f7de9a(a, b) < 0;
}
function $53a893834dd90926$export$96ec731ed4dcb222(x, y) {
    if ($53a893834dd90926$export$398604a469f7de9a(x, y) <= 0) return x;
    else return y;
}
function $53a893834dd90926$export$8960430cfd85939f(x, y) {
    if ($53a893834dd90926$export$398604a469f7de9a(x, y) >= 0) return x;
    else return y;
}
 /* No side effect */ 
});
parcelRegister("gfRPo", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $bd57cd2c3be44143$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $bd57cd2c3be44143$export$5f0017c582d45a2d; });
function $bd57cd2c3be44143$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("7GW0c", function(module, exports) {

$parcel$export(module.exports, "StyleDeclaration", function () { return $599972afeeb3f186$export$76bef20c8a3e0172; });
$parcel$export(module.exports, "setStyle", function () { return $599972afeeb3f186$export$37a5fde709c1db82; });
$parcel$export(module.exports, "$$Window", function () { return $599972afeeb3f186$export$3108b5e055227031; });
$parcel$export(module.exports, "$$Element", function () { return $599972afeeb3f186$export$9bef725ae9b77ed3; });
$parcel$export(module.exports, "$$Document", function () { return $599972afeeb3f186$export$329dd945ad6f2ea4; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $gfRPo = parcelRequire("gfRPo");

var $d3YYW = parcelRequire("d3YYW");

var $cHs0A = parcelRequire("cHs0A");

var $i7mYY = parcelRequire("i7mYY");

var $d1G6W = parcelRequire("d1G6W");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $dLC6y = parcelRequire("dLC6y");

var $is6i3 = parcelRequire("is6i3");
function $599972afeeb3f186$var$fromCssStyleDeclatation(cssStyleDeclaration) {
    return {
        top: $2whNH.getWithDefault($cHs0A.fromString(cssStyleDeclaration.top), 0),
        marginTop: $2whNH.getWithDefault($cHs0A.fromString(cssStyleDeclaration.marginTop), 0),
        transform: $is6i3.parse(cssStyleDeclaration.transform),
        transitionDuration: $2whNH.getWithDefault($d1G6W.fromString(cssStyleDeclaration.transitionDuration), 0.0),
        transitionDelay: $2whNH.getWithDefault($d1G6W.fromString(cssStyleDeclaration.transitionDelay), 0.0)
    };
}
function $599972afeeb3f186$var$fromString(style) {
    return $d3YYW.fromArray($i7mYY.keepMap($i7mYY.map(style.split(";"), function(property) {
        var keyValue = property.split(":");
        var key = $i7mYY.get(keyValue, 0);
        var value = $i7mYY.get(keyValue, 1);
        if (key !== undefined && value !== undefined) return [
            key,
            value
        ];
    }), function(a) {
        return a;
    }));
}
function $599972afeeb3f186$var$toString(dict) {
    return $i7mYY.map(Object.keys(dict), function(key) {
        return $2whNH.mapWithDefault($d3YYW.get(dict, key), "", function(value) {
            return [
                key,
                value
            ].join(":");
        });
    }).join(";");
}
var $599972afeeb3f186$export$76bef20c8a3e0172 = {
    fromCssStyleDeclatation: $599972afeeb3f186$var$fromCssStyleDeclatation,
    fromString: $599972afeeb3f186$var$fromString,
    toString: $599972afeeb3f186$var$toString
};
function $599972afeeb3f186$export$37a5fde709c1db82(element, property, value) {
    var currentStyle = element.getAttribute("style");
    if (currentStyle == null) element.setAttribute("style", $599972afeeb3f186$var$toString($d3YYW.fromArray([
        [
            property,
            value
        ]
    ])));
    else {
        var modifiedStyle = $599972afeeb3f186$var$toString($dLC6y.tap($599972afeeb3f186$var$fromString(currentStyle), function(a) {
            a[property] = value;
        }));
        element.setAttribute("style", modifiedStyle);
    }
    return element;
}
function $599972afeeb3f186$var$bind(captureOpt, passiveOpt, onceOpt, $$window, events, callback) {
    var capture = captureOpt !== undefined ? captureOpt : false;
    var passive = passiveOpt !== undefined ? passiveOpt : true;
    var once = onceOpt !== undefined ? onceOpt : false;
    $i7mYY.forEach(events, function($$event) {
        $$window.addEventListener($$event, callback, {
            capture: capture,
            passive: passive,
            once: once
        });
    });
}
function $599972afeeb3f186$var$unbind(captureOpt, passiveOpt, $$window, events, callback) {
    var capture = captureOpt !== undefined ? captureOpt : false;
    var passive = passiveOpt !== undefined ? passiveOpt : true;
    $i7mYY.forEach(events, function($$event) {
        $$window.removeEventListener($$event, callback, {
            capture: capture,
            passive: passive
        });
    });
}
function $599972afeeb3f186$var$getScrollYWithATerribleHack() {
    switch((0, $gfRPo._)(window.scrollY)){
        case "number":
            // this where 99% of the calls to this function would end.
            return window.scrollY;
        case "function":
            // this the other 1% of calls where window.scrollY was allegedly replaced with a function
            return window.scrollY();
        default:
            // otherwise, we don't know what to do at this point.
            return 0.0;
    }
}
var $599972afeeb3f186$var$scrollY = $599972afeeb3f186$var$getScrollYWithATerribleHack;
var $599972afeeb3f186$export$3108b5e055227031 = {
    bind: $599972afeeb3f186$var$bind,
    unbind: $599972afeeb3f186$var$unbind,
    scrollY: $599972afeeb3f186$var$scrollY
};
function $599972afeeb3f186$var$setAttribute(element, name, value) {
    if (value !== undefined) element.setAttribute(name, value);
    return element;
}
var $599972afeeb3f186$export$9bef725ae9b77ed3 = {
    setAttribute: $599972afeeb3f186$var$setAttribute
};
var $599972afeeb3f186$var$ReadyState = {};
function $599972afeeb3f186$var$readyState($$document) {
    var match = $$document.readyState;
    if (match === undefined) return /* Loading */ 0;
    switch(match){
        case "complete":
            return /* Complete */ 2;
        case "interactive":
            return /* Interactive */ 1;
        default:
            return /* Loading */ 0;
    }
}
function $599972afeeb3f186$var$body($$document) {
    return $loT9g.nullable_to_opt($$document.body);
}
var $599972afeeb3f186$export$329dd945ad6f2ea4 = {
    ReadyState: $599972afeeb3f186$var$ReadyState,
    readyState: $599972afeeb3f186$var$readyState,
    body: $599972afeeb3f186$var$body
};
 /*  Not a pure module */ 
});
parcelRegister("cHs0A", function(module, exports) {

$parcel$export(module.exports, "fromString", function () { return $93ef3a17725acfa9$export$3004f64547af360e; });
function $93ef3a17725acfa9$export$3004f64547af360e(i) {
    var i$1 = parseInt(i, 10);
    if (isNaN(i$1)) return;
    else return i$1;
}
 /* No side effect */ 
});

parcelRegister("d1G6W", function(module, exports) {

$parcel$export(module.exports, "fromString", function () { return $97bc08b311d24138$export$3004f64547af360e; });
function $97bc08b311d24138$export$3004f64547af360e(i) {
    var i$1 = parseFloat(i);
    if (isNaN(i$1)) return;
    else return i$1;
}
 /* No side effect */ 
});

parcelRegister("dLC6y", function(module, exports) {

$parcel$export(module.exports, "tap", function () { return $a05d38ed148614e7$export$3f23594af5f37336; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");
function $a05d38ed148614e7$export$3f23594af5f37336(data, fn) {
    $iv6Yc._1(fn, data);
    return data;
}
function $a05d38ed148614e7$export$b9fae0bba9d9094d(data, msg) {
    console.log(msg, data);
    return data;
}
function $a05d38ed148614e7$export$fbb6fe64487b8a2f(data, msg0, msg1) {
    var fn = function fn(param) {
        console.log(msg0, msg1, param);
    };
    fn(data);
    return data;
}
function $a05d38ed148614e7$export$fc0174cce4cf3114(data, msg0, msg1, mdg2) {
    var fn = function fn(param) {
        console.log(msg0, msg1, mdg2, param);
    };
    fn(data);
    return data;
}
function $a05d38ed148614e7$export$986fc5e077b1db97(array, msg) {
    console.log(msg, array.length);
    return array;
}
 /* No side effect */ 
});

parcelRegister("is6i3", function(module, exports) {

var $fKBt2 = parcelRequire("fKBt2");

var $gu11n = parcelRequire("gu11n");

var $iiZHH = parcelRequire("iiZHH");

var $kekIc = parcelRequire("kekIc");
(function(global, factory) {
    factory(module.exports);
})(undefined, function(exports1) {
    "use strict";
    // List of transforms for which the value has to be numeral. Default px substitution for these
    // transforms will be skipped.
    var transformsWithNumeralValues = [
        "scale",
        "scale3d",
        "scaleX",
        "scaleY",
        "scaleZ"
    ];
    /**
   * Returns a object representation of the transform string supplied. It parses the string and
   * converts them to an object.
   * @param transformString String containing the transforms
   */ var parse = function(transformString) {
        var transforms = transformString.trim().split(/\) |\)/);
        // Handle "initial", "inherit", "unset".
        if (transforms.length === 1) return (0, $fKBt2._)({}, transforms[0], true);
        /**
       * Converts string values to number when the unit is pixel or parsable. Returns a string when the
       * unit is not pixel or not parsable.
       * @param value Value of a transform
       */ var parsePixelValues = function(value) {
            if (value.endsWith("px")) return parseFloat(value);
            if (!Number.isNaN(Number(value))) return Number(value);
            return value;
        };
        return transforms.reduce(function(acc, transform) {
            if (!transform) return acc;
            var _transform_split = (0, $kekIc._)(transform.split("("), 2), name = _transform_split[0], transformValue = _transform_split[1];
            var valueArray = transformValue.split(",");
            var values = valueArray.map(function(val) {
                return parsePixelValues(val.endsWith(")") ? val.replace(")", "") : val.trim());
            });
            var value = values.length === 1 ? values[0] : values;
            return (0, $iiZHH._)((0, $gu11n._)({}, acc), (0, $fKBt2._)({}, name, value));
        }, {});
    };
    /**
   * Returns the transform string constructed from the transform object supplied.
   * @param transformObject Object containing the transforms
   */ var stringify = function(transformObject) {
        var resolveUnits = function(key, val) {
            if (typeof val === "number" && !transformsWithNumeralValues.includes(key)) return "".concat(val, "px");
            return val.toString();
        };
        return Object.keys(transformObject).reduce(function(acc, key) {
            var value = transformObject[key];
            if (value === true) return key;
            if (value === false) return acc;
            if (Array.isArray(value)) return "".concat(acc, " ").concat(key, "(").concat(value.map(function(val) {
                return resolveUnits(key, val);
            }).join(", "), ")");
            return "".concat(acc, " ").concat(key, "(").concat(resolveUnits(key, value), ")");
        }, "").trim();
    };
    exports1.parse = parse;
    exports1.stringify = stringify;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});
parcelRegister("fKBt2", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $b778371e42c5f4cc$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $b778371e42c5f4cc$export$1e71eb4bef00f6b0; });
function $b778371e42c5f4cc$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("gu11n", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c0003d7734f11d0b$export$581ff339ea0ba762; });

var $fKBt2 = parcelRequire("fKBt2");
function $c0003d7734f11d0b$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $fKBt2._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("iiZHH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d539c5878f8bb9eb$export$4fa2f4023c9cbda5; });
function $d539c5878f8bb9eb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d539c5878f8bb9eb$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d539c5878f8bb9eb$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("kekIc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $eba52e6496b32771$export$fdf2a89c76341bbf; });

var $iyetx = parcelRequire("iyetx");

var $hyNcg = parcelRequire("hyNcg");

var $535Oz = parcelRequire("535Oz");

var $hFE5s = parcelRequire("hFE5s");
function $eba52e6496b32771$export$fdf2a89c76341bbf(arr, i) {
    return (0, $iyetx._array_with_holes)(arr) || (0, $hyNcg._iterable_to_array_limit)(arr, i) || (0, $hFE5s._unsupported_iterable_to_array)(arr, i) || (0, $535Oz._non_iterable_rest)();
}

});
parcelRegister("iyetx", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $d816a182595497a3$export$e6256bf45c68d561; });
function $d816a182595497a3$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("hyNcg", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $cc8bc616e6ef2cc0$export$2fd15edff6687200; });
function $cc8bc616e6ef2cc0$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("535Oz", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $3ad1be4100d542df$export$60dbc22abd7da546; });
function $3ad1be4100d542df$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("cdK26", function(module, exports) {

$parcel$export(module.exports, "initialDocumentCookie", function () { return $8e5a681fe8edbb44$export$6d8a53c95d62f16a; });
$parcel$export(module.exports, "waitForShopifyAnalytics", function () { return $8e5a681fe8edbb44$export$f84603f07eeb1d63; });
$parcel$export(module.exports, "getProductPageProductId", function () { return $8e5a681fe8edbb44$export$655ef3e62ebfeb40; });
$parcel$export(module.exports, "getCollectionPageCollectionId", function () { return $8e5a681fe8edbb44$export$1ccfc961cba0f1c6; });
$parcel$export(module.exports, "getProductPageVariantId", function () { return $8e5a681fe8edbb44$export$cc267c015bc8901b; });
$parcel$export(module.exports, "isProductPage", function () { return $8e5a681fe8edbb44$export$a6ee0f0139d9689a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $bygWp = parcelRequire("bygWp");
function $8e5a681fe8edbb44$var$fromMeta(meta) {
    var page = meta.page;
    var page$1 = page == null ? undefined : $loT9g.some(page);
    var product = meta.product;
    var resourceId = $2whNH.flatMap($2whNH.map(page$1, function(prim) {
        return prim.resourceId;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
    var resourceType = $2whNH.flatMap($2whNH.map(page$1, function(prim) {
        return prim.resourceType;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
    if (resourceType === undefined) return;
    switch(resourceType){
        case "collection":
            if (resourceId !== undefined) return {
                TAG: /* CollectionPage */ 0,
                collectionId: resourceId.toString()
            };
            else return;
        case "product":
            if (resourceId !== undefined) return {
                TAG: /* ProductPage */ 1,
                productId: resourceId.toString(),
                variants: $2whNH.getWithDefault($2whNH.flatMap($2whNH.map(product == null ? undefined : $loT9g.some(product), function(prim) {
                    return prim.variants;
                }), function(prim) {
                    if (prim == null) return;
                    else return $loT9g.some(prim);
                }), [])
            };
            else return;
        default:
            return;
    }
}
var $8e5a681fe8edbb44$export$6955bcca4cd3539f = {
    fromMeta: $8e5a681fe8edbb44$var$fromMeta
};
function $8e5a681fe8edbb44$export$6d8a53c95d62f16a(param) {
    return $2whNH.flatMap($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.flatMap($2whNH.map(window.ShopifyAnalytics == null ? undefined : $loT9g.some(window.ShopifyAnalytics), function(prim) {
        return prim.lib;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.config;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.initialDocumentCookie;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
}
function $8e5a681fe8edbb44$export$f84603f07eeb1d63(retryCountOpt, param) {
    var retryCount = retryCountOpt !== undefined ? retryCountOpt : 0;
    var match = window.ShopifyAnalytics;
    var match$1 = retryCount > 25;
    if (!(match == null) || match$1) return Promise.resolve(undefined);
    else return new Promise(function(resolve, reject) {
        setTimeout(function(param) {
            $8e5a681fe8edbb44$export$f84603f07eeb1d63(retryCount + 1 | 0, undefined).then(function(result) {
                resolve(result);
            });
        }, 42);
    });
}
function $8e5a681fe8edbb44$export$c2a6433281518c91(param) {
    return $2whNH.flatMap($2whNH.flatMap($2whNH.map(window.ShopifyAnalytics == null ? undefined : $loT9g.some(window.ShopifyAnalytics), function(prim) {
        return prim.meta;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), $8e5a681fe8edbb44$var$fromMeta);
}
function $8e5a681fe8edbb44$export$655ef3e62ebfeb40(param) {
    return $2whNH.flatMap($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), function(page) {
        if (page.TAG === /* CollectionPage */ 0) return;
        else return page.productId;
    });
}
function $8e5a681fe8edbb44$export$1ccfc961cba0f1c6(param) {
    return $2whNH.flatMap($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), function(page) {
        if (page.TAG === /* CollectionPage */ 0) return page.collectionId;
    });
}
function $8e5a681fe8edbb44$export$cc267c015bc8901b(param) {
    var variants = $2whNH.mapWithDefault($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), [], function(page) {
        if (page.TAG === /* CollectionPage */ 0) return [];
        else return page.variants;
    });
    var idToFind = $bygWp.getParam(window.location.href, "variant");
    var foundVariant = idToFind !== undefined ? $i7mYY.getBy(variants, function(v) {
        var currentId = $2whNH.map($loT9g.nullable_to_opt(v.id), function(prim) {
            return prim.toString();
        });
        return $7bjme.equal(currentId, idToFind);
    }) : undefined;
    var firstVariant = $i7mYY.get(variants, 0);
    return $2whNH.map($2whNH.flatMap($2whNH.map($2whNH.orElse(foundVariant, firstVariant), function(prim) {
        return prim.id;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.toString();
    });
}
function $8e5a681fe8edbb44$export$a6ee0f0139d9689a(param) {
    return $2whNH.isSome($8e5a681fe8edbb44$export$655ef3e62ebfeb40(undefined));
}
 /* No side effect */ 
});


parcelRegister("9rqV0", function(module, exports) {

$parcel$export(module.exports, "getIdByEmbedType", function () { return $6dfb842246d6df6b$export$d18e9d55ca9c355e; });
$parcel$export(module.exports, "getEmbedTypeFromId", function () { return $6dfb842246d6df6b$export$639a39639d6e6b0c; });
$parcel$export(module.exports, "Attributes", function () { return $6dfb842246d6df6b$export$21991851b0bb231f; });
$parcel$export(module.exports, "getNamespace", function () { return $6dfb842246d6df6b$export$becf4f9e48e6290a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $cHs0A = parcelRequire("cHs0A");

var $i7mYY = parcelRequire("i7mYY");

var $2Ng4w = parcelRequire("2Ng4w");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $h6oMG = parcelRequire("h6oMG");

var $9bmXk = parcelRequire("9bmXk");

var $h6rW7 = parcelRequire("h6rW7");

var $b5aRK = parcelRequire("b5aRK");

var $78zWm = parcelRequire("78zWm");
function $6dfb842246d6df6b$export$d18e9d55ca9c355e(t) {
    switch(t){
        case /* Bottombar */ 0:
            return "maker-smartnav";
        case /* Inline */ 1:
            return "maker-smartnav-inline";
        case /* Launcher */ 2:
            return "maker-smartnav-launcher";
        case /* Section */ 3:
            return "maker-smartnav-section";
        case /* Menu */ 4:
            return "maker-smartnav-menu";
        case /* ProductDetailsPage */ 5:
            return "maker-smartnav-pdp";
    }
}
function $6dfb842246d6df6b$export$639a39639d6e6b0c(s) {
    switch(s){
        case "maker-smartnav":
            return /* Bottombar */ 0;
        case "maker-smartnav-inline":
            return /* Inline */ 1;
        case "maker-smartnav-launcher":
            return /* Launcher */ 2;
        case "maker-smartnav-menu":
            return /* Menu */ 4;
        case "maker-smartnav-pdp":
            return /* ProductDetailsPage */ 5;
        case "maker-smartnav-section":
            return /* Section */ 3;
        default:
            return;
    }
}
function $6dfb842246d6df6b$export$b42e70ddca33ff5b(o) {
    return $2whNH.keep(o, function(id) {
        return id !== "";
    });
}
function $6dfb842246d6df6b$var$fromDict(dict) {
    var match = $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-type"));
    var sectionType;
    if (match !== undefined) switch(match){
        case "node":
            sectionType = "node";
            break;
        case "related-media":
            sectionType = "related-media";
            break;
        case "root":
            sectionType = "root";
            break;
        default:
            sectionType = undefined;
    }
    else sectionType = undefined;
    return {
        config: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-config")),
        namespace: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-namespace")),
        account: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-account")),
        currency: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-currency")),
        sectionType: sectionType,
        sectionNode: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-node")),
        sectionCardShape: $2whNH.map($6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-shape")), function(v) {
            switch(v){
                case "circle":
                    return "circle";
                case "portrait":
                    return "portrait";
                default:
                    return "square";
            }
        }),
        sectionCardSize: $2whNH.map($6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-size")), function(v) {
            switch(v){
                case "large":
                    return "large";
                case "small":
                    return "small";
                default:
                    return "medium";
            }
        }),
        relatedProduct: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-product")),
        relatedCategory: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-category")),
        navMenuTopbarTarget: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-topbar-target")),
        navMenuTopbarTargetStyle: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-topbar-target-style")),
        navMenuTopbarZIndex: $2whNH.flatMap($6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-topbar-z-index")), $cHs0A.fromString),
        navMenuTopbarLayout: $2whNH.map($6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-topbar-layout")), function(layout) {
            if (layout === "three-column") return "three-column";
            else return "two-column";
        }),
        navMenuTopbarEnabled: $2whNH.map($6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-topbar-enabled")), $2Ng4w.bool_of_string),
        navMenuTopbarInsertMode: $2whNH.map($6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-topbar-insert-mode")), function(mode) {
            if (mode === "append") return "append";
            else return "replace";
        }),
        navMenuHamburgerTarget: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-hamburger-target")),
        navMenuHamburgerTriggerButtonTarget: $d3YYW.get(dict, "data-hamburger-trigger-button-target"),
        navMenuHamburgerTargetStyle: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-hamburger-target-style")),
        navMenuHamburgerZIndex: $2whNH.flatMap($6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-hamburger-z-index")), $cHs0A.fromString),
        navMenuBreakpointMaxWidth: $2whNH.flatMap($6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-breakpoint-max-width")), $cHs0A.fromString),
        pdpShowLauncher: $2whNH.map($6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-show-launcher")), $2Ng4w.bool_of_string),
        siteHeaderTarget: $6dfb842246d6df6b$export$b42e70ddca33ff5b($d3YYW.get(dict, "data-site-header-target"))
    };
}
function $6dfb842246d6df6b$var$autoAssignNamespaces(param) {
    var groupElementsByTypeAndConfigId = function groupElementsByTypeAndConfigId(elements) {
        return $i7mYY.map($h6oMG.toArray($i7mYY.reduce(elements, undefined, function(acc, el) {
            var match = $6dfb842246d6df6b$export$639a39639d6e6b0c(el.id);
            var typeId = match !== undefined ? match !== 1 ? match !== 4 ? "1" : "2" : "0" : "1";
            var configId = $2whNH.getWithDefault($loT9g.nullable_to_opt(el.getAttribute("data-config")), "0");
            var uniqueId = typeId + configId;
            return $h6oMG.set(acc, uniqueId, $i7mYY.concat($2whNH.getWithDefault($h6oMG.get(acc, uniqueId), []), [
                el
            ]));
        })), function(param) {
            return param[1];
        });
    };
    var __x = $i7mYY.map($i7mYY.map([
        /* Inline */ 1,
        /* Bottombar */ 0,
        /* Launcher */ 2,
        /* Section */ 3,
        /* Menu */ 4,
        /* ProductDetailsPage */ 5
    ], $6dfb842246d6df6b$export$d18e9d55ca9c355e), function(id) {
        return "#" + id;
    }).join(",");
    $i7mYY.forEachWithIndex(groupElementsByTypeAndConfigId($i7mYY.keepMap(Array.prototype.slice.call(document.querySelectorAll(__x)), $b5aRK.ofNode)), function(index, e) {
        $i7mYY.forEach(e, function(el) {
            var existingNamespace = el.getAttribute("data-namespace");
            var autoNamespace = $2whNH.mapWithDefault($loT9g.nullable_to_opt(el.getAttribute("data-auto-namespace")), false, function(a) {
                if (a === "true" || a === "1" || a === "yes" || a === "on") return true;
                else return a === "enabled";
            });
            if (!(existingNamespace == null) && !autoNamespace) return;
            var nextNamespace = el.id === "maker-smartnav-menu" ? "menu" : index === 0 ? undefined : String(index);
            el.setAttribute("data-auto-namespace", "true");
            $2whNH.forEach(nextNamespace, function(next) {
                el.setAttribute("data-namespace", next);
            });
        });
    });
}
function $6dfb842246d6df6b$var$fromElement(el) {
    return $6dfb842246d6df6b$var$fromDict($d3YYW.fromArray($i7mYY.map(Array.prototype.slice.call(el.attributes), function(attr) {
        var key = attr.localName;
        var value = attr.value;
        return [
            key,
            value
        ];
    })));
}
function $6dfb842246d6df6b$var$useAttributesObserver(element, fallbackAttributes) {
    var match = $g85JO.useState(function() {
        return fallbackAttributes;
    });
    var setAttributes = match[1];
    var elRef = $g85JO.useRef($9bmXk.fromOption(element));
    $78zWm.use({
        attributes: true,
        characterData: false,
        childList: false,
        subtree: false
    }, elRef, function(param) {
        $2whNH.forEach(element, function(element) {
            $iv6Yc._1(setAttributes, function(param) {
                return $6dfb842246d6df6b$var$fromElement(element);
            });
        });
    });
    return match[0];
}
var $6dfb842246d6df6b$export$21991851b0bb231f = {
    fromDict: $6dfb842246d6df6b$var$fromDict,
    autoAssignNamespaces: $6dfb842246d6df6b$var$autoAssignNamespaces,
    fromElement: $6dfb842246d6df6b$var$fromElement,
    useAttributesObserver: $6dfb842246d6df6b$var$useAttributesObserver
};
function $6dfb842246d6df6b$export$becf4f9e48e6290a(attributes) {
    return $2whNH.map($2whNH.flatMap(attributes, function(attr) {
        return attr.namespace;
    }), $h6rW7.fromString);
}
 /* react Not a pure module */ 
});
parcelRegister("g85JO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6mHgG"));

});
parcelRegister("6mHgG", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $4a265c46e3f8f73b$export$dca3b0875bd9a954; }, function (v) { return $4a265c46e3f8f73b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $4a265c46e3f8f73b$export$16fa2f45be04daa8; }, function (v) { return $4a265c46e3f8f73b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4a265c46e3f8f73b$export$ffb0004e005737fa; }, function (v) { return $4a265c46e3f8f73b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $4a265c46e3f8f73b$export$e2c29f18771995cb; }, function (v) { return $4a265c46e3f8f73b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $4a265c46e3f8f73b$export$221d75b3f55bb0bd; }, function (v) { return $4a265c46e3f8f73b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4a265c46e3f8f73b$export$5f8d39834fd61797; }, function (v) { return $4a265c46e3f8f73b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4a265c46e3f8f73b$export$74bf444e3cd11ea5; }, function (v) { return $4a265c46e3f8f73b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4a265c46e3f8f73b$export$ae55be85d98224ed; }, function (v) { return $4a265c46e3f8f73b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $4a265c46e3f8f73b$export$e530037191fcd5d7; }, function (v) { return $4a265c46e3f8f73b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $4a265c46e3f8f73b$export$fd42f52fd3ae1109; }, function (v) { return $4a265c46e3f8f73b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $4a265c46e3f8f73b$export$c8a8987d4410bf2d; }, function (v) { return $4a265c46e3f8f73b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $4a265c46e3f8f73b$export$d38cd72104c1f0e9; }, function (v) { return $4a265c46e3f8f73b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $4a265c46e3f8f73b$export$7d1e3a5e95ceca43; }, function (v) { return $4a265c46e3f8f73b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $4a265c46e3f8f73b$export$257a8862b851cb5b; }, function (v) { return $4a265c46e3f8f73b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $4a265c46e3f8f73b$export$a8257692ac88316c; }, function (v) { return $4a265c46e3f8f73b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $4a265c46e3f8f73b$export$488013bae63b21da; }, function (v) { return $4a265c46e3f8f73b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $4a265c46e3f8f73b$export$7c73462e0d25e514; }, function (v) { return $4a265c46e3f8f73b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $4a265c46e3f8f73b$export$35808ee640e87ca7; }, function (v) { return $4a265c46e3f8f73b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $4a265c46e3f8f73b$export$fae74005e78b1a27; }, function (v) { return $4a265c46e3f8f73b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $4a265c46e3f8f73b$export$dc8fbce3eb94dc1e; }, function (v) { return $4a265c46e3f8f73b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $4a265c46e3f8f73b$export$6d9c69b0de29b591; }, function (v) { return $4a265c46e3f8f73b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $4a265c46e3f8f73b$export$d5a552a76deda3c2; }, function (v) { return $4a265c46e3f8f73b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $4a265c46e3f8f73b$export$e5c5a5f917a5871c; }, function (v) { return $4a265c46e3f8f73b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $4a265c46e3f8f73b$export$1538c33de8887b59; }, function (v) { return $4a265c46e3f8f73b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $4a265c46e3f8f73b$export$13e3392192263954; }, function (v) { return $4a265c46e3f8f73b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $4a265c46e3f8f73b$export$b8f5890fc79d6aca; }, function (v) { return $4a265c46e3f8f73b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $4a265c46e3f8f73b$export$60241385465d0a34; }, function (v) { return $4a265c46e3f8f73b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $4a265c46e3f8f73b$export$83d89fbfd8236492; }, function (v) { return $4a265c46e3f8f73b$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gfRPo = parcelRequire("gfRPo");
var $4a265c46e3f8f73b$export$dca3b0875bd9a954;
var $4a265c46e3f8f73b$export$16fa2f45be04daa8;
var $4a265c46e3f8f73b$export$ffb0004e005737fa;
var $4a265c46e3f8f73b$export$e2c29f18771995cb;
var $4a265c46e3f8f73b$export$221d75b3f55bb0bd;
var $4a265c46e3f8f73b$export$5f8d39834fd61797;
var $4a265c46e3f8f73b$export$74bf444e3cd11ea5;
var $4a265c46e3f8f73b$export$ae55be85d98224ed;
var $4a265c46e3f8f73b$export$e530037191fcd5d7;
var $4a265c46e3f8f73b$export$fd42f52fd3ae1109;
var $4a265c46e3f8f73b$export$c8a8987d4410bf2d;
var $4a265c46e3f8f73b$export$d38cd72104c1f0e9;
var $4a265c46e3f8f73b$export$7d1e3a5e95ceca43;
var $4a265c46e3f8f73b$export$257a8862b851cb5b;
var $4a265c46e3f8f73b$export$a8257692ac88316c;
var $4a265c46e3f8f73b$export$488013bae63b21da;
var $4a265c46e3f8f73b$export$7c73462e0d25e514;
var $4a265c46e3f8f73b$export$35808ee640e87ca7;
var $4a265c46e3f8f73b$export$fae74005e78b1a27;
var $4a265c46e3f8f73b$export$dc8fbce3eb94dc1e;
var $4a265c46e3f8f73b$export$6d9c69b0de29b591;
var $4a265c46e3f8f73b$export$d5a552a76deda3c2;
var $4a265c46e3f8f73b$export$e5c5a5f917a5871c;
var $4a265c46e3f8f73b$export$1538c33de8887b59;
var $4a265c46e3f8f73b$export$13e3392192263954;
var $4a265c46e3f8f73b$export$b8f5890fc79d6aca;
var $4a265c46e3f8f73b$export$60241385465d0a34;
var $4a265c46e3f8f73b$export$83d89fbfd8236492;
"use strict";

var $22Kv0 = parcelRequire("22Kv0");
var $4a265c46e3f8f73b$var$n = "function" === typeof Symbol && Symbol.for, $4a265c46e3f8f73b$var$p = $4a265c46e3f8f73b$var$n ? Symbol.for("react.element") : 60103, $4a265c46e3f8f73b$var$q = $4a265c46e3f8f73b$var$n ? Symbol.for("react.portal") : 60106, $4a265c46e3f8f73b$var$r = $4a265c46e3f8f73b$var$n ? Symbol.for("react.fragment") : 60107, $4a265c46e3f8f73b$var$t = $4a265c46e3f8f73b$var$n ? Symbol.for("react.strict_mode") : 60108, $4a265c46e3f8f73b$var$u = $4a265c46e3f8f73b$var$n ? Symbol.for("react.profiler") : 60114, $4a265c46e3f8f73b$var$v = $4a265c46e3f8f73b$var$n ? Symbol.for("react.provider") : 60109, $4a265c46e3f8f73b$var$w = $4a265c46e3f8f73b$var$n ? Symbol.for("react.context") : 60110, $4a265c46e3f8f73b$var$x = $4a265c46e3f8f73b$var$n ? Symbol.for("react.forward_ref") : 60112, $4a265c46e3f8f73b$var$y = $4a265c46e3f8f73b$var$n ? Symbol.for("react.suspense") : 60113, $4a265c46e3f8f73b$var$z = $4a265c46e3f8f73b$var$n ? Symbol.for("react.memo") : 60115, $4a265c46e3f8f73b$var$A = $4a265c46e3f8f73b$var$n ? Symbol.for("react.lazy") : 60116, $4a265c46e3f8f73b$var$B = "function" === typeof Symbol && Symbol.iterator;
function $4a265c46e3f8f73b$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4a265c46e3f8f73b$var$D = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $4a265c46e3f8f73b$var$E = {};
function $4a265c46e3f8f73b$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $4a265c46e3f8f73b$var$E;
    this.updater = c || $4a265c46e3f8f73b$var$D;
}
$4a265c46e3f8f73b$var$F.prototype.isReactComponent = {};
$4a265c46e3f8f73b$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($4a265c46e3f8f73b$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4a265c46e3f8f73b$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4a265c46e3f8f73b$var$G() {}
$4a265c46e3f8f73b$var$G.prototype = $4a265c46e3f8f73b$var$F.prototype;
function $4a265c46e3f8f73b$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $4a265c46e3f8f73b$var$E;
    this.updater = c || $4a265c46e3f8f73b$var$D;
}
var $4a265c46e3f8f73b$var$I = $4a265c46e3f8f73b$var$H.prototype = new $4a265c46e3f8f73b$var$G;
$4a265c46e3f8f73b$var$I.constructor = $4a265c46e3f8f73b$var$H;
$22Kv0($4a265c46e3f8f73b$var$I, $4a265c46e3f8f73b$var$F.prototype);
$4a265c46e3f8f73b$var$I.isPureReactComponent = !0;
var $4a265c46e3f8f73b$var$J = {
    current: null
}, $4a265c46e3f8f73b$var$K = Object.prototype.hasOwnProperty, $4a265c46e3f8f73b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4a265c46e3f8f73b$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$4a265c46e3f8f73b$var$K.call(b, e) && !$4a265c46e3f8f73b$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $4a265c46e3f8f73b$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $4a265c46e3f8f73b$var$J.current
    };
}
function $4a265c46e3f8f73b$var$N(a, b) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4a265c46e3f8f73b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4a265c46e3f8f73b$var$p;
}
function $4a265c46e3f8f73b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4a265c46e3f8f73b$var$P = /\/+/g, $4a265c46e3f8f73b$var$Q = [];
function $4a265c46e3f8f73b$var$R(a, b, c, e) {
    if ($4a265c46e3f8f73b$var$Q.length) {
        var d = $4a265c46e3f8f73b$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $4a265c46e3f8f73b$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $4a265c46e3f8f73b$var$Q.length && $4a265c46e3f8f73b$var$Q.push(a);
}
function $4a265c46e3f8f73b$var$T(a, b, c, e) {
    var d = typeof a === "undefined" ? "undefined" : (0, $gfRPo._)(a);
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4a265c46e3f8f73b$var$p:
                case $4a265c46e3f8f73b$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $4a265c46e3f8f73b$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $4a265c46e3f8f73b$var$U(d, k);
        g += $4a265c46e3f8f73b$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $4a265c46e3f8f73b$var$B && a[$4a265c46e3f8f73b$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $4a265c46e3f8f73b$var$U(d, k++), g += $4a265c46e3f8f73b$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($4a265c46e3f8f73b$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $4a265c46e3f8f73b$var$V(a, b, c) {
    return null == a ? 0 : $4a265c46e3f8f73b$var$T(a, "", b, c);
}
function $4a265c46e3f8f73b$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4a265c46e3f8f73b$var$escape(a.key) : b.toString(36);
}
function $4a265c46e3f8f73b$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $4a265c46e3f8f73b$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $4a265c46e3f8f73b$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($4a265c46e3f8f73b$var$O(a) && (a = $4a265c46e3f8f73b$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($4a265c46e3f8f73b$var$P, "$&/") + "/") + c)), e.push(a));
}
function $4a265c46e3f8f73b$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($4a265c46e3f8f73b$var$P, "$&/") + "/");
    b = $4a265c46e3f8f73b$var$R(b, g, e, d);
    $4a265c46e3f8f73b$var$V(a, $4a265c46e3f8f73b$var$aa, b);
    $4a265c46e3f8f73b$var$S(b);
}
var $4a265c46e3f8f73b$var$Y = {
    current: null
};
function $4a265c46e3f8f73b$var$Z() {
    var a = $4a265c46e3f8f73b$var$Y.current;
    if (null === a) throw Error($4a265c46e3f8f73b$var$C(321));
    return a;
}
var $4a265c46e3f8f73b$var$ba = {
    ReactCurrentDispatcher: $4a265c46e3f8f73b$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $4a265c46e3f8f73b$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $22Kv0
};
$4a265c46e3f8f73b$export$dca3b0875bd9a954 = {
    map: function map(a, b, c) {
        if (null == a) return a;
        var e = [];
        $4a265c46e3f8f73b$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function forEach(a, b, c) {
        if (null == a) return a;
        b = $4a265c46e3f8f73b$var$R(null, null, b, c);
        $4a265c46e3f8f73b$var$V(a, $4a265c46e3f8f73b$var$W, b);
        $4a265c46e3f8f73b$var$S(b);
    },
    count: function count(a) {
        return $4a265c46e3f8f73b$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function toArray(a) {
        var b = [];
        $4a265c46e3f8f73b$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function only(a) {
        if (!$4a265c46e3f8f73b$var$O(a)) throw Error($4a265c46e3f8f73b$var$C(143));
        return a;
    }
};
$4a265c46e3f8f73b$export$16fa2f45be04daa8 = $4a265c46e3f8f73b$var$F;
$4a265c46e3f8f73b$export$ffb0004e005737fa = $4a265c46e3f8f73b$var$r;
$4a265c46e3f8f73b$export$e2c29f18771995cb = $4a265c46e3f8f73b$var$u;
$4a265c46e3f8f73b$export$221d75b3f55bb0bd = $4a265c46e3f8f73b$var$H;
$4a265c46e3f8f73b$export$5f8d39834fd61797 = $4a265c46e3f8f73b$var$t;
$4a265c46e3f8f73b$export$74bf444e3cd11ea5 = $4a265c46e3f8f73b$var$y;
$4a265c46e3f8f73b$export$ae55be85d98224ed = $4a265c46e3f8f73b$var$ba;
$4a265c46e3f8f73b$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($4a265c46e3f8f73b$var$C(267, a));
    var e = $22Kv0({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $4a265c46e3f8f73b$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$4a265c46e3f8f73b$var$K.call(b, h) && !$4a265c46e3f8f73b$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $4a265c46e3f8f73b$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$4a265c46e3f8f73b$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $4a265c46e3f8f73b$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $4a265c46e3f8f73b$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$4a265c46e3f8f73b$export$c8a8987d4410bf2d = $4a265c46e3f8f73b$var$M;
$4a265c46e3f8f73b$export$d38cd72104c1f0e9 = function(a) {
    var b = $4a265c46e3f8f73b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4a265c46e3f8f73b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4a265c46e3f8f73b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$x,
        render: a
    };
};
$4a265c46e3f8f73b$export$a8257692ac88316c = $4a265c46e3f8f73b$var$O;
$4a265c46e3f8f73b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$4a265c46e3f8f73b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4a265c46e3f8f73b$export$35808ee640e87ca7 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useCallback(a, b);
};
$4a265c46e3f8f73b$export$fae74005e78b1a27 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useContext(a, b);
};
$4a265c46e3f8f73b$export$dc8fbce3eb94dc1e = function() {};
$4a265c46e3f8f73b$export$6d9c69b0de29b591 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useEffect(a, b);
};
$4a265c46e3f8f73b$export$d5a552a76deda3c2 = function(a, b, c) {
    return $4a265c46e3f8f73b$var$Z().useImperativeHandle(a, b, c);
};
$4a265c46e3f8f73b$export$e5c5a5f917a5871c = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useLayoutEffect(a, b);
};
$4a265c46e3f8f73b$export$1538c33de8887b59 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useMemo(a, b);
};
$4a265c46e3f8f73b$export$13e3392192263954 = function(a, b, c) {
    return $4a265c46e3f8f73b$var$Z().useReducer(a, b, c);
};
$4a265c46e3f8f73b$export$b8f5890fc79d6aca = function(a) {
    return $4a265c46e3f8f73b$var$Z().useRef(a);
};
$4a265c46e3f8f73b$export$60241385465d0a34 = function(a) {
    return $4a265c46e3f8f73b$var$Z().useState(a);
};
$4a265c46e3f8f73b$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("22Kv0", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $17cfd6695af3e4f0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $17cfd6695af3e4f0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $17cfd6695af3e4f0$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $17cfd6695af3e4f0$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $17cfd6695af3e4f0$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $17cfd6695af3e4f0$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $17cfd6695af3e4f0$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($17cfd6695af3e4f0$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($17cfd6695af3e4f0$var$getOwnPropertySymbols) {
            symbols = $17cfd6695af3e4f0$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($17cfd6695af3e4f0$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("2Ng4w", function(module, exports) {

$parcel$export(module.exports, "failwith", function () { return $208c9febbffc0b64$export$dfacdc1bc3225b90; });
$parcel$export(module.exports, "abs", function () { return $208c9febbffc0b64$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "string_of_bool", function () { return $208c9febbffc0b64$export$d72f3e5a2687b7c4; });
$parcel$export(module.exports, "bool_of_string", function () { return $208c9febbffc0b64$export$7c5ed232a36d4124; });

var $iv6Yc = parcelRequire("iv6Yc");

var $6VA9O = parcelRequire("6VA9O");

var $kiuDo = parcelRequire("kiuDo");

var $axd0Z = parcelRequire("axd0Z");

var $1xvYg = parcelRequire("1xvYg");

var $bBMv4 = parcelRequire("bBMv4");
function $208c9febbffc0b64$export$dfacdc1bc3225b90(s) {
    throw {
        RE_EXN_ID: "Failure",
        _1: s,
        Error: new Error()
    };
}
function $208c9febbffc0b64$export$e28c21756d6cd4fd(s) {
    throw {
        RE_EXN_ID: "Invalid_argument",
        _1: s,
        Error: new Error()
    };
}
var $208c9febbffc0b64$export$6b467f3d80cc56bd = /* @__PURE__ */ $1xvYg.create("Pervasives.Exit");
function $208c9febbffc0b64$export$2335f513bbd82c6d(x) {
    if (x >= 0) return x;
    else return -x | 0;
}
function $208c9febbffc0b64$export$b8bfb75c96708e0b(x) {
    return x ^ -1;
}
var $208c9febbffc0b64$export$8c5d7acc34381e45 = -2147483648;
function $208c9febbffc0b64$export$522de874f1f7af40(x) {
    if (isFinite(x)) {
        if (Math.abs(x) >= 2.22507385850720138e-308) return /* FP_normal */ 0;
        else if (x !== 0) return /* FP_subnormal */ 1;
        else return /* FP_zero */ 2;
    } else if (isNaN(x)) return /* FP_nan */ 4;
    else return /* FP_infinite */ 3;
}
function $208c9febbffc0b64$export$869f5b0f7c1164e(n) {
    if (n < 0 || n > 255) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "char_of_int",
        Error: new Error()
    };
    return n;
}
function $208c9febbffc0b64$export$d72f3e5a2687b7c4(b) {
    if (b) return "true";
    else return "false";
}
function $208c9febbffc0b64$export$7c5ed232a36d4124(param) {
    switch(param){
        case "false":
            return false;
        case "true":
            return true;
        default:
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "bool_of_string",
                Error: new Error()
            };
    }
}
function $208c9febbffc0b64$export$5412d0c7f1b0c2c9(param) {
    switch(param){
        case "false":
            return false;
        case "true":
            return true;
        default:
            return;
    }
}
function $208c9febbffc0b64$export$f0d530eee4c0f3d2(s) {
    try {
        return $kiuDo.int_of_string(s);
    } catch (raw_exn) {
        var exn = $bBMv4.internalToOCamlException(raw_exn);
        if (exn.RE_EXN_ID === "Failure") return;
        throw exn;
    }
}
function $208c9febbffc0b64$export$209d0e37ffa1400a(s) {
    var l = s.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i >= l) return s + ".";
        var match = $axd0Z.get(s, i);
        if (match >= 48) {
            if (match >= 58) return s;
            _i = i + 1 | 0;
            continue;
        }
        if (match !== 45) return s;
        _i = i + 1 | 0;
        continue;
    }
}
function $208c9febbffc0b64$export$bb64ca0876cf9550(f) {
    return $208c9febbffc0b64$export$209d0e37ffa1400a($kiuDo.format_float("%.12g", f));
}
function $208c9febbffc0b64$export$9f0301bf5008d9e8(s) {
    try {
        return $kiuDo.float_of_string(s);
    } catch (raw_exn) {
        var exn = $bBMv4.internalToOCamlException(raw_exn);
        if (exn.RE_EXN_ID === "Failure") return;
        throw exn;
    }
}
function $208c9febbffc0b64$export$70df91f55959aaf8(l1, l2) {
    if (l1) return {
        hd: l1.hd,
        tl: $208c9febbffc0b64$export$70df91f55959aaf8(l1.tl, l2)
    };
    else return l2;
}
function $208c9febbffc0b64$export$17f66b3ecf98e55f(param) {
    console.log("");
}
function $208c9febbffc0b64$export$6d7cae81c2ba3604(param) {
    console.error("");
}
function $208c9febbffc0b64$export$80570877a21ed78d(i) {
    console.log(String(i));
}
function $208c9febbffc0b64$export$1a2402adf83b7def(i) {
    console.log($208c9febbffc0b64$export$209d0e37ffa1400a($kiuDo.format_float("%.12g", i)));
}
function $208c9febbffc0b64$export$3ac97a7df6b534cb(prim) {
    console.log(prim);
}
var $208c9febbffc0b64$var$exit_function = {
    contents: function contents(prim) {}
};
function $208c9febbffc0b64$export$412e79380d04e5db(f) {
    var g = $208c9febbffc0b64$var$exit_function.contents;
    $208c9febbffc0b64$var$exit_function.contents = function(param) {
        $iv6Yc._1(f, undefined);
        $iv6Yc._1(g, undefined);
    };
}
function $208c9febbffc0b64$export$5c525e238923a57d(retcode) {
    $iv6Yc._1($208c9febbffc0b64$var$exit_function.contents, undefined);
    return $6VA9O.sys_exit(retcode);
}
var $208c9febbffc0b64$export$44174b80ac4a558e = 2147483647;
var $208c9febbffc0b64$export$a0978488bc4efbee = Infinity;
var $208c9febbffc0b64$export$7eaa4fcb52076062 = -Infinity;
var $208c9febbffc0b64$export$95eda9d7526c1155 = 1.79769313486231571e+308;
var $208c9febbffc0b64$export$e7c578afecb80c3a = 2.22507385850720138e-308;
var $208c9febbffc0b64$export$c7acb1007673d49d = 2.22044604925031308e-16;
 /* No side effect */ 
});
parcelRegister("6VA9O", function(module, exports) {

$parcel$export(module.exports, "sys_exit", function () { return $50b41d0573d00898$export$20f1234ab13f2efe; });

var $41cgx = parcelRequire("41cgx");
function $50b41d0573d00898$export$fdc1b5f462a25209(s) {
    if (typeof $41cgx === "undefined" || $41cgx.env === undefined) throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
    var x = $41cgx.env[s];
    if (x !== undefined) return x;
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
var $50b41d0573d00898$export$6ec267727e2e4048 = function os_type(_) {
    if (typeof $41cgx !== "undefined" && $41cgx.platform === "win32") return "Win32";
    else return "Unix";
};
function $50b41d0573d00898$export$ac900bd2a3bcc17e(param) {
    if (typeof $41cgx === "undefined" || $41cgx.uptime === undefined) return -1;
    else return $41cgx.uptime();
}
var $50b41d0573d00898$export$3ab03f4c8408420e = function sys_getcwd(param) {
    if (typeof $41cgx === "undefined" || $41cgx.cwd === undefined) return "/";
    return $41cgx.cwd();
};
function $50b41d0573d00898$export$27a88e70d8ffb16f(param) {
    if (typeof $41cgx === "undefined") return [
        "",
        [
            ""
        ]
    ];
    var argv = $41cgx.argv;
    if (argv == null) return [
        "",
        [
            ""
        ]
    ];
    else return [
        argv[0],
        argv
    ];
}
function $50b41d0573d00898$export$20f1234ab13f2efe(exit_code) {
    if (typeof $41cgx !== "undefined") return $41cgx.exit(exit_code);
}
function $50b41d0573d00898$export$c4789b0820c4ab62(_s) {
    throw {
        RE_EXN_ID: "Failure",
        _1: "sys_is_directory not implemented",
        Error: new Error()
    };
}
function $50b41d0573d00898$export$751d143c39c5bd0(_s) {
    throw {
        RE_EXN_ID: "Failure",
        _1: "sys_file_exists not implemented",
        Error: new Error()
    };
}
 /* No side effect */ 
});
parcelRegister("41cgx", function(module, exports) {
// shim for using process in browser
var $2ed0c51f0a1c31d6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2ed0c51f0a1c31d6$var$cachedSetTimeout;
var $2ed0c51f0a1c31d6$var$cachedClearTimeout;
function $2ed0c51f0a1c31d6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $2ed0c51f0a1c31d6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $2ed0c51f0a1c31d6$var$cachedSetTimeout = setTimeout;
        else $2ed0c51f0a1c31d6$var$cachedSetTimeout = $2ed0c51f0a1c31d6$var$defaultSetTimout;
    } catch (e) {
        $2ed0c51f0a1c31d6$var$cachedSetTimeout = $2ed0c51f0a1c31d6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $2ed0c51f0a1c31d6$var$cachedClearTimeout = clearTimeout;
        else $2ed0c51f0a1c31d6$var$cachedClearTimeout = $2ed0c51f0a1c31d6$var$defaultClearTimeout;
    } catch (e) {
        $2ed0c51f0a1c31d6$var$cachedClearTimeout = $2ed0c51f0a1c31d6$var$defaultClearTimeout;
    }
})();
function $2ed0c51f0a1c31d6$var$runTimeout(fun) {
    if ($2ed0c51f0a1c31d6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2ed0c51f0a1c31d6$var$cachedSetTimeout === $2ed0c51f0a1c31d6$var$defaultSetTimout || !$2ed0c51f0a1c31d6$var$cachedSetTimeout) && setTimeout) {
        $2ed0c51f0a1c31d6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2ed0c51f0a1c31d6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2ed0c51f0a1c31d6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2ed0c51f0a1c31d6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2ed0c51f0a1c31d6$var$runClearTimeout(marker) {
    if ($2ed0c51f0a1c31d6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2ed0c51f0a1c31d6$var$cachedClearTimeout === $2ed0c51f0a1c31d6$var$defaultClearTimeout || !$2ed0c51f0a1c31d6$var$cachedClearTimeout) && clearTimeout) {
        $2ed0c51f0a1c31d6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2ed0c51f0a1c31d6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2ed0c51f0a1c31d6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2ed0c51f0a1c31d6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2ed0c51f0a1c31d6$var$queue = [];
var $2ed0c51f0a1c31d6$var$draining = false;
var $2ed0c51f0a1c31d6$var$currentQueue;
var $2ed0c51f0a1c31d6$var$queueIndex = -1;
function $2ed0c51f0a1c31d6$var$cleanUpNextTick() {
    if (!$2ed0c51f0a1c31d6$var$draining || !$2ed0c51f0a1c31d6$var$currentQueue) return;
    $2ed0c51f0a1c31d6$var$draining = false;
    if ($2ed0c51f0a1c31d6$var$currentQueue.length) $2ed0c51f0a1c31d6$var$queue = $2ed0c51f0a1c31d6$var$currentQueue.concat($2ed0c51f0a1c31d6$var$queue);
    else $2ed0c51f0a1c31d6$var$queueIndex = -1;
    if ($2ed0c51f0a1c31d6$var$queue.length) $2ed0c51f0a1c31d6$var$drainQueue();
}
function $2ed0c51f0a1c31d6$var$drainQueue() {
    if ($2ed0c51f0a1c31d6$var$draining) return;
    var timeout = $2ed0c51f0a1c31d6$var$runTimeout($2ed0c51f0a1c31d6$var$cleanUpNextTick);
    $2ed0c51f0a1c31d6$var$draining = true;
    var len = $2ed0c51f0a1c31d6$var$queue.length;
    while(len){
        $2ed0c51f0a1c31d6$var$currentQueue = $2ed0c51f0a1c31d6$var$queue;
        $2ed0c51f0a1c31d6$var$queue = [];
        while(++$2ed0c51f0a1c31d6$var$queueIndex < len)if ($2ed0c51f0a1c31d6$var$currentQueue) $2ed0c51f0a1c31d6$var$currentQueue[$2ed0c51f0a1c31d6$var$queueIndex].run();
        $2ed0c51f0a1c31d6$var$queueIndex = -1;
        len = $2ed0c51f0a1c31d6$var$queue.length;
    }
    $2ed0c51f0a1c31d6$var$currentQueue = null;
    $2ed0c51f0a1c31d6$var$draining = false;
    $2ed0c51f0a1c31d6$var$runClearTimeout(timeout);
}
$2ed0c51f0a1c31d6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2ed0c51f0a1c31d6$var$queue.push(new $2ed0c51f0a1c31d6$var$Item(fun, args));
    if ($2ed0c51f0a1c31d6$var$queue.length === 1 && !$2ed0c51f0a1c31d6$var$draining) $2ed0c51f0a1c31d6$var$runTimeout($2ed0c51f0a1c31d6$var$drainQueue);
};
// v8 likes predictible objects
function $2ed0c51f0a1c31d6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2ed0c51f0a1c31d6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2ed0c51f0a1c31d6$var$process.title = "browser";
$2ed0c51f0a1c31d6$var$process.browser = true;
$2ed0c51f0a1c31d6$var$process.env = {};
$2ed0c51f0a1c31d6$var$process.argv = [];
$2ed0c51f0a1c31d6$var$process.version = ""; // empty string to avoid regexp issues
$2ed0c51f0a1c31d6$var$process.versions = {};
function $2ed0c51f0a1c31d6$var$noop() {}
$2ed0c51f0a1c31d6$var$process.on = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.addListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.once = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.off = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.removeListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.removeAllListeners = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.emit = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.prependListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.prependOnceListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.listeners = function(name) {
    return [];
};
$2ed0c51f0a1c31d6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$2ed0c51f0a1c31d6$var$process.cwd = function() {
    return "/";
};
$2ed0c51f0a1c31d6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$2ed0c51f0a1c31d6$var$process.umask = function() {
    return 0;
};

});


parcelRegister("kiuDo", function(module, exports) {

$parcel$export(module.exports, "int_of_string", function () { return $ec6d4076064b4af9$export$54f1a2c7334cd47a; });
$parcel$export(module.exports, "format_float", function () { return $ec6d4076064b4af9$export$a1cc16e22de035c2; });
$parcel$export(module.exports, "float_of_string", function () { return $ec6d4076064b4af9$export$e64a7892310c43e6; });

var $81N94 = parcelRequire("81N94");

var $dD1bi = parcelRequire("dD1bi");
function $ec6d4076064b4af9$var$parse_digit(c) {
    if (c >= 65) {
        if (c >= 97) {
            if (c >= 123) return -1;
            else return c - 87 | 0;
        } else if (c >= 91) return -1;
        else return c - 55 | 0;
    } else if (c > 57 || c < 48) return -1;
    else return c - /* '0' */ 48 | 0;
}
function $ec6d4076064b4af9$var$int_of_string_base(param) {
    switch(param){
        case /* Oct */ 0:
            return 8;
        case /* Hex */ 1:
            return 16;
        case /* Dec */ 2:
            return 10;
        case /* Bin */ 3:
            return 2;
    }
}
function $ec6d4076064b4af9$var$parse_sign_and_base(s) {
    var sign = 1;
    var base = /* Dec */ 2;
    var i = 0;
    var match = s.codePointAt(i);
    switch(match){
        case 43:
            i = i + 1 | 0;
            break;
        case 44:
            break;
        case 45:
            sign = -1;
            i = i + 1 | 0;
            break;
        default:
    }
    if (s.codePointAt(i) === /* '0' */ 48) {
        var match$1 = s.codePointAt(i + 1 | 0);
        if (match$1 >= 89) {
            if (match$1 >= 111) {
                if (match$1 < 121) switch(match$1){
                    case 111:
                        base = /* Oct */ 0;
                        i = i + 2 | 0;
                        break;
                    case 117:
                        i = i + 2 | 0;
                        break;
                    case 112:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 118:
                    case 119:
                        break;
                    case 120:
                        base = /* Hex */ 1;
                        i = i + 2 | 0;
                        break;
                }
            } else if (match$1 === 98) {
                base = /* Bin */ 3;
                i = i + 2 | 0;
            }
        } else if (match$1 !== 66) {
            if (match$1 >= 79) switch(match$1){
                case 79:
                    base = /* Oct */ 0;
                    i = i + 2 | 0;
                    break;
                case 85:
                    i = i + 2 | 0;
                    break;
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 86:
                case 87:
                    break;
                case 88:
                    base = /* Hex */ 1;
                    i = i + 2 | 0;
                    break;
            }
        } else {
            base = /* Bin */ 3;
            i = i + 2 | 0;
        }
    }
    return [
        i,
        sign,
        base
    ];
}
function $ec6d4076064b4af9$export$54f1a2c7334cd47a(s) {
    var match = $ec6d4076064b4af9$var$parse_sign_and_base(s);
    var i = match[0];
    var base = $ec6d4076064b4af9$var$int_of_string_base(match[2]);
    var threshold = 4294967295;
    var len = s.length;
    var c = i < len ? s.codePointAt(i) : /* '\000' */ 0;
    var d = $ec6d4076064b4af9$var$parse_digit(c);
    if (d < 0 || d >= base) throw {
        RE_EXN_ID: "Failure",
        _1: "int_of_string",
        Error: new Error()
    };
    var aux = function aux(_acc, _k) {
        while(true){
            var k = _k;
            var acc = _acc;
            if (k === len) return acc;
            var a = s.codePointAt(k);
            if (a === /* '_' */ 95) {
                _k = k + 1 | 0;
                continue;
            }
            var v = $ec6d4076064b4af9$var$parse_digit(a);
            if (v < 0 || v >= base) throw {
                RE_EXN_ID: "Failure",
                _1: "int_of_string",
                Error: new Error()
            };
            var acc$1 = base * acc + v;
            if (acc$1 > threshold) throw {
                RE_EXN_ID: "Failure",
                _1: "int_of_string",
                Error: new Error()
            };
            _k = k + 1 | 0;
            _acc = acc$1;
            continue;
        }
    };
    var res = match[1] * aux(d, i + 1 | 0);
    var or_res = res | 0;
    if (base === 10 && res !== or_res) throw {
        RE_EXN_ID: "Failure",
        _1: "int_of_string",
        Error: new Error()
    };
    return or_res;
}
function $ec6d4076064b4af9$export$7a154557857cbfac(s) {
    var match = $ec6d4076064b4af9$var$parse_sign_and_base(s);
    var hbase = match[2];
    var i = match[0];
    var base = $dD1bi.of_int32($ec6d4076064b4af9$var$int_of_string_base(hbase));
    var sign = $dD1bi.of_int32(match[1]);
    var threshold;
    switch(hbase){
        case /* Oct */ 0:
            threshold = [
                536870911,
                4294967295
            ];
            break;
        case /* Hex */ 1:
            threshold = [
                268435455,
                4294967295
            ];
            break;
        case /* Dec */ 2:
            threshold = [
                429496729,
                2576980377
            ];
            break;
        case /* Bin */ 3:
            threshold = $dD1bi.max_int;
            break;
    }
    var len = s.length;
    var c = i < len ? s.codePointAt(i) : /* '\000' */ 0;
    var d = $dD1bi.of_int32($ec6d4076064b4af9$var$parse_digit(c));
    if ($81N94.i64_lt(d, $dD1bi.zero) || $81N94.i64_ge(d, base)) throw {
        RE_EXN_ID: "Failure",
        _1: "int64_of_string",
        Error: new Error()
    };
    var aux = function aux(_acc, _k) {
        while(true){
            var k = _k;
            var acc = _acc;
            if (k === len) return acc;
            var a = s.codePointAt(k);
            if (a === /* '_' */ 95) {
                _k = k + 1 | 0;
                continue;
            }
            var v = $dD1bi.of_int32($ec6d4076064b4af9$var$parse_digit(a));
            if ($81N94.i64_lt(v, $dD1bi.zero) || $81N94.i64_ge(v, base) || $81N94.i64_gt(acc, threshold)) throw {
                RE_EXN_ID: "Failure",
                _1: "int64_of_string",
                Error: new Error()
            };
            var acc$1 = $dD1bi.add($dD1bi.mul(base, acc), v);
            _k = k + 1 | 0;
            _acc = acc$1;
            continue;
        }
    };
    var res = $dD1bi.mul(sign, aux(d, i + 1 | 0));
    var or_res = $dD1bi.or_(res, $dD1bi.zero);
    if ($81N94.i64_eq(base, [
        0,
        10
    ]) && $81N94.i64_neq(res, or_res)) throw {
        RE_EXN_ID: "Failure",
        _1: "int64_of_string",
        Error: new Error()
    };
    return or_res;
}
function $ec6d4076064b4af9$var$int_of_base(param) {
    switch(param){
        case /* Oct */ 0:
            return 8;
        case /* Hex */ 1:
            return 16;
        case /* Dec */ 2:
            return 10;
    }
}
function $ec6d4076064b4af9$var$lowercase(c) {
    if (c >= /* 'A' */ 65 && c <= /* 'Z' */ 90 || c >= /* '\192' */ 192 && c <= /* '\214' */ 214 || c >= /* '\216' */ 216 && c <= /* '\222' */ 222) return c + 32 | 0;
    else return c;
}
function $ec6d4076064b4af9$var$parse_format(fmt) {
    var len = fmt.length;
    if (len > 31) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "format_int: format too long",
        Error: new Error()
    };
    var f = {
        justify: "+",
        signstyle: "-",
        filter: " ",
        alternate: false,
        base: /* Dec */ 2,
        signedconv: false,
        width: 0,
        uppercase: false,
        sign: 1,
        prec: -1,
        conv: "f"
    };
    var _i = 0;
    while(true){
        var i = _i;
        if (i >= len) return f;
        var c = fmt.codePointAt(i);
        var exit = 0;
        if (c >= 69) {
            if (c >= 88) {
                if (c >= 121) exit = 1;
                else switch(c){
                    case 88:
                        f.base = /* Hex */ 1;
                        f.uppercase = true;
                        _i = i + 1 | 0;
                        continue;
                    case 101:
                    case 102:
                    case 103:
                        exit = 5;
                        break;
                    case 100:
                    case 105:
                        exit = 4;
                        break;
                    case 111:
                        f.base = /* Oct */ 0;
                        _i = i + 1 | 0;
                        continue;
                    case 117:
                        f.base = /* Dec */ 2;
                        _i = i + 1 | 0;
                        continue;
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                    case 93:
                    case 94:
                    case 95:
                    case 96:
                    case 97:
                    case 98:
                    case 99:
                    case 104:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 112:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 118:
                    case 119:
                        exit = 1;
                        break;
                    case 120:
                        f.base = /* Hex */ 1;
                        _i = i + 1 | 0;
                        continue;
                }
            } else if (c >= 72) exit = 1;
            else {
                f.signedconv = true;
                f.uppercase = true;
                f.conv = String.fromCharCode($ec6d4076064b4af9$var$lowercase(c));
                _i = i + 1 | 0;
                continue;
            }
        } else switch(c){
            case 35:
                f.alternate = true;
                _i = i + 1 | 0;
                continue;
            case 32:
            case 43:
                exit = 2;
                break;
            case 45:
                f.justify = "-";
                _i = i + 1 | 0;
                continue;
            case 46:
                f.prec = 0;
                var j = i + 1 | 0;
                while((function(j) {
                    return function() {
                        var w = fmt.codePointAt(j) - /* '0' */ 48 | 0;
                        return w >= 0 && w <= 9;
                    };
                })(j)()){
                    f.prec = (Math.imul(f.prec, 10) + fmt.codePointAt(j) | 0) - /* '0' */ 48 | 0;
                    j = j + 1 | 0;
                }
                _i = j;
                continue;
            case 33:
            case 34:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
            case 41:
            case 42:
            case 44:
            case 47:
                exit = 1;
                break;
            case 48:
                f.filter = "0";
                _i = i + 1 | 0;
                continue;
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                exit = 3;
                break;
            default:
                exit = 1;
        }
        switch(exit){
            case 1:
                _i = i + 1 | 0;
                continue;
            case 2:
                f.signstyle = String.fromCharCode(c);
                _i = i + 1 | 0;
                continue;
            case 3:
                f.width = 0;
                var j$1 = i;
                while((function(j$1) {
                    return function() {
                        var w = fmt.codePointAt(j$1) - /* '0' */ 48 | 0;
                        return w >= 0 && w <= 9;
                    };
                })(j$1)()){
                    f.width = (Math.imul(f.width, 10) + fmt.codePointAt(j$1) | 0) - /* '0' */ 48 | 0;
                    j$1 = j$1 + 1 | 0;
                }
                _i = j$1;
                continue;
            case 4:
                f.signedconv = true;
                f.base = /* Dec */ 2;
                _i = i + 1 | 0;
                continue;
            case 5:
                f.signedconv = true;
                f.conv = String.fromCharCode(c);
                _i = i + 1 | 0;
                continue;
        }
    }
}
function $ec6d4076064b4af9$var$finish_formatting(config, rawbuffer) {
    var justify = config.justify;
    var signstyle = config.signstyle;
    var filter = config.filter;
    var alternate = config.alternate;
    var base = config.base;
    var signedconv = config.signedconv;
    var width = config.width;
    var uppercase = config.uppercase;
    var sign = config.sign;
    var len = rawbuffer.length;
    if (signedconv && (sign < 0 || signstyle !== "-")) len = len + 1 | 0;
    if (alternate) {
        if (base === /* Oct */ 0) len = len + 1 | 0;
        else if (base === /* Hex */ 1) len = len + 2 | 0;
    }
    var buffer = "";
    if (justify === "+" && filter === " ") for(var _for = len; _for < width; ++_for)buffer = buffer + filter;
    if (signedconv) {
        if (sign < 0) buffer = buffer + "-";
        else if (signstyle !== "-") buffer = buffer + signstyle;
    }
    if (alternate && base === /* Oct */ 0) buffer = buffer + "0";
    if (alternate && base === /* Hex */ 1) buffer = buffer + "0x";
    if (justify === "+" && filter === "0") for(var _for$1 = len; _for$1 < width; ++_for$1)buffer = buffer + filter;
    buffer = uppercase ? buffer + rawbuffer.toUpperCase() : buffer + rawbuffer;
    if (justify === "-") for(var _for$2 = len; _for$2 < width; ++_for$2)buffer = buffer + " ";
    return buffer;
}
function $ec6d4076064b4af9$export$7c65dd8409f37a29(fmt, i) {
    if (fmt === "%d") return String(i);
    var f = $ec6d4076064b4af9$var$parse_format(fmt);
    var i$1 = i < 0 ? f.signedconv ? (f.sign = -1, -i >>> 0) : i >>> 0 : i;
    var s = i$1.toString($ec6d4076064b4af9$var$int_of_base(f.base));
    if (f.prec >= 0) {
        f.filter = " ";
        var n = f.prec - s.length | 0;
        if (n > 0) s = "0".repeat(n) + s;
    }
    return $ec6d4076064b4af9$var$finish_formatting(f, s);
}
function $ec6d4076064b4af9$var$dec_of_pos_int64(x) {
    if (!$81N94.i64_lt(x, $dD1bi.zero)) return $dD1bi.to_string(x);
    var wbase = [
        0,
        10
    ];
    var y = $dD1bi.discard_sign(x);
    var match = $dD1bi.div_mod(y, wbase);
    var match$1 = $dD1bi.div_mod($dD1bi.add([
        0,
        8
    ], match[1]), wbase);
    var quotient = $dD1bi.add($dD1bi.add([
        214748364,
        3435973836
    ], match[0]), match$1[0]);
    return $dD1bi.to_string(quotient) + "0123456789"[$dD1bi.to_int32(match$1[1])];
}
function $ec6d4076064b4af9$var$oct_of_int64(x) {
    var s = "";
    var wbase = [
        0,
        8
    ];
    var cvtbl = "01234567";
    if ($81N94.i64_lt(x, $dD1bi.zero)) {
        var y = $dD1bi.discard_sign(x);
        var match = $dD1bi.div_mod(y, wbase);
        var quotient = $dD1bi.add([
            268435456,
            0
        ], match[0]);
        var modulus = match[1];
        s = cvtbl[$dD1bi.to_int32(modulus)] + s;
        while($81N94.i64_neq(quotient, $dD1bi.zero)){
            var match$1 = $dD1bi.div_mod(quotient, wbase);
            quotient = match$1[0];
            modulus = match$1[1];
            s = cvtbl[$dD1bi.to_int32(modulus)] + s;
        }
    } else {
        var match$2 = $dD1bi.div_mod(x, wbase);
        var quotient$1 = match$2[0];
        var modulus$1 = match$2[1];
        s = cvtbl[$dD1bi.to_int32(modulus$1)] + s;
        while($81N94.i64_neq(quotient$1, $dD1bi.zero)){
            var match$3 = $dD1bi.div_mod(quotient$1, wbase);
            quotient$1 = match$3[0];
            modulus$1 = match$3[1];
            s = cvtbl[$dD1bi.to_int32(modulus$1)] + s;
        }
    }
    return s;
}
function $ec6d4076064b4af9$export$890b36441b21018a(fmt, x) {
    if (fmt === "%d") return $dD1bi.to_string(x);
    var f = $ec6d4076064b4af9$var$parse_format(fmt);
    var x$1 = f.signedconv && $81N94.i64_lt(x, $dD1bi.zero) ? (f.sign = -1, $dD1bi.neg(x)) : x;
    var match = f.base;
    var s;
    switch(match){
        case /* Oct */ 0:
            s = $ec6d4076064b4af9$var$oct_of_int64(x$1);
            break;
        case /* Hex */ 1:
            s = $dD1bi.to_hex(x$1);
            break;
        case /* Dec */ 2:
            s = $ec6d4076064b4af9$var$dec_of_pos_int64(x$1);
            break;
    }
    var fill_s;
    if (f.prec >= 0) {
        f.filter = " ";
        var n = f.prec - s.length | 0;
        fill_s = n > 0 ? "0".repeat(n) + s : s;
    } else fill_s = s;
    return $ec6d4076064b4af9$var$finish_formatting(f, fill_s);
}
function $ec6d4076064b4af9$export$a1cc16e22de035c2(fmt, x) {
    var f = $ec6d4076064b4af9$var$parse_format(fmt);
    var prec = f.prec < 0 ? 6 : f.prec;
    var x$1 = x < 0 ? (f.sign = -1, -x) : x;
    var s = "";
    if (isNaN(x$1)) {
        s = "nan";
        f.filter = " ";
    } else if (isFinite(x$1)) {
        var match = f.conv;
        switch(match){
            case "e":
                s = x$1.toExponential(prec);
                var i = s.length;
                if (s.codePointAt(i - 3 | 0) === /* 'e' */ 101) s = s.slice(0, i - 1 | 0) + ("0" + s.slice(i - 1 | 0));
                break;
            case "f":
                s = x$1.toFixed(prec);
                break;
            case "g":
                var prec$1 = prec !== 0 ? prec : 1;
                s = x$1.toExponential(prec$1 - 1 | 0);
                var j = s.indexOf("e");
                var exp = Number(s.slice(j + 1 | 0)) | 0;
                if (exp < -4 || x$1 >= 1e21 || x$1.toFixed().length > prec$1) {
                    var i$1 = j - 1 | 0;
                    while(s.codePointAt(i$1) === /* '0' */ 48)i$1 = i$1 - 1 | 0;
                    if (s.codePointAt(i$1) === /* '.' */ 46) i$1 = i$1 - 1 | 0;
                    s = s.slice(0, i$1 + 1 | 0) + s.slice(j);
                    var i$2 = s.length;
                    if (s.codePointAt(i$2 - 3 | 0) === /* 'e' */ 101) s = s.slice(0, i$2 - 1 | 0) + ("0" + s.slice(i$2 - 1 | 0));
                } else {
                    var p = prec$1;
                    if (exp < 0) {
                        p = p - (exp + 1 | 0) | 0;
                        s = x$1.toFixed(p);
                    } else while(function() {
                        s = x$1.toFixed(p);
                        return s.length > (prec$1 + 1 | 0);
                    }())p = p - 1 | 0;
                    if (p !== 0) {
                        var k = s.length - 1 | 0;
                        while(s.codePointAt(k) === /* '0' */ 48)k = k - 1 | 0;
                        if (s.codePointAt(k) === /* '.' */ 46) k = k - 1 | 0;
                        s = s.slice(0, k + 1 | 0);
                    }
                }
                break;
            default:
        }
    } else {
        s = "inf";
        f.filter = " ";
    }
    return $ec6d4076064b4af9$var$finish_formatting(f, s);
}
var $ec6d4076064b4af9$export$6b16f782609bad1d = function hexstring_of_float(x, prec, style) {
    if (!isFinite(x)) {
        if (isNaN(x)) return "nan";
        return x > 0 ? "infinity" : "-infinity";
    }
    var sign = x == 0 && 1 / x == -Infinity ? 1 : x >= 0 ? 0 : 1;
    if (sign) x = -x;
    var exp = 0;
    if (x == 0) ;
    else if (x < 1) while(x < 1 && exp > -1022){
        x *= 2;
        exp--;
    }
    else while(x >= 2){
        x /= 2;
        exp++;
    }
    var exp_sign = exp < 0 ? "" : "+";
    var sign_str = "";
    if (sign) sign_str = "-";
    else switch(style){
        case 43 /* '+' */ :
            sign_str = "+";
            break;
        case 32 /* ' ' */ :
            sign_str = " ";
            break;
        default:
            break;
    }
    if (prec >= 0 && prec < 13) {
        /* If a precision is given, and is small, round mantissa accordingly */ var cst = Math.pow(2, prec * 4);
        x = Math.round(x * cst) / cst;
    }
    var x_str = x.toString(16);
    if (prec >= 0) {
        var idx = x_str.indexOf(".");
        if (idx < 0) x_str += "." + "0".repeat(prec);
        else {
            var size = idx + 1 + prec;
            if (x_str.length < size) x_str += "0".repeat(size - x_str.length);
            else x_str = x_str.substr(0, size);
        }
    }
    return sign_str + "0x" + x_str + "p" + exp_sign + exp.toString(10);
};
var $ec6d4076064b4af9$var$float_of_string = function float_of_string(s, exn) {
    var res = +s;
    if (s.length > 0 && res === res) return res;
    s = s.replace(/_/g, "");
    res = +s;
    if (s.length > 0 && res === res || /^[+-]?nan$/i.test(s)) return res;
    var m = /^ *([+-]?)0x([0-9a-f]+)\.?([0-9a-f]*)p([+-]?[0-9]+)/i.exec(s);
    //            1        2             3           4
    if (m) {
        var m3 = m[3].replace(/0+$/, "");
        var mantissa = parseInt(m[1] + m[2] + m3, 16);
        var exponent = (m[4] | 0) - 4 * m3.length;
        res = mantissa * Math.pow(2, exponent);
        return res;
    }
    if (/^\+?inf(inity)?$/i.test(s)) return Infinity;
    if (/^-inf(inity)?$/i.test(s)) return -Infinity;
    throw exn;
};
function $ec6d4076064b4af9$export$e64a7892310c43e6(s) {
    return $ec6d4076064b4af9$var$float_of_string(s, {
        RE_EXN_ID: "Failure",
        _1: "float_of_string"
    });
}
 /* No side effect */ 
});
parcelRegister("dD1bi", function(module, exports) {

$parcel$export(module.exports, "max_int", function () { return $9ebfd56c1029ee4d$export$44174b80ac4a558e; });
$parcel$export(module.exports, "zero", function () { return $9ebfd56c1029ee4d$export$7f9972325ebfd559; });
$parcel$export(module.exports, "neg", function () { return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5; });
$parcel$export(module.exports, "add", function () { return $9ebfd56c1029ee4d$export$e16d8520af44a096; });
$parcel$export(module.exports, "mul", function () { return $9ebfd56c1029ee4d$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "or_", function () { return $9ebfd56c1029ee4d$export$77e609ef32e106a4; });
$parcel$export(module.exports, "to_float", function () { return $9ebfd56c1029ee4d$export$179d0ee7d36d1d50; });
$parcel$export(module.exports, "of_float", function () { return $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6; });
$parcel$export(module.exports, "to_string", function () { return $9ebfd56c1029ee4d$export$46c173f28beef960; });
$parcel$export(module.exports, "div_mod", function () { return $9ebfd56c1029ee4d$export$6bd85662b525b3b9; });
$parcel$export(module.exports, "of_int32", function () { return $9ebfd56c1029ee4d$export$c0dea48708041221; });
$parcel$export(module.exports, "to_int32", function () { return $9ebfd56c1029ee4d$export$a6caf603acdaf417; });
$parcel$export(module.exports, "to_hex", function () { return $9ebfd56c1029ee4d$export$b34392537f2698a2; });
$parcel$export(module.exports, "discard_sign", function () { return $9ebfd56c1029ee4d$export$451161f7dbaf7ee5; });
$parcel$export(module.exports, "float_of_bits", function () { return $9ebfd56c1029ee4d$export$15bac053cf5e8d01; });
$parcel$export(module.exports, "bits_of_float", function () { return $9ebfd56c1029ee4d$export$f759bca77b24f29e; });

var $81N94 = parcelRequire("81N94");
function $9ebfd56c1029ee4d$export$ad7cae49b56e2eb8(lo, hi) {
    return [
        hi,
        lo >>> 0
    ];
}
var $9ebfd56c1029ee4d$export$8c5d7acc34381e45 = [
    -2147483648,
    0
];
var $9ebfd56c1029ee4d$export$44174b80ac4a558e = [
    2147483647,
    4294967295
];
var $9ebfd56c1029ee4d$export$80bf7733f1207381 = [
    0,
    1
];
var $9ebfd56c1029ee4d$export$7f9972325ebfd559 = [
    0,
    0
];
var $9ebfd56c1029ee4d$export$8258efd2c6861b6b = [
    -1,
    4294967295
];
function $9ebfd56c1029ee4d$var$neg_signed(x) {
    return (x & -2147483648) !== 0;
}
function $9ebfd56c1029ee4d$var$non_neg_signed(x) {
    return (x & -2147483648) === 0;
}
function $9ebfd56c1029ee4d$export$61d85e1612867711(param) {
    var x_lo = param[1];
    var x_hi = param[0];
    var lo = x_lo + 1 | 0;
    return [
        x_hi + (lo === 0 ? 1 : 0) | 0,
        lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(param) {
    var other_lo = (param[1] ^ -1) + 1 | 0;
    return [
        (param[0] ^ -1) + (other_lo === 0 ? 1 : 0) | 0,
        other_lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$var$add_aux(param, y_lo, y_hi) {
    var x_lo = param[1];
    var lo = x_lo + y_lo | 0;
    var overflow = $9ebfd56c1029ee4d$var$neg_signed(x_lo) && ($9ebfd56c1029ee4d$var$neg_signed(y_lo) || $9ebfd56c1029ee4d$var$non_neg_signed(lo)) || $9ebfd56c1029ee4d$var$neg_signed(y_lo) && $9ebfd56c1029ee4d$var$non_neg_signed(lo) ? 1 : 0;
    return [
        param[0] + y_hi + overflow | 0,
        lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$e16d8520af44a096(self, param) {
    return $9ebfd56c1029ee4d$var$add_aux(self, param[1], param[0]);
}
function $9ebfd56c1029ee4d$export$411ce8e5a71e3069(x, y) {
    if (x[1] === y[1]) return x[0] === y[0];
    else return false;
}
function $9ebfd56c1029ee4d$export$59e6990050957897(x, y) {
    if (y !== null) return $81N94.i64_eq(x, y);
    else return false;
}
function $9ebfd56c1029ee4d$export$f1ff0552b435f9a8(x, y) {
    if (y !== undefined) return $81N94.i64_eq(x, y);
    else return false;
}
function $9ebfd56c1029ee4d$export$82648b0ea8b9e17f(x, y) {
    if (y == null) return false;
    else return $81N94.i64_eq(x, y);
}
function $9ebfd56c1029ee4d$var$sub_aux(x, lo, hi) {
    var y_lo = (lo ^ -1) + 1 >>> 0;
    var y_hi = (hi ^ -1) + (y_lo === 0 ? 1 : 0) | 0;
    return $9ebfd56c1029ee4d$var$add_aux(x, y_lo, y_hi);
}
function $9ebfd56c1029ee4d$export$f93b5905241a7cca(self, param) {
    return $9ebfd56c1029ee4d$var$sub_aux(self, param[1], param[0]);
}
function $9ebfd56c1029ee4d$export$b824a15733c7c982(x, numBits) {
    if (numBits === 0) return x;
    var lo = x[1];
    if (numBits >= 32) return [
        lo << (numBits - 32 | 0),
        0
    ];
    else return [
        lo >>> (32 - numBits | 0) | x[0] << numBits,
        lo << numBits >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$9f754e9462ba943d(x, numBits) {
    if (numBits === 0) return x;
    var hi = x[0];
    var offset = numBits - 32 | 0;
    if (offset === 0) return [
        0,
        hi >>> 0
    ];
    else if (offset > 0) return [
        0,
        hi >>> offset
    ];
    else return [
        hi >>> numBits,
        (hi << (-offset | 0) | x[1] >>> numBits) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$fd2f69ca989c391d(x, numBits) {
    if (numBits === 0) return x;
    var hi = x[0];
    if (numBits < 32) return [
        hi >> numBits,
        (hi << (32 - numBits | 0) | x[1] >>> numBits) >>> 0
    ];
    else return [
        hi >= 0 ? 0 : -1,
        hi >> (numBits - 32 | 0) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$d141fa6c6d93da6f(param) {
    if (param[0] !== 0) return false;
    else return param[1] === 0;
}
function $9ebfd56c1029ee4d$export$6e3a27864ab166fe(_this, _other) {
    while(true){
        var other = _other;
        var $$this = _this;
        var lo;
        var this_hi = $$this[0];
        var exit = 0;
        var exit$1 = 0;
        var exit$2 = 0;
        if (this_hi !== 0) exit$2 = 4;
        else {
            if ($$this[1] === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
            exit$2 = 4;
        }
        if (exit$2 === 4) {
            if (other[0] !== 0) exit$1 = 3;
            else {
                if (other[1] === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
                exit$1 = 3;
            }
        }
        if (exit$1 === 3) {
            if (this_hi !== -2147483648 || $$this[1] !== 0) exit = 2;
            else lo = other[1];
        }
        if (exit === 2) {
            var other_hi = other[0];
            var lo$1 = $$this[1];
            var exit$3 = 0;
            if (other_hi !== -2147483648 || other[1] !== 0) exit$3 = 3;
            else lo = lo$1;
            if (exit$3 === 3) {
                var other_lo = other[1];
                if (this_hi < 0) {
                    if (other_hi >= 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$6e3a27864ab166fe($9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($$this), other));
                    _other = $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(other);
                    _this = $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($$this);
                    continue;
                }
                if (other_hi < 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$6e3a27864ab166fe($$this, $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(other)));
                var a48 = this_hi >>> 16;
                var a32 = this_hi & 65535;
                var a16 = lo$1 >>> 16;
                var a00 = lo$1 & 65535;
                var b48 = other_hi >>> 16;
                var b32 = other_hi & 65535;
                var b16 = other_lo >>> 16;
                var b00 = other_lo & 65535;
                var c48 = 0;
                var c32 = 0;
                var c16 = 0;
                var c00 = a00 * b00;
                c16 = (c00 >>> 16) + a16 * b00;
                c32 = c16 >>> 16;
                c16 = (c16 & 65535) + a00 * b16;
                c32 = c32 + (c16 >>> 16) + a32 * b00;
                c48 = c32 >>> 16;
                c32 = (c32 & 65535) + a16 * b16;
                c48 = c48 + (c32 >>> 16);
                c32 = (c32 & 65535) + a00 * b32;
                c48 = c48 + (c32 >>> 16);
                c32 = c32 & 65535;
                c48 = c48 + (a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48) & 65535;
                return [
                    c32 | c48 << 16,
                    (c00 & 65535 | (c16 & 65535) << 16) >>> 0
                ];
            }
        }
        if ((lo & 1) === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
        else return $9ebfd56c1029ee4d$export$8c5d7acc34381e45;
    }
}
function $9ebfd56c1029ee4d$export$6444ef5cd411280c(param, param$1) {
    return [
        param[0] ^ param$1[0],
        (param[1] ^ param$1[1]) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$77e609ef32e106a4(param, param$1) {
    return [
        param[0] | param$1[0],
        (param[1] | param$1[1]) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$2be5551b2b7d0f3c(param, param$1) {
    return [
        param[0] & param$1[0],
        (param[1] & param$1[1]) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$179d0ee7d36d1d50(param) {
    return param[0] * 0x100000000 + param[1];
}
function $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(x) {
    if (isNaN(x) || !isFinite(x)) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
    if (x <= -9223372036854776000) return $9ebfd56c1029ee4d$export$8c5d7acc34381e45;
    if (x + 1 >= 9.22337203685477581e+18) return $9ebfd56c1029ee4d$export$44174b80ac4a558e;
    if (x < 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(-x));
    var hi = x / 4294967296 | 0;
    var lo = x % 4294967296 | 0;
    return [
        hi,
        lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$var$isSafeInteger(param) {
    var hi = param[0];
    var top11Bits = hi >> 21;
    if (top11Bits === 0) return true;
    else if (top11Bits === -1) return !(param[1] === 0 && hi === -2097152);
    else return false;
}
function $9ebfd56c1029ee4d$export$46c173f28beef960(self) {
    if ($9ebfd56c1029ee4d$var$isSafeInteger(self)) return String($9ebfd56c1029ee4d$export$179d0ee7d36d1d50(self));
    if (self[0] < 0) {
        if ($81N94.i64_eq(self, $9ebfd56c1029ee4d$export$8c5d7acc34381e45)) return "-9223372036854775808";
        else return "-" + $9ebfd56c1029ee4d$export$46c173f28beef960($9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(self));
    }
    var approx_div1 = $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(Math.floor($9ebfd56c1029ee4d$export$179d0ee7d36d1d50(self) / 10));
    var lo = approx_div1[1];
    var hi = approx_div1[0];
    var match = $9ebfd56c1029ee4d$var$sub_aux($9ebfd56c1029ee4d$var$sub_aux(self, lo << 3, lo >>> 29 | hi << 3), lo << 1, lo >>> 31 | hi << 1);
    var rem_lo = match[1];
    var rem_hi = match[0];
    if (rem_lo === 0 && rem_hi === 0) return $9ebfd56c1029ee4d$export$46c173f28beef960(approx_div1) + "0";
    if (rem_hi < 0) {
        var rem_lo$1 = (rem_lo ^ -1) + 1 >>> 0;
        var delta = Math.ceil(rem_lo$1 / 10);
        var remainder = 10 * delta - rem_lo$1;
        return $9ebfd56c1029ee4d$export$46c173f28beef960($9ebfd56c1029ee4d$var$sub_aux(approx_div1, delta | 0, 0)) + String(remainder | 0);
    }
    var delta$1 = Math.floor(rem_lo / 10);
    var remainder$1 = rem_lo - 10 * delta$1;
    return $9ebfd56c1029ee4d$export$46c173f28beef960($9ebfd56c1029ee4d$var$add_aux(approx_div1, delta$1 | 0, 0)) + String(remainder$1 | 0);
}
function $9ebfd56c1029ee4d$export$159d9494db57879b(_self, _other) {
    while(true){
        var other = _other;
        var self = _self;
        var self_hi = self[0];
        var exit = 0;
        var exit$1 = 0;
        if (other[0] !== 0 || other[1] !== 0) exit$1 = 2;
        else throw {
            RE_EXN_ID: "Division_by_zero",
            Error: new Error()
        };
        if (exit$1 === 2) {
            if (self_hi !== -2147483648) {
                if (self_hi !== 0) exit = 1;
                else {
                    if (self[1] === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
                    exit = 1;
                }
            } else if (self[1] !== 0) exit = 1;
            else {
                if ($81N94.i64_eq(other, $9ebfd56c1029ee4d$export$80bf7733f1207381) || $81N94.i64_eq(other, $9ebfd56c1029ee4d$export$8258efd2c6861b6b)) return self;
                if ($81N94.i64_eq(other, $9ebfd56c1029ee4d$export$8c5d7acc34381e45)) return $9ebfd56c1029ee4d$export$80bf7733f1207381;
                var half_this = $9ebfd56c1029ee4d$export$fd2f69ca989c391d(self, 1);
                var approx = $9ebfd56c1029ee4d$export$b824a15733c7c982($9ebfd56c1029ee4d$export$159d9494db57879b(half_this, other), 1);
                var exit$2 = 0;
                if (approx[0] !== 0) exit$2 = 3;
                else {
                    if (approx[1] === 0) {
                        if (other[0] < 0) return $9ebfd56c1029ee4d$export$80bf7733f1207381;
                        else return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$80bf7733f1207381);
                    }
                    exit$2 = 3;
                }
                if (exit$2 === 3) {
                    var rem = $9ebfd56c1029ee4d$export$f93b5905241a7cca(self, $9ebfd56c1029ee4d$export$6e3a27864ab166fe(other, approx));
                    return $9ebfd56c1029ee4d$export$e16d8520af44a096(approx, $9ebfd56c1029ee4d$export$159d9494db57879b(rem, other));
                }
            }
        }
        if (exit === 1) {
            var other_hi = other[0];
            var exit$3 = 0;
            if (other_hi !== -2147483648) exit$3 = 2;
            else {
                if (other[1] === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
                exit$3 = 2;
            }
            if (exit$3 === 2) {
                if (self_hi < 0) {
                    if (other_hi >= 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$159d9494db57879b($9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(self), other));
                    _other = $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(other);
                    _self = $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(self);
                    continue;
                }
                if (other_hi < 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$159d9494db57879b(self, $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(other)));
                var res = $9ebfd56c1029ee4d$export$7f9972325ebfd559;
                var rem$1 = self;
                while($81N94.i64_ge(rem$1, other)){
                    var b = Math.floor($9ebfd56c1029ee4d$export$179d0ee7d36d1d50(rem$1) / $9ebfd56c1029ee4d$export$179d0ee7d36d1d50(other));
                    var approx$1 = 1 > b ? 1 : b;
                    var log2 = Math.ceil(Math.log(approx$1) / Math.LN2);
                    var delta = log2 <= 48 ? 1 : Math.pow(2, log2 - 48);
                    var approxRes = $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(approx$1);
                    var approxRem = $9ebfd56c1029ee4d$export$6e3a27864ab166fe(approxRes, other);
                    while(approxRem[0] < 0 || $81N94.i64_gt(approxRem, rem$1)){
                        approx$1 = approx$1 - delta;
                        approxRes = $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(approx$1);
                        approxRem = $9ebfd56c1029ee4d$export$6e3a27864ab166fe(approxRes, other);
                    }
                    if ($9ebfd56c1029ee4d$export$d141fa6c6d93da6f(approxRes)) approxRes = $9ebfd56c1029ee4d$export$80bf7733f1207381;
                    res = $9ebfd56c1029ee4d$export$e16d8520af44a096(res, approxRes);
                    rem$1 = $9ebfd56c1029ee4d$export$f93b5905241a7cca(rem$1, approxRem);
                }
                return res;
            }
        }
    }
}
function $9ebfd56c1029ee4d$export$3f70e015da55297(self, other) {
    return $9ebfd56c1029ee4d$export$f93b5905241a7cca(self, $9ebfd56c1029ee4d$export$6e3a27864ab166fe($9ebfd56c1029ee4d$export$159d9494db57879b(self, other), other));
}
function $9ebfd56c1029ee4d$export$6bd85662b525b3b9(self, other) {
    var quotient = $9ebfd56c1029ee4d$export$159d9494db57879b(self, other);
    return [
        quotient,
        $9ebfd56c1029ee4d$export$f93b5905241a7cca(self, $9ebfd56c1029ee4d$export$6e3a27864ab166fe(quotient, other))
    ];
}
function $9ebfd56c1029ee4d$export$398604a469f7de9a(self, other) {
    var y = other[0];
    var x = self[0];
    var v = x < y ? -1 : x === y ? 0 : 1;
    if (v !== 0) return v;
    var y$1 = other[1];
    var x$1 = self[1];
    if (x$1 < y$1) return -1;
    else if (x$1 === y$1) return 0;
    else return 1;
}
function $9ebfd56c1029ee4d$export$c0dea48708041221(lo) {
    return [
        lo < 0 ? -1 : 0,
        lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$a6caf603acdaf417(x) {
    return x[1] | 0;
}
function $9ebfd56c1029ee4d$export$b34392537f2698a2(x) {
    var x_lo = x[1];
    var x_hi = x[0];
    var aux = function aux(v) {
        return (v >>> 0).toString(16);
    };
    if (x_hi === 0 && x_lo === 0) return "0";
    if (x_lo === 0) return aux(x_hi) + "00000000";
    if (x_hi === 0) return aux(x_lo);
    var lo = aux(x_lo);
    var pad = 8 - lo.length | 0;
    if (pad <= 0) return aux(x_hi) + lo;
    else return aux(x_hi) + ("0".repeat(pad) + lo);
}
function $9ebfd56c1029ee4d$export$451161f7dbaf7ee5(x) {
    return [
        2147483647 & x[0],
        x[1]
    ];
}
function $9ebfd56c1029ee4d$export$15bac053cf5e8d01(x) {
    return function(lo, hi) {
        return new Float64Array(new Int32Array([
            lo,
            hi
        ]).buffer)[0];
    }(x[1], x[0]);
}
function $9ebfd56c1029ee4d$export$f759bca77b24f29e(x) {
    var match = function(x) {
        return new Int32Array(new Float64Array([
            x
        ]).buffer);
    }(x);
    return [
        match[1],
        match[0] >>> 0
    ];
}
 /* No side effect */ 
});


parcelRegister("axd0Z", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $7ab714f402cde22c$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "make", function () { return $7ab714f402cde22c$export$dd44f18ab656f3bb; });
function $7ab714f402cde22c$export$3988ae62b71be9a3(s, i) {
    if (i >= s.length || i < 0) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "index out of bounds",
        Error: new Error()
    };
    return s.codePointAt(i);
}
function $7ab714f402cde22c$export$dd44f18ab656f3bb(n, ch) {
    return String.fromCharCode(ch).repeat(n);
}
 /* No side effect */ 
});

parcelRegister("1xvYg", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $11f1ac4476932d3c$export$185802fd694ee1f5; });
$parcel$export(module.exports, "is_extension", function () { return $11f1ac4476932d3c$export$18fe2da6a9df47cb; });
var $11f1ac4476932d3c$export$d560c7e4a29451c2 = {
    contents: 0
};
function $11f1ac4476932d3c$export$185802fd694ee1f5(str) {
    $11f1ac4476932d3c$export$d560c7e4a29451c2.contents = $11f1ac4476932d3c$export$d560c7e4a29451c2.contents + 1 | 0;
    return str + ("/" + $11f1ac4476932d3c$export$d560c7e4a29451c2.contents);
}
function $11f1ac4476932d3c$export$18fe2da6a9df47cb(e) {
    if (e == null) return false;
    else return typeof e.RE_EXN_ID === "string";
}
function $11f1ac4476932d3c$export$65f6247af03a69e8(x) {
    return x.RE_EXN_ID;
}
 /* No side effect */ 
});

parcelRegister("bBMv4", function(module, exports) {

$parcel$export(module.exports, "internalToOCamlException", function () { return $8738c58b359047fe$export$83ef66a157212b9e; });
$parcel$export(module.exports, "as_js_exn", function () { return $8738c58b359047fe$export$410c7f658f342601; });

var $loT9g = parcelRequire("loT9g");

var $1xvYg = parcelRequire("1xvYg");
var $8738c58b359047fe$export$507b31d55a607b45 = "JsError";
function $8738c58b359047fe$export$83ef66a157212b9e(e) {
    if ($1xvYg.is_extension(e)) return e;
    else return {
        RE_EXN_ID: "JsError",
        _1: e
    };
}
function $8738c58b359047fe$export$410c7f658f342601(exn) {
    if (exn.RE_EXN_ID === $8738c58b359047fe$export$507b31d55a607b45) return $loT9g.some(exn._1);
}
 /* No side effect */ 
});


parcelRegister("h6oMG", function(module, exports) {

$parcel$export(module.exports, "set", function () { return $c73638db6150e167$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "toArray", function () { return $c73638db6150e167$export$45b10814cc054894; });
$parcel$export(module.exports, "get", function () { return $c73638db6150e167$export$3988ae62b71be9a3; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");

var $2WL7H = parcelRequire("2WL7H");

var $cJvir = parcelRequire("cJvir");
function $c73638db6150e167$export$adaa4cf7ef1b65be(t, newK, newD) {
    if (t === undefined) return $2WL7H.singleton(newK, newD);
    var k = t.k;
    if (newK === k) return $2WL7H.updateValue(t, newD);
    var v = t.v;
    if (newK < k) return $2WL7H.bal($c73638db6150e167$export$adaa4cf7ef1b65be(t.l, newK, newD), k, v, t.r);
    else return $2WL7H.bal(t.l, k, v, $c73638db6150e167$export$adaa4cf7ef1b65be(t.r, newK, newD));
}
function $c73638db6150e167$export$6de2fa9ee08eb932(t, x, f) {
    if (t !== undefined) {
        var k = t.k;
        if (x === k) {
            var data = f($loT9g.some(t.v));
            if (data !== undefined) return $2WL7H.updateValue(t, $loT9g.valFromOption(data));
            var l = t.l;
            var r = t.r;
            if (l === undefined) return r;
            if (r === undefined) return l;
            var kr = {
                contents: r.k
            };
            var vr = {
                contents: r.v
            };
            var r$1 = $2WL7H.removeMinAuxWithRef(r, kr, vr);
            return $2WL7H.bal(l, kr.contents, vr.contents, r$1);
        }
        var v = t.v;
        var l$1 = t.l;
        var r$2 = t.r;
        if (x < k) {
            var ll = $c73638db6150e167$export$6de2fa9ee08eb932(l$1, x, f);
            if (l$1 === ll) return t;
            else return $2WL7H.bal(ll, k, v, r$2);
        }
        var rr = $c73638db6150e167$export$6de2fa9ee08eb932(r$2, x, f);
        if (r$2 === rr) return t;
        else return $2WL7H.bal(l$1, k, v, rr);
    }
    var data$1 = f(undefined);
    if (data$1 !== undefined) return $2WL7H.singleton(x, $loT9g.valFromOption(data$1));
    else return t;
}
function $c73638db6150e167$export$722fbec263ad908a(t, x, f) {
    return $c73638db6150e167$export$6de2fa9ee08eb932(t, x, $iv6Yc.__1(f));
}
function $c73638db6150e167$var$removeAux(n, x) {
    var v = n.k;
    var l = n.l;
    var r = n.r;
    if (x === v) {
        if (l === undefined) return r;
        if (r === undefined) return l;
        var kr = {
            contents: r.k
        };
        var vr = {
            contents: r.v
        };
        var r$1 = $2WL7H.removeMinAuxWithRef(r, kr, vr);
        return $2WL7H.bal(l, kr.contents, vr.contents, r$1);
    }
    if (x < v) {
        if (l === undefined) return n;
        var ll = $c73638db6150e167$var$removeAux(l, x);
        if (ll === l) return n;
        else return $2WL7H.bal(ll, v, n.v, r);
    }
    if (r === undefined) return n;
    var rr = $c73638db6150e167$var$removeAux(r, x);
    return $2WL7H.bal(l, v, n.v, rr);
}
function $c73638db6150e167$export$cd7f480d6b8286c3(n, x) {
    if (n !== undefined) return $c73638db6150e167$var$removeAux(n, x);
}
function $c73638db6150e167$export$eee7be0b5a29d3f7(t, keys) {
    var len = keys.length;
    if (t !== undefined) {
        var _t = t;
        var _i = 0;
        while(true){
            var i = _i;
            var t$1 = _t;
            if (i >= len) return t$1;
            var ele = keys[i];
            var u = $c73638db6150e167$var$removeAux(t$1, ele);
            if (u === undefined) return u;
            _i = i + 1 | 0;
            _t = u;
            continue;
        }
    }
}
function $c73638db6150e167$export$98faf9ec60742c15(h, arr) {
    var len = arr.length;
    var v = h;
    for(var i = 0; i < len; ++i){
        var match = arr[i];
        v = $c73638db6150e167$export$adaa4cf7ef1b65be(v, match[0], match[1]);
    }
    return v;
}
var $c73638db6150e167$export$6e22c362a0406a2c;
var $c73638db6150e167$export$dd1bc94b04021eeb = $2WL7H.isEmpty;
var $c73638db6150e167$export$a4f4bb6b1453fff5 = $cJvir.has;
var $c73638db6150e167$export$c0aec0f0618831d3 = $cJvir.cmpU;
var $c73638db6150e167$export$6154dcdb7d23e37b = $cJvir.cmp;
var $c73638db6150e167$export$f28cee400b9bf71f = $cJvir.eqU;
var $c73638db6150e167$export$9663ddc1cf085b32 = $cJvir.eq;
var $c73638db6150e167$export$7c409e5cbe59641e = $2WL7H.findFirstByU;
var $c73638db6150e167$export$f4f458d1ae1dd5cb = $2WL7H.findFirstBy;
var $c73638db6150e167$export$e4198045b3bb8c9c = $2WL7H.forEachU;
var $c73638db6150e167$export$4b80e395e36b5a56 = $2WL7H.forEach;
var $c73638db6150e167$export$ae643c57dec5ffec = $2WL7H.reduceU;
var $c73638db6150e167$export$533b26079ad0b4b = $2WL7H.reduce;
var $c73638db6150e167$export$f294ebd954c6e224 = $2WL7H.everyU;
var $c73638db6150e167$export$7ecc1a3b11b57dab = $2WL7H.every;
var $c73638db6150e167$export$6d4e2e7ededf6e6e = $2WL7H.someU;
var $c73638db6150e167$export$ad14ef4001db2bcd = $2WL7H.some;
var $c73638db6150e167$export$346677f925de839c = $2WL7H.size;
var $c73638db6150e167$export$effcdbd76139450 = $2WL7H.toList;
var $c73638db6150e167$export$45b10814cc054894 = $2WL7H.toArray;
var $c73638db6150e167$export$571d59b505e6bb4e = $cJvir.fromArray;
var $c73638db6150e167$export$7ee39d337e5e81fb = $2WL7H.keysToArray;
var $c73638db6150e167$export$8c3292533c32885a = $2WL7H.valuesToArray;
var $c73638db6150e167$export$72a052230784f507 = $2WL7H.minKey;
var $c73638db6150e167$export$4be97da70779417a = $2WL7H.minKeyUndefined;
var $c73638db6150e167$export$baa7462c10499cf2 = $2WL7H.maxKey;
var $c73638db6150e167$export$1d51acc707ea9637 = $2WL7H.maxKeyUndefined;
var $c73638db6150e167$export$916782c1f0ddb132 = $2WL7H.minimum;
var $c73638db6150e167$export$268216b526523de4 = $2WL7H.minUndefined;
var $c73638db6150e167$export$b25e0be55f42c9a = $2WL7H.maximum;
var $c73638db6150e167$export$5f0769a557ef797a = $2WL7H.maxUndefined;
var $c73638db6150e167$export$3988ae62b71be9a3 = $cJvir.get;
var $c73638db6150e167$export$c0e2df34d3ecdf22 = $cJvir.getUndefined;
var $c73638db6150e167$export$73b8ef55a37133c7 = $cJvir.getWithDefault;
var $c73638db6150e167$export$2d6fda808293d631 = $cJvir.getExn;
var $c73638db6150e167$export$43922ffb4a8274b9 = $2WL7H.checkInvariantInternal;
var $c73638db6150e167$export$6f8d4ae0dfb14052 = $cJvir.mergeU;
var $c73638db6150e167$export$4950aa0f605343fb = $cJvir.merge;
var $c73638db6150e167$export$2e45af2d40d3fd2b = $2WL7H.keepSharedU;
var $c73638db6150e167$export$fae3166c418e0471 = $2WL7H.keepShared;
var $c73638db6150e167$export$5a6fbee869ed7abd = $2WL7H.partitionSharedU;
var $c73638db6150e167$export$b29f828819edca8d = $2WL7H.partitionShared;
var $c73638db6150e167$export$65980d18b75784e2 = $cJvir.split;
var $c73638db6150e167$export$cc22bf2a9ce99b1 = $2WL7H.mapU;
var $c73638db6150e167$export$871de8747c9eaa88 = $2WL7H.map;
var $c73638db6150e167$export$bfe0fea5f66add25 = $2WL7H.mapWithKeyU;
var $c73638db6150e167$export$1292458786b96e98 = $2WL7H.mapWithKey;
 /* No side effect */ 
});
parcelRegister("2WL7H", function(module, exports) {

$parcel$export(module.exports, "singleton", function () { return $22558d40829e937a$export$439306a4dcaafbb9; });
$parcel$export(module.exports, "updateValue", function () { return $22558d40829e937a$export$5c3953ae27cbb39e; });
$parcel$export(module.exports, "bal", function () { return $22558d40829e937a$export$4183307208b73eb5; });
$parcel$export(module.exports, "minKey", function () { return $22558d40829e937a$export$72a052230784f507; });
$parcel$export(module.exports, "minKeyUndefined", function () { return $22558d40829e937a$export$4be97da70779417a; });
$parcel$export(module.exports, "maxKey", function () { return $22558d40829e937a$export$baa7462c10499cf2; });
$parcel$export(module.exports, "maxKeyUndefined", function () { return $22558d40829e937a$export$1d51acc707ea9637; });
$parcel$export(module.exports, "minimum", function () { return $22558d40829e937a$export$916782c1f0ddb132; });
$parcel$export(module.exports, "minUndefined", function () { return $22558d40829e937a$export$268216b526523de4; });
$parcel$export(module.exports, "maximum", function () { return $22558d40829e937a$export$b25e0be55f42c9a; });
$parcel$export(module.exports, "maxUndefined", function () { return $22558d40829e937a$export$5f0769a557ef797a; });
$parcel$export(module.exports, "removeMinAuxWithRef", function () { return $22558d40829e937a$export$a0d89a1c7f533b3d; });
$parcel$export(module.exports, "isEmpty", function () { return $22558d40829e937a$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "stackAllLeft", function () { return $22558d40829e937a$export$d641d8cc434af25b; });
$parcel$export(module.exports, "findFirstByU", function () { return $22558d40829e937a$export$7c409e5cbe59641e; });
$parcel$export(module.exports, "findFirstBy", function () { return $22558d40829e937a$export$f4f458d1ae1dd5cb; });
$parcel$export(module.exports, "forEachU", function () { return $22558d40829e937a$export$e4198045b3bb8c9c; });
$parcel$export(module.exports, "forEach", function () { return $22558d40829e937a$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "mapU", function () { return $22558d40829e937a$export$cc22bf2a9ce99b1; });
$parcel$export(module.exports, "map", function () { return $22558d40829e937a$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapWithKeyU", function () { return $22558d40829e937a$export$bfe0fea5f66add25; });
$parcel$export(module.exports, "mapWithKey", function () { return $22558d40829e937a$export$1292458786b96e98; });
$parcel$export(module.exports, "reduceU", function () { return $22558d40829e937a$export$ae643c57dec5ffec; });
$parcel$export(module.exports, "reduce", function () { return $22558d40829e937a$export$533b26079ad0b4b; });
$parcel$export(module.exports, "everyU", function () { return $22558d40829e937a$export$f294ebd954c6e224; });
$parcel$export(module.exports, "every", function () { return $22558d40829e937a$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "someU", function () { return $22558d40829e937a$export$6d4e2e7ededf6e6e; });
$parcel$export(module.exports, "some", function () { return $22558d40829e937a$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "join", function () { return $22558d40829e937a$export$f7e2c8231c57a8bd; });
$parcel$export(module.exports, "concatOrJoin", function () { return $22558d40829e937a$export$f02365201558e217; });
$parcel$export(module.exports, "keepSharedU", function () { return $22558d40829e937a$export$61b0d1894ad2e744; });
$parcel$export(module.exports, "keepShared", function () { return $22558d40829e937a$export$2845aafc131423cd; });
$parcel$export(module.exports, "partitionSharedU", function () { return $22558d40829e937a$export$6a5fd59e59553019; });
$parcel$export(module.exports, "partitionShared", function () { return $22558d40829e937a$export$42c76eac3290c4ab; });
$parcel$export(module.exports, "size", function () { return $22558d40829e937a$export$346677f925de839c; });
$parcel$export(module.exports, "toList", function () { return $22558d40829e937a$export$effcdbd76139450; });
$parcel$export(module.exports, "checkInvariantInternal", function () { return $22558d40829e937a$export$43922ffb4a8274b9; });
$parcel$export(module.exports, "toArray", function () { return $22558d40829e937a$export$45b10814cc054894; });
$parcel$export(module.exports, "keysToArray", function () { return $22558d40829e937a$export$7ee39d337e5e81fb; });
$parcel$export(module.exports, "valuesToArray", function () { return $22558d40829e937a$export$8c3292533c32885a; });
$parcel$export(module.exports, "fromSortedArrayRevAux", function () { return $22558d40829e937a$export$6635064176e858ca; });
$parcel$export(module.exports, "fromSortedArrayAux", function () { return $22558d40829e937a$export$faaaa901e4a41f53; });
$parcel$export(module.exports, "balMutate", function () { return $22558d40829e937a$export$7ba8ef59999a0393; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");

var $58Tj9 = parcelRequire("58Tj9");
function $22558d40829e937a$var$treeHeight(n) {
    if (n !== undefined) return n.h;
    else return 0;
}
function $22558d40829e937a$export$784d13d8ee351f07(n) {
    if (n !== undefined) return {
        k: n.k,
        v: n.v,
        h: n.h,
        l: $22558d40829e937a$export$784d13d8ee351f07(n.l),
        r: $22558d40829e937a$export$784d13d8ee351f07(n.r)
    };
    else return n;
}
function $22558d40829e937a$export$185802fd694ee1f5(l, x, d, r) {
    var hl = $22558d40829e937a$var$treeHeight(l);
    var hr = $22558d40829e937a$var$treeHeight(r);
    return {
        k: x,
        v: d,
        h: hl >= hr ? hl + 1 | 0 : hr + 1 | 0,
        l: l,
        r: r
    };
}
function $22558d40829e937a$export$439306a4dcaafbb9(x, d) {
    return {
        k: x,
        v: d,
        h: 1,
        l: undefined,
        r: undefined
    };
}
function $22558d40829e937a$var$heightGe(l, r) {
    if (r !== undefined) {
        if (l !== undefined) return l.h >= r.h;
        else return false;
    } else return true;
}
function $22558d40829e937a$export$5c3953ae27cbb39e(n, newValue) {
    if (n.v === newValue) return n;
    else return {
        k: n.k,
        v: newValue,
        h: n.h,
        l: n.l,
        r: n.r
    };
}
function $22558d40829e937a$export$4183307208b73eb5(l, x, d, r) {
    var hl = l !== undefined ? l.h : 0;
    var hr = r !== undefined ? r.h : 0;
    if (hl > (hr + 2 | 0)) {
        var ll = l.l;
        var lr = l.r;
        if ($22558d40829e937a$var$treeHeight(ll) >= $22558d40829e937a$var$treeHeight(lr)) return $22558d40829e937a$export$185802fd694ee1f5(ll, l.k, l.v, $22558d40829e937a$export$185802fd694ee1f5(lr, x, d, r));
        else return $22558d40829e937a$export$185802fd694ee1f5($22558d40829e937a$export$185802fd694ee1f5(ll, l.k, l.v, lr.l), lr.k, lr.v, $22558d40829e937a$export$185802fd694ee1f5(lr.r, x, d, r));
    }
    if (hr <= (hl + 2 | 0)) return {
        k: x,
        v: d,
        h: hl >= hr ? hl + 1 | 0 : hr + 1 | 0,
        l: l,
        r: r
    };
    var rl = r.l;
    var rr = r.r;
    if ($22558d40829e937a$var$treeHeight(rr) >= $22558d40829e937a$var$treeHeight(rl)) return $22558d40829e937a$export$185802fd694ee1f5($22558d40829e937a$export$185802fd694ee1f5(l, x, d, rl), r.k, r.v, rr);
    else return $22558d40829e937a$export$185802fd694ee1f5($22558d40829e937a$export$185802fd694ee1f5(l, x, d, rl.l), rl.k, rl.v, $22558d40829e937a$export$185802fd694ee1f5(rl.r, r.k, r.v, rr));
}
function $22558d40829e937a$var$minKey0Aux(_n) {
    while(true){
        var n = _n;
        var n$1 = n.l;
        if (n$1 === undefined) return n.k;
        _n = n$1;
        continue;
    }
}
function $22558d40829e937a$export$72a052230784f507(n) {
    if (n !== undefined) return $loT9g.some($22558d40829e937a$var$minKey0Aux(n));
}
function $22558d40829e937a$export$4be97da70779417a(n) {
    if (n !== undefined) return $22558d40829e937a$var$minKey0Aux(n);
}
function $22558d40829e937a$var$maxKey0Aux(_n) {
    while(true){
        var n = _n;
        var n$1 = n.r;
        if (n$1 === undefined) return n.k;
        _n = n$1;
        continue;
    }
}
function $22558d40829e937a$export$baa7462c10499cf2(n) {
    if (n !== undefined) return $loT9g.some($22558d40829e937a$var$maxKey0Aux(n));
}
function $22558d40829e937a$export$1d51acc707ea9637(n) {
    if (n !== undefined) return $22558d40829e937a$var$maxKey0Aux(n);
}
function $22558d40829e937a$var$minKV0Aux(_n) {
    while(true){
        var n = _n;
        var n$1 = n.l;
        if (n$1 === undefined) return [
            n.k,
            n.v
        ];
        _n = n$1;
        continue;
    }
}
function $22558d40829e937a$export$916782c1f0ddb132(n) {
    if (n !== undefined) return $22558d40829e937a$var$minKV0Aux(n);
}
function $22558d40829e937a$export$268216b526523de4(n) {
    if (n !== undefined) return $22558d40829e937a$var$minKV0Aux(n);
}
function $22558d40829e937a$var$maxKV0Aux(_n) {
    while(true){
        var n = _n;
        var n$1 = n.r;
        if (n$1 === undefined) return [
            n.k,
            n.v
        ];
        _n = n$1;
        continue;
    }
}
function $22558d40829e937a$export$b25e0be55f42c9a(n) {
    if (n !== undefined) return $22558d40829e937a$var$maxKV0Aux(n);
}
function $22558d40829e937a$export$5f0769a557ef797a(n) {
    if (n !== undefined) return $22558d40829e937a$var$maxKV0Aux(n);
}
function $22558d40829e937a$export$a0d89a1c7f533b3d(n, kr, vr) {
    var ln = n.l;
    if (ln !== undefined) return $22558d40829e937a$export$4183307208b73eb5($22558d40829e937a$export$a0d89a1c7f533b3d(ln, kr, vr), n.k, n.v, n.r);
    else {
        kr.contents = n.k;
        vr.contents = n.v;
        return n.r;
    }
}
function $22558d40829e937a$export$dd1bc94b04021eeb(x) {
    return x === undefined;
}
function $22558d40829e937a$export$d641d8cc434af25b(_v, _s) {
    while(true){
        var s = _s;
        var v = _v;
        if (v === undefined) return s;
        _s = {
            hd: v,
            tl: s
        };
        _v = v.l;
        continue;
    }
}
function $22558d40829e937a$export$7c409e5cbe59641e(n, p) {
    if (n === undefined) return;
    var left = $22558d40829e937a$export$7c409e5cbe59641e(n.l, p);
    if (left !== undefined) return left;
    var v = n.k;
    var d = n.v;
    var pvd = p(v, d);
    if (pvd) return [
        v,
        d
    ];
    var right = $22558d40829e937a$export$7c409e5cbe59641e(n.r, p);
    if (right !== undefined) return right;
}
function $22558d40829e937a$export$f4f458d1ae1dd5cb(n, p) {
    return $22558d40829e937a$export$7c409e5cbe59641e(n, $iv6Yc.__2(p));
}
function $22558d40829e937a$export$e4198045b3bb8c9c(_n, f) {
    while(true){
        var n = _n;
        if (n === undefined) return;
        $22558d40829e937a$export$e4198045b3bb8c9c(n.l, f);
        f(n.k, n.v);
        _n = n.r;
        continue;
    }
}
function $22558d40829e937a$export$4b80e395e36b5a56(n, f) {
    $22558d40829e937a$export$e4198045b3bb8c9c(n, $iv6Yc.__2(f));
}
function $22558d40829e937a$export$cc22bf2a9ce99b1(n, f) {
    if (n === undefined) return;
    var newLeft = $22558d40829e937a$export$cc22bf2a9ce99b1(n.l, f);
    var newD = f(n.v);
    var newRight = $22558d40829e937a$export$cc22bf2a9ce99b1(n.r, f);
    return {
        k: n.k,
        v: newD,
        h: n.h,
        l: newLeft,
        r: newRight
    };
}
function $22558d40829e937a$export$871de8747c9eaa88(n, f) {
    return $22558d40829e937a$export$cc22bf2a9ce99b1(n, $iv6Yc.__1(f));
}
function $22558d40829e937a$export$bfe0fea5f66add25(n, f) {
    if (n === undefined) return;
    var key = n.k;
    var newLeft = $22558d40829e937a$export$bfe0fea5f66add25(n.l, f);
    var newD = f(key, n.v);
    var newRight = $22558d40829e937a$export$bfe0fea5f66add25(n.r, f);
    return {
        k: key,
        v: newD,
        h: n.h,
        l: newLeft,
        r: newRight
    };
}
function $22558d40829e937a$export$1292458786b96e98(n, f) {
    return $22558d40829e937a$export$bfe0fea5f66add25(n, $iv6Yc.__2(f));
}
function $22558d40829e937a$export$ae643c57dec5ffec(_m, _accu, f) {
    while(true){
        var accu = _accu;
        var m = _m;
        if (m === undefined) return accu;
        var v = m.k;
        var d = m.v;
        var l = m.l;
        var r = m.r;
        _accu = f($22558d40829e937a$export$ae643c57dec5ffec(l, accu, f), v, d);
        _m = r;
        continue;
    }
}
function $22558d40829e937a$export$533b26079ad0b4b(m, accu, f) {
    return $22558d40829e937a$export$ae643c57dec5ffec(m, accu, $iv6Yc.__3(f));
}
function $22558d40829e937a$export$f294ebd954c6e224(_n, p) {
    while(true){
        var n = _n;
        if (n === undefined) return true;
        if (!p(n.k, n.v)) return false;
        if (!$22558d40829e937a$export$f294ebd954c6e224(n.l, p)) return false;
        _n = n.r;
        continue;
    }
}
function $22558d40829e937a$export$7ecc1a3b11b57dab(n, p) {
    return $22558d40829e937a$export$f294ebd954c6e224(n, $iv6Yc.__2(p));
}
function $22558d40829e937a$export$6d4e2e7ededf6e6e(_n, p) {
    while(true){
        var n = _n;
        if (n === undefined) return false;
        if (p(n.k, n.v)) return true;
        if ($22558d40829e937a$export$6d4e2e7ededf6e6e(n.l, p)) return true;
        _n = n.r;
        continue;
    }
}
function $22558d40829e937a$export$ad14ef4001db2bcd(n, p) {
    return $22558d40829e937a$export$6d4e2e7ededf6e6e(n, $iv6Yc.__2(p));
}
function $22558d40829e937a$var$addMinElement(n, k, v) {
    if (n !== undefined) return $22558d40829e937a$export$4183307208b73eb5($22558d40829e937a$var$addMinElement(n.l, k, v), n.k, n.v, n.r);
    else return $22558d40829e937a$export$439306a4dcaafbb9(k, v);
}
function $22558d40829e937a$var$addMaxElement(n, k, v) {
    if (n !== undefined) return $22558d40829e937a$export$4183307208b73eb5(n.l, n.k, n.v, $22558d40829e937a$var$addMaxElement(n.r, k, v));
    else return $22558d40829e937a$export$439306a4dcaafbb9(k, v);
}
function $22558d40829e937a$export$f7e2c8231c57a8bd(ln, v, d, rn) {
    if (ln === undefined) return $22558d40829e937a$var$addMinElement(rn, v, d);
    if (rn === undefined) return $22558d40829e937a$var$addMaxElement(ln, v, d);
    var lv = ln.k;
    var ld = ln.v;
    var lh = ln.h;
    var ll = ln.l;
    var lr = ln.r;
    var rv = rn.k;
    var rd = rn.v;
    var rh = rn.h;
    var rl = rn.l;
    var rr = rn.r;
    if (lh > (rh + 2 | 0)) return $22558d40829e937a$export$4183307208b73eb5(ll, lv, ld, $22558d40829e937a$export$f7e2c8231c57a8bd(lr, v, d, rn));
    else if (rh > (lh + 2 | 0)) return $22558d40829e937a$export$4183307208b73eb5($22558d40829e937a$export$f7e2c8231c57a8bd(ln, v, d, rl), rv, rd, rr);
    else return $22558d40829e937a$export$185802fd694ee1f5(ln, v, d, rn);
}
function $22558d40829e937a$export$ee1b3e54f0441b22(t1, t2) {
    if (t1 === undefined) return t2;
    if (t2 === undefined) return t1;
    var kr = {
        contents: t2.k
    };
    var vr = {
        contents: t2.v
    };
    var t2r = $22558d40829e937a$export$a0d89a1c7f533b3d(t2, kr, vr);
    return $22558d40829e937a$export$f7e2c8231c57a8bd(t1, kr.contents, vr.contents, t2r);
}
function $22558d40829e937a$export$f02365201558e217(t1, v, d, t2) {
    if (d !== undefined) return $22558d40829e937a$export$f7e2c8231c57a8bd(t1, v, $loT9g.valFromOption(d), t2);
    else return $22558d40829e937a$export$ee1b3e54f0441b22(t1, t2);
}
function $22558d40829e937a$export$61b0d1894ad2e744(n, p) {
    if (n === undefined) return;
    var v = n.k;
    var d = n.v;
    var newLeft = $22558d40829e937a$export$61b0d1894ad2e744(n.l, p);
    var pvd = p(v, d);
    var newRight = $22558d40829e937a$export$61b0d1894ad2e744(n.r, p);
    if (pvd) return $22558d40829e937a$export$f7e2c8231c57a8bd(newLeft, v, d, newRight);
    else return $22558d40829e937a$export$ee1b3e54f0441b22(newLeft, newRight);
}
function $22558d40829e937a$export$2845aafc131423cd(n, p) {
    return $22558d40829e937a$export$61b0d1894ad2e744(n, $iv6Yc.__2(p));
}
function $22558d40829e937a$export$fb6daf1607d5d777(n, p) {
    if (n === undefined) return;
    var v = n.k;
    var d = n.v;
    var newLeft = $22558d40829e937a$export$fb6daf1607d5d777(n.l, p);
    var pvd = p(v, d);
    var newRight = $22558d40829e937a$export$fb6daf1607d5d777(n.r, p);
    if (pvd !== undefined) return $22558d40829e937a$export$f7e2c8231c57a8bd(newLeft, v, $loT9g.valFromOption(pvd), newRight);
    else return $22558d40829e937a$export$ee1b3e54f0441b22(newLeft, newRight);
}
function $22558d40829e937a$export$8b311cdc49e179cd(n, p) {
    return $22558d40829e937a$export$fb6daf1607d5d777(n, $iv6Yc.__2(p));
}
function $22558d40829e937a$export$6a5fd59e59553019(n, p) {
    if (n === undefined) return [
        undefined,
        undefined
    ];
    var key = n.k;
    var value = n.v;
    var match = $22558d40829e937a$export$6a5fd59e59553019(n.l, p);
    var lf = match[1];
    var lt = match[0];
    var pvd = p(key, value);
    var match$1 = $22558d40829e937a$export$6a5fd59e59553019(n.r, p);
    var rf = match$1[1];
    var rt = match$1[0];
    if (pvd) return [
        $22558d40829e937a$export$f7e2c8231c57a8bd(lt, key, value, rt),
        $22558d40829e937a$export$ee1b3e54f0441b22(lf, rf)
    ];
    else return [
        $22558d40829e937a$export$ee1b3e54f0441b22(lt, rt),
        $22558d40829e937a$export$f7e2c8231c57a8bd(lf, key, value, rf)
    ];
}
function $22558d40829e937a$export$42c76eac3290c4ab(n, p) {
    return $22558d40829e937a$export$6a5fd59e59553019(n, $iv6Yc.__2(p));
}
function $22558d40829e937a$export$194b3636cff0ce4b(n) {
    var l = n.l;
    var r = n.r;
    var sizeL = l !== undefined ? $22558d40829e937a$export$194b3636cff0ce4b(l) : 0;
    var sizeR = r !== undefined ? $22558d40829e937a$export$194b3636cff0ce4b(r) : 0;
    return (1 + sizeL | 0) + sizeR | 0;
}
function $22558d40829e937a$export$346677f925de839c(n) {
    if (n !== undefined) return $22558d40829e937a$export$194b3636cff0ce4b(n);
    else return 0;
}
function $22558d40829e937a$var$toListAux(_n, _accu) {
    while(true){
        var accu = _accu;
        var n = _n;
        if (n === undefined) return accu;
        var k = n.k;
        var v = n.v;
        var l = n.l;
        var r = n.r;
        _accu = {
            hd: [
                k,
                v
            ],
            tl: $22558d40829e937a$var$toListAux(r, accu)
        };
        _n = l;
        continue;
    }
}
function $22558d40829e937a$export$effcdbd76139450(s) {
    return $22558d40829e937a$var$toListAux(s, /* [] */ 0);
}
function $22558d40829e937a$export$43922ffb4a8274b9(_v) {
    while(true){
        var v = _v;
        if (v === undefined) return;
        var l = v.l;
        var r = v.r;
        var diff = $22558d40829e937a$var$treeHeight(l) - $22558d40829e937a$var$treeHeight(r) | 0;
        if (!(diff <= 2 && diff >= -2)) throw {
            RE_EXN_ID: "Assert_failure",
            _1: [
                "belt_internalAVLtree.ml",
                373,
                4
            ],
            Error: new Error()
        };
        $22558d40829e937a$export$43922ffb4a8274b9(l);
        _v = r;
        continue;
    }
}
function $22558d40829e937a$var$fillArrayKey(_n, _i, arr) {
    while(true){
        var i = _i;
        var n = _n;
        var v = n.k;
        var l = n.l;
        var r = n.r;
        var next = l !== undefined ? $22558d40829e937a$var$fillArrayKey(l, i, arr) : i;
        arr[next] = v;
        var rnext = next + 1 | 0;
        if (r === undefined) return rnext;
        _i = rnext;
        _n = r;
        continue;
    }
}
function $22558d40829e937a$var$fillArrayValue(_n, _i, arr) {
    while(true){
        var i = _i;
        var n = _n;
        var l = n.l;
        var r = n.r;
        var next = l !== undefined ? $22558d40829e937a$var$fillArrayValue(l, i, arr) : i;
        arr[next] = n.v;
        var rnext = next + 1 | 0;
        if (r === undefined) return rnext;
        _i = rnext;
        _n = r;
        continue;
    }
}
function $22558d40829e937a$export$57295b69bf9c5d15(_n, _i, arr) {
    while(true){
        var i = _i;
        var n = _n;
        var l = n.l;
        var v = n.k;
        var r = n.r;
        var next = l !== undefined ? $22558d40829e937a$export$57295b69bf9c5d15(l, i, arr) : i;
        arr[next] = [
            v,
            n.v
        ];
        var rnext = next + 1 | 0;
        if (r === undefined) return rnext;
        _i = rnext;
        _n = r;
        continue;
    }
}
function $22558d40829e937a$export$45b10814cc054894(n) {
    if (n === undefined) return [];
    var size = $22558d40829e937a$export$194b3636cff0ce4b(n);
    var v = new Array(size);
    $22558d40829e937a$export$57295b69bf9c5d15(n, 0, v);
    return v;
}
function $22558d40829e937a$export$7ee39d337e5e81fb(n) {
    if (n === undefined) return [];
    var size = $22558d40829e937a$export$194b3636cff0ce4b(n);
    var v = new Array(size);
    $22558d40829e937a$var$fillArrayKey(n, 0, v);
    return v;
}
function $22558d40829e937a$export$8c3292533c32885a(n) {
    if (n === undefined) return [];
    var size = $22558d40829e937a$export$194b3636cff0ce4b(n);
    var v = new Array(size);
    $22558d40829e937a$var$fillArrayValue(n, 0, v);
    return v;
}
function $22558d40829e937a$export$6635064176e858ca(arr, off, len) {
    switch(len){
        case 0:
            return;
        case 1:
            var match = arr[off];
            return $22558d40829e937a$export$439306a4dcaafbb9(match[0], match[1]);
        case 2:
            var match_0 = arr[off];
            var match_1 = arr[off - 1 | 0];
            var match$1 = match_1;
            var match$2 = match_0;
            return {
                k: match$1[0],
                v: match$1[1],
                h: 2,
                l: $22558d40829e937a$export$439306a4dcaafbb9(match$2[0], match$2[1]),
                r: undefined
            };
        case 3:
            var match_0$1 = arr[off];
            var match_1$1 = arr[off - 1 | 0];
            var match_2 = arr[off - 2 | 0];
            var match$3 = match_2;
            var match$4 = match_1$1;
            var match$5 = match_0$1;
            return {
                k: match$4[0],
                v: match$4[1],
                h: 2,
                l: $22558d40829e937a$export$439306a4dcaafbb9(match$5[0], match$5[1]),
                r: $22558d40829e937a$export$439306a4dcaafbb9(match$3[0], match$3[1])
            };
        default:
            var nl = len / 2 | 0;
            var left = $22558d40829e937a$export$6635064176e858ca(arr, off, nl);
            var match$6 = arr[off - nl | 0];
            var right = $22558d40829e937a$export$6635064176e858ca(arr, (off - nl | 0) - 1 | 0, (len - nl | 0) - 1 | 0);
            return $22558d40829e937a$export$185802fd694ee1f5(left, match$6[0], match$6[1], right);
    }
}
function $22558d40829e937a$export$faaaa901e4a41f53(arr, off, len) {
    switch(len){
        case 0:
            return;
        case 1:
            var match = arr[off];
            return $22558d40829e937a$export$439306a4dcaafbb9(match[0], match[1]);
        case 2:
            var match_0 = arr[off];
            var match_1 = arr[off + 1 | 0];
            var match$1 = match_1;
            var match$2 = match_0;
            return {
                k: match$1[0],
                v: match$1[1],
                h: 2,
                l: $22558d40829e937a$export$439306a4dcaafbb9(match$2[0], match$2[1]),
                r: undefined
            };
        case 3:
            var match_0$1 = arr[off];
            var match_1$1 = arr[off + 1 | 0];
            var match_2 = arr[off + 2 | 0];
            var match$3 = match_2;
            var match$4 = match_1$1;
            var match$5 = match_0$1;
            return {
                k: match$4[0],
                v: match$4[1],
                h: 2,
                l: $22558d40829e937a$export$439306a4dcaafbb9(match$5[0], match$5[1]),
                r: $22558d40829e937a$export$439306a4dcaafbb9(match$3[0], match$3[1])
            };
        default:
            var nl = len / 2 | 0;
            var left = $22558d40829e937a$export$faaaa901e4a41f53(arr, off, nl);
            var match$6 = arr[off + nl | 0];
            var right = $22558d40829e937a$export$faaaa901e4a41f53(arr, (off + nl | 0) + 1 | 0, (len - nl | 0) - 1 | 0);
            return $22558d40829e937a$export$185802fd694ee1f5(left, match$6[0], match$6[1], right);
    }
}
function $22558d40829e937a$export$84e8ee0769cf2b5e(arr) {
    return $22558d40829e937a$export$faaaa901e4a41f53(arr, 0, arr.length);
}
function $22558d40829e937a$export$c0aec0f0618831d3(s1, s2, kcmp, vcmp) {
    var len1 = $22558d40829e937a$export$346677f925de839c(s1);
    var len2 = $22558d40829e937a$export$346677f925de839c(s2);
    if (len1 === len2) {
        var _e1 = $22558d40829e937a$export$d641d8cc434af25b(s1, /* [] */ 0);
        var _e2 = $22558d40829e937a$export$d641d8cc434af25b(s2, /* [] */ 0);
        while(true){
            var e2 = _e2;
            var e1 = _e1;
            if (!e1) return 0;
            if (!e2) return 0;
            var h2 = e2.hd;
            var h1 = e1.hd;
            var c = kcmp(h1.k, h2.k);
            if (c !== 0) return c;
            var cx = vcmp(h1.v, h2.v);
            if (cx !== 0) return cx;
            _e2 = $22558d40829e937a$export$d641d8cc434af25b(h2.r, e2.tl);
            _e1 = $22558d40829e937a$export$d641d8cc434af25b(h1.r, e1.tl);
            continue;
        }
    } else if (len1 < len2) return -1;
    else return 1;
}
function $22558d40829e937a$export$6154dcdb7d23e37b(s1, s2, kcmp, vcmp) {
    return $22558d40829e937a$export$c0aec0f0618831d3(s1, s2, kcmp, $iv6Yc.__2(vcmp));
}
function $22558d40829e937a$export$f28cee400b9bf71f(s1, s2, kcmp, veq) {
    var len1 = $22558d40829e937a$export$346677f925de839c(s1);
    var len2 = $22558d40829e937a$export$346677f925de839c(s2);
    if (len1 === len2) {
        var _e1 = $22558d40829e937a$export$d641d8cc434af25b(s1, /* [] */ 0);
        var _e2 = $22558d40829e937a$export$d641d8cc434af25b(s2, /* [] */ 0);
        while(true){
            var e2 = _e2;
            var e1 = _e1;
            if (!e1) return true;
            if (!e2) return true;
            var h2 = e2.hd;
            var h1 = e1.hd;
            if (!(kcmp(h1.k, h2.k) === 0 && veq(h1.v, h2.v))) return false;
            _e2 = $22558d40829e937a$export$d641d8cc434af25b(h2.r, e2.tl);
            _e1 = $22558d40829e937a$export$d641d8cc434af25b(h1.r, e1.tl);
            continue;
        }
    } else return false;
}
function $22558d40829e937a$export$9663ddc1cf085b32(s1, s2, kcmp, veq) {
    return $22558d40829e937a$export$f28cee400b9bf71f(s1, s2, kcmp, $iv6Yc.__2(veq));
}
function $22558d40829e937a$export$3988ae62b71be9a3(_n, x, cmp) {
    while(true){
        var n = _n;
        if (n === undefined) return;
        var v = n.k;
        var c = cmp(x, v);
        if (c === 0) return $loT9g.some(n.v);
        _n = c < 0 ? n.l : n.r;
        continue;
    }
}
function $22558d40829e937a$export$c0e2df34d3ecdf22(_n, x, cmp) {
    while(true){
        var n = _n;
        if (n === undefined) return;
        var v = n.k;
        var c = cmp(x, v);
        if (c === 0) return n.v;
        _n = c < 0 ? n.l : n.r;
        continue;
    }
}
function $22558d40829e937a$export$2d6fda808293d631(_n, x, cmp) {
    while(true){
        var n = _n;
        if (n !== undefined) {
            var v = n.k;
            var c = cmp(x, v);
            if (c === 0) return n.v;
            _n = c < 0 ? n.l : n.r;
            continue;
        }
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
}
function $22558d40829e937a$export$73b8ef55a37133c7(_n, x, def, cmp) {
    while(true){
        var n = _n;
        if (n === undefined) return def;
        var v = n.k;
        var c = cmp(x, v);
        if (c === 0) return n.v;
        _n = c < 0 ? n.l : n.r;
        continue;
    }
}
function $22558d40829e937a$export$a4f4bb6b1453fff5(_n, x, cmp) {
    while(true){
        var n = _n;
        if (n === undefined) return false;
        var v = n.k;
        var c = cmp(x, v);
        if (c === 0) return true;
        _n = c < 0 ? n.l : n.r;
        continue;
    }
}
function $22558d40829e937a$var$rotateWithLeftChild(k2) {
    var k1 = k2.l;
    k2.l = k1.r;
    k1.r = k2;
    var hlk2 = $22558d40829e937a$var$treeHeight(k2.l);
    var hrk2 = $22558d40829e937a$var$treeHeight(k2.r);
    k2.h = (hlk2 > hrk2 ? hlk2 : hrk2) + 1 | 0;
    var hlk1 = $22558d40829e937a$var$treeHeight(k1.l);
    var hk2 = k2.h;
    k1.h = (hlk1 > hk2 ? hlk1 : hk2) + 1 | 0;
    return k1;
}
function $22558d40829e937a$var$rotateWithRightChild(k1) {
    var k2 = k1.r;
    k1.r = k2.l;
    k2.l = k1;
    var hlk1 = $22558d40829e937a$var$treeHeight(k1.l);
    var hrk1 = $22558d40829e937a$var$treeHeight(k1.r);
    k1.h = (hlk1 > hrk1 ? hlk1 : hrk1) + 1 | 0;
    var hrk2 = $22558d40829e937a$var$treeHeight(k2.r);
    var hk1 = k1.h;
    k2.h = (hrk2 > hk1 ? hrk2 : hk1) + 1 | 0;
    return k2;
}
function $22558d40829e937a$var$doubleWithLeftChild(k3) {
    var x = k3.l;
    var v = $22558d40829e937a$var$rotateWithRightChild(x);
    k3.l = v;
    return $22558d40829e937a$var$rotateWithLeftChild(k3);
}
function $22558d40829e937a$var$doubleWithRightChild(k2) {
    var x = k2.r;
    var v = $22558d40829e937a$var$rotateWithLeftChild(x);
    k2.r = v;
    return $22558d40829e937a$var$rotateWithRightChild(k2);
}
function $22558d40829e937a$var$heightUpdateMutate(t) {
    var hlt = $22558d40829e937a$var$treeHeight(t.l);
    var hrt = $22558d40829e937a$var$treeHeight(t.r);
    t.h = (hlt > hrt ? hlt : hrt) + 1 | 0;
    return t;
}
function $22558d40829e937a$export$7ba8ef59999a0393(nt) {
    var l = nt.l;
    var r = nt.r;
    var hl = $22558d40829e937a$var$treeHeight(l);
    var hr = $22558d40829e937a$var$treeHeight(r);
    if (hl > (2 + hr | 0)) {
        var ll = l.l;
        var lr = l.r;
        if ($22558d40829e937a$var$heightGe(ll, lr)) return $22558d40829e937a$var$heightUpdateMutate($22558d40829e937a$var$rotateWithLeftChild(nt));
        else return $22558d40829e937a$var$heightUpdateMutate($22558d40829e937a$var$doubleWithLeftChild(nt));
    }
    if (hr > (2 + hl | 0)) {
        var rl = r.l;
        var rr = r.r;
        if ($22558d40829e937a$var$heightGe(rr, rl)) return $22558d40829e937a$var$heightUpdateMutate($22558d40829e937a$var$rotateWithRightChild(nt));
        else return $22558d40829e937a$var$heightUpdateMutate($22558d40829e937a$var$doubleWithRightChild(nt));
    }
    nt.h = (hl > hr ? hl : hr) + 1 | 0;
    return nt;
}
function $22558d40829e937a$export$cf26006d4bdb7cc7(t, x, data, cmp) {
    if (t === undefined) return $22558d40829e937a$export$439306a4dcaafbb9(x, data);
    var k = t.k;
    var c = cmp(x, k);
    if (c === 0) {
        t.v = data;
        return t;
    }
    var l = t.l;
    var r = t.r;
    if (c < 0) {
        var ll = $22558d40829e937a$export$cf26006d4bdb7cc7(l, x, data, cmp);
        t.l = ll;
    } else t.r = $22558d40829e937a$export$cf26006d4bdb7cc7(r, x, data, cmp);
    return $22558d40829e937a$export$7ba8ef59999a0393(t);
}
function $22558d40829e937a$export$571d59b505e6bb4e(xs, cmp) {
    var len = xs.length;
    if (len === 0) return;
    var next = $58Tj9.strictlySortedLengthU(xs, function(param, param$1) {
        return cmp(param[0], param$1[0]) < 0;
    });
    var result;
    if (next >= 0) result = $22558d40829e937a$export$faaaa901e4a41f53(xs, 0, next);
    else {
        next = -next | 0;
        result = $22558d40829e937a$export$6635064176e858ca(xs, next - 1 | 0, next);
    }
    for(var i = next; i < len; ++i){
        var match = xs[i];
        result = $22558d40829e937a$export$cf26006d4bdb7cc7(result, match[0], match[1], cmp);
    }
    return result;
}
function $22558d40829e937a$export$34839c140fcf8cd7(nt, n) {
    var rn = n.r;
    var ln = n.l;
    if (ln !== undefined) {
        n.l = $22558d40829e937a$export$34839c140fcf8cd7(nt, ln);
        return $22558d40829e937a$export$7ba8ef59999a0393(n);
    } else {
        nt.k = n.k;
        nt.v = n.v;
        return rn;
    }
}
 /* No side effect */ 
});
parcelRegister("58Tj9", function(module, exports) {

$parcel$export(module.exports, "strictlySortedLengthU", function () { return $3be89a1fe3e1ec7c$export$676638e94f0291c6; });
$parcel$export(module.exports, "stableSortInPlaceByU", function () { return $3be89a1fe3e1ec7c$export$2a81044477c2c00d; });
$parcel$export(module.exports, "stableSortBy", function () { return $3be89a1fe3e1ec7c$export$4a7b200faa4203c7; });

var $iv6Yc = parcelRequire("iv6Yc");

var $i7mYY = parcelRequire("i7mYY");
function $3be89a1fe3e1ec7c$var$sortedLengthAuxMore(xs, _prec, _acc, len, lt) {
    while(true){
        var acc = _acc;
        var prec = _prec;
        if (acc >= len) return acc;
        var v = xs[acc];
        if (!lt(v, prec)) return acc;
        _acc = acc + 1 | 0;
        _prec = v;
        continue;
    }
}
function $3be89a1fe3e1ec7c$export$676638e94f0291c6(xs, lt) {
    var len = xs.length;
    if (len === 0 || len === 1) return len;
    var x0 = xs[0];
    var x1 = xs[1];
    if (lt(x0, x1)) {
        var _prec = x1;
        var _acc = 2;
        while(true){
            var acc = _acc;
            var prec = _prec;
            if (acc >= len) return acc;
            var v = xs[acc];
            if (!lt(prec, v)) return acc;
            _acc = acc + 1 | 0;
            _prec = v;
            continue;
        }
    } else if (lt(x1, x0)) return -$3be89a1fe3e1ec7c$var$sortedLengthAuxMore(xs, x1, 2, len, lt) | 0;
    else return 1;
}
function $3be89a1fe3e1ec7c$export$bb0e766956b8a888(xs, lt) {
    return $3be89a1fe3e1ec7c$export$676638e94f0291c6(xs, $iv6Yc.__2(lt));
}
function $3be89a1fe3e1ec7c$export$f4769c9c596d6470(a, cmp) {
    var len = a.length;
    if (len === 0) return true;
    else {
        var _i = 0;
        var last_bound = len - 1 | 0;
        while(true){
            var i = _i;
            if (i === last_bound) return true;
            if (cmp(a[i], a[i + 1 | 0]) > 0) return false;
            _i = i + 1 | 0;
            continue;
        }
    }
}
function $3be89a1fe3e1ec7c$export$efa610630f9e181(a, cmp) {
    return $3be89a1fe3e1ec7c$export$f4769c9c596d6470(a, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$var$merge(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        if (cmp(s1, s2) <= 0) {
            dst[d] = s1;
            var i1$1 = i1 + 1 | 0;
            if (i1$1 >= src1r) return $i7mYY.blitUnsafe(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
            _d = d + 1 | 0;
            _s1 = src[i1$1];
            _i1 = i1$1;
            continue;
        }
        dst[d] = s2;
        var i2$1 = i2 + 1 | 0;
        if (i2$1 >= src2r) return $i7mYY.blitUnsafe(src, i1, dst, d + 1 | 0, src1r - i1 | 0);
        _d = d + 1 | 0;
        _s2 = src2[i2$1];
        _i2 = i2$1;
        continue;
    }
}
function $3be89a1fe3e1ec7c$export$135b0c9cef4594bd(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        var c = cmp(s1, s2);
        if (c < 0) {
            dst[d] = s1;
            var i1$1 = i1 + 1 | 0;
            var d$1 = d + 1 | 0;
            if (i1$1 < src1r) {
                _d = d$1;
                _s1 = src[i1$1];
                _i1 = i1$1;
                continue;
            }
            $i7mYY.blitUnsafe(src2, i2, dst, d$1, src2r - i2 | 0);
            return (d$1 + src2r | 0) - i2 | 0;
        }
        if (c === 0) {
            dst[d] = s1;
            var i1$2 = i1 + 1 | 0;
            var i2$1 = i2 + 1 | 0;
            var d$2 = d + 1 | 0;
            if (!(i1$2 < src1r && i2$1 < src2r)) {
                if (i1$2 === src1r) {
                    $i7mYY.blitUnsafe(src2, i2$1, dst, d$2, src2r - i2$1 | 0);
                    return (d$2 + src2r | 0) - i2$1 | 0;
                } else {
                    $i7mYY.blitUnsafe(src, i1$2, dst, d$2, src1r - i1$2 | 0);
                    return (d$2 + src1r | 0) - i1$2 | 0;
                }
            }
            _d = d$2;
            _s2 = src2[i2$1];
            _i2 = i2$1;
            _s1 = src[i1$2];
            _i1 = i1$2;
            continue;
        }
        dst[d] = s2;
        var i2$2 = i2 + 1 | 0;
        var d$3 = d + 1 | 0;
        if (i2$2 < src2r) {
            _d = d$3;
            _s2 = src2[i2$2];
            _i2 = i2$2;
            continue;
        }
        $i7mYY.blitUnsafe(src, i1, dst, d$3, src1r - i1 | 0);
        return (d$3 + src1r | 0) - i1 | 0;
    }
}
function $3be89a1fe3e1ec7c$export$971dd5b0dfd021b6(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    return $3be89a1fe3e1ec7c$export$135b0c9cef4594bd(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$export$ee0dfe9b7c7205d0(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        var c = cmp(s1, s2);
        if (c < 0) {
            var i1$1 = i1 + 1 | 0;
            if (i1$1 >= src1r) return d;
            _s1 = src[i1$1];
            _i1 = i1$1;
            continue;
        }
        if (c === 0) {
            dst[d] = s1;
            var i1$2 = i1 + 1 | 0;
            var i2$1 = i2 + 1 | 0;
            var d$1 = d + 1 | 0;
            if (!(i1$2 < src1r && i2$1 < src2r)) return d$1;
            _d = d$1;
            _s2 = src2[i2$1];
            _i2 = i2$1;
            _s1 = src[i1$2];
            _i1 = i1$2;
            continue;
        }
        var i2$2 = i2 + 1 | 0;
        if (i2$2 >= src2r) return d;
        _s2 = src2[i2$2];
        _i2 = i2$2;
        continue;
    }
}
function $3be89a1fe3e1ec7c$export$1f4807a235930d45(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    return $3be89a1fe3e1ec7c$export$ee0dfe9b7c7205d0(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$export$f1f7eb63d928521d(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        var c = cmp(s1, s2);
        if (c < 0) {
            dst[d] = s1;
            var d$1 = d + 1 | 0;
            var i1$1 = i1 + 1 | 0;
            if (i1$1 >= src1r) return d$1;
            _d = d$1;
            _s1 = src[i1$1];
            _i1 = i1$1;
            continue;
        }
        if (c === 0) {
            var i1$2 = i1 + 1 | 0;
            var i2$1 = i2 + 1 | 0;
            if (!(i1$2 < src1r && i2$1 < src2r)) {
                if (i1$2 === src1r) return d;
                else {
                    $i7mYY.blitUnsafe(src, i1$2, dst, d, src1r - i1$2 | 0);
                    return (d + src1r | 0) - i1$2 | 0;
                }
            }
            _s2 = src2[i2$1];
            _i2 = i2$1;
            _s1 = src[i1$2];
            _i1 = i1$2;
            continue;
        }
        var i2$2 = i2 + 1 | 0;
        if (i2$2 < src2r) {
            _s2 = src2[i2$2];
            _i2 = i2$2;
            continue;
        }
        $i7mYY.blitUnsafe(src, i1, dst, d, src1r - i1 | 0);
        return (d + src1r | 0) - i1 | 0;
    }
}
function $3be89a1fe3e1ec7c$export$a37e3c603d7117e5(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    return $3be89a1fe3e1ec7c$export$f1f7eb63d928521d(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$var$insertionSort(src, srcofs, dst, dstofs, len, cmp) {
    for(var i = 0; i < len; ++i){
        var e = src[srcofs + i | 0];
        var j = (dstofs + i | 0) - 1 | 0;
        while(j >= dstofs && cmp(dst[j], e) > 0){
            dst[j + 1 | 0] = dst[j];
            j = j - 1 | 0;
        }
        dst[j + 1 | 0] = e;
    }
}
function $3be89a1fe3e1ec7c$var$sortTo(src, srcofs, dst, dstofs, len, cmp) {
    if (len <= 5) return $3be89a1fe3e1ec7c$var$insertionSort(src, srcofs, dst, dstofs, len, cmp);
    var l1 = len / 2 | 0;
    var l2 = len - l1 | 0;
    $3be89a1fe3e1ec7c$var$sortTo(src, srcofs + l1 | 0, dst, dstofs + l1 | 0, l2, cmp);
    $3be89a1fe3e1ec7c$var$sortTo(src, srcofs, src, srcofs + l2 | 0, l1, cmp);
    $3be89a1fe3e1ec7c$var$merge(src, srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs, cmp);
}
function $3be89a1fe3e1ec7c$export$2a81044477c2c00d(a, cmp) {
    var l = a.length;
    if (l <= 5) return $3be89a1fe3e1ec7c$var$insertionSort(a, 0, a, 0, l, cmp);
    var l1 = l / 2 | 0;
    var l2 = l - l1 | 0;
    var t = new Array(l2);
    $3be89a1fe3e1ec7c$var$sortTo(a, l1, t, 0, l2, cmp);
    $3be89a1fe3e1ec7c$var$sortTo(a, 0, a, l2, l1, cmp);
    $3be89a1fe3e1ec7c$var$merge(a, l2, l1, t, 0, l2, a, 0, cmp);
}
function $3be89a1fe3e1ec7c$export$40cca47fcdb32a75(a, cmp) {
    $3be89a1fe3e1ec7c$export$2a81044477c2c00d(a, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$export$5fea39d1086f7acb(a, cmp) {
    var b = a.slice(0);
    $3be89a1fe3e1ec7c$export$2a81044477c2c00d(b, cmp);
    return b;
}
function $3be89a1fe3e1ec7c$export$4a7b200faa4203c7(a, cmp) {
    return $3be89a1fe3e1ec7c$export$5fea39d1086f7acb(a, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$export$427641b688ae4f8c(sorted, key, cmp) {
    var len = sorted.length;
    if (len === 0) return -1;
    var lo = sorted[0];
    var c = cmp(key, lo);
    if (c < 0) return -1;
    var hi = sorted[len - 1 | 0];
    var c2 = cmp(key, hi);
    if (c2 > 0) return -(len + 1 | 0) | 0;
    else {
        var _lo = 0;
        var _hi = len - 1 | 0;
        while(true){
            var hi$1 = _hi;
            var lo$1 = _lo;
            var mid = (lo$1 + hi$1 | 0) / 2 | 0;
            var midVal = sorted[mid];
            var c$1 = cmp(key, midVal);
            if (c$1 === 0) return mid;
            if (c$1 < 0) {
                if (hi$1 === mid) {
                    if (cmp(sorted[lo$1], key) === 0) return lo$1;
                    else return -(hi$1 + 1 | 0) | 0;
                }
                _hi = mid;
                continue;
            }
            if (lo$1 === mid) {
                if (cmp(sorted[hi$1], key) === 0) return hi$1;
                else return -(hi$1 + 1 | 0) | 0;
            }
            _lo = mid;
            continue;
        }
    }
}
function $3be89a1fe3e1ec7c$export$cfdf5c5dfceb78b(sorted, key, cmp) {
    return $3be89a1fe3e1ec7c$export$427641b688ae4f8c(sorted, key, $iv6Yc.__2(cmp));
}
var $3be89a1fe3e1ec7c$export$fdd676b64b72b00;
var $3be89a1fe3e1ec7c$export$96ac42349eda6d06;
 /* No side effect */ 
});


parcelRegister("cJvir", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $9451f6d15b4be818$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "getUndefined", function () { return $9451f6d15b4be818$export$c0e2df34d3ecdf22; });
$parcel$export(module.exports, "getExn", function () { return $9451f6d15b4be818$export$2d6fda808293d631; });
$parcel$export(module.exports, "getWithDefault", function () { return $9451f6d15b4be818$export$73b8ef55a37133c7; });
$parcel$export(module.exports, "has", function () { return $9451f6d15b4be818$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "split", function () { return $9451f6d15b4be818$export$65980d18b75784e2; });
$parcel$export(module.exports, "mergeU", function () { return $9451f6d15b4be818$export$6f8d4ae0dfb14052; });
$parcel$export(module.exports, "merge", function () { return $9451f6d15b4be818$export$4950aa0f605343fb; });
$parcel$export(module.exports, "cmpU", function () { return $9451f6d15b4be818$export$c0aec0f0618831d3; });
$parcel$export(module.exports, "cmp", function () { return $9451f6d15b4be818$export$6154dcdb7d23e37b; });
$parcel$export(module.exports, "eqU", function () { return $9451f6d15b4be818$export$f28cee400b9bf71f; });
$parcel$export(module.exports, "eq", function () { return $9451f6d15b4be818$export$9663ddc1cf085b32; });
$parcel$export(module.exports, "fromArray", function () { return $9451f6d15b4be818$export$571d59b505e6bb4e; });

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");

var $58Tj9 = parcelRequire("58Tj9");

var $2WL7H = parcelRequire("2WL7H");
function $9451f6d15b4be818$export$e16d8520af44a096(t, x, data) {
    if (t === undefined) return $2WL7H.singleton(x, data);
    var k = t.k;
    if (x === k) return $2WL7H.updateValue(t, data);
    var v = t.v;
    if (x < k) return $2WL7H.bal($9451f6d15b4be818$export$e16d8520af44a096(t.l, x, data), k, v, t.r);
    else return $2WL7H.bal(t.l, k, v, $9451f6d15b4be818$export$e16d8520af44a096(t.r, x, data));
}
function $9451f6d15b4be818$export$3988ae62b71be9a3(_n, x) {
    while(true){
        var n = _n;
        if (n === undefined) return;
        var v = n.k;
        if (x === v) return $loT9g.some(n.v);
        _n = x < v ? n.l : n.r;
        continue;
    }
}
function $9451f6d15b4be818$export$c0e2df34d3ecdf22(_n, x) {
    while(true){
        var n = _n;
        if (n === undefined) return;
        var v = n.k;
        if (x === v) return n.v;
        _n = x < v ? n.l : n.r;
        continue;
    }
}
function $9451f6d15b4be818$export$2d6fda808293d631(_n, x) {
    while(true){
        var n = _n;
        if (n !== undefined) {
            var v = n.k;
            if (x === v) return n.v;
            _n = x < v ? n.l : n.r;
            continue;
        }
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
}
function $9451f6d15b4be818$export$73b8ef55a37133c7(_n, x, def) {
    while(true){
        var n = _n;
        if (n === undefined) return def;
        var v = n.k;
        if (x === v) return n.v;
        _n = x < v ? n.l : n.r;
        continue;
    }
}
function $9451f6d15b4be818$export$a4f4bb6b1453fff5(_n, x) {
    while(true){
        var n = _n;
        if (n === undefined) return false;
        var v = n.k;
        if (x === v) return true;
        _n = x < v ? n.l : n.r;
        continue;
    }
}
function $9451f6d15b4be818$export$cd7f480d6b8286c3(n, x) {
    if (n === undefined) return n;
    var v = n.k;
    var l = n.l;
    var r = n.r;
    if (x !== v) {
        if (x < v) return $2WL7H.bal($9451f6d15b4be818$export$cd7f480d6b8286c3(l, x), v, n.v, r);
        else return $2WL7H.bal(l, v, n.v, $9451f6d15b4be818$export$cd7f480d6b8286c3(r, x));
    }
    if (l === undefined) return r;
    if (r === undefined) return l;
    var kr = {
        contents: r.k
    };
    var vr = {
        contents: r.v
    };
    var r$1 = $2WL7H.removeMinAuxWithRef(r, kr, vr);
    return $2WL7H.bal(l, kr.contents, vr.contents, r$1);
}
function $9451f6d15b4be818$export$86df3a9f3eac7a90(x, n) {
    var v = n.k;
    var d = n.v;
    var l = n.l;
    var r = n.r;
    if (x === v) return [
        l,
        $loT9g.some(d),
        r
    ];
    if (x < v) {
        if (l === undefined) return [
            undefined,
            undefined,
            n
        ];
        var match = $9451f6d15b4be818$export$86df3a9f3eac7a90(x, l);
        return [
            match[0],
            match[1],
            $2WL7H.join(match[2], v, d, r)
        ];
    }
    if (r === undefined) return [
        n,
        undefined,
        undefined
    ];
    var match$1 = $9451f6d15b4be818$export$86df3a9f3eac7a90(x, r);
    return [
        $2WL7H.join(l, v, d, match$1[0]),
        match$1[1],
        match$1[2]
    ];
}
function $9451f6d15b4be818$export$65980d18b75784e2(x, n) {
    if (n !== undefined) return $9451f6d15b4be818$export$86df3a9f3eac7a90(x, n);
    else return [
        undefined,
        undefined,
        undefined
    ];
}
function $9451f6d15b4be818$export$6f8d4ae0dfb14052(s1, s2, f) {
    if (s1 !== undefined) {
        if (s1.h >= (s2 !== undefined ? s2.h : 0)) {
            var v1 = s1.k;
            var d1 = s1.v;
            var l1 = s1.l;
            var r1 = s1.r;
            var match = $9451f6d15b4be818$export$65980d18b75784e2(v1, s2);
            return $2WL7H.concatOrJoin($9451f6d15b4be818$export$6f8d4ae0dfb14052(l1, match[0], f), v1, f(v1, $loT9g.some(d1), match[1]), $9451f6d15b4be818$export$6f8d4ae0dfb14052(r1, match[2], f));
        }
    } else if (s2 === undefined) return;
    var v2 = s2.k;
    var d2 = s2.v;
    var l2 = s2.l;
    var r2 = s2.r;
    var match$1 = $9451f6d15b4be818$export$65980d18b75784e2(v2, s1);
    return $2WL7H.concatOrJoin($9451f6d15b4be818$export$6f8d4ae0dfb14052(match$1[0], l2, f), v2, f(v2, match$1[1], $loT9g.some(d2)), $9451f6d15b4be818$export$6f8d4ae0dfb14052(match$1[2], r2, f));
}
function $9451f6d15b4be818$export$4950aa0f605343fb(s1, s2, f) {
    return $9451f6d15b4be818$export$6f8d4ae0dfb14052(s1, s2, $iv6Yc.__3(f));
}
function $9451f6d15b4be818$export$a6149bd3c6bd2b39(_e1, _e2, vcmp) {
    while(true){
        var e2 = _e2;
        var e1 = _e1;
        if (!e1) return 0;
        if (!e2) return 0;
        var h2 = e2.hd;
        var h1 = e1.hd;
        var c = $81N94.string_compare(h1.k, h2.k);
        if (c !== 0) return c;
        var cx = vcmp(h1.v, h2.v);
        if (cx !== 0) return cx;
        _e2 = $2WL7H.stackAllLeft(h2.r, e2.tl);
        _e1 = $2WL7H.stackAllLeft(h1.r, e1.tl);
        continue;
    }
}
function $9451f6d15b4be818$export$c0aec0f0618831d3(s1, s2, cmp) {
    var len1 = $2WL7H.size(s1);
    var len2 = $2WL7H.size(s2);
    if (len1 === len2) return $9451f6d15b4be818$export$a6149bd3c6bd2b39($2WL7H.stackAllLeft(s1, /* [] */ 0), $2WL7H.stackAllLeft(s2, /* [] */ 0), cmp);
    else if (len1 < len2) return -1;
    else return 1;
}
function $9451f6d15b4be818$export$6154dcdb7d23e37b(s1, s2, f) {
    return $9451f6d15b4be818$export$c0aec0f0618831d3(s1, s2, $iv6Yc.__2(f));
}
function $9451f6d15b4be818$export$da81f308573672af(_e1, _e2, eq) {
    while(true){
        var e2 = _e2;
        var e1 = _e1;
        if (!e1) return true;
        if (!e2) return true;
        var h2 = e2.hd;
        var h1 = e1.hd;
        if (!(h1.k === h2.k && eq(h1.v, h2.v))) return false;
        _e2 = $2WL7H.stackAllLeft(h2.r, e2.tl);
        _e1 = $2WL7H.stackAllLeft(h1.r, e1.tl);
        continue;
    }
}
function $9451f6d15b4be818$export$f28cee400b9bf71f(s1, s2, eq) {
    var len1 = $2WL7H.size(s1);
    var len2 = $2WL7H.size(s2);
    if (len1 === len2) return $9451f6d15b4be818$export$da81f308573672af($2WL7H.stackAllLeft(s1, /* [] */ 0), $2WL7H.stackAllLeft(s2, /* [] */ 0), eq);
    else return false;
}
function $9451f6d15b4be818$export$9663ddc1cf085b32(s1, s2, f) {
    return $9451f6d15b4be818$export$f28cee400b9bf71f(s1, s2, $iv6Yc.__2(f));
}
function $9451f6d15b4be818$export$4e6e15d0cd5c1ca5(t, x, data) {
    if (t === undefined) return $2WL7H.singleton(x, data);
    var k = t.k;
    if (x === k) {
        t.k = x;
        t.v = data;
        return t;
    }
    var l = t.l;
    var r = t.r;
    if (x < k) {
        var ll = $9451f6d15b4be818$export$4e6e15d0cd5c1ca5(l, x, data);
        t.l = ll;
    } else t.r = $9451f6d15b4be818$export$4e6e15d0cd5c1ca5(r, x, data);
    return $2WL7H.balMutate(t);
}
function $9451f6d15b4be818$export$571d59b505e6bb4e(xs) {
    var len = xs.length;
    if (len === 0) return;
    var next = $58Tj9.strictlySortedLengthU(xs, function(param, param$1) {
        return param[0] < param$1[0];
    });
    var result;
    if (next >= 0) result = $2WL7H.fromSortedArrayAux(xs, 0, next);
    else {
        next = -next | 0;
        result = $2WL7H.fromSortedArrayRevAux(xs, next - 1 | 0, next);
    }
    for(var i = next; i < len; ++i){
        var match = xs[i];
        result = $9451f6d15b4be818$export$4e6e15d0cd5c1ca5(result, match[0], match[1]);
    }
    return result;
}
var $9451f6d15b4be818$export$a07804094c3ecf2d;
var $9451f6d15b4be818$export$ebd11618f299a286;
var $9451f6d15b4be818$export$25ce5a424b770e84;
 /* No side effect */ 
});


parcelRegister("9bmXk", function(module, exports) {

$parcel$export(module.exports, "fromOption", function () { return $6af6f2b7793ec660$export$172ec0a6ebfeb6fa; });

var $loT9g = parcelRequire("loT9g");
function $6af6f2b7793ec660$export$2385a24977818dd0(x, f) {
    if (x == null) return x;
    else return f(x);
}
function $6af6f2b7793ec660$export$c0bf298a2e425654(x, f) {
    if (!(x == null)) return f(x);
}
function $6af6f2b7793ec660$export$172ec0a6ebfeb6fa(x) {
    if (x !== undefined) return $loT9g.valFromOption(x);
}
var $6af6f2b7793ec660$export$9d85d2d85cb82adf = $6af6f2b7793ec660$export$172ec0a6ebfeb6fa;
 /* No side effect */ 
});

parcelRegister("h6rW7", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $c738aacb6830be55$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromString", function () { return $c738aacb6830be55$export$3004f64547af360e; });
$parcel$export(module.exports, "empty", function () { return $c738aacb6830be55$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "toNamespacedKey", function () { return $c738aacb6830be55$export$9886bab0176e1b3e; });
$parcel$export(module.exports, "getDictByNamespace", function () { return $c738aacb6830be55$export$2ddb74fbdf359c07; });
$parcel$export(module.exports, "map", function () { return $c738aacb6830be55$export$871de8747c9eaa88; });
$parcel$export(module.exports, "forEach", function () { return $c738aacb6830be55$export$4b80e395e36b5a56; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");
function $c738aacb6830be55$export$327e003d2047f30a($star) {
    var _$toString = function toString(key) {
        return key;
    };
    var _$fromString = function fromString(key) {
        return key;
    };
    return {
        toString: _$toString,
        fromString: _$fromString
    };
}
function $c738aacb6830be55$export$f84e8e69fd4488a5(key) {
    return key;
}
function $c738aacb6830be55$export$3004f64547af360e(key) {
    return key;
}
var $c738aacb6830be55$export$971d5caa766a69d7 = {
    toString: $c738aacb6830be55$export$f84e8e69fd4488a5,
    fromString: $c738aacb6830be55$export$3004f64547af360e
};
var $c738aacb6830be55$export$c889f2fcc19dbf12 = "__";
var $c738aacb6830be55$export$6e22c362a0406a2c = "nonamespace";
function $c738aacb6830be55$export$9886bab0176e1b3e(nonNamespacedKey, namespace) {
    var namespace$1 = $2whNH.map(namespace, $c738aacb6830be55$export$f84e8e69fd4488a5);
    if (namespace$1 !== undefined && namespace$1 !== "") return nonNamespacedKey + $c738aacb6830be55$export$c889f2fcc19dbf12 + namespace$1;
    else return nonNamespacedKey;
}
function $c738aacb6830be55$export$ac0413943b7bd356(namespacedKey) {
    var split = namespacedKey.split($c738aacb6830be55$export$c889f2fcc19dbf12);
    var nonNamespacedKey = $2whNH.getWithDefault($i7mYY.get(split, 0), namespacedKey);
    var namespace = $2whNH.map($i7mYY.get(split, 1), $c738aacb6830be55$export$3004f64547af360e);
    return [
        nonNamespacedKey,
        namespace
    ];
}
function $c738aacb6830be55$export$2ddb74fbdf359c07(dict, namespace) {
    return $d3YYW.fromArray($i7mYY.keepMap($i7mYY.map($d3YYW.entries(dict), function(param) {
        return [
            $c738aacb6830be55$export$ac0413943b7bd356(param[0]),
            param[1]
        ];
    }), function(param) {
        var match = param[0];
        if ($7bjme.equal(match[1], namespace)) return [
            match[0],
            param[1]
        ];
    }));
}
function $c738aacb6830be55$export$871de8747c9eaa88(namespace, fn) {
    return $iv6Yc._1(fn, $2whNH.getWithDefault(namespace, $c738aacb6830be55$export$6e22c362a0406a2c));
}
function $c738aacb6830be55$export$4b80e395e36b5a56(namespace, fn) {
    $iv6Yc._1(fn, $2whNH.getWithDefault(namespace, $c738aacb6830be55$export$6e22c362a0406a2c));
}
 /* No side effect */ 
});

parcelRegister("b5aRK", function(module, exports) {

$parcel$export(module.exports, "ofNode", function () { return $8118970f5d9e20b3$export$b09cfa9b7e510069; });
$parcel$export(module.exports, "asHtmlElement", function () { return $8118970f5d9e20b3$export$83b3005418b2b918; });
$parcel$export(module.exports, "Impl", function () { return $8118970f5d9e20b3$export$c08352ad19c25332; });

var $loT9g = parcelRequire("loT9g");

var $amOA8 = parcelRequire("amOA8");

var $cstWc = parcelRequire("cstWc");

var $29BbK = parcelRequire("29BbK");

var $bhL4E = parcelRequire("bhL4E");

var $5BvP6 = parcelRequire("5BvP6");

var $5OXjM = parcelRequire("5OXjM");

var $f70MN = parcelRequire("f70MN");

var $9pD4n = parcelRequire("9pD4n");
function $8118970f5d9e20b3$export$b09cfa9b7e510069(node) {
    if ($amOA8.nodeType(node) === /* Element */ 0) return $loT9g.some(node);
}
var $8118970f5d9e20b3$export$83b3005418b2b918 = function asHtmlElement(element) {
    if (window.constructor.name !== undefined && /^HTML\w*Element$/.test(element.constructor.name) || /^\[object HTML\w*Element\]$/.test(element.constructor.toString())) return element;
};
function $8118970f5d9e20b3$export$c08352ad19c25332(T) {
    var insertAdjacentElement = function insertAdjacentElement(self, position, element) {
        self.insertAdjacentElement($cstWc.encodeInsertPosition(position), element);
    };
    var insertAdjacentHTML = function insertAdjacentHTML(self, position, text) {
        self.insertAdjacentHTML($cstWc.encodeInsertPosition(position), text);
    };
    var insertAdjacentText = function insertAdjacentText(self, position, text) {
        self.insertAdjacentText($cstWc.encodeInsertPosition(position), text);
    };
    return {
        asHtmlElement: $8118970f5d9e20b3$export$83b3005418b2b918,
        ofNode: $8118970f5d9e20b3$export$b09cfa9b7e510069,
        insertAdjacentElement: insertAdjacentElement,
        insertAdjacentHTML: insertAdjacentHTML,
        insertAdjacentText: insertAdjacentText
    };
}
var $8118970f5d9e20b3$var$include = $amOA8.Impl({});
$5OXjM.Impl({});
$f70MN.Impl({});
$5BvP6.Impl({});
$9pD4n.Impl({});
$bhL4E.Impl({});
$29BbK.Impl({});
function $8118970f5d9e20b3$export$bcf37bc7ac72b44e(self, position, element) {
    self.insertAdjacentElement($cstWc.encodeInsertPosition(position), element);
}
function $8118970f5d9e20b3$export$56db5d470f98d841(self, position, text) {
    self.insertAdjacentHTML($cstWc.encodeInsertPosition(position), text);
}
function $8118970f5d9e20b3$export$63b055236462c0b2(self, position, text) {
    self.insertAdjacentText($cstWc.encodeInsertPosition(position), text);
}
var $8118970f5d9e20b3$export$4debbe1037afe35e = $8118970f5d9e20b3$var$include.nodeType;
 /* include Not a pure module */ 
});
parcelRegister("amOA8", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $78c331f32a57dcbf$export$c08352ad19c25332; });
$parcel$export(module.exports, "nodeType", function () { return $78c331f32a57dcbf$export$4debbe1037afe35e; });

var $cstWc = parcelRequire("cstWc");

var $5OXjM = parcelRequire("5OXjM");
function $78c331f32a57dcbf$export$c08352ad19c25332(T) {
    var nodeType = function nodeType(self) {
        return $cstWc.decodeNodeType(self.nodeType);
    };
    return {
        nodeType: nodeType
    };
}
$5OXjM.Impl({});
function $78c331f32a57dcbf$export$4debbe1037afe35e(self) {
    return $cstWc.decodeNodeType(self.nodeType);
}
 /*  Not a pure module */ 
});
parcelRegister("cstWc", function(module, exports) {

$parcel$export(module.exports, "decodeCompatMode", function () { return $911f528f090317fc$export$4aa2174b1f9b281d; });
$parcel$export(module.exports, "encodeContentEditable", function () { return $911f528f090317fc$export$11e4dded6305aac5; });
$parcel$export(module.exports, "decodeContentEditable", function () { return $911f528f090317fc$export$33ee79228d0c88e9; });
$parcel$export(module.exports, "encodeDir", function () { return $911f528f090317fc$export$60f9589b1ae70ec4; });
$parcel$export(module.exports, "decodeDir", function () { return $911f528f090317fc$export$effab2688df43525; });
$parcel$export(module.exports, "encodeInsertPosition", function () { return $911f528f090317fc$export$b7b0561a1a2440cf; });
$parcel$export(module.exports, "decodeNodeType", function () { return $911f528f090317fc$export$5c924db342d17115; });
$parcel$export(module.exports, "decodeVisibilityState", function () { return $911f528f090317fc$export$2251030e379f19a7; });
function $911f528f090317fc$export$3c3191cdd4f03507(x) {
    return x;
}
function $911f528f090317fc$export$3f3d0079954536f4(x) {
    if (x + 1 >>> 0 > 2) return /* Unknown */ 3;
    else return x + 1 | 0;
}
function $911f528f090317fc$export$4aa2174b1f9b281d(x) {
    switch(x){
        case "BackCompat":
            return /* BackCompat */ 0;
        case "CSS1Compat":
            return /* CSS1Compat */ 1;
        default:
            return /* Unknown */ 2;
    }
}
function $911f528f090317fc$export$11e4dded6305aac5(x) {
    switch(x){
        case /* True */ 0:
            return "true";
        case /* False */ 1:
            return "false";
        case /* Inherit */ 2:
            return "inherit";
        case /* Unknown */ 3:
            return "";
    }
}
function $911f528f090317fc$export$33ee79228d0c88e9(x) {
    switch(x){
        case "false":
            return /* False */ 1;
        case "inherit":
            return /* Inherit */ 2;
        case "true":
            return /* True */ 0;
        default:
            return /* Unknown */ 3;
    }
}
function $911f528f090317fc$export$e5fbea3206fe4b3c(x) {
    if (x > 2 || x < 0) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "invalid deltaMode",
        Error: new Error()
    };
    return x;
}
function $911f528f090317fc$export$3dde7b99cba1956c(x) {
    switch(x){
        case /* On */ 0:
            return "on";
        case /* Off */ 1:
            return "off";
        case /* Unknown */ 2:
            return "";
    }
}
function $911f528f090317fc$export$65c5110e76ff3dcc(x) {
    switch(x){
        case "off":
            return /* Off */ 1;
        case "on":
            return /* On */ 0;
        default:
            return /* Unknown */ 2;
    }
}
function $911f528f090317fc$export$60f9589b1ae70ec4(x) {
    switch(x){
        case /* Ltr */ 0:
            return "ltr";
        case /* Rtl */ 1:
            return "rtl";
        case /* Unknown */ 2:
            return "";
    }
}
function $911f528f090317fc$export$effab2688df43525(x) {
    switch(x){
        case "ltr":
            return /* Ltr */ 0;
        case "rtl":
            return /* Rtl */ 1;
        default:
            return /* Unknown */ 2;
    }
}
function $911f528f090317fc$var$decode(x) {
    if (x > 3 || x < 0) return /* Unknown */ 4;
    else return x;
}
var $911f528f090317fc$export$26762ca2f68a3191 = {
    decode: $911f528f090317fc$var$decode
};
function $911f528f090317fc$export$24374a5985756f50(x) {
    return x + 1 | 0;
}
function $911f528f090317fc$export$b7b0561a1a2440cf(x) {
    switch(x){
        case /* BeforeBegin */ 0:
            return "beforebegin";
        case /* AfterBegin */ 1:
            return "afterbegin";
        case /* BeforeEnd */ 2:
            return "beforeend";
        case /* AfterEnd */ 3:
            return "afterend";
    }
}
function $911f528f090317fc$export$509e0dc687c1381a(x) {
    switch(x){
        case /* Alt */ 0:
            return "Alt";
        case /* AltGraph */ 1:
            return "AltGraph";
        case /* CapsLock */ 2:
            return "CapsLock";
        case /* Control */ 3:
            return "Control";
        case /* Fn */ 4:
            return "Fn";
        case /* FnLock */ 5:
            return "FnLock";
        case /* Hyper */ 6:
            return "Hyper";
        case /* Meta */ 7:
            return "Meta";
        case /* NumLock */ 8:
            return "NumLock";
        case /* ScrollLock */ 9:
            return "ScrollLock";
        case /* Shift */ 10:
            return "Shift";
        case /* Super */ 11:
            return "Super";
        case /* Symbol */ 12:
            return "Symbol";
        case /* SymbolLock */ 13:
            return "SymbolLock";
    }
}
function $911f528f090317fc$export$5c924db342d17115(x) {
    if (x > 12 || x < 1) return /* Unknown */ 12;
    else return x - 1 | 0;
}
function $911f528f090317fc$export$64d4f5c3bdeaf4d(x) {
    switch(x){
        case "mouse":
            return /* Mouse */ 0;
        case "pen":
            return /* Pen */ 1;
        case "touch|":
            return /* Touch */ 2;
        default:
            return /* Unknown */ 3;
    }
}
function $911f528f090317fc$export$db630ac806153a82(x) {
    switch(x){
        case "complete":
            return /* Complete */ 2;
        case "interactive":
            return /* Interactive */ 1;
        case "loading":
            return /* Loading */ 0;
        default:
            return /* Unknown */ 3;
    }
}
function $911f528f090317fc$export$98c66c6ec1c08548(x) {
    switch(x){
        case "closed":
            return /* Closed */ 1;
        case "open":
            return /* Open */ 0;
        default:
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "Unknown shadowRootMode",
                Error: new Error()
            };
    }
}
function $911f528f090317fc$export$2251030e379f19a7(x) {
    switch(x){
        case "hidden":
            return /* Hidden */ 1;
        case "prerender":
            return /* Prerender */ 2;
        case "unloaded":
            return /* Unloaded */ 3;
        case "visible":
            return /* Visible */ 0;
        default:
            return /* Unknown */ 4;
    }
}
function $911f528f090317fc$var$many(x) {
    if (x) return x.hd | $911f528f090317fc$var$many(x.tl);
    else return 0;
}
var $911f528f090317fc$export$d07c789697b72851 = {
    _All: -1,
    _Element: 1,
    _Attribute: 2,
    _Text: 4,
    _CDATASection: 8,
    _EntityReference: 16,
    _Entity: 32,
    _ProcessingInstruction: 64,
    _Comment: 128,
    _Document: 256,
    _DocumentType: 512,
    _DocumentFragment: 1024,
    _Notation: 2048,
    many: $911f528f090317fc$var$many
};
 /* No side effect */ 
});

parcelRegister("5OXjM", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $43cfa29c5061abc3$export$c08352ad19c25332; });
function $43cfa29c5061abc3$export$c08352ad19c25332(T) {
    return {};
}
 /* No side effect */ 
});


parcelRegister("29BbK", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $191944df332f7a89$export$c08352ad19c25332; });
function $191944df332f7a89$export$c08352ad19c25332(T) {
    return {};
}
 /* No side effect */ 
});

parcelRegister("bhL4E", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $8375cc26cd747cbf$export$c08352ad19c25332; });
function $8375cc26cd747cbf$export$c08352ad19c25332(T) {
    return {};
}
 /* No side effect */ 
});

parcelRegister("5BvP6", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $414917e15bba6a6f$export$c08352ad19c25332; });
function $414917e15bba6a6f$export$c08352ad19c25332(T) {
    return {};
}
 /* No side effect */ 
});

parcelRegister("f70MN", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $b0081e8e55436f98$export$c08352ad19c25332; });
function $b0081e8e55436f98$export$c08352ad19c25332(T) {
    return {};
}
 /* No side effect */ 
});

parcelRegister("9pD4n", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $6da4c141d50bb31d$export$c08352ad19c25332; });
function $6da4c141d50bb31d$export$c08352ad19c25332(T) {
    return {};
}
 /* No side effect */ 
});


parcelRegister("78zWm", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $532528c63ef586dc$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $532528c63ef586dc$export$1f96ae73734a86cc(optionsOpt, ref, callback) {
    var options = optionsOpt !== undefined ? optionsOpt : {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    };
    var observerRef = $g85JO.useRef(undefined);
    $g85JO.useEffect(function() {
        var match = ref.current;
        if (!(match == null)) {
            var match$1 = observerRef.current;
            if (match$1 === undefined) {
                var observer = new MutationObserver(callback);
                observer.observe(ref.current, options);
                observerRef.current = observer;
            }
        }
    }, [
        ref,
        callback,
        options
    ]);
    $g85JO.useEffect(function() {
        return function(param) {
            var observer = observerRef.current;
            if (observer !== undefined) return observer.disconnect();
        };
    }, []);
}
 /* react Not a pure module */ 
});


parcelRegister("hrFTE", function(module, exports) {

$parcel$export(module.exports, "insertCSS", function () { return $cb357519db67f29d$export$98cb916552ec6ef6; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $41eh7 = parcelRequire("41eh7");

var $7GW0c = parcelRequire("7GW0c");
function $cb357519db67f29d$var$getCurrentScriptOrigin(param) {
    return localStorage && localStorage.getItem("smartnav-script-origin") || "https://showside.maker.co";
}
var $cb357519db67f29d$var$match = $41eh7.getVersion(undefined);
var $cb357519db67f29d$export$7de29939931d8a66 = $cb357519db67f29d$var$match === "v3" ? "smartnav-v3.css" : "smartnav-v2.css";
function $cb357519db67f29d$export$ea6b1c92ade1c6f5(param) {
    return $2whNH.isSome($loT9g.nullable_to_opt(document.querySelector('link[rel="stylesheet"][href*="' + $cb357519db67f29d$export$7de29939931d8a66 + '"]')));
}
function $cb357519db67f29d$export$98cb916552ec6ef6(onLoadedOpt, param) {
    var onLoaded = onLoadedOpt !== undefined ? onLoadedOpt : function onLoaded(param) {};
    if ($cb357519db67f29d$export$ea6b1c92ade1c6f5(undefined)) return $iv6Yc._1(onLoaded, undefined);
    var link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("as", "style");
    link.setAttribute("href", $cb357519db67f29d$var$getCurrentScriptOrigin(undefined) + ("/" + $cb357519db67f29d$export$7de29939931d8a66 + ""));
    link.setAttribute("id", "maker-smartnav-style");
    link.addEventListener("load", function(param) {
        $iv6Yc._1(onLoaded, undefined);
    });
    $2whNH.forEach($7GW0c.$$Document.body(document), function(param) {
        param.appendChild(link);
    });
}
 /* match Not a pure module */ 
});
parcelRegister("41eh7", function(module, exports) {

$parcel$export(module.exports, "getVersion", function () { return $2ed2542c0e827925$export$c506eb22e615ba4a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $loT9g = parcelRequire("loT9g");
function $2ed2542c0e827925$export$c506eb22e615ba4a(param) {
    var isPages = $loT9g.nullable_to_opt(document.querySelector("#quicknav, maker-show")) !== undefined;
    if (isPages) return "v2";
    else return "v3";
}
 /* No side effect */ 
});


parcelRegister("kMqPq", function(module, exports) {

$parcel$export(module.exports, "makeApiUrl", function () { return $f20d19efe359e012$export$122a632893579567; });
$parcel$export(module.exports, "preloadConfig", function () { return $f20d19efe359e012$export$4113fd76ece5c26f; });
$parcel$export(module.exports, "nodeLimit", function () { return $f20d19efe359e012$export$3e97b5ef32dc0192; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $hxhfd = parcelRequire("hxhfd");

var $bBMv4 = parcelRequire("bBMv4");

var $jEVpK = parcelRequire("jEVpK");

var $9MZLD = parcelRequire("9MZLD");
function $f20d19efe359e012$export$122a632893579567(apiHostname, live, backup, configId, breakpoint, trimTreeByReferrer, noTreeOpt, param) {
    var noTree = noTreeOpt !== undefined ? noTreeOpt : false;
    return apiHostname + "/api/get_config?config_id=" + configId + (live ? "&live=true" : "") + $2whNH.mapWithDefault(backup, "", function(backup) {
        return "&backup=" + backup;
    }) + $2whNH.mapWithDefault(trimTreeByReferrer, "", function(trimTreeByReferrer) {
        return "&trim_tree_by_referrer=" + trimTreeByReferrer;
    }) + "&showside_format=true&breakpoint=" + breakpoint + ("&node_limit=" + String(30)) + "&paginate=true" + (noTree ? "&no_tree=true" : "");
}
function $f20d19efe359e012$export$4113fd76ece5c26f(enableTrimmingTreeByReferrerOpt, breakpointOverride, embedType, configId) {
    var enableTrimmingTreeByReferrer = enableTrimmingTreeByReferrerOpt !== undefined ? enableTrimmingTreeByReferrerOpt : false;
    var $$location = window.location;
    var trimTreeByReferrer = enableTrimmingTreeByReferrer ? encodeURIComponent($$location.origin + $$location.pathname) : undefined;
    var match;
    try {
        var url = new URL(window.location.href);
        var navParams = url.searchParams;
        var devMode = $2whNH.mapWithDefault($loT9g.nullable_to_opt(navParams.get("QNDevMode")), /* Production */ 1, $hxhfd.getApiEnv);
        var previewMode = navParams.get("QNPreviewMode");
        var backup;
        if (previewMode == null) backup = undefined;
        else {
            var match$1 = previewMode.match(/^T([0-9]+)$/);
            if (match$1 !== null && match$1.length === 2) {
                var timestamp = match$1[1];
                backup = timestamp !== undefined ? timestamp : undefined;
            } else backup = undefined;
        }
        var live = previewMode == null || previewMode !== "HEAD" ? true : false;
        match = [
            $hxhfd.getApiHostname(devMode),
            live,
            backup
        ];
    } catch (raw_e) {
        var e = $bBMv4.internalToOCamlException(raw_e);
        console.error("Failed to get referrer, apiHostname, live, backup for preloading:", e);
        match = [
            $hxhfd.apiHostnameProduction,
            true,
            undefined
        ];
    }
    var apiHostname = match[0];
    var breakpoint = $9MZLD.toString($2whNH.getWithDefault(breakpointOverride, $9MZLD.calc($jEVpK.getWidth(undefined))));
    var fragment = document.createDocumentFragment();
    var preconnect = document.createElement("link");
    preconnect.setAttribute("rel", "preconnect");
    preconnect.setAttribute("href", apiHostname);
    preconnect.setAttribute("crossorigin", "anonymous");
    fragment.appendChild(preconnect);
    var dnsPrefetch = document.createElement("link");
    dnsPrefetch.setAttribute("rel", "dns-prefetch");
    dnsPrefetch.setAttribute("href", apiHostname);
    fragment.appendChild(dnsPrefetch);
    var preload = document.createElement("link");
    preload.setAttribute("rel", "preload");
    preload.setAttribute("as", "fetch");
    preload.setAttribute("fetchpriority", "high");
    preload.setAttribute("href", $f20d19efe359e012$export$122a632893579567(apiHostname, match[1], match[2], configId, breakpoint, trimTreeByReferrer, embedType === /* ProductDetailsPage */ 5, undefined));
    preload.setAttribute("crossorigin", "anonymous");
    fragment.appendChild(preload);
    $2whNH.forEach($loT9g.nullable_to_opt(document.querySelector("head")), function(__x) {
        __x.appendChild(fragment);
    });
}
var $f20d19efe359e012$export$3e97b5ef32dc0192 = 30;
 /* Env-Showside Not a pure module */ 
});
parcelRegister("hxhfd", function(module, exports) {

$parcel$export(module.exports, "rollbarAccessToken", function () { return $034b66cada616cfa$export$d60a81027a7fc168; });
$parcel$export(module.exports, "nodeEnv", function () { return $034b66cada616cfa$export$37fa9d2aa1bf6dd1; });
$parcel$export(module.exports, "gitCommitSha", function () { return $034b66cada616cfa$export$747e59cf66009941; });
$parcel$export(module.exports, "apiHostnameProduction", function () { return $034b66cada616cfa$export$c72a56dea64b03fb; });
$parcel$export(module.exports, "getApiEnv", function () { return $034b66cada616cfa$export$25f63cee9d874dd7; });
$parcel$export(module.exports, "getApiHostname", function () { return $034b66cada616cfa$export$bd4ab0797d61c2b; });
$parcel$export(module.exports, "isTest", function () { return $034b66cada616cfa$export$410cbc2864fa25b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $bygWp = parcelRequire("bygWp");
var $034b66cada616cfa$export$d60a81027a7fc168 = "533bb4b491e442a7be988a4644319547";
var $034b66cada616cfa$export$37fa9d2aa1bf6dd1 = "production";
var $034b66cada616cfa$export$a2d882c07f06d405 = undefined;
var $034b66cada616cfa$export$a2390155e08931f4 = "5a1d52e298bb1cff5009e8727e0476bb417f702f";
var $034b66cada616cfa$export$747e59cf66009941 = $2whNH.getWithDefault($2whNH.orElse($034b66cada616cfa$export$a2d882c07f06d405, $034b66cada616cfa$export$a2390155e08931f4), "");
var $034b66cada616cfa$export$c72a56dea64b03fb = "https://api.maker.co";
var $034b66cada616cfa$export$ecb130f066f23e18 = "https://api-git-master-makerco.vercel.app";
var $034b66cada616cfa$export$c14bca7cd1b899b8 = "http://localhost:3001";
function $034b66cada616cfa$export$29a9c8be395a5cb3(env) {
    if (typeof env !== "number") return env._0;
    switch(env){
        case /* Staging */ 0:
            return "staging";
        case /* Production */ 1:
            return "production";
        case /* Local */ 2:
            return "local";
    }
}
function $034b66cada616cfa$export$25f63cee9d874dd7(devMode) {
    var partial_arg = /^(smartnav|api)\-([^\-]+)\-makerco\.vercel\.app$/;
    var isHostnameSafe = function isHostnameSafe(param) {
        return partial_arg.test(param);
    };
    var devMode$1 = devMode.toLowerCase();
    switch(devMode$1){
        case "dev":
        case "local":
            return /* Local */ 2;
        case "head":
        case "master":
        case "preview":
        case "staging":
            return /* Staging */ 0;
        default:
            if ($iv6Yc._1(isHostnameSafe, devMode$1)) return /* Hostname */ {
                _0: devMode$1
            };
            else return /* Production */ 1;
    }
}
function $034b66cada616cfa$export$bd4ab0797d61c2b(devMode) {
    if (typeof devMode !== "number") return "https://" + devMode._0;
    switch(devMode){
        case /* Staging */ 0:
            return $034b66cada616cfa$export$ecb130f066f23e18;
        case /* Production */ 1:
            return $034b66cada616cfa$export$c72a56dea64b03fb;
        case /* Local */ 2:
            return $034b66cada616cfa$export$c14bca7cd1b899b8;
    }
}
function $034b66cada616cfa$export$410cbc2864fa25b5(param) {
    if ($034b66cada616cfa$export$37fa9d2aa1bf6dd1 !== "production" || $bygWp.getCurrentHostname(undefined).endsWith(".vercel.app")) return true;
    else return $bygWp.getCurrentHostname(undefined).endsWith(".pages.dev");
}
 /* rollbarAccessToken Not a pure module */ 
});

parcelRegister("jEVpK", function(module, exports) {

$parcel$export(module.exports, "getWidth", function () { return $e4fe4a070745e220$export$3c49c185de0c2bfc; });
$parcel$export(module.exports, "getHeight", function () { return $e4fe4a070745e220$export$c08559766941f856; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");
function $e4fe4a070745e220$export$3c49c185de0c2bfc(param) {
    var clientWidth = document.documentElement.clientWidth;
    var innerWidth = window.innerWidth;
    var tmp;
    var exit = 0;
    if (innerWidth !== 0 || clientWidth <= 0) exit = 1;
    else tmp = clientWidth;
    if (exit === 1) tmp = clientWidth !== 0 ? clientWidth < innerWidth ? clientWidth : innerWidth : innerWidth > 0 || clientWidth >= innerWidth ? innerWidth : clientWidth;
    return $2whNH.getWithDefault($2whNH.flatMap($2whNH.flatMap(window.parentScrollPosition, function(position) {
        return position.window;
    }), function($$window) {
        return $$window.windowWidth;
    }), tmp);
}
function $e4fe4a070745e220$export$c08559766941f856(param) {
    var clientHeight = document.documentElement.clientHeight;
    var innerHeight = window.innerHeight;
    var tmp;
    var exit = 0;
    if (innerHeight !== 0 || clientHeight <= 0) exit = 1;
    else tmp = clientHeight;
    if (exit === 1) tmp = clientHeight !== 0 ? clientHeight > innerHeight ? clientHeight : innerHeight : innerHeight > 0 || clientHeight <= innerHeight ? innerHeight : clientHeight;
    return $2whNH.getWithDefault($2whNH.flatMap($2whNH.flatMap(window.parentScrollPosition, function(position) {
        return position.window;
    }), function($$window) {
        return $$window.windowHeight;
    }), tmp);
}
 /* No side effect */ 
});

parcelRegister("9MZLD", function(module, exports) {

$parcel$export(module.exports, "calc", function () { return $72088279e53ed889$export$42bfa9b2d4dad91a; });
$parcel$export(module.exports, "toString", function () { return $72088279e53ed889$export$f84e8e69fd4488a5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $aaMxi = parcelRequire("aaMxi");
function $72088279e53ed889$export$42bfa9b2d4dad91a(vw) {
    if (vw <= 360) return /* Xs */ 0;
    else if (vw <= 600) return /* Sm */ 1;
    else if (vw < 1024) return /* Md */ 2;
    else if (vw < 1366) return /* Lg */ 3;
    else return /* Xl */ 4;
}
function $72088279e53ed889$export$f84e8e69fd4488a5(breakpoint) {
    switch(breakpoint){
        case /* Xs */ 0:
            return "xs";
        case /* Sm */ 1:
            return "sm";
        case /* Md */ 2:
            return "md";
        case /* Lg */ 3:
            return "lg";
        case /* Xl */ 4:
            return "xl";
    }
}
var $72088279e53ed889$export$3004f64547af360e = $aaMxi.fromString;
 /* No side effect */ 
});
parcelRegister("aaMxi", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $76807cd06135ae8a$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromString", function () { return $76807cd06135ae8a$export$3004f64547af360e; });
// Generated by ReScript, PLEASE EDIT WITH CARE
function $76807cd06135ae8a$export$f84e8e69fd4488a5(breakpoint) {
    switch(breakpoint){
        case /* Xs */ 0:
            return "xs";
        case /* Sm */ 1:
            return "sm";
        case /* Md */ 2:
            return "md";
        case /* Lg */ 3:
            return "lg";
        case /* Xl */ 4:
            return "xl";
    }
}
function $76807cd06135ae8a$export$3004f64547af360e(breakpoint) {
    switch(breakpoint){
        case "lg":
            return /* Lg */ 3;
        case "md":
            return /* Md */ 2;
        case "sm":
            return /* Sm */ 1;
        case "xl":
            return /* Xl */ 4;
        case "xs":
            return /* Xs */ 0;
        default:
            return;
    }
}
 /* No side effect */ 
});



parcelRegister("jjS2R", function(module, exports) {

$parcel$export(module.exports, "getConfigId", function () { return $e109b6ec59682f7f$export$8e9a746d593b1ce4; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $hxhfd = parcelRequire("hxhfd");

var $kK0OQ = parcelRequire("kK0OQ");
function $e109b6ec59682f7f$export$1507408c8fdd6223(retryOpt, param) {
    var retry = retryOpt !== undefined ? retryOpt : 0;
    var getExperiment = $2whNH.flatMap(window.maker_optimize, function(o) {
        return o.get;
    });
    return new Promise(function(resolve, reject) {
        var match = window.maker_optimize;
        if (getExperiment !== undefined) return resolve(getExperiment);
        else if (match !== undefined && retry < 12) {
            setTimeout(function(param) {
                $e109b6ec59682f7f$export$1507408c8fdd6223(retry + 1 | 0, undefined).then(function(response) {
                    resolve(response);
                });
            }, 42);
            return;
        } else return resolve(undefined);
    });
}
var $e109b6ec59682f7f$export$efa8878d396e1167 = function looksLikeAFunction(value) {
    return typeof value === "function" || typeof value === "string" && value.includes("function");
};
function $e109b6ec59682f7f$export$8e9a746d593b1ce4(useConfigIdFromEmbedOpt, useConfigIdFromExperimentOpt, useConfigIdFromShopifyOpt, attributes, embedType) {
    return $e109b6ec59682f7f$var$_getConfigId.apply(this, arguments);
}
function $e109b6ec59682f7f$var$_getConfigId() {
    $e109b6ec59682f7f$var$_getConfigId = (0, $5YOUh._)(function(useConfigIdFromEmbedOpt, useConfigIdFromExperimentOpt, useConfigIdFromShopifyOpt, attributes, embedType) {
        var useConfigIdFromEmbed, useConfigIdFromExperiment, useConfigIdFromShopify, configIdFromEmbed, getExperiment, _tmp, configIdFromExperiment, _tmp1, configIdFromExperiment$1, configIdFromShopify, config;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    useConfigIdFromEmbed = useConfigIdFromEmbedOpt !== undefined ? useConfigIdFromEmbedOpt : true;
                    useConfigIdFromExperiment = useConfigIdFromExperimentOpt !== undefined ? useConfigIdFromExperimentOpt : true;
                    useConfigIdFromShopify = useConfigIdFromShopifyOpt !== undefined ? useConfigIdFromShopifyOpt : true;
                    configIdFromEmbed = $2whNH.keep(attributes.config, function(param) {
                        return useConfigIdFromEmbed;
                    });
                    if (!useConfigIdFromExperiment) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $e109b6ec59682f7f$export$1507408c8fdd6223(undefined, undefined)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = undefined;
                    _state.label = 3;
                case 3:
                    getExperiment = _tmp;
                    if (!(getExperiment !== undefined)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        $iv6Yc._5(getExperiment, undefined, embedType, undefined, undefined, undefined)
                    ];
                case 4:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    _tmp1 = undefined;
                    _state.label = 6;
                case 6:
                    configIdFromExperiment = _tmp1;
                    configIdFromExperiment$1 = $e109b6ec59682f7f$export$efa8878d396e1167(configIdFromExperiment) ? undefined : configIdFromExperiment;
                    if (!(useConfigIdFromShopify && !(configIdFromEmbed !== undefined || configIdFromExperiment$1 !== undefined))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        $kK0OQ.load($hxhfd.apiHostnameProduction)
                    ];
                case 7:
                    config = _state.sent();
                    configIdFromShopify = config.id;
                    return [
                        3,
                        9
                    ];
                case 8:
                    configIdFromShopify = undefined;
                    _state.label = 9;
                case 9:
                    if (configIdFromExperiment$1 !== undefined) {
                        if (configIdFromExperiment$1 === "empty") return [
                            2
                        ];
                        else return [
                            2,
                            configIdFromExperiment$1
                        ];
                    } else if (configIdFromEmbed !== undefined) return [
                        2,
                        configIdFromEmbed
                    ];
                    else if (configIdFromShopify !== undefined) return [
                        2,
                        configIdFromShopify
                    ];
                    else return [
                        2
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $e109b6ec59682f7f$var$_getConfigId.apply(this, arguments);
}
 /* Env-Showside Not a pure module */ 
});
parcelRegister("kK0OQ", function(module, exports) {

$parcel$export(module.exports, "load", function () { return $f198bd26d7ab9fbe$export$11e63f7b0f3d9900; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $GuWH3 = parcelRequire("GuWH3");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $2gwg0 = parcelRequire("2gwg0");

var $h7kEx = parcelRequire("h7kEx");

var $bjgUL = parcelRequire("bjgUL");

var $fcz2a = parcelRequire("fcz2a");
var $f198bd26d7ab9fbe$var$t_decode = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "gaTrackingId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("gaVersion", $fcz2a.GaVersion.fromJson, /* Gtag */ 1), $iv6Yc._2($jVmMx.Decode.field, "checkoutLink", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "historyEnabled", $jVmMx.Decode.bool), function(gaTrackingId, gaVersion, checkoutLink, historyEnabled) {
    return {
        gaTrackingId: gaTrackingId,
        gaVersion: gaVersion,
        checkoutLink: checkoutLink,
        historyEnabled: historyEnabled
    };
});
var $f198bd26d7ab9fbe$export$c72f6eaae7b9adff = {
    t_decode: $f198bd26d7ab9fbe$var$t_decode
};
var $f198bd26d7ab9fbe$export$bb5e712207166a02 = $79vie.map3($79vie.field("id", $79vie.string), $79vie.field("accountId", $79vie.option($79vie.string)), $79vie.field("settings", $f198bd26d7ab9fbe$var$t_decode), function(id, accountId, settings) {
    return {
        id: id,
        accountId: accountId,
        settings: settings
    };
});
function $f198bd26d7ab9fbe$export$11e63f7b0f3d9900(smartnavApiHost) {
    var shop = $2gwg0.getShop(undefined);
    if (shop === undefined) return Promise.reject($GuWH3.raiseError("Shopify store not found"));
    if (shop === "") return Promise.reject($GuWH3.raiseError("Shopify store not found"));
    var url = smartnavApiHost + "/api/get_shopify_url_config?url=" + encodeURIComponent("https://" + shop);
    return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, $h7kEx.Server.ignoreNotFoundError, function() {
        var _ref = (0, $5YOUh._)(function(json) {
            return (0, $j4B9x.__generator)(this, function(_state) {
                return [
                    2,
                    $bjgUL.decode(json, $f198bd26d7ab9fbe$export$bb5e712207166a02)
                ];
            });
        });
        return function(json) {
            return _ref.apply(this, arguments);
        };
    }(), url);
}
var $f198bd26d7ab9fbe$export$7ae2d2a8b28a8cb8 = $f198bd26d7ab9fbe$export$bb5e712207166a02;
 /* t_decode Not a pure module */ 
});
parcelRegister("GuWH3", function(module, exports) {

$parcel$export(module.exports, "raiseError", function () { return $07fbed860c71343c$export$d00b56ff2d620eb9; });
$parcel$export(module.exports, "$$Error", function () { return $07fbed860c71343c$export$507b31d55a607b45; });
function $07fbed860c71343c$export$d00b56ff2d620eb9(str) {
    throw new Error(str);
}
function $07fbed860c71343c$export$93807fddf246b6fd(str) {
    throw new EvalError(str);
}
function $07fbed860c71343c$export$a0f9c56f70c19509(str) {
    throw new RangeError(str);
}
function $07fbed860c71343c$export$1eb15f043789d5e9(str) {
    throw new ReferenceError(str);
}
function $07fbed860c71343c$export$e287b37aa627dc6(str) {
    throw new SyntaxError(str);
}
function $07fbed860c71343c$export$836409896c392e8b(str) {
    throw new TypeError(str);
}
function $07fbed860c71343c$export$6511d306f3a81413(str) {
    throw new URIError(str);
}
var $07fbed860c71343c$export$507b31d55a607b45 = "JsError";
 /* No side effect */ 
});

parcelRegister("79vie", function(module, exports) {

$parcel$export(module.exports, "string", function () { return $5351a5cabcc2510e$export$22b082955e083ec3; });
$parcel$export(module.exports, "bool", function () { return $5351a5cabcc2510e$export$87b259aa03e3d267; });
$parcel$export(module.exports, "$$int", function () { return $5351a5cabcc2510e$export$b537f535eb826cd3; });
$parcel$export(module.exports, "$$float", function () { return $5351a5cabcc2510e$export$7af93c3912c36b2a; });
$parcel$export(module.exports, "array", function () { return $5351a5cabcc2510e$export$2f23118c22fb2630; });
$parcel$export(module.exports, "list", function () { return $5351a5cabcc2510e$export$8837f4fc672e936d; });
$parcel$export(module.exports, "dict", function () { return $5351a5cabcc2510e$export$b7eef48498bbd53e; });
$parcel$export(module.exports, "keyValuePairs", function () { return $5351a5cabcc2510e$export$a6b37472941cc417; });
$parcel$export(module.exports, "tuple2", function () { return $5351a5cabcc2510e$export$92cb60c38e93b2cb; });
$parcel$export(module.exports, "tuple3", function () { return $5351a5cabcc2510e$export$7664ff7197245275; });
$parcel$export(module.exports, "tuple4", function () { return $5351a5cabcc2510e$export$b14eba571629e996; });
$parcel$export(module.exports, "tuple5", function () { return $5351a5cabcc2510e$export$51158e295b814981; });
$parcel$export(module.exports, "tuple6", function () { return $5351a5cabcc2510e$export$f52b7ee4eabdb261; });
$parcel$export(module.exports, "tuple7", function () { return $5351a5cabcc2510e$export$16acf2602fbdbf83; });
$parcel$export(module.exports, "tuple8", function () { return $5351a5cabcc2510e$export$258c90b8fff5318e; });
$parcel$export(module.exports, "field", function () { return $5351a5cabcc2510e$export$e0f35d825088c098; });
$parcel$export(module.exports, "at", function () { return $5351a5cabcc2510e$export$493d36ec626b6698; });
$parcel$export(module.exports, "index", function () { return $5351a5cabcc2510e$export$b610b8812bbcded9; });
$parcel$export(module.exports, "option", function () { return $5351a5cabcc2510e$export$a75d1723e6bda2ec; });
$parcel$export(module.exports, "oneOf", function () { return $5351a5cabcc2510e$export$a9a18ae5ba42aeab; });
$parcel$export(module.exports, "decodeString", function () { return $5351a5cabcc2510e$export$a0fb664af7d0cc44; });
$parcel$export(module.exports, "decodeValue", function () { return $5351a5cabcc2510e$export$1bc3347b5a3e0603; });
$parcel$export(module.exports, "errorToString", function () { return $5351a5cabcc2510e$export$46c1952d522542d7; });
$parcel$export(module.exports, "map", function () { return $5351a5cabcc2510e$export$871de8747c9eaa88; });
$parcel$export(module.exports, "map2", function () { return $5351a5cabcc2510e$export$5be556bf484c4f10; });
$parcel$export(module.exports, "andMap", function () { return $5351a5cabcc2510e$export$1ae5bb9217ed77cc; });
$parcel$export(module.exports, "$$null", function () { return $5351a5cabcc2510e$export$75050adc5191c049; });
$parcel$export(module.exports, "nullable", function () { return $5351a5cabcc2510e$export$133fc36489ac9add; });
$parcel$export(module.exports, "value", function () { return $5351a5cabcc2510e$export$2ab9a8f9f1186f14; });
$parcel$export(module.exports, "andThen", function () { return $5351a5cabcc2510e$export$9768a9ae43d7f016; });
$parcel$export(module.exports, "succeed", function () { return $5351a5cabcc2510e$export$9094b7742a87955e; });
$parcel$export(module.exports, "fail", function () { return $5351a5cabcc2510e$export$2b62a06a9fee979c; });
$parcel$export(module.exports, "map3", function () { return $5351a5cabcc2510e$export$f7389512af34c855; });
$parcel$export(module.exports, "map4", function () { return $5351a5cabcc2510e$export$dddc425886bb4024; });
$parcel$export(module.exports, "map5", function () { return $5351a5cabcc2510e$export$89e0958a4f22698b; });
$parcel$export(module.exports, "map6", function () { return $5351a5cabcc2510e$export$93c2dc1c6eacd42c; });
$parcel$export(module.exports, "map7", function () { return $5351a5cabcc2510e$export$a23802bf7d2b7306; });
$parcel$export(module.exports, "map8", function () { return $5351a5cabcc2510e$export$308685edec35689e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $8ncuc = parcelRequire("8ncuc");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $gTtop = parcelRequire("gTtop");

var $loT9g = parcelRequire("loT9g");

var $AAkl8 = parcelRequire("AAkl8");
function $5351a5cabcc2510e$var$optToRes(option, err) {
    if (option !== undefined) return {
        TAG: /* Ok */ 0,
        _0: $loT9g.valFromOption(option)
    };
    else return {
        TAG: /* Error */ 1,
        _0: err
    };
}
function $5351a5cabcc2510e$var$resMapError(res, f) {
    if (res.TAG === /* Ok */ 0) return {
        TAG: /* Ok */ 0,
        _0: res._0
    };
    else return {
        TAG: /* Error */ 1,
        _0: $iv6Yc._1(f, res._0)
    };
}
function $5351a5cabcc2510e$var$resAndMap(resF, resV) {
    return $gTtop.flatMap(resF, function(f) {
        return $gTtop.map(resV, $iv6Yc.__1(f));
    });
}
function $5351a5cabcc2510e$export$22b082955e083ec3(j) {
    return $5351a5cabcc2510e$var$optToRes($1ArWc.decodeString(j), {
        TAG: /* Failure */ 0,
        _0: "Expecting a STRING",
        _1: j
    });
}
function $5351a5cabcc2510e$export$87b259aa03e3d267(j) {
    return $5351a5cabcc2510e$var$optToRes($1ArWc.decodeBoolean(j), {
        TAG: /* Failure */ 0,
        _0: "Expecting a BOOL",
        _1: j
    });
}
function $5351a5cabcc2510e$export$b537f535eb826cd3(j) {
    return $5351a5cabcc2510e$var$optToRes($2whNH.map($1ArWc.decodeNumber(j), function(prim) {
        return prim | 0;
    }), {
        TAG: /* Failure */ 0,
        _0: "Expecting an INT",
        _1: j
    });
}
function $5351a5cabcc2510e$export$7af93c3912c36b2a(j) {
    return $5351a5cabcc2510e$var$optToRes($1ArWc.decodeNumber(j), {
        TAG: /* Failure */ 0,
        _0: "Expecting a FLOAT",
        _1: j
    });
}
function $5351a5cabcc2510e$export$2f23118c22fb2630(aDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            return arr.reduce(function(acc, cur, index) {
                if (acc.TAG !== /* Ok */ 0) return acc;
                var error = $iv6Yc._1(aDecoder, cur);
                if (error.TAG === /* Ok */ 0) return {
                    TAG: /* Ok */ 0,
                    _0: acc._0.concat([
                        error._0
                    ])
                };
                else return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* Index */ 1,
                        _0: index,
                        _1: error._0
                    }
                };
            }, {
                TAG: /* Ok */ 0,
                _0: []
            });
        });
    };
}
function $5351a5cabcc2510e$export$8837f4fc672e936d(aDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            return $i7mYY.reverse(arr).reduce(function(acc, cur, index) {
                if (acc.TAG !== /* Ok */ 0) return acc;
                var error = $iv6Yc._1(aDecoder, cur);
                if (error.TAG === /* Ok */ 0) return {
                    TAG: /* Ok */ 0,
                    _0: {
                        hd: error._0,
                        tl: acc._0
                    }
                };
                else return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* Index */ 1,
                        _0: index,
                        _1: error._0
                    }
                };
            }, {
                TAG: /* Ok */ 0,
                _0: /* [] */ 0
            });
        });
    };
}
function $5351a5cabcc2510e$export$b7eef48498bbd53e(aDecoder) {
    return function(j) {
        return $gTtop.map($gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeObject(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an OBJECT",
            _1: j
        }), function(obj) {
            return $d3YYW.entries(obj).reduce(function(acc, param) {
                var key = param[0];
                if (acc.TAG !== /* Ok */ 0) return acc;
                var error = $iv6Yc._1(aDecoder, param[1]);
                if (error.TAG === /* Ok */ 0) return {
                    TAG: /* Ok */ 0,
                    _0: acc._0.concat([
                        [
                            key,
                            error._0
                        ]
                    ])
                };
                else return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* Field */ 2,
                        _0: key,
                        _1: error._0
                    }
                };
            }, {
                TAG: /* Ok */ 0,
                _0: []
            });
        }), $d3YYW.fromArray);
    };
}
function $5351a5cabcc2510e$export$a6b37472941cc417(aDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeObject(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an OBJECT",
            _1: j
        }), function(obj) {
            return $d3YYW.entries(obj).reduce(function(acc, param) {
                var key = param[0];
                if (acc.TAG !== /* Ok */ 0) return acc;
                var error = $iv6Yc._1(aDecoder, param[1]);
                if (error.TAG === /* Ok */ 0) return {
                    TAG: /* Ok */ 0,
                    _0: acc._0.concat([
                        [
                            key,
                            error._0
                        ]
                    ])
                };
                else return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* Field */ 2,
                        _0: key,
                        _1: error._0
                    }
                };
            }, {
                TAG: /* Ok */ 0,
                _0: []
            });
        });
    };
}
function $5351a5cabcc2510e$export$92cb60c38e93b2cb(aDecoder, bDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 2) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 2 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b) {
                    return [
                        a,
                        b
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b));
        });
    };
}
function $5351a5cabcc2510e$export$7664ff7197245275(aDecoder, bDecoder, cDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 3) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 3 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c) {
                    return [
                        a,
                        b,
                        c
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c));
        });
    };
}
function $5351a5cabcc2510e$export$b14eba571629e996(aDecoder, bDecoder, cDecoder, dDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 4) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 4 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d));
        });
    };
}
function $5351a5cabcc2510e$export$51158e295b814981(aDecoder, bDecoder, cDecoder, dDecoder, eDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 5) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 5 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            var e = arr[4];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d, e) {
                    return [
                        a,
                        b,
                        c,
                        d,
                        e
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d)), $iv6Yc._1(eDecoder, e));
        });
    };
}
function $5351a5cabcc2510e$export$f52b7ee4eabdb261(aDecoder, bDecoder, cDecoder, dDecoder, eDecoder, fDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 6) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 6 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            var e = arr[4];
            var f = arr[5];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d, e, f) {
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d)), $iv6Yc._1(eDecoder, e)), $iv6Yc._1(fDecoder, f));
        });
    };
}
function $5351a5cabcc2510e$export$16acf2602fbdbf83(aDecoder, bDecoder, cDecoder, dDecoder, eDecoder, fDecoder, gDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 7) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 7 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            var e = arr[4];
            var f = arr[5];
            var g = arr[6];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d, e, f, g) {
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f,
                        g
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d)), $iv6Yc._1(eDecoder, e)), $iv6Yc._1(fDecoder, f)), $iv6Yc._1(gDecoder, g));
        });
    };
}
function $5351a5cabcc2510e$export$258c90b8fff5318e(aDecoder, bDecoder, cDecoder, dDecoder, eDecoder, fDecoder, gDecoder, hDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 8) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 8 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            var e = arr[4];
            var f = arr[5];
            var g = arr[6];
            var h = arr[7];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d, e, f, g, h) {
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f,
                        g,
                        h
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d)), $iv6Yc._1(eDecoder, e)), $iv6Yc._1(fDecoder, f)), $iv6Yc._1(gDecoder, g)), $iv6Yc._1(hDecoder, h));
        });
    };
}
function $5351a5cabcc2510e$var$fieldHelp(j, key) {
    return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeObject(j), {
        TAG: /* Failure */ 0,
        _0: "Expecting an OBJECT with a field named '" + key + "'",
        _1: j
    }), function(sObj) {
        return $5351a5cabcc2510e$var$optToRes($d3YYW.get(sObj, key), {
            TAG: /* Failure */ 0,
            _0: "Expecting an OBJECT with a field named '" + key + "'",
            _1: j
        });
    });
}
function $5351a5cabcc2510e$export$e0f35d825088c098(key, aDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$fieldHelp(j, key), function(jv) {
            return $5351a5cabcc2510e$var$resMapError($iv6Yc._1(aDecoder, jv), function(e) {
                return {
                    TAG: /* Field */ 2,
                    _0: key,
                    _1: e
                };
            });
        });
    };
}
function $5351a5cabcc2510e$var$atHelp(firstKey, keys, decoder) {
    return $5351a5cabcc2510e$export$e0f35d825088c098(firstKey, keys ? $5351a5cabcc2510e$var$atHelp(keys.hd, keys.tl, decoder) : decoder);
}
function $5351a5cabcc2510e$export$493d36ec626b6698(firstKey, keys, decoder) {
    return $5351a5cabcc2510e$var$atHelp(firstKey, $8ncuc.fromArray(keys), decoder);
}
function $5351a5cabcc2510e$export$b610b8812bbcded9(index$1, aDecoder) {
    return function(j) {
        return $gTtop.flatMap($gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length === 0) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting a NON-EMPTY array. Need index " + String(index$1) + " but only saw an empty array",
                    _1: j
                }
            };
            else return $5351a5cabcc2510e$var$optToRes($i7mYY.get(arr, index$1), index$1 >= arr.length ? {
                TAG: /* Failure */ 0,
                _0: "Expecting a LONGER array. Need index " + String(index$1) + " but only saw " + String(arr.length) + " entries",
                _1: j
            } : {
                TAG: /* Failure */ 0,
                _0: "Expecting a POSITIVE index but saw " + String(index$1) + "",
                _1: j
            });
        }), function(jv) {
            return $5351a5cabcc2510e$var$resMapError($iv6Yc._1(aDecoder, jv), function(e) {
                return {
                    TAG: /* Index */ 1,
                    _0: index$1,
                    _1: e
                };
            });
        });
    };
}
function $5351a5cabcc2510e$export$a75d1723e6bda2ec(aDecoder) {
    return function(j) {
        return {
            TAG: /* Ok */ 0,
            _0: $gTtop.getWithDefault($gTtop.map($iv6Yc._1(aDecoder, j), function(a) {
                return $loT9g.some(a);
            }), undefined)
        };
    };
}
function $5351a5cabcc2510e$export$a9a18ae5ba42aeab(firstDecoder, decoders) {
    return function(j) {
        var a = $iv6Yc._1(firstDecoder, j);
        if (a.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: a._0
        };
        else return $5351a5cabcc2510e$var$resMapError(decoders.reduce(function(acc, cur) {
            if (acc.TAG === /* Ok */ 0) return acc;
            var match = acc._0;
            var ne = $iv6Yc._1(cur, j);
            if (ne.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: ne._0
            };
            else return {
                TAG: /* Error */ 1,
                _0: [
                    match[0],
                    {
                        hd: ne._0,
                        tl: match[1]
                    }
                ]
            };
        }, {
            TAG: /* Error */ 1,
            _0: [
                a._0,
                /* [] */ 0
            ]
        }), function(param) {
            return {
                TAG: /* OneOf */ 3,
                _0: param[0],
                _1: $8ncuc.toArray(param[1])
            };
        });
    };
}
function $5351a5cabcc2510e$var$fromString(s) {
    try {
        return $loT9g.some(JSON.parse(s));
    } catch (exn) {
        return;
    }
}
function $5351a5cabcc2510e$export$a0fb664af7d0cc44(s, decoder) {
    return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($5351a5cabcc2510e$var$fromString(s), {
        TAG: /* Failure */ 0,
        _0: "Invalid JSON",
        _1: s
    }), decoder);
}
function $5351a5cabcc2510e$export$1bc3347b5a3e0603(j, decoder) {
    return $iv6Yc._1(decoder, j);
}
function $5351a5cabcc2510e$var$joinList(l, s) {
    if (l) return $8ncuc.reduce(l.tl, l.hd, function(acc, cur) {
        return acc + s + cur;
    });
    else return "";
}
function $5351a5cabcc2510e$var$indent(str) {
    return $5351a5cabcc2510e$var$joinList($8ncuc.fromArray(str.split("\n")), "\n    ");
}
function $5351a5cabcc2510e$var$errorToStringHelp(_error, _context) {
    while(true){
        var context = _context;
        var error = _error;
        switch(error.TAG | 0){
            case /* Failure */ 0:
                var reveresed = $8ncuc.reverse(context);
                var intro = reveresed ? "Problem with the value at json" + $5351a5cabcc2510e$var$joinList(reveresed, "") + ":\n\n    " : "Problem with the given value:\n\n";
                return "" + intro + "" + $5351a5cabcc2510e$var$indent($AAkl8.encode(error._1, 4)) + "\n\n" + error._0 + "";
            case /* Index */ 1:
                var fieldName = "[" + String(error._0) + "]";
                _context = {
                    hd: fieldName,
                    tl: context
                };
                _error = error._1;
                continue;
            case /* Field */ 2:
                var fieldName$1 = '["' + error._0 + '"]';
                _context = {
                    hd: fieldName$1,
                    tl: context
                };
                _error = error._1;
                continue;
            case /* OneOf */ 3:
                var errs = error._1;
                var firstErr = error._0;
                if (errs.length !== 0) {
                    var reveresed$1 = $8ncuc.reverse(context);
                    var starter = reveresed$1 ? "oneOf at json" + $5351a5cabcc2510e$var$joinList(reveresed$1, "") + "" : "oneOf";
                    var intro$1 = "" + starter + " failed in the following " + String($8ncuc.length(context)) + " ways:";
                    return $5351a5cabcc2510e$var$joinList({
                        hd: intro$1,
                        tl: $8ncuc.mapWithIndex($8ncuc.fromArray($i7mYY.concat([
                            firstErr
                        ], errs)), function(i, err) {
                            return "\n\n(" + String(i + 1 | 0) + ") " + $5351a5cabcc2510e$var$indent($5351a5cabcc2510e$var$errorToStringHelp(err, /* [] */ 0));
                        })
                    }, "\n\n");
                }
                _error = firstErr;
                continue;
        }
    }
}
function $5351a5cabcc2510e$export$46c1952d522542d7(e) {
    return $5351a5cabcc2510e$var$errorToStringHelp(e, /* [] */ 0);
}
function $5351a5cabcc2510e$export$871de8747c9eaa88(decoder, f) {
    return function(j) {
        return $gTtop.map($iv6Yc._1(decoder, j), f);
    };
}
function $5351a5cabcc2510e$export$5be556bf484c4f10(decoderA, decoderB, f) {
    return function(j) {
        return $gTtop.flatMap($iv6Yc._1(decoderA, j), function(a) {
            return $gTtop.map($iv6Yc._1(decoderB, j), function(b) {
                return $iv6Yc._2(f, a, b);
            });
        });
    };
}
function $5351a5cabcc2510e$export$1ae5bb9217ed77cc(decoderF, decoderA) {
    return $5351a5cabcc2510e$export$5be556bf484c4f10(decoderF, decoderA, function(f, a) {
        return $iv6Yc._1(f, a);
    });
}
function $5351a5cabcc2510e$export$75050adc5191c049(v) {
    return function(j) {
        return $gTtop.map($5351a5cabcc2510e$var$optToRes($1ArWc.decodeNull(j), {
            TAG: /* Failure */ 0,
            _0: "invalid null",
            _1: j
        }), function(param) {
            return v;
        });
    };
}
function $5351a5cabcc2510e$export$133fc36489ac9add(decoder) {
    var f = function f(a) {
        return $loT9g.some(a);
    };
    return $5351a5cabcc2510e$export$a9a18ae5ba42aeab(function(j) {
        return $gTtop.map($iv6Yc._1(decoder, j), f);
    }, [
        $5351a5cabcc2510e$export$75050adc5191c049(undefined)
    ]);
}
function $5351a5cabcc2510e$export$2ab9a8f9f1186f14(j) {
    return {
        TAG: /* Ok */ 0,
        _0: j
    };
}
function $5351a5cabcc2510e$export$9768a9ae43d7f016(decoder, f) {
    return function(j) {
        return $gTtop.flatMap($iv6Yc._1(decoder, j), function(a) {
            var b = $iv6Yc._1(f, a);
            return $iv6Yc._1(b, j);
        });
    };
}
function $5351a5cabcc2510e$export$9094b7742a87955e(a) {
    return function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: a
        };
    };
}
function $5351a5cabcc2510e$export$2b62a06a9fee979c(err) {
    return function(j) {
        return {
            TAG: /* Error */ 1,
            _0: {
                TAG: /* Failure */ 0,
                _0: err,
                _1: j
            }
        };
    };
}
function $5351a5cabcc2510e$export$f7389512af34c855(decoderA, decoderB, decoderC, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC);
}
function $5351a5cabcc2510e$export$dddc425886bb4024(decoderA, decoderB, decoderC, decoderD, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD);
}
function $5351a5cabcc2510e$export$89e0958a4f22698b(decoderA, decoderB, decoderC, decoderD, decoderE, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD), decoderE);
}
function $5351a5cabcc2510e$export$93c2dc1c6eacd42c(decoderA, decoderB, decoderC, decoderD, decoderE, decoderF, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD), decoderE), decoderF);
}
function $5351a5cabcc2510e$export$a23802bf7d2b7306(decoderA, decoderB, decoderC, decoderD, decoderE, decoderF, decoderG, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD), decoderE), decoderF), decoderG);
}
function $5351a5cabcc2510e$export$308685edec35689e(decoderA, decoderB, decoderC, decoderD, decoderE, decoderF, decoderG, decoderH, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD), decoderE), decoderF), decoderG), decoderH);
}
 /* Json__Encode Not a pure module */ 
});
parcelRegister("1ArWc", function(module, exports) {

$parcel$export(module.exports, "classify", function () { return $127ed31820607685$export$b04d9b8d414ba5e8; });
$parcel$export(module.exports, "decodeString", function () { return $127ed31820607685$export$a0fb664af7d0cc44; });
$parcel$export(module.exports, "decodeNumber", function () { return $127ed31820607685$export$874d75d651b25595; });
$parcel$export(module.exports, "decodeObject", function () { return $127ed31820607685$export$57868717af36a6c; });
$parcel$export(module.exports, "decodeArray", function () { return $127ed31820607685$export$81879b02e9646afe; });
$parcel$export(module.exports, "decodeBoolean", function () { return $127ed31820607685$export$7e6b1898d6f2947e; });
$parcel$export(module.exports, "decodeNull", function () { return $127ed31820607685$export$d6ce7784e89e4f30; });

var $gfRPo = parcelRequire("gfRPo");

var $loT9g = parcelRequire("loT9g");
function $127ed31820607685$export$b04d9b8d414ba5e8(x) {
    var ty = typeof x === "undefined" ? "undefined" : (0, $gfRPo._)(x);
    if (ty === "string") return {
        TAG: /* JSONString */ 0,
        _0: x
    };
    else if (ty === "number") return {
        TAG: /* JSONNumber */ 1,
        _0: x
    };
    else if (ty === "boolean") {
        if (x === true) return /* JSONTrue */ 1;
        else return /* JSONFalse */ 0;
    } else if (x === null) return /* JSONNull */ 2;
    else if (Array.isArray(x)) return {
        TAG: /* JSONArray */ 3,
        _0: x
    };
    else return {
        TAG: /* JSONObject */ 2,
        _0: x
    };
}
function $127ed31820607685$export$e0969da9b8fb378d(x, v) {
    switch(v){
        case /* String */ 0:
            return typeof x === "string";
        case /* Number */ 1:
            return typeof x === "number";
        case /* Object */ 2:
            if (x !== null && typeof x === "object") return !Array.isArray(x);
            else return false;
        case /* Array */ 3:
            return Array.isArray(x);
        case /* Boolean */ 4:
            return typeof x === "boolean";
        case /* Null */ 5:
            return x === null;
    }
}
function $127ed31820607685$export$a0fb664af7d0cc44(json) {
    if (typeof json === "string") return json;
}
function $127ed31820607685$export$874d75d651b25595(json) {
    if (typeof json === "number") return json;
}
function $127ed31820607685$export$57868717af36a6c(json) {
    if (typeof json === "object" && !Array.isArray(json) && json !== null) return $loT9g.some(json);
}
function $127ed31820607685$export$81879b02e9646afe(json) {
    if (Array.isArray(json)) return json;
}
function $127ed31820607685$export$7e6b1898d6f2947e(json) {
    if (typeof json === "boolean") return json;
}
function $127ed31820607685$export$d6ce7784e89e4f30(json) {
    if (json === null) return null;
}
var $127ed31820607685$var$patch = function patch(json) {
    var x = [
        json
    ];
    var q = [
        {
            kind: 0,
            i: 0,
            parent: x
        }
    ];
    while(q.length !== 0){
        // begin pop the stack
        var cur = q[q.length - 1];
        if (cur.kind === 0) {
            cur.val = cur.parent[cur.i]; // patch the undefined value for array
            if (++cur.i === cur.parent.length) q.pop();
        } else q.pop();
        // finish
        var task = cur.val;
        if (typeof task === "object") {
            if (Array.isArray(task) && task.length !== 0) q.push({
                kind: 0,
                i: 0,
                parent: task,
                val: undefined
            });
            else for(var k in task){
                if (k === "RE_PRIVATE_NONE") {
                    if (cur.kind === 0) cur.parent[cur.i - 1] = undefined;
                    else cur.parent[cur.i] = undefined;
                    continue;
                }
                q.push({
                    kind: 1,
                    i: k,
                    parent: task,
                    val: task[k]
                });
            }
        }
    }
    return x[0];
};
function $127ed31820607685$export$d4424ececc0daddd(x) {
    return function(obj) {
        var output = JSON.stringify(obj, function(_, value) {
            if (value === undefined) return {
                RE_PRIVATE_NONE: true
            };
            return value;
        });
        if (output === undefined) // JSON.stringify will raise TypeError when it detects cylic objects
        throw new TypeError("output is undefined");
        return output;
    }(x);
}
function $127ed31820607685$export$9bd0effa93766bf1(s) {
    return $127ed31820607685$var$patch(JSON.parse(s));
}
 /* No side effect */ 
});

parcelRegister("8ncuc", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $618a28301baf2026$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "mapWithIndex", function () { return $618a28301baf2026$export$8f07ddce13659f50; });
$parcel$export(module.exports, "length", function () { return $618a28301baf2026$export$f24224f1c91d8156; });
$parcel$export(module.exports, "fromArray", function () { return $618a28301baf2026$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "toArray", function () { return $618a28301baf2026$export$45b10814cc054894; });
$parcel$export(module.exports, "reverse", function () { return $618a28301baf2026$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "reduce", function () { return $618a28301baf2026$export$533b26079ad0b4b; });

var $iv6Yc = parcelRequire("iv6Yc");

var $i7mYY = parcelRequire("i7mYY");

var $loT9g = parcelRequire("loT9g");

var $58Tj9 = parcelRequire("58Tj9");
function $618a28301baf2026$export$5fd5031fecdacec3(x) {
    if (x) return $loT9g.some(x.hd);
}
function $618a28301baf2026$export$ceea6ccfccd07fd7(x) {
    if (x) return x.hd;
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function $618a28301baf2026$export$c01875f616615628(x) {
    if (x) return x.tl;
}
function $618a28301baf2026$export$a54e29821c34e5ee(x) {
    if (x) return x.tl;
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function $618a28301baf2026$export$e16d8520af44a096(xs, x) {
    return {
        hd: x,
        tl: xs
    };
}
function $618a28301baf2026$export$3988ae62b71be9a3(x, n) {
    if (n < 0) return;
    else {
        var _x = x;
        var _n = n;
        while(true){
            var n$1 = _n;
            var x$1 = _x;
            if (!x$1) return;
            if (n$1 === 0) return $loT9g.some(x$1.hd);
            _n = n$1 - 1 | 0;
            _x = x$1.tl;
            continue;
        }
    }
}
function $618a28301baf2026$export$2d6fda808293d631(x, n) {
    if (n < 0) throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
    var _x = x;
    var _n = n;
    while(true){
        var n$1 = _n;
        var x$1 = _x;
        if (x$1) {
            if (n$1 === 0) return x$1.hd;
            _n = n$1 - 1 | 0;
            _x = x$1.tl;
            continue;
        }
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
}
function $618a28301baf2026$var$partitionAux(p, _cell, _precX, _precY) {
    while(true){
        var precY = _precY;
        var precX = _precX;
        var cell = _cell;
        if (!cell) return;
        var t = cell.tl;
        var h = cell.hd;
        var next = {
            hd: h,
            tl: /* [] */ 0
        };
        if (p(h)) {
            precX.tl = next;
            _precX = next;
            _cell = t;
            continue;
        }
        precY.tl = next;
        _precY = next;
        _cell = t;
        continue;
    }
}
function $618a28301baf2026$var$splitAux(_cell, _precX, _precY) {
    while(true){
        var precY = _precY;
        var precX = _precX;
        var cell = _cell;
        if (!cell) return;
        var match = cell.hd;
        var nextA = {
            hd: match[0],
            tl: /* [] */ 0
        };
        var nextB = {
            hd: match[1],
            tl: /* [] */ 0
        };
        precX.tl = nextA;
        precY.tl = nextB;
        _precY = nextB;
        _precX = nextA;
        _cell = cell.tl;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxCont(_cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return prec;
        var next = {
            hd: cellX.hd,
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = cellX.tl;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWitFilter(f, _cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return;
        var t = cellX.tl;
        var h = cellX.hd;
        if (f(h)) {
            var next = {
                hd: h,
                tl: /* [] */ 0
            };
            prec.tl = next;
            _prec = next;
            _cellX = t;
            continue;
        }
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWithFilterIndex(f, _cellX, _prec, _i) {
    while(true){
        var i = _i;
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return;
        var t = cellX.tl;
        var h = cellX.hd;
        if (f(h, i)) {
            var next = {
                hd: h,
                tl: /* [] */ 0
            };
            prec.tl = next;
            _i = i + 1 | 0;
            _prec = next;
            _cellX = t;
            continue;
        }
        _i = i + 1 | 0;
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWitFilterMap(f, _cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return;
        var t = cellX.tl;
        var h = f(cellX.hd);
        if (h !== undefined) {
            var next = {
                hd: $loT9g.valFromOption(h),
                tl: /* [] */ 0
            };
            prec.tl = next;
            _prec = next;
            _cellX = t;
            continue;
        }
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$removeAssocAuxWithMap(_cellX, x, _prec, f) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return false;
        var t = cellX.tl;
        var h = cellX.hd;
        if (f(h[0], x)) {
            prec.tl = t;
            return true;
        }
        var next = {
            hd: h,
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$setAssocAuxWithMap(_cellX, x, k, _prec, eq) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return false;
        var t = cellX.tl;
        var h = cellX.hd;
        if (eq(h[0], x)) {
            prec.tl = {
                hd: [
                    x,
                    k
                ],
                tl: t
            };
            return true;
        }
        var next = {
            hd: h,
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWithMap(_cellX, _prec, f) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return;
        var next = {
            hd: f(cellX.hd),
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = cellX.tl;
        continue;
    }
}
function $618a28301baf2026$var$zipAux(_cellX, _cellY, _prec) {
    while(true){
        var prec = _prec;
        var cellY = _cellY;
        var cellX = _cellX;
        if (!cellX) return;
        if (!cellY) return;
        var next = {
            hd: [
                cellX.hd,
                cellY.hd
            ],
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellY = cellY.tl;
        _cellX = cellX.tl;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWithMap2(f, _cellX, _cellY, _prec) {
    while(true){
        var prec = _prec;
        var cellY = _cellY;
        var cellX = _cellX;
        if (!cellX) return;
        if (!cellY) return;
        var next = {
            hd: f(cellX.hd, cellY.hd),
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellY = cellY.tl;
        _cellX = cellX.tl;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWithMapI(f, _i, _cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        var i = _i;
        if (!cellX) return;
        var next = {
            hd: f(i, cellX.hd),
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = cellX.tl;
        _i = i + 1 | 0;
        continue;
    }
}
function $618a28301baf2026$var$takeAux(_n, _cell, _prec) {
    while(true){
        var prec = _prec;
        var cell = _cell;
        var n = _n;
        if (n === 0) return true;
        if (!cell) return false;
        var cell$1 = {
            hd: cell.hd,
            tl: /* [] */ 0
        };
        prec.tl = cell$1;
        _prec = cell$1;
        _cell = cell.tl;
        _n = n - 1 | 0;
        continue;
    }
}
function $618a28301baf2026$var$splitAtAux(_n, _cell, _prec) {
    while(true){
        var prec = _prec;
        var cell = _cell;
        var n = _n;
        if (n === 0) return cell;
        if (!cell) return;
        var cell$1 = {
            hd: cell.hd,
            tl: /* [] */ 0
        };
        prec.tl = cell$1;
        _prec = cell$1;
        _cell = cell.tl;
        _n = n - 1 | 0;
        continue;
    }
}
function $618a28301baf2026$export$b7df5d561049483a(lst, n) {
    if (n < 0) return;
    if (n === 0) return /* [] */ 0;
    if (!lst) return;
    var cell = {
        hd: lst.hd,
        tl: /* [] */ 0
    };
    var has = $618a28301baf2026$var$takeAux(n - 1 | 0, lst.tl, cell);
    if (has) return cell;
}
function $618a28301baf2026$export$663103110d94aac9(lst, n) {
    if (n < 0) return;
    else {
        var _l = lst;
        var _n = n;
        while(true){
            var n$1 = _n;
            var l = _l;
            if (n$1 === 0) return l;
            if (!l) return;
            _n = n$1 - 1 | 0;
            _l = l.tl;
            continue;
        }
    }
}
function $618a28301baf2026$export$b0d75975ac0be0e1(lst, n) {
    if (n < 0) return;
    if (n === 0) return [
        /* [] */ 0,
        lst
    ];
    if (!lst) return;
    var cell = {
        hd: lst.hd,
        tl: /* [] */ 0
    };
    var rest = $618a28301baf2026$var$splitAtAux(n - 1 | 0, lst.tl, cell);
    if (rest !== undefined) return [
        cell,
        rest
    ];
}
function $618a28301baf2026$export$ee1b3e54f0441b22(xs, ys) {
    if (!xs) return ys;
    var cell = {
        hd: xs.hd,
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$copyAuxCont(xs.tl, cell).tl = ys;
    return cell;
}
function $618a28301baf2026$export$cc22bf2a9ce99b1(xs, f) {
    if (!xs) return /* [] */ 0;
    var cell = {
        hd: f(xs.hd),
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$copyAuxWithMap(xs.tl, cell, f);
    return cell;
}
function $618a28301baf2026$export$871de8747c9eaa88(xs, f) {
    return $618a28301baf2026$export$cc22bf2a9ce99b1(xs, $iv6Yc.__1(f));
}
function $618a28301baf2026$export$35c5113aa227aa5(l1, l2, f) {
    if (!l1) return /* [] */ 0;
    if (!l2) return /* [] */ 0;
    var cell = {
        hd: f(l1.hd, l2.hd),
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$copyAuxWithMap2(f, l1.tl, l2.tl, cell);
    return cell;
}
function $618a28301baf2026$export$d9e678742f9ba92(l1, l2, f) {
    return $618a28301baf2026$export$35c5113aa227aa5(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$4cb8e22ecd37a3cf(xs, f) {
    if (!xs) return /* [] */ 0;
    var cell = {
        hd: f(0, xs.hd),
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$copyAuxWithMapI(f, 1, xs.tl, cell);
    return cell;
}
function $618a28301baf2026$export$8f07ddce13659f50(xs, f) {
    return $618a28301baf2026$export$4cb8e22ecd37a3cf(xs, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$790d8bf8abeeba86(n, f) {
    if (n <= 0) return /* [] */ 0;
    var headX = {
        hd: f(0),
        tl: /* [] */ 0
    };
    var cur = headX;
    var i = 1;
    while(i < n){
        var v = {
            hd: f(i),
            tl: /* [] */ 0
        };
        cur.tl = v;
        cur = v;
        i = i + 1 | 0;
    }
    return headX;
}
function $618a28301baf2026$export$849fbdcc2211fcde(n, f) {
    return $618a28301baf2026$export$790d8bf8abeeba86(n, $iv6Yc.__1(f));
}
function $618a28301baf2026$export$dd44f18ab656f3bb(n, v) {
    if (n <= 0) return /* [] */ 0;
    var headX = {
        hd: v,
        tl: /* [] */ 0
    };
    var cur = headX;
    var i = 1;
    while(i < n){
        var v$1 = {
            hd: v,
            tl: /* [] */ 0
        };
        cur.tl = v$1;
        cur = v$1;
        i = i + 1 | 0;
    }
    return headX;
}
function $618a28301baf2026$export$f24224f1c91d8156(xs) {
    var _x = xs;
    var _acc = 0;
    while(true){
        var acc = _acc;
        var x = _x;
        if (!x) return acc;
        _acc = acc + 1 | 0;
        _x = x.tl;
        continue;
    }
}
function $618a28301baf2026$var$fillAux(arr, _i, _x) {
    while(true){
        var x = _x;
        var i = _i;
        if (!x) return;
        arr[i] = x.hd;
        _x = x.tl;
        _i = i + 1 | 0;
        continue;
    }
}
function $618a28301baf2026$export$571d59b505e6bb4e(a) {
    var _i = a.length - 1 | 0;
    var _res = /* [] */ 0;
    while(true){
        var res = _res;
        var i = _i;
        if (i < 0) return res;
        _res = {
            hd: a[i],
            tl: res
        };
        _i = i - 1 | 0;
        continue;
    }
}
function $618a28301baf2026$export$45b10814cc054894(x) {
    var len = $618a28301baf2026$export$f24224f1c91d8156(x);
    var arr = new Array(len);
    $618a28301baf2026$var$fillAux(arr, 0, x);
    return arr;
}
function $618a28301baf2026$export$448332262467e042(xs) {
    var v = $618a28301baf2026$export$45b10814cc054894(xs);
    $i7mYY.shuffleInPlace(v);
    return $618a28301baf2026$export$571d59b505e6bb4e(v);
}
function $618a28301baf2026$export$be71da2caf12f8(_l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return l2;
        _l2 = {
            hd: l1.hd,
            tl: l2
        };
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$66c1ae025e96b4bc(l) {
    return $618a28301baf2026$export$be71da2caf12f8(l, /* [] */ 0);
}
function $618a28301baf2026$var$flattenAux(_prec, _xs) {
    while(true){
        var xs = _xs;
        var prec = _prec;
        if (xs) {
            _xs = xs.tl;
            _prec = $618a28301baf2026$var$copyAuxCont(xs.hd, prec);
            continue;
        }
        prec.tl = /* [] */ 0;
        return;
    }
}
function $618a28301baf2026$export$bffa455ba8c619a6(_xs) {
    while(true){
        var xs = _xs;
        if (!xs) return /* [] */ 0;
        var match = xs.hd;
        if (match) {
            var cell = {
                hd: match.hd,
                tl: /* [] */ 0
            };
            $618a28301baf2026$var$flattenAux($618a28301baf2026$var$copyAuxCont(match.tl, cell), xs.tl);
            return cell;
        }
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$252d63de73a739bf(xs) {
    var len = xs.length;
    if (len === 1) return xs[0];
    if (len === 0) return /* [] */ 0;
    var len$1 = xs.length;
    var v = xs[len$1 - 1 | 0];
    for(var i = len$1 - 2 | 0; i >= 0; --i)v = $618a28301baf2026$export$ee1b3e54f0441b22(xs[i], v);
    return v;
}
function $618a28301baf2026$export$bcd62aac6e97f7fa(l, f) {
    var _accu = /* [] */ 0;
    var _xs = l;
    while(true){
        var xs = _xs;
        var accu = _accu;
        if (!xs) return accu;
        _xs = xs.tl;
        _accu = {
            hd: f(xs.hd),
            tl: accu
        };
        continue;
    }
}
function $618a28301baf2026$export$c69fed31bf090369(l, f) {
    return $618a28301baf2026$export$bcd62aac6e97f7fa(l, $iv6Yc.__1(f));
}
function $618a28301baf2026$export$e4198045b3bb8c9c(_xs, f) {
    while(true){
        var xs = _xs;
        if (!xs) return;
        f(xs.hd);
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$4b80e395e36b5a56(xs, f) {
    $618a28301baf2026$export$e4198045b3bb8c9c(xs, $iv6Yc.__1(f));
}
function $618a28301baf2026$export$fd682543f1c8c317(l, f) {
    var _xs = l;
    var _i = 0;
    while(true){
        var i = _i;
        var xs = _xs;
        if (!xs) return;
        f(i, xs.hd);
        _i = i + 1 | 0;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$2590cec716f5563e(l, f) {
    $618a28301baf2026$export$fd682543f1c8c317(l, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$ae643c57dec5ffec(_l, _accu, f) {
    while(true){
        var accu = _accu;
        var l = _l;
        if (!l) return accu;
        _accu = f(accu, l.hd);
        _l = l.tl;
        continue;
    }
}
function $618a28301baf2026$export$533b26079ad0b4b(l, accu, f) {
    return $618a28301baf2026$export$ae643c57dec5ffec(l, accu, $iv6Yc.__2(f));
}
function $618a28301baf2026$var$reduceReverseUnsafeU(l, accu, f) {
    if (l) return f($618a28301baf2026$var$reduceReverseUnsafeU(l.tl, accu, f), l.hd);
    else return accu;
}
function $618a28301baf2026$export$ef531491e938ae6d(l, acc, f) {
    var len = $618a28301baf2026$export$f24224f1c91d8156(l);
    if (len < 1000) return $618a28301baf2026$var$reduceReverseUnsafeU(l, acc, f);
    else return $i7mYY.reduceReverseU($618a28301baf2026$export$45b10814cc054894(l), acc, f);
}
function $618a28301baf2026$export$e11ac067bdfe867d(l, accu, f) {
    return $618a28301baf2026$export$ef531491e938ae6d(l, accu, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$671b20c9914d5d4(l, acc, f) {
    var _l = l;
    var _acc = acc;
    var _i = 0;
    while(true){
        var i = _i;
        var acc$1 = _acc;
        var l$1 = _l;
        if (!l$1) return acc$1;
        _i = i + 1 | 0;
        _acc = f(acc$1, l$1.hd, i);
        _l = l$1.tl;
        continue;
    }
}
function $618a28301baf2026$export$bbd3ef8720e22369(l, acc, f) {
    return $618a28301baf2026$export$671b20c9914d5d4(l, acc, $iv6Yc.__3(f));
}
function $618a28301baf2026$export$1aed73332dd48c3(l1, l2, f) {
    var _l1 = l1;
    var _l2 = l2;
    var _accu = /* [] */ 0;
    while(true){
        var accu = _accu;
        var l2$1 = _l2;
        var l1$1 = _l1;
        if (!l1$1) return accu;
        if (!l2$1) return accu;
        _accu = {
            hd: f(l1$1.hd, l2$1.hd),
            tl: accu
        };
        _l2 = l2$1.tl;
        _l1 = l1$1.tl;
        continue;
    }
}
function $618a28301baf2026$export$56386c46e9127d6d(l1, l2, f) {
    return $618a28301baf2026$export$1aed73332dd48c3(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$749f3ae5014c3ba3(_l1, _l2, f) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return;
        if (!l2) return;
        f(l1.hd, l2.hd);
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$df99ccf98ba8fcd3(l1, l2, f) {
    $618a28301baf2026$export$749f3ae5014c3ba3(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$e99d6518da14805d(_l1, _l2, _accu, f) {
    while(true){
        var accu = _accu;
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return accu;
        if (!l2) return accu;
        _accu = f(accu, l1.hd, l2.hd);
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$45ce22197e959b90(l1, l2, acc, f) {
    return $618a28301baf2026$export$e99d6518da14805d(l1, l2, acc, $iv6Yc.__3(f));
}
function $618a28301baf2026$var$reduceReverse2UnsafeU(l1, l2, accu, f) {
    if (l1 && l2) return f($618a28301baf2026$var$reduceReverse2UnsafeU(l1.tl, l2.tl, accu, f), l1.hd, l2.hd);
    else return accu;
}
function $618a28301baf2026$export$c37d484a2f360d20(l1, l2, acc, f) {
    var len = $618a28301baf2026$export$f24224f1c91d8156(l1);
    if (len < 1000) return $618a28301baf2026$var$reduceReverse2UnsafeU(l1, l2, acc, f);
    else return $i7mYY.reduceReverse2U($618a28301baf2026$export$45b10814cc054894(l1), $618a28301baf2026$export$45b10814cc054894(l2), acc, f);
}
function $618a28301baf2026$export$29d0b882e6ca8ad4(l1, l2, acc, f) {
    return $618a28301baf2026$export$c37d484a2f360d20(l1, l2, acc, $iv6Yc.__3(f));
}
function $618a28301baf2026$export$f294ebd954c6e224(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return true;
        if (!p(xs.hd)) return false;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$7ecc1a3b11b57dab(xs, p) {
    return $618a28301baf2026$export$f294ebd954c6e224(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$6d4e2e7ededf6e6e(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return false;
        if (p(xs.hd)) return true;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$ad14ef4001db2bcd(xs, p) {
    return $618a28301baf2026$export$6d4e2e7ededf6e6e(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$32d47f85bf8fcd80(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return true;
        if (!l2) return true;
        if (!p(l1.hd, l2.hd)) return false;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$bb2198ede04be76f(l1, l2, p) {
    return $618a28301baf2026$export$32d47f85bf8fcd80(l1, l2, $iv6Yc.__2(p));
}
function $618a28301baf2026$export$98a8fd8b7df34937(_l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) return -1;
            else return 0;
        }
        if (!l2) return 1;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$c0aec0f0618831d3(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) return -1;
            else return 0;
        }
        if (!l2) return 1;
        var c = p(l1.hd, l2.hd);
        if (c !== 0) return c;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$6154dcdb7d23e37b(l1, l2, f) {
    return $618a28301baf2026$export$c0aec0f0618831d3(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$f28cee400b9bf71f(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) return false;
            else return true;
        }
        if (!l2) return false;
        if (!p(l1.hd, l2.hd)) return false;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$9663ddc1cf085b32(l1, l2, f) {
    return $618a28301baf2026$export$f28cee400b9bf71f(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$febfdec44bdabfd5(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return false;
        if (!l2) return false;
        if (p(l1.hd, l2.hd)) return true;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$2b9a9c68d2ecbfcb(l1, l2, p) {
    return $618a28301baf2026$export$febfdec44bdabfd5(l1, l2, $iv6Yc.__2(p));
}
function $618a28301baf2026$export$8754c2358255764(_xs, x, eq) {
    while(true){
        var xs = _xs;
        if (!xs) return false;
        if (eq(xs.hd, x)) return true;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$a4f4bb6b1453fff5(xs, x, eq) {
    return $618a28301baf2026$export$8754c2358255764(xs, x, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$9f10509a9cbf6343(_xs, x, eq) {
    while(true){
        var xs = _xs;
        if (!xs) return;
        var match = xs.hd;
        if (eq(match[0], x)) return $loT9g.some(match[1]);
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$d7de0eeef62c07d9(xs, x, eq) {
    return $618a28301baf2026$export$9f10509a9cbf6343(xs, x, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$aed88f778c485831(_xs, x, eq) {
    while(true){
        var xs = _xs;
        if (!xs) return false;
        if (eq(xs.hd[0], x)) return true;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$ec1dbb0d1232b51b(xs, x, eq) {
    return $618a28301baf2026$export$aed88f778c485831(xs, x, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$f15cecf84141c51d(xs, x, eq) {
    if (!xs) return /* [] */ 0;
    var l = xs.tl;
    var pair = xs.hd;
    if (eq(pair[0], x)) return l;
    var cell = {
        hd: pair,
        tl: /* [] */ 0
    };
    var removed = $618a28301baf2026$var$removeAssocAuxWithMap(l, x, cell, eq);
    if (removed) return cell;
    else return xs;
}
function $618a28301baf2026$export$bcc5750484d95a79(xs, x, eq) {
    return $618a28301baf2026$export$f15cecf84141c51d(xs, x, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$6052dceb8d8eaf34(xs, x, k, eq) {
    if (!xs) return {
        hd: [
            x,
            k
        ],
        tl: /* [] */ 0
    };
    var l = xs.tl;
    var pair = xs.hd;
    if (eq(pair[0], x)) return {
        hd: [
            x,
            k
        ],
        tl: l
    };
    var cell = {
        hd: pair,
        tl: /* [] */ 0
    };
    var replaced = $618a28301baf2026$var$setAssocAuxWithMap(l, x, k, cell, eq);
    if (replaced) return cell;
    else return {
        hd: [
            x,
            k
        ],
        tl: xs
    };
}
function $618a28301baf2026$export$ecd570b0c2c99011(xs, x, k, eq) {
    return $618a28301baf2026$export$6052dceb8d8eaf34(xs, x, k, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$147aeb9de40837c4(xs, cmp) {
    var arr = $618a28301baf2026$export$45b10814cc054894(xs);
    $58Tj9.stableSortInPlaceByU(arr, cmp);
    return $618a28301baf2026$export$571d59b505e6bb4e(arr);
}
function $618a28301baf2026$export$97db5808d8f88186(xs, cmp) {
    return $618a28301baf2026$export$147aeb9de40837c4(xs, $iv6Yc.__2(cmp));
}
function $618a28301baf2026$export$bc39419d633f09a1(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return;
        var x = xs.hd;
        if (p(x)) return $loT9g.some(x);
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$d42617c71165e4fc(xs, p) {
    return $618a28301baf2026$export$bc39419d633f09a1(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$2e45af2d40d3fd2b(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return /* [] */ 0;
        var t = xs.tl;
        var h = xs.hd;
        if (p(h)) {
            var cell = {
                hd: h,
                tl: /* [] */ 0
            };
            $618a28301baf2026$var$copyAuxWitFilter(p, t, cell);
            return cell;
        }
        _xs = t;
        continue;
    }
}
function $618a28301baf2026$export$fae3166c418e0471(xs, p) {
    return $618a28301baf2026$export$2e45af2d40d3fd2b(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$c322a8aa3e32d301(xs, p) {
    var _xs = xs;
    var _i = 0;
    while(true){
        var i = _i;
        var xs$1 = _xs;
        if (!xs$1) return /* [] */ 0;
        var t = xs$1.tl;
        var h = xs$1.hd;
        if (p(h, i)) {
            var cell = {
                hd: h,
                tl: /* [] */ 0
            };
            $618a28301baf2026$var$copyAuxWithFilterIndex(p, t, cell, i + 1 | 0);
            return cell;
        }
        _i = i + 1 | 0;
        _xs = t;
        continue;
    }
}
function $618a28301baf2026$export$3f46207acfee6bc5(xs, p) {
    return $618a28301baf2026$export$c322a8aa3e32d301(xs, $iv6Yc.__2(p));
}
function $618a28301baf2026$export$fb6daf1607d5d777(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return /* [] */ 0;
        var t = xs.tl;
        var h = p(xs.hd);
        if (h !== undefined) {
            var cell = {
                hd: $loT9g.valFromOption(h),
                tl: /* [] */ 0
            };
            $618a28301baf2026$var$copyAuxWitFilterMap(p, t, cell);
            return cell;
        }
        _xs = t;
        continue;
    }
}
function $618a28301baf2026$export$8b311cdc49e179cd(xs, p) {
    return $618a28301baf2026$export$fb6daf1607d5d777(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$5a6fbee869ed7abd(l, p) {
    if (!l) return [
        /* [] */ 0,
        /* [] */ 0
    ];
    var h = l.hd;
    var nextX = {
        hd: h,
        tl: /* [] */ 0
    };
    var nextY = {
        hd: h,
        tl: /* [] */ 0
    };
    var b = p(h);
    $618a28301baf2026$var$partitionAux(p, l.tl, nextX, nextY);
    if (b) return [
        nextX,
        nextY.tl
    ];
    else return [
        nextX.tl,
        nextY
    ];
}
function $618a28301baf2026$export$b29f828819edca8d(l, p) {
    return $618a28301baf2026$export$5a6fbee869ed7abd(l, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$23c8d3f8757cab88(xs) {
    if (!xs) return [
        /* [] */ 0,
        /* [] */ 0
    ];
    var match = xs.hd;
    var cellX = {
        hd: match[0],
        tl: /* [] */ 0
    };
    var cellY = {
        hd: match[1],
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$splitAux(xs.tl, cellX, cellY);
    return [
        cellX,
        cellY
    ];
}
function $618a28301baf2026$export$8901015135f2fb22(l1, l2) {
    if (!l1) return /* [] */ 0;
    if (!l2) return /* [] */ 0;
    var cell = {
        hd: [
            l1.hd,
            l2.hd
        ],
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$zipAux(l1.tl, l2.tl, cell);
    return cell;
}
var $618a28301baf2026$export$346677f925de839c = $618a28301baf2026$export$f24224f1c91d8156;
var $618a28301baf2026$export$3dea766d36a8935f = $618a28301baf2026$export$fae3166c418e0471;
var $618a28301baf2026$export$36e42aef19fc7171 = $618a28301baf2026$export$3f46207acfee6bc5;
 /* No side effect */ 
});

parcelRegister("gTtop", function(module, exports) {

$parcel$export(module.exports, "getExn", function () { return $c4c8952c771923ee$export$2d6fda808293d631; });
$parcel$export(module.exports, "map", function () { return $c4c8952c771923ee$export$871de8747c9eaa88; });
$parcel$export(module.exports, "flatMap", function () { return $c4c8952c771923ee$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "getWithDefault", function () { return $c4c8952c771923ee$export$73b8ef55a37133c7; });

var $iv6Yc = parcelRequire("iv6Yc");
function $c4c8952c771923ee$export$2d6fda808293d631(x) {
    if (x.TAG === /* Ok */ 0) return x._0;
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function $c4c8952c771923ee$export$28a83b3631ef8d34(opt, $$default, f) {
    if (opt.TAG === /* Ok */ 0) return f(opt._0);
    else return $$default;
}
function $c4c8952c771923ee$export$ae51aac33fd70d30(opt, $$default, f) {
    return $c4c8952c771923ee$export$28a83b3631ef8d34(opt, $$default, $iv6Yc.__1(f));
}
function $c4c8952c771923ee$export$cc22bf2a9ce99b1(opt, f) {
    if (opt.TAG === /* Ok */ 0) return {
        TAG: /* Ok */ 0,
        _0: f(opt._0)
    };
    else return {
        TAG: /* Error */ 1,
        _0: opt._0
    };
}
function $c4c8952c771923ee$export$871de8747c9eaa88(opt, f) {
    return $c4c8952c771923ee$export$cc22bf2a9ce99b1(opt, $iv6Yc.__1(f));
}
function $c4c8952c771923ee$export$88eb46a8b99993cf(opt, f) {
    if (opt.TAG === /* Ok */ 0) return f(opt._0);
    else return {
        TAG: /* Error */ 1,
        _0: opt._0
    };
}
function $c4c8952c771923ee$export$5b8affa63fc6df16(opt, f) {
    return $c4c8952c771923ee$export$88eb46a8b99993cf(opt, $iv6Yc.__1(f));
}
function $c4c8952c771923ee$export$73b8ef55a37133c7(opt, $$default) {
    if (opt.TAG === /* Ok */ 0) return opt._0;
    else return $$default;
}
function $c4c8952c771923ee$export$71a04ee6075aae31(param) {
    if (param.TAG === /* Ok */ 0) return true;
    else return false;
}
function $c4c8952c771923ee$export$e6127cc7fe7395c3(param) {
    if (param.TAG === /* Ok */ 0) return false;
    else return true;
}
function $c4c8952c771923ee$export$f28cee400b9bf71f(a, b, f) {
    if (a.TAG === /* Ok */ 0) {
        if (b.TAG === /* Ok */ 0) return f(a._0, b._0);
        else return false;
    } else if (b.TAG === /* Ok */ 0) return false;
    else return true;
}
function $c4c8952c771923ee$export$9663ddc1cf085b32(a, b, f) {
    return $c4c8952c771923ee$export$f28cee400b9bf71f(a, b, $iv6Yc.__2(f));
}
function $c4c8952c771923ee$export$c0aec0f0618831d3(a, b, f) {
    if (a.TAG === /* Ok */ 0) {
        if (b.TAG === /* Ok */ 0) return f(a._0, b._0);
        else return 1;
    } else if (b.TAG === /* Ok */ 0) return -1;
    else return 0;
}
function $c4c8952c771923ee$export$6154dcdb7d23e37b(a, b, f) {
    return $c4c8952c771923ee$export$c0aec0f0618831d3(a, b, $iv6Yc.__2(f));
}
 /* No side effect */ 
});

parcelRegister("AAkl8", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $06df8ab499e05972$export$c564cdbbe6da493; });
$parcel$export(module.exports, "string", function () { return $06df8ab499e05972$export$22b082955e083ec3; });
$parcel$export(module.exports, "$$int", function () { return $06df8ab499e05972$export$b537f535eb826cd3; });
$parcel$export(module.exports, "$$float", function () { return $06df8ab499e05972$export$7af93c3912c36b2a; });
$parcel$export(module.exports, "bool", function () { return $06df8ab499e05972$export$87b259aa03e3d267; });
$parcel$export(module.exports, "$$null", function () { return $06df8ab499e05972$export$75050adc5191c049; });
$parcel$export(module.exports, "array", function () { return $06df8ab499e05972$export$2f23118c22fb2630; });
$parcel$export(module.exports, "list", function () { return $06df8ab499e05972$export$8837f4fc672e936d; });
$parcel$export(module.exports, "object", function () { return $06df8ab499e05972$export$be5493f9613cbbe; });
$parcel$export(module.exports, "dict", function () { return $06df8ab499e05972$export$b7eef48498bbd53e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $8ncuc = parcelRequire("8ncuc");
function $06df8ab499e05972$export$c564cdbbe6da493(v, indentLevel) {
    return JSON.stringify(v, null, indentLevel);
}
function $06df8ab499e05972$export$22b082955e083ec3(prim) {
    return prim;
}
function $06df8ab499e05972$export$b537f535eb826cd3(i) {
    return i;
}
function $06df8ab499e05972$export$7af93c3912c36b2a(prim) {
    return prim;
}
function $06df8ab499e05972$export$87b259aa03e3d267(prim) {
    return prim;
}
var $06df8ab499e05972$export$75050adc5191c049 = null;
function $06df8ab499e05972$export$2f23118c22fb2630(arr, encodeI) {
    return arr.map($iv6Yc.__1(encodeI));
}
function $06df8ab499e05972$export$8837f4fc672e936d(l, encodeI) {
    return $8ncuc.toArray(l).map($iv6Yc.__1(encodeI));
}
var $06df8ab499e05972$export$be5493f9613cbbe = $d3YYW.fromArray;
function $06df8ab499e05972$export$b7eef48498bbd53e(obj) {
    return obj;
}
 /* null Not a pure module */ 
});


parcelRegister("jVmMx", function(module, exports) {

$parcel$export(module.exports, "Encode", function () { return $e81503310f020e69$export$7feeb05a8babbb15; });
$parcel$export(module.exports, "Decode", function () { return $e81503310f020e69$export$325185342b153af9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");
function $e81503310f020e69$var$nullable(value, encoder) {
    return $2whNH.mapWithDefault(value, $AAkl8.$$null, encoder);
}
function $e81503310f020e69$var$simpleVariant(values, value) {
    return $i7mYY.reduce(values, $AAkl8.string("THIS SHOULD NEVER HAPPEN!"), function(acc, param) {
        if ($7bjme.equal(value, param[1])) return $AAkl8.array([
            param[0]
        ], $AAkl8.string);
        else return acc;
    });
}
function $e81503310f020e69$var$deccoVariantWithPayload(value, name, payloadEncoder) {
    return $AAkl8.array([
        $AAkl8.string(name),
        $iv6Yc._1(payloadEncoder, value)
    ], function(x) {
        return x;
    });
}
function $e81503310f020e69$var$dictWithEncoder(d, encoder) {
    return $AAkl8.dict($d3YYW.map($iv6Yc.__1(encoder), d));
}
function $e81503310f020e69$var$addIf(notEqualTo, previous, encode, input) {
    var value = input[1];
    if ($7bjme.notequal(value, notEqualTo)) return $i7mYY.concat(previous, [
        [
            input[0],
            $iv6Yc._1(encode, value)
        ]
    ]);
    else return previous;
}
var $e81503310f020e69$export$7feeb05a8babbb15 = {
    encode: $AAkl8.encode,
    string: $AAkl8.string,
    $$int: $AAkl8.$$int,
    $$float: $AAkl8.$$float,
    bool: $AAkl8.bool,
    $$null: $AAkl8.$$null,
    array: $AAkl8.array,
    list: $AAkl8.list,
    object: $AAkl8.object,
    dict: $AAkl8.dict,
    nullable: $e81503310f020e69$var$nullable,
    simpleVariant: $e81503310f020e69$var$simpleVariant,
    deccoVariantWithPayload: $e81503310f020e69$var$deccoVariantWithPayload,
    dictWithEncoder: $e81503310f020e69$var$dictWithEncoder,
    addIf: $e81503310f020e69$var$addIf
};
function $e81503310f020e69$var$lazy_(thunk) {
    return $79vie.andThen($79vie.succeed(undefined), thunk);
}
function $e81503310f020e69$var$$$default(encoder, $$default$1) {
    return $79vie.oneOf(encoder, [
        $79vie.succeed($$default$1)
    ]);
}
function $e81503310f020e69$var$fieldWithDefault(name, decoder, defaultTo) {
    return $79vie.map($79vie.option($79vie.field(name, decoder)), function(v) {
        return $2whNH.getWithDefault(v, defaultTo);
    });
}
function $e81503310f020e69$var$exactString(exactValue) {
    return $79vie.andThen($79vie.string, function(str) {
        if (str === exactValue) return $79vie.succeed($79vie.string);
        else return $79vie.fail("String is not the expected value of: " + exactValue + "");
    });
}
function $e81503310f020e69$var$exactStringVariant(exactString, variant) {
    return $79vie.andThen($79vie.index(0, $79vie.string), function(str) {
        if (str === exactString) return $79vie.succeed(variant);
        else return $79vie.fail("Not " + exactString + "");
    });
}
function $e81503310f020e69$var$exactVariantChoice(exactValue) {
    return $79vie.andThen($79vie.index(0, $79vie.string), function(str) {
        if (str === exactValue) return $79vie.succeed(exactValue);
        else return $79vie.fail("Trying to decode " + str + " but it doesn't match value " + exactValue + "");
    });
}
function $e81503310f020e69$var$simpleVariant$1(values) {
    var acceptedValues = values.map(function(param) {
        return '"' + param[0] + '"';
    }).join(" or ");
    return $79vie.andThen($79vie.index(0, $79vie.string), function(str) {
        var match = values.find(function(param) {
            return param[0] === str;
        });
        if (match !== undefined) return $79vie.succeed(match[1]);
        else return $79vie.fail("Trying to decode but the string " + str + " is not supported! Accepted values: " + acceptedValues + "");
    });
}
function $e81503310f020e69$var$deccoVariantWithPayload$1(name, decoder, f) {
    return $79vie.map2($79vie.index(0, $e81503310f020e69$var$exactString(name)), $79vie.index(1, decoder), function(param, value) {
        return $iv6Yc._1(f, value);
    });
}
function $e81503310f020e69$var$stringifiedPayloadVariant(name, decoder, then) {
    return $79vie.map($79vie.andThen($79vie.string, function(str) {
        if (!str.includes(name)) return $79vie.fail("Not " + name + "");
        var split = str.split(name);
        var secondPart = $i7mYY.get(split, 1);
        if (secondPart === undefined) return $79vie.fail("Not " + name + "");
        var e = $79vie.decodeString(secondPart, decoder);
        if (e.TAG === /* Ok */ 0) return $79vie.succeed(e._0);
        else return $79vie.fail("Could not parse payload in " + name + "");
    }), $iv6Yc.__1(then));
}
var $e81503310f020e69$export$325185342b153af9 = {
    string: $79vie.string,
    bool: $79vie.bool,
    $$int: $79vie.$$int,
    $$float: $79vie.$$float,
    nullable: $79vie.nullable,
    array: $79vie.array,
    list: $79vie.list,
    dict: $79vie.dict,
    keyValuePairs: $79vie.keyValuePairs,
    tuple2: $79vie.tuple2,
    tuple3: $79vie.tuple3,
    tuple4: $79vie.tuple4,
    tuple5: $79vie.tuple5,
    tuple6: $79vie.tuple6,
    tuple7: $79vie.tuple7,
    tuple8: $79vie.tuple8,
    field: $79vie.field,
    at: $79vie.at,
    index: $79vie.index,
    option: $79vie.option,
    oneOf: $79vie.oneOf,
    decodeString: $79vie.decodeString,
    decodeValue: $79vie.decodeValue,
    errorToString: $79vie.errorToString,
    map: $79vie.map,
    map2: $79vie.map2,
    map3: $79vie.map3,
    map4: $79vie.map4,
    map5: $79vie.map5,
    map6: $79vie.map6,
    map7: $79vie.map7,
    map8: $79vie.map8,
    value: $79vie.value,
    $$null: $79vie.$$null,
    succeed: $79vie.succeed,
    fail: $79vie.fail,
    andMap: $79vie.andMap,
    andThen: $79vie.andThen,
    lazy_: $e81503310f020e69$var$lazy_,
    $$default: $e81503310f020e69$var$$$default,
    fieldWithDefault: $e81503310f020e69$var$fieldWithDefault,
    exactString: $e81503310f020e69$var$exactString,
    exactStringVariant: $e81503310f020e69$var$exactStringVariant,
    exactVariantChoice: $e81503310f020e69$var$exactVariantChoice,
    simpleVariant: $e81503310f020e69$var$simpleVariant$1,
    deccoVariantWithPayload: $e81503310f020e69$var$deccoVariantWithPayload$1,
    stringifiedPayloadVariant: $e81503310f020e69$var$stringifiedPayloadVariant
};
 /* Json__Decode Not a pure module */ 
});

parcelRegister("h7kEx", function(module, exports) {

$parcel$export(module.exports, "Server", function () { return $c7631c58fbf98032$export$d59771a2e9612de9; });
$parcel$export(module.exports, "Decoding", function () { return $c7631c58fbf98032$export$34a9c8428d70b516; });
$parcel$export(module.exports, "$$fetch", function () { return $c7631c58fbf98032$export$eb3fff827c83c3a1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $gOCfv = parcelRequire("gOCfv");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $eklj4 = parcelRequire("eklj4");

var $75ZqT = parcelRequire("75ZqT");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $hxhfd = parcelRequire("hxhfd");

var $1xvYg = parcelRequire("1xvYg");

var $4RPwt = parcelRequire("4RPwt");

var $bsv7W = parcelRequire("bsv7W");

var $bygWp = parcelRequire("bygWp");

var $bBMv4 = parcelRequire("bBMv4");

var $ehnwQ = parcelRequire("ehnwQ");

var $4QdUt = parcelRequire("4QdUt");
var $c7631c58fbf98032$export$ea52035eac03daf0 = /* @__PURE__ */ $1xvYg.create("FetchUtils-Showside.ServerError");
var $c7631c58fbf98032$export$ef3eed12d06c0285 = /* @__PURE__ */ $1xvYg.create("FetchUtils-Showside.DecodeError");
var $c7631c58fbf98032$export$bae979e68e4dc802 = /* @__PURE__ */ $1xvYg.create("FetchUtils-Showside.NetworkError");
function $c7631c58fbf98032$export$f53235827bfffde0(url, requestInit) {
    var $$fetch$1 = window.makerFetch;
    if ($$fetch$1 !== undefined) return $$fetch$1(url, requestInit);
    else return fetch(url, requestInit);
}
function $c7631c58fbf98032$var$entries(headers) {
    return Object.fromEntries(headers.entries());
}
var $c7631c58fbf98032$export$953df90d5d5fed48 = {
    entries: $c7631c58fbf98032$var$entries
};
function $c7631c58fbf98032$var$toString(method_) {
    if (typeof method_ !== "number") return method_._0.toUpperCase();
    switch(method_){
        case /* Get */ 0:
            return "GET";
        case /* Head */ 1:
            return "HEAD";
        case /* Post */ 2:
            return "POST";
        case /* Put */ 3:
            return "PUT";
        case /* Delete */ 4:
            return "DELETE";
        case /* Connect */ 5:
            return "CONNECT";
        case /* Options */ 6:
            return "OPTIONS";
        case /* Trace */ 7:
            return "TRACE";
        case /* Patch */ 8:
            return "PATCH";
    }
}
var $c7631c58fbf98032$export$31bb55db0b3e4187 = {
    toString: $c7631c58fbf98032$var$toString
};
function $c7631c58fbf98032$var$toObject(req) {
    return $c7631c58fbf98032$var$_toObject.apply(this, arguments);
}
function $c7631c58fbf98032$var$_toObject() {
    $c7631c58fbf98032$var$_toObject = (0, $5YOUh._)(function(req) {
        var req$1, text, headers;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    try {
                        req$1 = req.clone();
                    } catch (exn) {
                        req$1 = req;
                    }
                    return [
                        4,
                        $eklj4.$$catch($gOCfv.$$Request.text(req$1), function(param) {
                            return Promise.resolve("");
                        })
                    ];
                case 1:
                    text = _state.sent();
                    headers = req$1.headers;
                    return [
                        2,
                        {
                            url: req$1.url,
                            headers: Object.fromEntries(headers.entries()),
                            method: $c7631c58fbf98032$var$toString($gOCfv.$$Request.method_(req$1)),
                            text: text
                        }
                    ];
            }
        });
    });
    return $c7631c58fbf98032$var$_toObject.apply(this, arguments);
}
var $c7631c58fbf98032$export$53d047610dcbd7d1 = {
    toObject: $c7631c58fbf98032$var$toObject
};
function $c7631c58fbf98032$var$toObject$1(res) {
    return $c7631c58fbf98032$var$_toObject$1.apply(this, arguments);
}
function $c7631c58fbf98032$var$_toObject$1() {
    $c7631c58fbf98032$var$_toObject$1 = (0, $5YOUh._)(function(res) {
        var res$1, text, headers;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    try {
                        res$1 = res.clone();
                    } catch (exn) {
                        res$1 = res;
                    }
                    return [
                        4,
                        $eklj4.$$catch($gOCfv.$$Response.text(res$1), function(param) {
                            return Promise.resolve("");
                        })
                    ];
                case 1:
                    text = _state.sent();
                    headers = res$1.headers;
                    return [
                        2,
                        {
                            url: res$1.url,
                            headers: Object.fromEntries(headers.entries()),
                            status: res$1.status,
                            statusText: res$1.statusText,
                            text: text
                        }
                    ];
            }
        });
    });
    return $c7631c58fbf98032$var$_toObject$1.apply(this, arguments);
}
var $c7631c58fbf98032$export$ccdc019228fc9db2 = {
    toObject: $c7631c58fbf98032$var$toObject$1
};
var $c7631c58fbf98032$export$cea17b2eb787e8f6 = {};
var $c7631c58fbf98032$export$852e4a2c9592440a = "Unknown error occurred";
function $c7631c58fbf98032$export$bf7e10db8fb87848(error, statusCode, requestUrl) {
    var nonCriticalErrorSubstrings = [
        "Focal product not found in result set"
    ];
    var isNonCriticalMessage = function isNonCriticalMessage(msg) {
        return $i7mYY.some(nonCriticalErrorSubstrings, function(sub) {
            return msg.includes(sub);
        });
    };
    var errorMessage = error.RE_EXN_ID === $c7631c58fbf98032$export$bae979e68e4dc802 || error.RE_EXN_ID === $c7631c58fbf98032$export$ea52035eac03daf0 || error.RE_EXN_ID === $c7631c58fbf98032$export$ef3eed12d06c0285 ? error._1 : "";
    var isProduction = requestUrl.startsWith($hxhfd.apiHostnameProduction);
    var isForbidden = $7bjme.equal(statusCode, 403);
    var isNonCritical = isNonCriticalMessage(errorMessage);
    if (isProduction && !isForbidden) return !isNonCritical;
    else return false;
}
function $c7631c58fbf98032$export$42595fc4624ec725(urlStr) {
    var url = $bygWp.maybeMakeUrl($bygWp.resolveRelativePath(urlStr));
    if (url === undefined) return urlStr;
    var url$1 = $loT9g.valFromOption(url);
    var pathname = url$1.pathname;
    var host = url$1.host;
    return host + pathname;
}
function $c7631c58fbf98032$var$makeError(req, res, message, param) {
    var statusCode = res.status;
    var url = res.url;
    var displayUrl = $c7631c58fbf98032$export$42595fc4624ec725(url);
    return {
        exn: {
            RE_EXN_ID: $c7631c58fbf98032$export$ea52035eac03daf0,
            _1: "Error " + statusCode.toString() + " in API " + displayUrl + ": " + message + ""
        },
        request: req,
        response: res
    };
}
function $c7631c58fbf98032$var$truncateTo100Characters(str) {
    if (str.length > 100) return str.slice(0, 100) + "...";
    else return str;
}
function $c7631c58fbf98032$var$extractUsefulErrorMessageFromResponse(req, res) {
    return $gOCfv.$$Response.text(res.clone()).then(function(text) {
        var json;
        try {
            json = $loT9g.some(JSON.parse(text));
        } catch (e) {
            json = undefined;
        }
        var message = $c7631c58fbf98032$var$truncateTo100Characters(text);
        var message$1 = message.trim() === "" ? $c7631c58fbf98032$export$852e4a2c9592440a : message;
        var obj = $2whNH.flatMap(json, $1ArWc.decodeObject);
        if (obj === undefined) return Promise.resolve($c7631c58fbf98032$var$makeError(req, res, message$1, undefined));
        var displayError = $2whNH.flatMap($d3YYW.get($loT9g.valFromOption(obj), "error"), $1ArWc.decodeString);
        if (displayError !== undefined) return Promise.resolve($c7631c58fbf98032$var$makeError(req, res, displayError, undefined));
        else return Promise.resolve($c7631c58fbf98032$var$makeError(req, res, message$1, undefined));
    });
}
function $c7631c58fbf98032$var$handleServerResponse(req, res) {
    var statusCode = res.status;
    if (statusCode >= 200 && statusCode < 300) return Promise.resolve({
        TAG: /* Ok */ 0,
        _0: res
    });
    else return $c7631c58fbf98032$var$extractUsefulErrorMessageFromResponse(req, res).then(function(error) {
        return {
            TAG: /* Error */ 1,
            _0: error
        };
    });
}
function $c7631c58fbf98032$var$reportToRollbar(error) {
    return $c7631c58fbf98032$var$_reportToRollbar.apply(this, arguments);
}
function $c7631c58fbf98032$var$_reportToRollbar() {
    $c7631c58fbf98032$var$_reportToRollbar = (0, $5YOUh._)(function(error) {
        var isCriticalError$1, request, response;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isCriticalError$1 = $c7631c58fbf98032$export$bf7e10db8fb87848(error.exn, error.response.status, error.request.url);
                    return [
                        4,
                        $c7631c58fbf98032$var$toObject(error.request)
                    ];
                case 1:
                    request = _state.sent();
                    return [
                        4,
                        $c7631c58fbf98032$var$toObject$1(error.response)
                    ];
                case 2:
                    response = _state.sent();
                    if (isCriticalError$1) return [
                        2,
                        $4QdUt.critical2($75ZqT.$$Error.fromRescript(error.exn), {
                            request: request,
                            response: response
                        })
                    ];
                    else return [
                        2,
                        $4QdUt.error2(error.exn, {
                            request: request,
                            response: response
                        })
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $c7631c58fbf98032$var$_reportToRollbar.apply(this, arguments);
}
function $c7631c58fbf98032$var$reportAllServerErrors(res, req) {
    return res.then(function(param) {
        return $c7631c58fbf98032$var$handleServerResponse(req, param);
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) return Promise.resolve(result._0);
        var error = result._0;
        return $c7631c58fbf98032$var$reportToRollbar(error).then(function(param) {
            return Promise.reject(error.exn);
        });
    });
}
function $c7631c58fbf98032$var$ignoreNotFoundError(res, req) {
    return res.then(function(param) {
        return $c7631c58fbf98032$var$handleServerResponse(req, param);
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) return Promise.resolve(result._0);
        var error = result._0;
        if (error.response.status === 404) return Promise.reject({
            RE_EXN_ID: $c7631c58fbf98032$export$ea52035eac03daf0,
            _1: "Not found"
        });
        else return $c7631c58fbf98032$var$reportToRollbar(error).then(function(param) {
            return Promise.reject(error.exn);
        });
    });
}
var $c7631c58fbf98032$export$d59771a2e9612de9 = {
    makeError: $c7631c58fbf98032$var$makeError,
    truncateTo100Characters: $c7631c58fbf98032$var$truncateTo100Characters,
    extractUsefulErrorMessageFromResponse: $c7631c58fbf98032$var$extractUsefulErrorMessageFromResponse,
    handleServerResponse: $c7631c58fbf98032$var$handleServerResponse,
    reportToRollbar: $c7631c58fbf98032$var$reportToRollbar,
    reportAllServerErrors: $c7631c58fbf98032$var$reportAllServerErrors,
    ignoreNotFoundError: $c7631c58fbf98032$var$ignoreNotFoundError
};
function $c7631c58fbf98032$var$ignoreDecode(json) {
    return Promise.resolve({
        TAG: /* Ok */ 0,
        _0: json
    });
}
function $c7631c58fbf98032$var$raiseExnIfFound(json, decoder) {
    var decodedObject = $1ArWc.decodeObject(json);
    var error = $2whNH.flatMap($2whNH.flatMap(decodedObject, function(dict) {
        return $d3YYW.get(dict, "error");
    }), $1ArWc.decodeString);
    var numberOfFields = $2whNH.getWithDefault($2whNH.map(decodedObject, function(object) {
        return Object.keys(object).length;
    }), 0);
    if (error !== undefined && error.trim() !== "" && numberOfFields === 1) return Promise.resolve({
        TAG: /* Error */ 1,
        _0: error
    });
    else return $iv6Yc._1(decoder, json);
}
var $c7631c58fbf98032$var$SuccessfulResponseErrorBody = {
    raiseExnIfFound: $c7631c58fbf98032$var$raiseExnIfFound
};
function $c7631c58fbf98032$var$reportAllDecodingErrors(res, decoder) {
    return res.then(function(res) {
        return $gOCfv.$$Response.json(res).then(function(json) {
            var decoded = $c7631c58fbf98032$var$raiseExnIfFound(json, decoder);
            var url = res.url;
            var displayUrl = $c7631c58fbf98032$export$42595fc4624ec725(url);
            return $ehnwQ.$$catch(decoded, function(e) {
                var rootCause = $75ZqT.$$Error.fromRescript(e);
                var name = $2whNH.getWithDefault(rootCause.name, "Error");
                var message = $2whNH.getWithDefault(rootCause.message, $c7631c58fbf98032$export$852e4a2c9592440a);
                var errorMessage = "Error raised when decoding " + displayUrl + ": " + name + " " + message + "";
                var error = {
                    RE_EXN_ID: $c7631c58fbf98032$export$ef3eed12d06c0285,
                    _1: errorMessage
                };
                if (message.includes("Failed to fetch dynamically imported module:") || message.includes("Cannot find module") || message.includes("Could not resolve bundle with id")) return Promise.reject(error);
                else return $c7631c58fbf98032$var$toObject$1(res).then(function(response) {
                    var isCriticalError$1 = $c7631c58fbf98032$export$bf7e10db8fb87848(error, res.status, res.url);
                    if (isCriticalError$1) return $4QdUt.critical2($75ZqT.$$Error.fromRescript(error), {
                        apiUrl: url,
                        response: response
                    }).then(function(param) {
                        return Promise.reject(error);
                    });
                    else return $4QdUt.error2(error, {
                        apiUrl: url,
                        response: response
                    }).then(function(param) {
                        return Promise.reject(error);
                    });
                });
            }).then(function(decoded) {
                if (decoded.TAG === /* Ok */ 0) return Promise.resolve(decoded._0);
                var errorMessage = "Failed to decode response of API " + displayUrl + ": " + decoded._0 + "";
                var error = {
                    RE_EXN_ID: $c7631c58fbf98032$export$ef3eed12d06c0285,
                    _1: errorMessage
                };
                return $c7631c58fbf98032$var$toObject$1(res).then(function(response) {
                    var isCriticalError$1 = $c7631c58fbf98032$export$bf7e10db8fb87848(error, res.status, res.url);
                    if (isCriticalError$1) return $4QdUt.critical2($75ZqT.$$Error.fromRescript(error), {
                        apiUrl: url,
                        response: response
                    }).then(function(param) {
                        return Promise.reject(error);
                    });
                    else return $4QdUt.error2(error, {
                        apiUrl: url,
                        response: response
                    }).then(function(param) {
                        return Promise.reject(error);
                    });
                });
            });
        });
    });
}
var $c7631c58fbf98032$export$34a9c8428d70b516 = {
    ignoreDecode: $c7631c58fbf98032$var$ignoreDecode,
    SuccessfulResponseErrorBody: $c7631c58fbf98032$var$SuccessfulResponseErrorBody,
    reportAllDecodingErrors: $c7631c58fbf98032$var$reportAllDecodingErrors
};
function $c7631c58fbf98032$export$d5856779b17605db(e, req) {
    var url = req.url;
    var displayUrl = $c7631c58fbf98032$export$42595fc4624ec725(url);
    var err = $75ZqT.$$Error.fromRescript(e);
    var name = $2whNH.getWithDefault(err.name, "Error");
    var message = $2whNH.getWithDefault(err.message, $c7631c58fbf98032$export$852e4a2c9592440a);
    var errorMessage = "Error raised when fetching " + displayUrl + ": " + name + " " + message + "";
    var error = $75ZqT.$$Error.fromRescriptWithNewMessage(e, errorMessage);
    var isNetworkError = (0, $bsv7W.default)(e);
    if (isNetworkError) return Promise.reject({
        RE_EXN_ID: $c7631c58fbf98032$export$bae979e68e4dc802,
        _1: $2whNH.getWithDefault(err.message, "Network error")
    });
    else return $c7631c58fbf98032$var$toObject(req).then(function(request) {
        var isCriticalError$1 = $c7631c58fbf98032$export$bf7e10db8fb87848(e, undefined, req.url);
        if (isCriticalError$1) return $4QdUt.critical2(error, {
            apiUrl: url,
            request: request
        }).then(function(param) {
            return Promise.reject(e);
        });
        else return $4QdUt.jsError2(error, {
            apiUrl: url,
            request: request
        }).then(function(param) {
            return Promise.reject(e);
        });
    });
}
function $c7631c58fbf98032$export$eb3fff827c83c3a1(method_Opt, body, headers, reportDecodingError, reportServerError, decoder, url) {
    var method_ = method_Opt !== undefined ? method_Opt : /* Get */ 0;
    var reportServerError$1 = $2whNH.getWithDefault(reportServerError, $c7631c58fbf98032$var$reportAllServerErrors);
    var reportDecodingError$1 = $2whNH.getWithDefault(reportDecodingError, $c7631c58fbf98032$var$reportAllDecodingErrors);
    var requestInit = $gOCfv.RequestInit.make(method_, headers, body, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var request = new Request(url, requestInit);
    try {
        return $iv6Yc._2(reportDecodingError$1, $iv6Yc._2(reportServerError$1, $ehnwQ.$$catch($c7631c58fbf98032$export$f53235827bfffde0(url, requestInit), function(exn) {
            return $c7631c58fbf98032$export$d5856779b17605db(exn, request);
        }), request), decoder);
    } catch (raw_e) {
        var e = $bBMv4.internalToOCamlException(raw_e);
        return $c7631c58fbf98032$export$d5856779b17605db($4RPwt.Exn.unwrapJsError(e), request);
    }
}
 /* Rollbar Not a pure module */ 
});
parcelRegister("gOCfv", function(module, exports) {

$parcel$export(module.exports, "RequestInit", function () { return $c3defc4fec8ac51e$export$ffbc82ea5de81ac6; });
$parcel$export(module.exports, "$$Request", function () { return $c3defc4fec8ac51e$export$53d047610dcbd7d1; });
$parcel$export(module.exports, "$$Response", function () { return $c3defc4fec8ac51e$export$ccdc019228fc9db2; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");
function $c3defc4fec8ac51e$var$encodeRequestMethod(method_) {
    if (typeof method_ !== "number") return method_._0;
    switch(method_){
        case /* Get */ 0:
            return "GET";
        case /* Head */ 1:
            return "HEAD";
        case /* Post */ 2:
            return "POST";
        case /* Put */ 3:
            return "PUT";
        case /* Delete */ 4:
            return "DELETE";
        case /* Connect */ 5:
            return "CONNECT";
        case /* Options */ 6:
            return "OPTIONS";
        case /* Trace */ 7:
            return "TRACE";
        case /* Patch */ 8:
            return "PATCH";
    }
}
function $c3defc4fec8ac51e$var$encodeReferrerPolicy(param) {
    switch(param){
        case /* None */ 0:
            return "";
        case /* NoReferrer */ 1:
            return "no-referrer";
        case /* NoReferrerWhenDowngrade */ 2:
            return "no-referrer-when-downgrade";
        case /* SameOrigin */ 3:
            return "same-origin";
        case /* Origin */ 4:
            return "origin";
        case /* StrictOrigin */ 5:
            return "strict-origin";
        case /* OriginWhenCrossOrigin */ 6:
            return "origin-when-cross-origin";
        case /* StrictOriginWhenCrossOrigin */ 7:
            return "strict-origin-when-cross-origin";
        case /* UnsafeUrl */ 8:
            return "unsafe-url";
    }
}
function $c3defc4fec8ac51e$var$encodeRequestMode(param) {
    switch(param){
        case /* Navigate */ 0:
            return "navigate";
        case /* SameOrigin */ 1:
            return "same-origin";
        case /* NoCORS */ 2:
            return "no-cors";
        case /* CORS */ 3:
            return "cors";
    }
}
function $c3defc4fec8ac51e$var$encodeRequestCredentials(param) {
    switch(param){
        case /* Omit */ 0:
            return "omit";
        case /* SameOrigin */ 1:
            return "same-origin";
        case /* Include */ 2:
            return "include";
    }
}
function $c3defc4fec8ac51e$var$encodeRequestCache(param) {
    switch(param){
        case /* Default */ 0:
            return "default";
        case /* NoStore */ 1:
            return "no-store";
        case /* Reload */ 2:
            return "reload";
        case /* NoCache */ 3:
            return "no-cache";
        case /* ForceCache */ 4:
            return "force-cache";
        case /* OnlyIfCached */ 5:
            return "only-if-cached";
    }
}
function $c3defc4fec8ac51e$var$encodeRequestRedirect(param) {
    switch(param){
        case /* Follow */ 0:
            return "follow";
        case /* Error */ 1:
            return "error";
        case /* Manual */ 2:
            return "manual";
    }
}
var $c3defc4fec8ac51e$export$6dc17dc4269800be = {};
function $c3defc4fec8ac51e$var$append(arg1, arg2, obj) {
    obj.append(arg1, arg2);
}
function $c3defc4fec8ac51e$var$$$delete(arg1, obj) {
    obj.delete(arg1);
}
function $c3defc4fec8ac51e$var$get(arg1, obj) {
    return $loT9g.null_to_opt(obj.get(arg1));
}
function $c3defc4fec8ac51e$var$has(arg1, obj) {
    return obj.has(arg1);
}
function $c3defc4fec8ac51e$var$set(arg1, arg2, obj) {
    obj.set(arg1, arg2);
}
var $c3defc4fec8ac51e$export$953df90d5d5fed48 = {
    append: $c3defc4fec8ac51e$var$append,
    $$delete: $c3defc4fec8ac51e$var$$$delete,
    get: $c3defc4fec8ac51e$var$get,
    has: $c3defc4fec8ac51e$var$has,
    set: $c3defc4fec8ac51e$var$set
};
var $c3defc4fec8ac51e$export$f7d5d70d55931f4b = {};
function $c3defc4fec8ac51e$var$map(f, v) {
    if (v !== undefined) return $loT9g.some($iv6Yc._1(f, $loT9g.valFromOption(v)));
}
function $c3defc4fec8ac51e$var$make(method_, headers, body, referrer, referrerPolicyOpt, mode, credentials, cache, redirect, integrityOpt, keepalive, signal) {
    var _$referrerPolicy = referrerPolicyOpt !== undefined ? referrerPolicyOpt : /* None */ 0;
    var integrity = integrityOpt !== undefined ? integrityOpt : "";
    var partial_arg = integrity;
    var partial_arg$1 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestRedirect, redirect);
    var partial_arg$2 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestCache, cache);
    var partial_arg$3 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestCredentials, credentials);
    var partial_arg$4 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestMode, mode);
    var partial_arg$5 = $c3defc4fec8ac51e$var$encodeReferrerPolicy(_$referrerPolicy);
    var partial_arg$6 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestMethod, method_);
    return function(param) {
        var tmp = {};
        if (partial_arg$6 !== undefined) tmp.method = partial_arg$6;
        if (headers !== undefined) tmp.headers = $loT9g.valFromOption(headers);
        if (body !== undefined) tmp.body = $loT9g.valFromOption(body);
        if (referrer !== undefined) tmp.referrer = referrer;
        if (partial_arg$5 !== undefined) tmp.referrerPolicy = partial_arg$5;
        if (partial_arg$4 !== undefined) tmp.mode = partial_arg$4;
        if (partial_arg$3 !== undefined) tmp.credentials = partial_arg$3;
        if (partial_arg$2 !== undefined) tmp.cache = partial_arg$2;
        if (partial_arg$1 !== undefined) tmp.redirect = partial_arg$1;
        if (partial_arg !== undefined) tmp.integrity = partial_arg;
        if (keepalive !== undefined) tmp.keepalive = keepalive;
        if (signal !== undefined) tmp.signal = $loT9g.valFromOption(signal);
        return tmp;
    };
}
function $c3defc4fec8ac51e$var$method_(self) {
    var method_$1 = self.method;
    switch(method_$1){
        case "CONNECT":
            return /* Connect */ 5;
        case "DELETE":
            return /* Delete */ 4;
        case "GET":
            return /* Get */ 0;
        case "HEAD":
            return /* Head */ 1;
        case "OPTIONS":
            return /* Options */ 6;
        case "PATCH":
            return /* Patch */ 8;
        case "POST":
            return /* Post */ 2;
        case "PUT":
            return /* Put */ 3;
        case "TRACE":
            return /* Trace */ 7;
        default:
            return /* Other */ {
                _0: method_$1
            };
    }
}
function $c3defc4fec8ac51e$var$type_(self) {
    var e = self.type;
    switch(e){
        case "":
            return /* None */ 0;
        case "audio":
            return /* Audio */ 1;
        case "font":
            return /* Font */ 2;
        case "image":
            return /* Image */ 3;
        case "script":
            return /* Script */ 4;
        case "style":
            return /* Style */ 5;
        case "track":
            return /* Track */ 6;
        case "video":
            return /* Video */ 7;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestType: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$destination(self) {
    var e = self.destination;
    switch(e){
        case "":
            return /* None */ 0;
        case "document":
            return /* Document */ 1;
        case "embed":
            return /* Embed */ 2;
        case "font":
            return /* Font */ 3;
        case "image":
            return /* Image */ 4;
        case "manifest":
            return /* Manifest */ 5;
        case "media":
            return /* Media */ 6;
        case "object":
            return /* Object */ 7;
        case "report":
            return /* Report */ 8;
        case "script":
            return /* Script */ 9;
        case "serviceworker":
            return /* ServiceWorker */ 10;
        case "sharedworder":
            return /* SharedWorker */ 11;
        case "style":
            return /* Style */ 12;
        case "worker":
            return /* Worker */ 13;
        case "xslt":
            return /* Xslt */ 14;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestDestination: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$referrerPolicy(self) {
    var e = self.referrerPolicy;
    switch(e){
        case "":
            return /* None */ 0;
        case "no-referrer":
            return /* NoReferrer */ 1;
        case "no-referrer-when-downgrade":
            return /* NoReferrerWhenDowngrade */ 2;
        case "origin":
            return /* Origin */ 4;
        case "origin-when-cross-origin":
            return /* OriginWhenCrossOrigin */ 6;
        case "same-origin":
            return /* SameOrigin */ 3;
        case "strict-origin":
            return /* StrictOrigin */ 5;
        case "strict-origin-when-cross-origin":
            return /* StrictOriginWhenCrossOrigin */ 7;
        case "unsafe-url":
            return /* UnsafeUrl */ 8;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown referrerPolicy: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$mode(self) {
    var e = self.mode;
    switch(e){
        case "cors":
            return /* CORS */ 3;
        case "navigate":
            return /* Navigate */ 0;
        case "no-cors":
            return /* NoCORS */ 2;
        case "same-origin":
            return /* SameOrigin */ 1;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestMode: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$credentials(self) {
    var e = self.credentials;
    switch(e){
        case "include":
            return /* Include */ 2;
        case "omit":
            return /* Omit */ 0;
        case "same-origin":
            return /* SameOrigin */ 1;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestCredentials: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$cache(self) {
    var e = self.cache;
    switch(e){
        case "default":
            return /* Default */ 0;
        case "force-cache":
            return /* ForceCache */ 4;
        case "no-cache":
            return /* NoCache */ 3;
        case "no-store":
            return /* NoStore */ 1;
        case "only-if-cached":
            return /* OnlyIfCached */ 5;
        case "reload":
            return /* Reload */ 2;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestCache: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$redirect(self) {
    var e = self.redirect;
    switch(e){
        case "error":
            return /* Error */ 1;
        case "follow":
            return /* Follow */ 0;
        case "manual":
            return /* Manual */ 2;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestRedirect: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$classify(t) {
    if (typeof t === "string") return {
        NAME: "String",
        VAL: t
    };
    else return {
        NAME: "File",
        VAL: t
    };
}
var $c3defc4fec8ac51e$var$EntryValue = {
    classify: $c3defc4fec8ac51e$var$classify
};
function $c3defc4fec8ac51e$var$append$1(arg1, arg2, obj) {
    obj.append(arg1, arg2);
}
function $c3defc4fec8ac51e$var$$$delete$1(arg1, obj) {
    obj.delete(arg1);
}
function $c3defc4fec8ac51e$var$get$1(arg1, obj) {
    return obj.get(arg1);
}
function $c3defc4fec8ac51e$var$getAll(arg1, obj) {
    return obj.getAll(arg1);
}
function $c3defc4fec8ac51e$var$set$1(arg1, arg2, obj) {
    obj.set(arg1, arg2);
}
function $c3defc4fec8ac51e$var$has$1(arg1, obj) {
    return obj.has(arg1);
}
function $c3defc4fec8ac51e$var$appendObject(arg1, arg2, filename, obj) {
    obj.append(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$appendBlob(arg1, arg2, filename, obj) {
    obj.append(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$appendFile(arg1, arg2, filename, obj) {
    obj.append(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$setObject(arg1, arg2, filename, obj) {
    obj.set(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$setBlob(arg1, arg2, filename, obj) {
    obj.set(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$setFile(arg1, arg2, filename, obj) {
    obj.set(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
var $c3defc4fec8ac51e$export$18c5480443206253 = {
    EntryValue: $c3defc4fec8ac51e$var$EntryValue,
    Iterator: undefined,
    append: $c3defc4fec8ac51e$var$append$1,
    $$delete: $c3defc4fec8ac51e$var$$$delete$1,
    get: $c3defc4fec8ac51e$var$get$1,
    getAll: $c3defc4fec8ac51e$var$getAll,
    set: $c3defc4fec8ac51e$var$set$1,
    has: $c3defc4fec8ac51e$var$has$1,
    appendObject: $c3defc4fec8ac51e$var$appendObject,
    appendBlob: $c3defc4fec8ac51e$var$appendBlob,
    appendFile: $c3defc4fec8ac51e$var$appendFile,
    setObject: $c3defc4fec8ac51e$var$setObject,
    setBlob: $c3defc4fec8ac51e$var$setBlob,
    setFile: $c3defc4fec8ac51e$var$setFile
};
var $c3defc4fec8ac51e$export$271af40fe955dbf7 = {
    abort: function abort(prim) {
        prim.abort();
    }
};
function $c3defc4fec8ac51e$var$Body_arrayBuffer(prim) {
    return prim.arrayBuffer();
}
function $c3defc4fec8ac51e$var$Body_blob(prim) {
    return prim.blob();
}
function $c3defc4fec8ac51e$var$Body_formData(prim) {
    return prim.formData();
}
function $c3defc4fec8ac51e$var$Body_json(prim) {
    return prim.json();
}
function $c3defc4fec8ac51e$var$Body_text(prim) {
    return prim.text();
}
var $c3defc4fec8ac51e$export$4b2c32e08f77ff18 = {
    arrayBuffer: $c3defc4fec8ac51e$var$Body_arrayBuffer,
    blob: $c3defc4fec8ac51e$var$Body_blob,
    formData: $c3defc4fec8ac51e$var$Body_formData,
    json: $c3defc4fec8ac51e$var$Body_json,
    text: $c3defc4fec8ac51e$var$Body_text
};
var $c3defc4fec8ac51e$export$ffbc82ea5de81ac6 = {
    make: $c3defc4fec8ac51e$var$make
};
function $c3defc4fec8ac51e$var$Request_arrayBuffer(prim) {
    return prim.arrayBuffer();
}
function $c3defc4fec8ac51e$var$Request_blob(prim) {
    return prim.blob();
}
function $c3defc4fec8ac51e$var$Request_formData(prim) {
    return prim.formData();
}
function $c3defc4fec8ac51e$var$Request_json(prim) {
    return prim.json();
}
function $c3defc4fec8ac51e$var$Request_text(prim) {
    return prim.text();
}
var $c3defc4fec8ac51e$export$53d047610dcbd7d1 = {
    method_: $c3defc4fec8ac51e$var$method_,
    type_: $c3defc4fec8ac51e$var$type_,
    destination: $c3defc4fec8ac51e$var$destination,
    referrerPolicy: $c3defc4fec8ac51e$var$referrerPolicy,
    mode: $c3defc4fec8ac51e$var$mode,
    credentials: $c3defc4fec8ac51e$var$credentials,
    cache: $c3defc4fec8ac51e$var$cache,
    redirect: $c3defc4fec8ac51e$var$redirect,
    arrayBuffer: $c3defc4fec8ac51e$var$Request_arrayBuffer,
    blob: $c3defc4fec8ac51e$var$Request_blob,
    formData: $c3defc4fec8ac51e$var$Request_formData,
    json: $c3defc4fec8ac51e$var$Request_json,
    text: $c3defc4fec8ac51e$var$Request_text
};
function $c3defc4fec8ac51e$var$Response_clone(prim) {
    return prim.clone();
}
function $c3defc4fec8ac51e$var$Response_arrayBuffer(prim) {
    return prim.arrayBuffer();
}
function $c3defc4fec8ac51e$var$Response_blob(prim) {
    return prim.blob();
}
function $c3defc4fec8ac51e$var$Response_formData(prim) {
    return prim.formData();
}
function $c3defc4fec8ac51e$var$Response_json(prim) {
    return prim.json();
}
function $c3defc4fec8ac51e$var$Response_text(prim) {
    return prim.text();
}
var $c3defc4fec8ac51e$export$ccdc019228fc9db2 = {
    clone: $c3defc4fec8ac51e$var$Response_clone,
    arrayBuffer: $c3defc4fec8ac51e$var$Response_arrayBuffer,
    blob: $c3defc4fec8ac51e$var$Response_blob,
    formData: $c3defc4fec8ac51e$var$Response_formData,
    json: $c3defc4fec8ac51e$var$Response_json,
    text: $c3defc4fec8ac51e$var$Response_text
};
 /* No side effect */ 
});

parcelRegister("eklj4", function(module, exports) {

$parcel$export(module.exports, "$$catch", function () { return $a6e376032d552f87$export$e62bb7a22f80ae34; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $1xvYg = parcelRequire("1xvYg");
var $a6e376032d552f87$export$696ef7156ff42767 = /* @__PURE__ */ $1xvYg.create("Promise.JsError");
function $a6e376032d552f87$export$e62bb7a22f80ae34(promise, callback) {
    return promise.catch(function(err) {
        return $iv6Yc._1(callback, $1xvYg.is_extension(err) ? err : {
            RE_EXN_ID: $a6e376032d552f87$export$696ef7156ff42767,
            _1: err
        });
    });
}
 /* No side effect */ 
});

parcelRegister("75ZqT", function(module, exports) {

$parcel$export(module.exports, "$$Error", function () { return $52a8a74a8d9b8da3$export$507b31d55a607b45; });
$parcel$export(module.exports, "critical1", function () { return $52a8a74a8d9b8da3$export$c72c201879be19f7; });
$parcel$export(module.exports, "critical2", function () { return $52a8a74a8d9b8da3$export$d81adedbc8266a46; });
$parcel$export(module.exports, "critical3", function () { return $52a8a74a8d9b8da3$export$abbc13d208d7fd9d; });
$parcel$export(module.exports, "error1", function () { return $52a8a74a8d9b8da3$export$16b612f002658c42; });
$parcel$export(module.exports, "error2", function () { return $52a8a74a8d9b8da3$export$d509cefd34be14b1; });
$parcel$export(module.exports, "error3", function () { return $52a8a74a8d9b8da3$export$7da009fca5b7be62; });
$parcel$export(module.exports, "info1", function () { return $52a8a74a8d9b8da3$export$b2447b3a74273ee1; });
$parcel$export(module.exports, "info2", function () { return $52a8a74a8d9b8da3$export$be46b8986d197da1; });
$parcel$export(module.exports, "warning1", function () { return $52a8a74a8d9b8da3$export$e6c9b5ac8658dcc8; });
$parcel$export(module.exports, "warning2", function () { return $52a8a74a8d9b8da3$export$739cf6bc6f40dab2; });
// Generated by ReScript, PLEASE EDIT WITH CARE
var $52a8a74a8d9b8da3$var$findAMeaningfulMessageInArgs = function(args) {
    for(var k in args){
        if (typeof args[k] == "object" && args[k] instanceof Error) return args[k].message;
        if (typeof args[k] == "string") return args[k];
    }
};
// RE_EXN_ID irritatingly has the variant index /1 on it
// this can only confuse error grouping and seems to make
// rollbar not treat it as a valid error.name
var $52a8a74a8d9b8da3$var$clean_REX_ID = function(id) {
    var split = id.split("/");
    if (split.length == 2) return split[0];
    return id;
};
var $52a8a74a8d9b8da3$var$fromString = function fromString(str) {
    return new Error(str);
};
var $52a8a74a8d9b8da3$var$fromStringWithCause = function fromStringWithCause(str, cause) {
    var error = new Error(str, {
        cause: cause
    });
    error.stack = cause.stack;
    return error;
};
var $52a8a74a8d9b8da3$var$getRootCause = function getRootCause(err) {
    while(typeof err.cause == "object" && err.cause instanceof Error)err = err.cause;
    return err;
};
var $52a8a74a8d9b8da3$var$fromRescript = function fromRescript(err) {
    // It already is a js exn, not rescript exception, perhaps a type issue
    // could lead to this so we just want to keep it
    if (err instanceof Error) return err;
    // Looks in every way like a real rescript exception
    if (err !== null && typeof err === "object" && typeof err.RE_EXN_ID == "string") {
        var args = [
            err._0,
            err._1,
            err._2,
            err._3,
            err._4,
            err._5,
            err._6
        ].filter(function(arg) {
            return typeof arg !== "undefined";
        });
        var newError = new Error();
        newError.name = $52a8a74a8d9b8da3$var$clean_REX_ID(err.RE_EXN_ID);
        newError.message = $52a8a74a8d9b8da3$var$findAMeaningfulMessageInArgs(args);
        newError.RE_EXN_ID = err.RE_EXN_ID;
        for(var i = 0; i < args.length; i++)if (typeof args[i] !== "undefined") newError["RE_EXN_ARG_" + i] = args[i];
        if (err.Error instanceof Error) newError.stack = err.Error.stack;
        return newError;
    }
    // Not clear how this could be possible but keeping because no harm
    // Probably never was possible and just exists for no reason
    if (err !== null && typeof err === "object" && err._1 instanceof Error) return err._1;
    return new Error("Rescript (uninterpretable) " + JSON.stringify(err));
};
function $52a8a74a8d9b8da3$var$fromRescriptWithNewMessage(err, newMessage) {
    return $52a8a74a8d9b8da3$var$fromStringWithCause(newMessage, $52a8a74a8d9b8da3$var$fromRescript(err));
}
var $52a8a74a8d9b8da3$export$507b31d55a607b45 = {
    fromString: $52a8a74a8d9b8da3$var$fromString,
    fromStringWithCause: $52a8a74a8d9b8da3$var$fromStringWithCause,
    getRootCause: $52a8a74a8d9b8da3$var$getRootCause,
    fromRescript: $52a8a74a8d9b8da3$var$fromRescript,
    fromRescriptWithNewMessage: $52a8a74a8d9b8da3$var$fromRescriptWithNewMessage
};
function $52a8a74a8d9b8da3$export$c72c201879be19f7(client, e) {
    return new Promise(function(resolve, reject) {
        client.critical(e, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$d81adedbc8266a46(client, e, a) {
    return new Promise(function(resolve, reject) {
        client.critical(e, a, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$abbc13d208d7fd9d(client, e, a, b) {
    return new Promise(function(resolve, reject) {
        client.critical(e, a, b, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$16b612f002658c42(client, e) {
    return new Promise(function(resolve, reject) {
        client.error(e, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$d509cefd34be14b1(client, e, a) {
    return new Promise(function(resolve, reject) {
        client.error(e, a, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$7da009fca5b7be62(client, e, a, b) {
    return new Promise(function(resolve, reject) {
        client.error(e, a, b, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$b2447b3a74273ee1(client, msg) {
    return new Promise(function(resolve, reject) {
        client.info(msg, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$be46b8986d197da1(client, msg, extraInfo) {
    return new Promise(function(resolve, reject) {
        client.info(msg, extraInfo, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$e6c9b5ac8658dcc8(client, msg) {
    return new Promise(function(resolve, reject) {
        client.warning(msg, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$739cf6bc6f40dab2(client, msg, extraInfo) {
    return new Promise(function(resolve, reject) {
        client.warning(msg, extraInfo, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
 /*  Not a pure module */ 
});

parcelRegister("4RPwt", function(module, exports) {

$parcel$export(module.exports, "Exn", function () { return $38b414089bbb92f4$export$3448ba6aefb0114; });
// Generated by ReScript, PLEASE EDIT WITH CARE
var $38b414089bbb92f4$export$8d5400d15923e166 = {};
var $38b414089bbb92f4$var$unwrapJsError = function unwrapJsError(exn) {
    if (typeof exn != "object") return exn;
    if (!exn.hasOwnProperty("RE_EXN_ID") || !exn.hasOwnProperty("_1")) return exn;
    if (typeof exn["RE_EXN_ID"] == "string" && exn["RE_EXN_ID"].includes("JsError") && typeof exn["_1"] == "object" && exn["_1"] instanceof Error) return exn["_1"];
    else return exn;
};
var $38b414089bbb92f4$export$3448ba6aefb0114 = {
    unwrapJsError: $38b414089bbb92f4$var$unwrapJsError
};
 /* No side effect */ 
});

parcelRegister("bsv7W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $857a746c851076f0$export$2e2bcd8739ae039; });
var $857a746c851076f0$var$objectToString = Object.prototype.toString;
var $857a746c851076f0$var$isError = function(value) {
    return $857a746c851076f0$var$objectToString.call(value) === "[object Error]";
};
var $857a746c851076f0$var$errorMessages = new Set([
    "network error",
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "The Internet connection appears to be offline.",
    "Load failed",
    "Network request failed",
    "fetch failed",
    "terminated"
]);
function $857a746c851076f0$export$2e2bcd8739ae039(error) {
    var isValid = error && $857a746c851076f0$var$isError(error) && error.name === "TypeError" && typeof error.message === "string";
    if (!isValid) return false;
    // We do an extra check for Safari 17+ as it has a very generic error message.
    // Network errors in Safari have no stack.
    if (error.message === "Load failed") return error.stack === undefined;
    return $857a746c851076f0$var$errorMessages.has(error.message);
}

});

parcelRegister("ehnwQ", function(module, exports) {

$parcel$export(module.exports, "$$catch", function () { return $a654e78b37424f32$export$e62bb7a22f80ae34; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $eklj4 = parcelRequire("eklj4");

var $4RPwt = parcelRequire("4RPwt");
function $a654e78b37424f32$export$e62bb7a22f80ae34(promise, fn) {
    return $eklj4.$$catch(promise, function(e) {
        return $iv6Yc._1(fn, $4RPwt.Exn.unwrapJsError(e));
    });
}
 /* No side effect */ 
});

parcelRegister("4QdUt", function(module, exports) {

$parcel$export(module.exports, "LogicalError", function () { return $3866cef03bb4f5d9$export$21682c112315ff06; });
$parcel$export(module.exports, "LogicalErrorUnreported", function () { return $3866cef03bb4f5d9$export$63c8c81b4abafe13; });
$parcel$export(module.exports, "makeError", function () { return $3866cef03bb4f5d9$export$5a4bb2b1c89bdce7; });
$parcel$export(module.exports, "jsError1", function () { return $3866cef03bb4f5d9$export$f871d1f00b8c5f6a; });
$parcel$export(module.exports, "jsError2", function () { return $3866cef03bb4f5d9$export$9d57cf5a2e014ce6; });
$parcel$export(module.exports, "error1", function () { return $3866cef03bb4f5d9$export$16b612f002658c42; });
$parcel$export(module.exports, "error2", function () { return $3866cef03bb4f5d9$export$d509cefd34be14b1; });
$parcel$export(module.exports, "error3", function () { return $3866cef03bb4f5d9$export$7da009fca5b7be62; });
$parcel$export(module.exports, "info2", function () { return $3866cef03bb4f5d9$export$be46b8986d197da1; });
$parcel$export(module.exports, "warning2", function () { return $3866cef03bb4f5d9$export$739cf6bc6f40dab2; });
$parcel$export(module.exports, "critical2", function () { return $3866cef03bb4f5d9$export$d81adedbc8266a46; });
$parcel$export(module.exports, "critical3", function () { return $3866cef03bb4f5d9$export$abbc13d208d7fd9d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $75ZqT = parcelRequire("75ZqT");

var $hxhfd = parcelRequire("hxhfd");

var $1xvYg = parcelRequire("1xvYg");

var $bBMv4 = parcelRequire("bBMv4");

var $3866cef03bb4f5d9$export$a1d4d71ddf15b4b4 = function importRollbarClient() {
    return (parcelRequire("8XXN2")).then(function(rollbar) {
        return function(options) {
            return new rollbar(options);
        };
    });
};
function $3866cef03bb4f5d9$export$57570b1603cf6adb(param) {
    var host = window.location.host;
    var isIgnoredHost = host.endsWith(".vercel.app") || host.endsWith(".pages.dev") || host.endsWith("showside.maker.co") || host.endsWith("showside-staging.maker.co") || host.endsWith("nav.maker.co") || host.endsWith(".myshopify.com") || host.endsWith(".shopifypreview.com") || host.endsWith(".glitch.me") || host.endsWith("localhost:3000") || host.endsWith("localhost:3002");
    if (isIgnoredHost && $hxhfd.nodeEnv === "production") return "production-ignored";
    else return $hxhfd.nodeEnv;
}
function $3866cef03bb4f5d9$export$8bedcca5bbd73999(param) {
    return $3866cef03bb4f5d9$var$_getInstance.apply(this, arguments);
}
function $3866cef03bb4f5d9$var$_getInstance() {
    $3866cef03bb4f5d9$var$_getInstance = (0, $5YOUh._)(function(param) {
        var makeClient;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $iv6Yc._1($3866cef03bb4f5d9$export$a1d4d71ddf15b4b4, undefined)
                    ];
                case 1:
                    makeClient = _state.sent();
                    return [
                        2,
                        makeClient({
                            accessToken: $hxhfd.rollbarAccessToken,
                            captureUncaught: false,
                            captureUnhandledRejections: false,
                            environment: $3866cef03bb4f5d9$export$57570b1603cf6adb(undefined),
                            checkIgnore: undefined,
                            payload: {
                                client: {
                                    javascript: {
                                        source_map_enabled: true,
                                        code_version: $hxhfd.gitCommitSha,
                                        guess_uncaught_frames: true
                                    }
                                }
                            },
                            codeVersion: $hxhfd.gitCommitSha
                        })
                    ];
            }
        });
    });
    return $3866cef03bb4f5d9$var$_getInstance.apply(this, arguments);
}
var $3866cef03bb4f5d9$export$21682c112315ff06 = /* @__PURE__ */ $1xvYg.create("RollbarInstance-Showside.LogicalError");
var $3866cef03bb4f5d9$export$63c8c81b4abafe13 = /* @__PURE__ */ $1xvYg.create("RollbarInstance-Showside.LogicalErrorUnreported");
function $3866cef03bb4f5d9$export$5a4bb2b1c89bdce7(reportOpt, message) {
    var report = reportOpt !== undefined ? reportOpt : true;
    try {
        throw report ? {
            RE_EXN_ID: $3866cef03bb4f5d9$export$21682c112315ff06,
            _1: message
        } : {
            RE_EXN_ID: $3866cef03bb4f5d9$export$63c8c81b4abafe13,
            _1: message
        };
    } catch (raw_err) {
        return $bBMv4.internalToOCamlException(raw_err);
    }
}
var $3866cef03bb4f5d9$export$15f4d6fb99115d67 = function(error) {
    if (typeof window !== "undefined" && window.location.host !== "") {
        if (typeof error === "string") return "[" + window.location.host + "] " + error;
        else if (typeof error === "object" && error instanceof Error) {
            error.message = "[" + window.location.host + "] " + error.message;
            return error;
        } else return error;
    } else return error;
};
function $3866cef03bb4f5d9$export$f871d1f00b8c5f6a(error) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.error1(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error));
    });
}
function $3866cef03bb4f5d9$export$9d57cf5a2e014ce6(error, extraInfo) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.error2(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo));
    });
}
function $3866cef03bb4f5d9$export$61ff420436c0eab3(error, extraInfo1, extraInfo2) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.error3(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo1), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo2));
    });
}
function $3866cef03bb4f5d9$export$16b612f002658c42(error) {
    return $3866cef03bb4f5d9$export$f871d1f00b8c5f6a($75ZqT.$$Error.fromRescript(error));
}
function $3866cef03bb4f5d9$export$d509cefd34be14b1(error, extraInfo) {
    return $3866cef03bb4f5d9$export$9d57cf5a2e014ce6($75ZqT.$$Error.fromRescript(error), extraInfo);
}
function $3866cef03bb4f5d9$export$7da009fca5b7be62(error, extraInfo1, extraInfo2) {
    return $3866cef03bb4f5d9$export$61ff420436c0eab3($75ZqT.$$Error.fromRescript(error), extraInfo1, extraInfo2);
}
function $3866cef03bb4f5d9$export$b2447b3a74273ee1(msg) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.info1(__x, msg);
    });
}
function $3866cef03bb4f5d9$export$be46b8986d197da1(msg, extraInfo) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.info2(__x, msg, extraInfo);
    });
}
function $3866cef03bb4f5d9$export$e6c9b5ac8658dcc8(msg) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.warning1(__x, msg);
    });
}
function $3866cef03bb4f5d9$export$739cf6bc6f40dab2(msg, extraInfo) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.warning2(__x, msg, extraInfo);
    });
}
function $3866cef03bb4f5d9$export$c72c201879be19f7(error) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.critical1(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error));
    });
}
function $3866cef03bb4f5d9$export$d81adedbc8266a46(error, extraInfo) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.critical2(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo));
    });
}
function $3866cef03bb4f5d9$export$abbc13d208d7fd9d(error, extraInfo1, extraInfo2) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.critical3(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo1), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo2));
    });
}
 /* Rollbar Not a pure module */ 
});
parcelRegister("8XXN2", function(module, exports) {


module.exports = (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hOJSK")).then(function() {
    return parcelRequire("dmQ15");
});

});
parcelRegister("isbc1", function(module, exports) {
"use strict";

var $7J4BA = parcelRequire("7J4BA");
module.exports = $7J4BA(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7J4BA", function(module, exports) {
"use strict";
var $5a004edf52e5b33a$var$cachedBundles = {};
var $5a004edf52e5b33a$var$cachedPreloads = {};
var $5a004edf52e5b33a$var$cachedPrefetches = {};
function $5a004edf52e5b33a$var$getCache(type) {
    switch(type){
        case "preload":
            return $5a004edf52e5b33a$var$cachedPreloads;
        case "prefetch":
            return $5a004edf52e5b33a$var$cachedPrefetches;
        default:
            return $5a004edf52e5b33a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5a004edf52e5b33a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("bjgUL", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $83be96e9a9e1b412$export$2f872c0f2117be69; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $79vie = parcelRequire("79vie");
function $83be96e9a9e1b412$export$2f872c0f2117be69(j, decoder) {
    var errorToString = function errorToString(_error) {
        while(true){
            var error = _error;
            switch(error.TAG | 0){
                case /* Failure */ 0:
                    return error._0;
                case /* Index */ 1:
                case /* Field */ 2:
                    _error = error._1;
                    continue;
                case /* OneOf */ 3:
                    _error = error._0;
                    continue;
            }
        }
    };
    var result = $79vie.decodeValue(j, decoder);
    if (result.TAG === /* Ok */ 0) return {
        TAG: /* Ok */ 0,
        _0: result._0
    };
    else return {
        TAG: /* Error */ 1,
        _0: errorToString(result._0)
    };
}
 /* Json__Decode Not a pure module */ 
});

parcelRegister("fcz2a", function(module, exports) {

$parcel$export(module.exports, "GaVersion", function () { return $b1132707dbc023c6$export$a65f4ba0b4d85314; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $b1132707dbc023c6$var$partial_arg = [
    [
        "Ua",
        /* Ua */ 0
    ],
    [
        "Gtag",
        /* Gtag */ 1
    ]
];
function $b1132707dbc023c6$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($b1132707dbc023c6$var$partial_arg, param);
}
var $b1132707dbc023c6$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Ua",
        /* Ua */ 0
    ],
    [
        "Gtag",
        /* Gtag */ 1
    ]
]);
var $b1132707dbc023c6$var$include = $doJJK.Make({
    toJson: $b1132707dbc023c6$var$toJson,
    fromJson: $b1132707dbc023c6$var$fromJson
});
var $b1132707dbc023c6$var$t_encode = $b1132707dbc023c6$var$include.t_encode;
var $b1132707dbc023c6$var$t_decode = $b1132707dbc023c6$var$include.t_decode;
var $b1132707dbc023c6$var$GaVersion_codec = $b1132707dbc023c6$var$include.codec;
var $b1132707dbc023c6$export$a65f4ba0b4d85314 = {
    toJson: $b1132707dbc023c6$var$toJson,
    fromJson: $b1132707dbc023c6$var$fromJson,
    t_encode: $b1132707dbc023c6$var$t_encode,
    t_decode: $b1132707dbc023c6$var$t_decode,
    codec: $b1132707dbc023c6$var$GaVersion_codec
};
var $b1132707dbc023c6$export$88678e9619c1f002 = $b1132707dbc023c6$var$t_encode;
var $b1132707dbc023c6$export$52971681fb885ae3 = $b1132707dbc023c6$var$t_decode;
 /* fromJson Not a pure module */ 
});
parcelRegister("doJJK", function(module, exports) {

$parcel$export(module.exports, "Make", function () { return $9c10fea84862ada0$export$ec284e6c61e81f96; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");
function $9c10fea84862ada0$var$toDeccoError(e) {
    var errorStr = $79vie.errorToString(e);
    return {
        path: "unknown from rescript-json",
        message: errorStr,
        value: null
    };
}
function $9c10fea84862ada0$export$ec284e6c61e81f96(Serializable) {
    var t_encode = Serializable.toJson;
    var t_decode = function t_decode(json) {
        var ok = $79vie.decodeValue(json, Serializable.fromJson);
        if (ok.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: ok._0
        };
        else return {
            TAG: /* Error */ 1,
            _0: $9c10fea84862ada0$var$toDeccoError(ok._0)
        };
    };
    var codec = [
        t_encode,
        t_decode
    ];
    return {
        t_encode: t_encode,
        t_decode: t_decode,
        codec: codec
    };
}
function $9c10fea84862ada0$export$9e9dc98d17ddfffc(RecursiveSerializable) {
    var t_encode = RecursiveSerializable.toJson;
    var t_decode = function t_decode(json) {
        var ok = $79vie.decodeValue(json, $iv6Yc._1(RecursiveSerializable.fromJson, undefined));
        if (ok.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: ok._0
        };
        else return {
            TAG: /* Error */ 1,
            _0: $9c10fea84862ada0$var$toDeccoError(ok._0)
        };
    };
    var codec = [
        t_encode,
        t_decode
    ];
    return {
        t_encode: t_encode,
        t_decode: t_decode,
        codec: codec
    };
}
 /* Json__Decode Not a pure module */ 
});




parcelRegister("7pMKc", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bYlNO"))
]).then(function() {
    return parcelRequire("SXVLB");
});

});

parcelRegister("adVJW", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("eqk31")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1YO94")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6BNlF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("heMtg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5lEhM"))
]).then(function() {
    return parcelRequire("6shAo");
});

});

parcelRegister("aUETq", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6BNlF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5G2Uq"))
]).then(function() {
    return parcelRequire("khdgl");
});

});

parcelRegister("33EHy", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9UnI4")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6BNlF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("heMtg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5Jza1"))
]).then(function() {
    return parcelRequire("4jlPh");
});

});

parcelRegister("4MVeP", function(module, exports) {






















module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("95FGc")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9j6sg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1YO94")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9UnI4")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6BNlF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("heMtg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hBqlq"))
]).then(function() {
    return parcelRequire("hjWPk");
});

});

parcelRegister("9GRF4", function(module, exports) {






























module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9j6sg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1YO94")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9UnI4")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6BNlF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("heMtg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("by1hz")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fW0Yj")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6Tuh6")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fbQqy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("4aK9x"))
]).then(function() {
    return parcelRequire("9HhFF");
});

});

var $035ded6750fa4d28$exports = {};


(parcelRequire("7wgKE")).register((parcelRequire("kSeqf")).getBundleURL("8agRl"), JSON.parse('["8agRl","smartnav-v2.js","hOJSK","rollbar.noconflict.umd.59f66347.js","bYlNO","ConfigurationDecoder.bs.b1f81d12.js","hI3Yy","ConfigurationDecoder.bs.856444d3.js","aVOcH","ConfigurationDecoder.bs.efd81eca.js","5lEhM","Entrypoint.bs.6d208d7c.js","hujXY","PDPApp.bs.a399d7b7.js","3pqCl","QuickViewOverlay.bs.c8a51251.js","5G2Uq","Slider.bs.a199e594.js","6BNlF","Entrypoint.bs.680e3614.js","WepAH","ProductDetailsPage.bs.fa95187e.js","5Jza1","LauncherApp.bs.d5e6a156.js","hBqlq","BottombarApp.bs.5f9e4ff9.js","ebd07","MiniCartDrawer.bs.e8c55966.js","519fX","Entrypoint.bs.783b0a4a.js","6Tuh6","QuickViewOverlay.bs.322bcffb.js","6zo4Z","PDPApp.bs.1afbcc74.js","fW0Yj","QuickViewOverlay.bs.185d9f67.js","by1hz","SectionContent.bs.aa39c4a1.js","heMtg","Entrypoint.bs.70bf646d.js","hg8pJ","hls.ab9cc5cd.js","1EEJk","index.esm.b82cf7e5.js","7sEFF","index.esm.bd52e383.js","jAZo8","index.esm.b6e87719.js","9UnI4","PDPApp.bs.ca264701.js","lcTMQ","smartnav-v2.csspages.css","1YO94","Entrypoint.bs.327bca0d.js","9j6sg","PDPApp.bs.b0032789.js","iw4cu","PDPApp.bs.11efef92.js","95FGc","BottombarApp.bs.38a6a5b0.js","40A3X","NavbarHoverMenu.bs.2be2d96d.js","fbQqy","SectionContent.bs.8f055474.js","f8V71","PictureInPicture2.bs.c02502e8.js","i1uwo","QuickViewOverlay.bs.3438a289.js","d773D","ListPageContent.bs.4872d773.js","i8GHl","Sidebar.bs.5ddfe7fe.js","cQJlP","TreeAccordion.bs.f0aee609.js","eybsM","FiltersPanel.bs.b13f1b0b.js","gORIA","ListPageContent.bs.ea64334f.js","fgps0","EditorLayer.bs.d933c8e9.js","eqk31","Entrypoint.bs.46283cdb.js","4aK9x","SectionApp.bs.99f93dab.js","fxv0f","smartnav-v2.css"]'));


var $kRmIq = parcelRequire("kRmIq");
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $2gwg0 = parcelRequire("2gwg0");

var $dJ00A = parcelRequire("dJ00A");

var $9rqV0 = parcelRequire("9rqV0");

var $hrFTE = parcelRequire("hrFTE");

var $7GW0c = parcelRequire("7GW0c");

var $b5aRK = parcelRequire("b5aRK");

var $kMqPq = parcelRequire("kMqPq");

var $jjS2R = parcelRequire("jjS2R");
function $c518ccd17f672b97$export$8d4a4a389ba6cafa(index, element) {
    return $c518ccd17f672b97$var$_initSmartnav.apply(this, arguments);
}
function $c518ccd17f672b97$var$_initSmartnav() {
    $c518ccd17f672b97$var$_initSmartnav = (0, $5YOUh._)(function(index, element) {
        var attributes, embedType, configId;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $9rqV0.Attributes.autoAssignNamespaces(undefined);
                    attributes = $9rqV0.Attributes.fromElement(element);
                    embedType = $2whNH.getWithDefault($9rqV0.getEmbedTypeFromId(element.id), /* Bottombar */ 0);
                    return [
                        4,
                        $jjS2R.getConfigId(undefined, undefined, undefined, attributes, embedType)
                    ];
                case 1:
                    configId = _state.sent();
                    if (configId !== undefined) return [
                        2,
                        $kMqPq.preloadConfig(undefined, undefined, embedType, configId)
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $c518ccd17f672b97$var$_initSmartnav.apply(this, arguments);
}
function $c518ccd17f672b97$export$2e83b5c43fb7af7b(selector) {
    return $i7mYY.keepMap($i7mYY.map(Array.prototype.slice.call(document.querySelectorAll(selector)), $b5aRK.ofNode), function(node) {
        return node;
    });
}
function $c518ccd17f672b97$export$c8603593494de511(param) {
    var child = document.createElement("div");
    child.id = "maker-smartnav";
    $2whNH.forEach($7GW0c.$$Document.body(document), function(param) {
        param.appendChild(child);
    });
    return child;
}
function $c518ccd17f672b97$export$73eac51a39d6b0eb(param) {
    var foundLauncher = $c518ccd17f672b97$export$2e83b5c43fb7af7b("#maker-smartnav-launcher");
    var foundSection = $c518ccd17f672b97$export$2e83b5c43fb7af7b("#maker-smartnav-section");
    var foundPDP = $c518ccd17f672b97$export$2e83b5c43fb7af7b("#maker-smartnav-pdp");
    var foundBottombar = foundPDP.length === 0 ? $c518ccd17f672b97$export$2e83b5c43fb7af7b("#maker-smartnav") : [];
    var foundElements = $i7mYY.concat($i7mYY.concat($i7mYY.concat(foundBottombar, foundLauncher), foundSection), foundPDP);
    var hasSmartNavElements = foundElements.length !== 0;
    var pagesModal = document.querySelector("#maker-modal");
    var isShopifyShop = $2whNH.isSome($2gwg0.getShop(undefined));
    var isAltFunnel = $dJ00A.isAltFunnel(undefined);
    var isPagesModalAbsent = $2whNH.isNone(pagesModal == null ? undefined : $loT9g.some(pagesModal));
    var elementsToUse = hasSmartNavElements ? foundElements : isShopifyShop && isPagesModalAbsent || isAltFunnel && isPagesModalAbsent ? [
        $c518ccd17f672b97$export$c8603593494de511(undefined)
    ] : [];
    return $i7mYY.map(elementsToUse, $dJ00A.setupAltFunnelElement);
}






function $c518ccd17f672b97$export$2cd8252107eb640b(param) {
    var elements = $c518ccd17f672b97$export$73eac51a39d6b0eb(undefined);
    if (elements.length !== 0) {
        $i7mYY.mapWithIndex(elements, $c518ccd17f672b97$export$8d4a4a389ba6cafa);
        $hrFTE.insertCSS(undefined, undefined);
        (parcelRequire("7pMKc"));
        (parcelRequire("adVJW")).then(function(entrypoint) {
            entrypoint.init();
            window.SmartNav = entrypoint;
        });
        (parcelRequire("aUETq"));
        (parcelRequire("33EHy"));
        (parcelRequire("4MVeP"));
        return (parcelRequire("9GRF4"));
    } else {
        console.warn("Could not initialize SmartNav: no element found");
        return;
    }
}

function $c518ccd17f672b97$export$95e8d77caafa3e06(quickView, quickNav, replaceState, preserveScroll, namespace) {
    (parcelRequire("adVJW")).then(function(entrypoint) {
        entrypoint.goTo(quickView, quickNav, replaceState, preserveScroll, namespace);
    });
}

function $c518ccd17f672b97$export$b3890eb0ae9dca99(configId, onOpenLink, onAddToCart, trackers, isLauncher, element, attributes) {
    (parcelRequire("adVJW")).then(function(entrypoint) {
        entrypoint.render(configId, onOpenLink, onAddToCart, trackers, isLauncher, element, attributes);
    });
}
 /* AltFunnel-Showside Not a pure module */ 


var $48773e3a9327554b$var$_headID;
// We store a copy of the fetch function in window.makerFetch
// This is to avoid the fetch function being overwritten by other scripts
// Very common for other trackers on the page to overwrite it.
window.makerFetch = window.makerFetch || window.fetch;
var $48773e3a9327554b$var$scriptOrigin = document.currentScript && document.currentScript.src.replace(/(https?:.+)(\/smartnav-.+\.js)(\?id=(.*))?/g, "$1") || "https://showside.maker.co";
if (localStorage) localStorage.setItem("smartnav-script-origin", $48773e3a9327554b$var$scriptOrigin);
var $48773e3a9327554b$var$headID = document.getElementsByTagName("head")[0];
var $48773e3a9327554b$var$createImgDomainsPreconnectLinks = function() {
    var linkShopifyPreconnect = document.createElement("link");
    linkShopifyPreconnect.rel = "preconnect";
    linkShopifyPreconnect.href = "https://cdn.shopify.com";
    var linkCloudinaryPreconnect = document.createElement("link");
    linkCloudinaryPreconnect.rel = "preconnect";
    linkCloudinaryPreconnect.href = "https://res.cloudinary.com";
    return [
        linkShopifyPreconnect,
        linkCloudinaryPreconnect
    ];
};
var $48773e3a9327554b$var$createMakerDomainsPreconnectLinks = function() {
    var smartnavPreconnect = document.createElement("link");
    smartnavPreconnect.rel = "preconnect";
    smartnavPreconnect.href = "https://api.maker.co";
    return [
        smartnavPreconnect
    ];
};
var $48773e3a9327554b$var$links = (0, $kRmIq._)($48773e3a9327554b$var$createImgDomainsPreconnectLinks()).concat((0, $kRmIq._)($48773e3a9327554b$var$createMakerDomainsPreconnectLinks()));
($48773e3a9327554b$var$_headID = $48773e3a9327554b$var$headID).append.apply($48773e3a9327554b$var$_headID, (0, $kRmIq._)($48773e3a9327554b$var$links));
// Wait for window.maker_optimize that might be appended
setTimeout((0, $c518ccd17f672b97$export$2cd8252107eb640b), 0);
window.addEventListener("DOMContentLoaded", function() {
    return (0, $c518ccd17f672b97$export$2cd8252107eb640b)();
});
window.SmartNav = {
    init: (0, $c518ccd17f672b97$export$2cd8252107eb640b),
    render: (0, $c518ccd17f672b97$export$b3890eb0ae9dca99),
    goTo: (0, $c518ccd17f672b97$export$95e8d77caafa3e06)
};

})();
//# sourceMappingURL=smartnav-v2.js.map
